webpackJsonp([3],{

/***/ "+44D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Mpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/components/logs/distributor-details-log-report.vue + 2 modules
var distributor_details_log_report = __webpack_require__("WZ70");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-distributor-details-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var show_distributor_details_dialog = ({
  data: function data() {
    return {
      dialog: false
    };
  },

  computed: {
    areDetailsShown: function areDetailsShown() {
      return !Object(lodash["isEmpty"])(this.detailedDistributor);
    },
    isDialog: function isDialog() {
      return this.areDetailsShown;
    }
  },
  components: {
    DistributorDetailsLogReport: distributor_details_log_report["default"]
  },
  props: {
    detailedDistributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showLogsDetails: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60217100","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-distributor-details-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.$vuetify.breakpoint.xsOnly)?_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.isDialog),callback:function ($$v) {_vm.isDialog=$$v},expression:"isDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"dark":"","icon":""},on:{"click":function($event){return _vm.showLogsDetails(_vm.detailedDistributor)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Detalles")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items')],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0"},[_c('distributor-details-log-report',{attrs:{"detailedDistributor":_vm.detailedDistributor}})],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-distributor-details-dialog.vue
function injectStyle (context) {
  __webpack_require__("QNmV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_distributor_details_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_distributor_details_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+gN6":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./App": "M93x",
	"./App.vue": "M93x",
	"./assets/Frameicon-lupa.png": "FyRe",
	"./assets/Nexa/Nexa_Bold.otf": "KQcc",
	"./assets/Nexa/Nexa_Light.otf": "2Z1F",
	"./assets/Nexa/Nexa_Regular.otf": "T670",
	"./assets/background-login.jpg": "98nQ",
	"./assets/dashboard-icons/card-consistency.png": "g9ls",
	"./assets/dashboard-icons/card-database.png": "HGiz",
	"./assets/dashboard-icons/card-remote-files.png": "kQl+",
	"./assets/dashboard-icons/icono-administrar-.png": "qLC+",
	"./assets/dashboard-icons/icono-administrar.png": "wwhr",
	"./assets/dashboard-icons/icono-tarjeta-.png": "j/nF",
	"./assets/dashboard-icons/icono-tarjeta.png": "yUJT",
	"./assets/dashboard-icons/indicator-amber.png": "f1PE",
	"./assets/dashboard-icons/indicator-gray.png": "0RtZ",
	"./assets/dashboard-icons/indicator-green.png": "klvw",
	"./assets/dashboard-icons/indicator-light-red.png": "WsEI",
	"./assets/dashboard-icons/indicator-red.png": "dXC/",
	"./assets/fondo-loginstrategio.jpg": "dkhU",
	"./assets/fonts/Nexa/Nexa_Bold.otf": "mjlg",
	"./assets/fonts/Nexa/Nexa_Light.otf": "3Hgn",
	"./assets/fonts/Nexa/Nexa_Regular.otf": "Qn1R",
	"./assets/icon-folder.svg": "SzZz",
	"./assets/icon-metabase.png": "4+6E",
	"./assets/icono-strategio.png": "pCjg",
	"./assets/icono-user.png": "9Mjp",
	"./assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.eot": "6/lO",
	"./assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.svg": "GFdn",
	"./assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.ttf": "jsmt",
	"./assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.woff": "/UK/",
	"./assets/iconosVidaSoftware-v1.0/style.css": "cKcr",
	"./assets/icons/folder-icon.png": "op7a",
	"./assets/icons/report-icon.png": "8Sb3",
	"./assets/indicadores/ind1.png": "b9tb",
	"./assets/indicadores/ind2.png": "jnq8",
	"./assets/indicadores/ind3.png": "pg7M",
	"./assets/indicadores/ind4.png": "S4jV",
	"./assets/loading/animacion_background.jpg": "t91I",
	"./assets/loading/animacion_carga.gif": "HxCl",
	"./assets/logo-strategio.png": "KDbQ",
	"./assets/logo-vida-software.png": "KaMS",
	"./assets/logo.png": "7Otq",
	"./assets/logotipo-strategio.png": "9FQj",
	"./assets/logotipo.png": "FB/y",
	"./assets/manage-users-icons/email.png": "ZmgP",
	"./assets/manage-users-icons/position.png": "1W7+",
	"./assets/manage-users-icons/user.png": "qLPu",
	"./assets/metabase.png": "6mg8",
	"./assets/placeholder.png": "nsAd",
	"./assets/pregunta-tus-datos.png": "D01m",
	"./assets/profile-icons/email.png": "saB/",
	"./assets/profile-icons/password-visible.png": "gEAh",
	"./assets/profile-icons/password.png": "K+Ru",
	"./assets/profile-icons/phone.png": "6W2l",
	"./assets/profile-icons/position.png": "wlwR",
	"./assets/profile-icons/user.png": "Fiq4",
	"./assets/report-imgs/icon-alt1.png": "1Hyf",
	"./assets/report-imgs/icon-alt2.png": "4c0w",
	"./assets/report-imgs/icon-excel.png": "sluv",
	"./assets/report-imgs/icon-powerbi.png": "EmU2",
	"./components/autoservicios/autoservicio-btn-back": "VfmT",
	"./components/autoservicios/autoservicio-btn-back.vue": "VfmT",
	"./components/autoservicios/autoservicio-step-validation": "kOLc",
	"./components/autoservicios/autoservicio-step-validation.vue": "kOLc",
	"./components/autoservicios/bonus/custom-bonus-table": "jHDf",
	"./components/autoservicios/bonus/custom-bonus-table.vue": "jHDf",
	"./components/autoservicios/groups/autoservicio-group": "DITZ",
	"./components/autoservicios/groups/autoservicio-group.vue": "DITZ",
	"./components/autoservicios/groups/autoservicio-list-groups": "Eqwn",
	"./components/autoservicios/groups/autoservicio-list-groups.vue": "Eqwn",
	"./components/autoservicios/processes/autoservicio-list-processes": "41Kw",
	"./components/autoservicios/processes/autoservicio-list-processes.vue": "41Kw",
	"./components/autoservicios/processes/autoservicio-process": "Jxcz",
	"./components/autoservicios/processes/autoservicio-process.vue": "Jxcz",
	"./components/autoservicios/validation/validation-config": "PSrw",
	"./components/autoservicios/validation/validation-config.vue": "PSrw",
	"./components/autoservicios/validation/validation-dialog-confirmation": "kZfn",
	"./components/autoservicios/validation/validation-dialog-confirmation.vue": "kZfn",
	"./components/autoservicios/validation/validation-dialog-error": "1CsE",
	"./components/autoservicios/validation/validation-dialog-error.vue": "1CsE",
	"./components/autoservicios/validation/validation-header": "8vt4",
	"./components/autoservicios/validation/validation-header.vue": "8vt4",
	"./components/autoservicios/validation/validation-insert-data-dialog-error": "ljja",
	"./components/autoservicios/validation/validation-insert-data-dialog-error.vue": "ljja",
	"./components/autoservicios/validation/validation-upload-file": "nFpD",
	"./components/autoservicios/validation/validation-upload-file.vue": "nFpD",
	"./components/custom-loading": "OxhJ",
	"./components/custom-loading.vue": "OxhJ",
	"./components/dialogs/are-you-sure-dialog": "u9Gr",
	"./components/dialogs/are-you-sure-dialog.vue": "u9Gr",
	"./components/dialogs/configure-ftp-dialog": "seyq",
	"./components/dialogs/configure-ftp-dialog.vue": "seyq",
	"./components/dialogs/distributor-form-dialog": "pNPm",
	"./components/dialogs/distributor-form-dialog.vue": "pNPm",
	"./components/dialogs/drop-item-dialog": "4+lJ",
	"./components/dialogs/drop-item-dialog.vue": "4+lJ",
	"./components/dialogs/folder-form-dialog": "1iFf",
	"./components/dialogs/folder-form-dialog.vue": "1iFf",
	"./components/dialogs/inconsistencies-report-question-dialog": "5GOF",
	"./components/dialogs/inconsistencies-report-question-dialog.vue": "5GOF",
	"./components/dialogs/new-items-manager-dialog": "nVqS",
	"./components/dialogs/new-items-manager-dialog.vue": "nVqS",
	"./components/dialogs/paste-structure-form-dialog": "AuUj",
	"./components/dialogs/paste-structure-form-dialog.vue": "AuUj",
	"./components/dialogs/replicate-folder-dialog": "KcZP",
	"./components/dialogs/replicate-folder-dialog.vue": "KcZP",
	"./components/dialogs/report-form-dialog": "MoDk",
	"./components/dialogs/report-form-dialog.vue": "MoDk",
	"./components/dialogs/show-card-details-dialog": "HX3A",
	"./components/dialogs/show-card-details-dialog.vue": "HX3A",
	"./components/dialogs/show-cards-dialog": "sYgN",
	"./components/dialogs/show-cards-dialog.vue": "sYgN",
	"./components/dialogs/show-distributor-details-dialog": "+Mpy",
	"./components/dialogs/show-distributor-details-dialog.vue": "+Mpy",
	"./components/dialogs/show-distributors-dialog": "F7A0",
	"./components/dialogs/show-distributors-dialog.vue": "F7A0",
	"./components/dialogs/show-reports-permisions-dialog": "/LT7",
	"./components/dialogs/show-reports-permisions-dialog.vue": "/LT7",
	"./components/dialogs/show-users-folder-permissions": "wP5p",
	"./components/dialogs/show-users-folder-permissions.vue": "wP5p",
	"./components/dialogs/structure-form-dialog": "BbCC",
	"./components/dialogs/structure-form-dialog.vue": "BbCC",
	"./components/folders/current-folder-permissions-tree": "e+PE",
	"./components/folders/current-folder-permissions-tree.vue": "e+PE",
	"./components/folders/folder-list": "A+kn",
	"./components/folders/folder-list-item": "6NyI",
	"./components/folders/folder-list-item.vue": "6NyI",
	"./components/folders/folder-list.vue": "A+kn",
	"./components/header-bar/strategio-app-bar": "Cy8i",
	"./components/header-bar/strategio-app-bar.vue": "Cy8i",
	"./components/header-main-page/header-main-page": "8lGR",
	"./components/header-main-page/header-main-page.vue": "8lGR",
	"./components/logs/distributor-details-log-report": "WZ70",
	"./components/logs/distributor-details-log-report.vue": "WZ70",
	"./components/menus/item-menu": "F7n2",
	"./components/menus/item-menu.vue": "F7n2",
	"./components/reports/report-list": "MJmm",
	"./components/reports/report-list-item": "BmF5",
	"./components/reports/report-list-item-rectangle": "jYJk",
	"./components/reports/report-list-item-rectangle.vue": "jYJk",
	"./components/reports/report-list-item.vue": "BmF5",
	"./components/reports/report-list.vue": "MJmm",
	"./components/reports/reports-tree": "uRxK",
	"./components/reports/reports-tree.vue": "uRxK",
	"./components/reports/tree-item": "1DXM",
	"./components/reports/tree-item.vue": "1DXM",
	"./components/snackbars/custom-snack-bar": "xdpQ",
	"./components/snackbars/custom-snack-bar.vue": "xdpQ",
	"./components/structures/flat-structure-item": "mxb/",
	"./components/structures/flat-structure-item.vue": "mxb/",
	"./components/structures/structure-item": "pSq4",
	"./components/structures/structure-item.vue": "pSq4",
	"./components/structures/structure-list": "+yo/",
	"./components/structures/structure-list.vue": "+yo/",
	"./components/supervisor/card-consistencies": "Uxnk",
	"./components/supervisor/card-consistencies.vue": "Uxnk",
	"./components/supervisor/card-database": "n6WR",
	"./components/supervisor/card-database.vue": "n6WR",
	"./components/supervisor/card-ftp-files": "gEzQ",
	"./components/supervisor/card-ftp-files.vue": "gEzQ",
	"./components/supervisor/card-generator": "NL7v",
	"./components/supervisor/card-generator.vue": "NL7v",
	"./components/supervisor/card-template": "XR0q",
	"./components/supervisor/card-template.vue": "XR0q",
	"./components/supervisor/card-template_OLD": "w/aW",
	"./components/supervisor/card-template_OLD.vue": "w/aW",
	"./components/supervisor/cards-list": "dW/+",
	"./components/supervisor/cards-list.vue": "dW/+",
	"./components/supervisor/distributor-detail-section": "geiL",
	"./components/supervisor/distributor-detail-section.vue": "geiL",
	"./components/supervisor/distributor-details-indicators-list": "GGPP",
	"./components/supervisor/distributor-details-indicators-list.vue": "GGPP",
	"./components/supervisor/distributors-details": "nhJ5",
	"./components/supervisor/distributors-details-color-filter": "Hibl",
	"./components/supervisor/distributors-details-color-filter.vue": "Hibl",
	"./components/supervisor/distributors-details-list": "myCr",
	"./components/supervisor/distributors-details-list.vue": "myCr",
	"./components/supervisor/distributors-details.vue": "nhJ5",
	"./components/users/user-form": "3GQB",
	"./components/users/user-form.bk": "3Dow",
	"./components/users/user-form.bk.vue": "3Dow",
	"./components/users/user-form.vue": "3GQB",
	"./components/users/user-rights-form": "S8x3",
	"./components/users/user-rights-form.vue": "S8x3",
	"./components/users/users-list": "BL3A",
	"./components/users/users-list-item": "sW4m",
	"./components/users/users-list-item.vue": "sW4m",
	"./components/users/users-list.vue": "BL3A",
	"./main": "NHnr",
	"./main.js": "NHnr",
	"./router": "YaEn",
	"./router/": "YaEn",
	"./router/index": "YaEn",
	"./router/index.js": "YaEn",
	"./routes/autoservicios/autoservicios": "odzK",
	"./routes/autoservicios/autoservicios.vue": "odzK",
	"./routes/autoservicios/bonus/show-bonus-distributor": "V91D",
	"./routes/autoservicios/bonus/show-bonus-distributor.vue": "V91D",
	"./routes/autoservicios/bonus/show-bonus-report": "gf/7",
	"./routes/autoservicios/bonus/show-bonus-report.vue": "gf/7",
	"./routes/autoservicios/bonus/show-validation": "dNo6",
	"./routes/autoservicios/bonus/show-validation.vue": "dNo6",
	"./routes/autoservicios/homologation/show-homologation": "t+SW",
	"./routes/autoservicios/homologation/show-homologation.vue": "t+SW",
	"./routes/autoservicios/show-autoservicio-data": "aVm2",
	"./routes/autoservicios/show-autoservicio-data.vue": "aVm2",
	"./routes/autoservicios/show-autoservicio-group": "cUXx",
	"./routes/autoservicios/show-autoservicio-group.vue": "cUXx",
	"./routes/autoservicios/show-process-validation": "tfuP",
	"./routes/autoservicios/show-process-validation.vue": "tfuP",
	"./routes/codigo-usuario": "1Wy7",
	"./routes/codigo-usuario.vue": "1Wy7",
	"./routes/download-cube": "JOiW",
	"./routes/download-cube.vue": "JOiW",
	"./routes/favorites": "QsRl",
	"./routes/favorites.vue": "QsRl",
	"./routes/login": "Bm+n",
	"./routes/login.vue": "Bm+n",
	"./routes/main-page": "K/Nx",
	"./routes/main-page.vue": "K/Nx",
	"./routes/reports": "MxmD",
	"./routes/reports.vue": "MxmD",
	"./routes/search-items": "HjeH",
	"./routes/search-items.vue": "HjeH",
	"./routes/show-helpdesk": "aecv",
	"./routes/show-helpdesk.vue": "aecv",
	"./routes/show-metabase": "63oR",
	"./routes/show-metabase.vue": "63oR",
	"./routes/show-report": "cC8f",
	"./routes/show-report-bi": "CDy0",
	"./routes/show-report-bi.vue": "CDy0",
	"./routes/show-report.vue": "cC8f",
	"./routes/supervise-dashboard": "aXVe",
	"./routes/supervise-dashboard.vue": "aXVe",
	"./routes/user-account": "LKIZ",
	"./routes/user-account.vue": "LKIZ",
	"./routes/user-admin": "5qaI",
	"./routes/user-admin-by-id": "1HtN",
	"./routes/user-admin-by-id.vue": "1HtN",
	"./routes/user-admin-create": "ct65",
	"./routes/user-admin-create.vue": "ct65",
	"./routes/user-admin.vue": "5qaI",
	"./storage/adminStorage": "6orz",
	"./storage/adminStorage.js": "6orz",
	"./storage/cardsStorage": "l4NB",
	"./storage/cardsStorage.js": "l4NB",
	"./storage/logsStorage": "niPX",
	"./storage/logsStorage.js": "niPX",
	"./storage/reportsStorage": "dX8W",
	"./storage/reportsStorage.js": "dX8W",
	"./storage/structureStorage": "nCdY",
	"./storage/structureStorage.js": "nCdY",
	"./storage/supervisorStorage": "zaRw",
	"./storage/supervisorStorage.js": "zaRw",
	"./storage/userStorage": "4SVp",
	"./storage/userStorage.js": "4SVp",
	"./utils/auth": "TIfe",
	"./utils/auth.js": "TIfe",
	"./utils/axiosWrapper": "BRjr",
	"./utils/axiosWrapper.js": "BRjr",
	"./utils/axiosWrapperAutoservicio": "QNHe",
	"./utils/axiosWrapperAutoservicio.js": "QNHe",
	"./utils/eventBus": "irLX",
	"./utils/eventBus.js": "irLX",
	"./utils/introBus": "1wbc",
	"./utils/introBus.js": "1wbc",
	"./utils/navigator": "7KIX",
	"./utils/navigator.js": "7KIX",
	"./utils/storageCleaner": "Rqrm",
	"./utils/storageCleaner.js": "Rqrm",
	"./utils/uris": "xbPH",
	"./utils/uris.js": "xbPH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+gN6";

/***/ }),

/***/ "+yo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/folders/folder-list-item.vue + 2 modules
var folder_list_item = __webpack_require__("6NyI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/structures/structure-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var structure_list = ({
  name: 'structure-list',
  data: function data() {
    return {
      showMovingMessage: false
    };
  },
  created: function created() {},

  methods: {},
  components: {
    FolderListItem: folder_list_item["default"]
  },
  props: {
    folders: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    containedBy: {
      default: function _default() {
        return {};
      }
    },
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    searchInfo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    addInnerFolder: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    addInnerReport: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4319f81c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/structures/structure-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearching),expression:"!isSearching"}],style:(_vm.showMovingMessage ? ("margin-top: " + _vm.movingMessageHeight + "px") : ''),attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-layout',[_c('v-flex',{staticClass:"layout align-center"},[_c('v-icon',{staticClass:"ma-2",attrs:{"color":"black","medium":""}},[_vm._v("low_priority")]),_vm._v(" "),_c('span',{staticClass:"strategio-folder-title"},[_vm._v("Base")]),_vm._v(" "),_c('v-spacer')],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},_vm._l((_vm.folders),function(f){return _c('folder-list-item',{key:f.folderID,attrs:{"folder-data":f,"is-searching":_vm.isSearching,"add-inner-folder":_vm.addInnerFolder,"add-inner-report":_vm.addInnerReport}})}),1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/structures/structure-list.vue
function injectStyle (context) {
  __webpack_require__("uOFS")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4319f81c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  structure_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var structures_structure_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/LT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/reports/reports-tree.vue + 2 modules
var reports_tree = __webpack_require__("uRxK");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-reports-permisions-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var show_reports_permisions_dialog = ({
  name: 'show-reports-permisions-dialog',
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      var q = reportsStorage["default"].getCheckedItems(this.itemsData);
      // emit to: components/users/user-form.vue
      eventBus["default"].$emit('show-updated-Reports', q);
      this.dialog = false;
    },
    updatePermissions: function updatePermissions() {
      var _this = this;

      var q = reportsStorage["default"].getCheckedItems(this.itemsData);
      if (this.isNewUser) {
        // emit to: components/users/user-form.vue
        eventBus["default"].$emit('show-updated-Reports', q);
        this.dialog = false;
      } else {
        reportsStorage["default"].updatePermissions({
          userID: this.userId,
          permissions: q,
          onSuccess: function onSuccess() {
            // emits to: components/snacksbars/custom-snack-bar.vue
            eventBus["default"].$emit('open-custom-snack-bar', {
              message: 'Se actualizo la visualizacion de reportes',
              itsOk: true
            });
            _this.dialog = false;
          },
          onerror: function onerror() {
            eventBus["default"].$emit('open-custom-snack-bar', {
              // emits to: components/snacksbars/custom-snack-bar.vue
              message: 'Ha habido un error actualizando la visualizacion de reportes',
              itsOk: false
            });
            _this.dialog = false;
          }
        });
      }
    }
  },
  components: {
    ReportsTree: reports_tree["default"]
  },
  props: ['itemsData', 'userId', 'isNewUser']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d129f360","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-reports-permisions-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout justify-end"},[_c('v-btn',{staticClass:"strategio-card-button",staticStyle:{"background-color":"#19BAE8"},attrs:{"depressed":"","rounded":"","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_vm._v("\n    Ver reportes\n  ")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("Reportes")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('reports-tree',{attrs:{"items-data":_vm.itemsData}})],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"error"},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"success"},nativeOn:{"click":function($event){return _vm.updatePermissions()}}},[_vm._v("Aceptar")])],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-reports-permisions-dialog.vue
function injectStyle (context) {
  __webpack_require__("Z6iq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_reports_permisions_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_reports_permisions_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/UK/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/iconosVidaSoftware.4b12752.woff";

/***/ }),

/***/ "0RtZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RkI4QjlENDQ3QjE2MTFFODkzMkRENzlFMTgwNkY4MDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RkI4QjlENDM3QjE2MTFFODkzMkRENzlFMTgwNkY4MDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QUFDMTI0RDM3NTlFMTFFOEFDOTJFNkFGMzQwNUY5RkEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUFDMTI0RDQ3NTlFMTFFOEFDOTJFNkFGMzQwNUY5RkEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6EQfHNAAABnUlEQVR42sSXQUrDQBSG09BltSvtBQRt9tZFtb2AtYIUvUBBT6CeQHsDW3oAUVCrBTeChdaF1nVrj6Cu1KyN/4MXGcRMJjrJPPhWk7yP5A3z3qRub64txVgAa2AZ5MEMyII38ArGYAAuwZNKwnTIegpUwT4oBDyTZeZABTTAAzgAHeAFJbcl4nnQA+cScVAU+L0e54kkr4FHULL+FyXOU1OV18ExyFh6IsP56mHyTXAUUo6/BOVrcv5f5VSbdgxicfO2xT1gCwstjb9aVoIW+77lVQ2bK8omXBfle1aysevLHbCUsJx8eZKvWmaiQvIVQ/KizQ3DRDgknzUkz5F82pB8iuTvhuQfJH8xJH+2VaeOGGJM8r4h+YDkXUPyLslH4D5hMflGfmM5TFjeELtaJ8Hak+dClHs8Y7kxi132eD/HqIm4EEP4HzgJGiBpytwGnzGIdzi/dHSmGWtLYwlcztdUvTScgkUNm7DPeU6iXpfo2C2DDTCMKB3ye2XZ8Z1WqNUZ4/BFsMi31By1RepO1CT4lnoHrvjgCo0vAQYA13FP7WoOQUsAAAAASUVORK5CYII="

/***/ }),

/***/ "0TKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1CsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-dialog-error.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var validation_dialog_error = ({
  name: 'validation-dialog-error',
  data: function data() {
    return {
      loading: false,
      showDialog: false,
      errors: [],
      file: []
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-dialog-autoservicio-error');
    eventBus["default"].$on('open-dialog-autoservicio-error', function (data) {
      _this.openDialogError(data.showDialog, data.errors, data.file);
    });
  },

  methods: {
    openDialogError: function openDialogError(showDialog, errors, file) {
      this.showDialog = showDialog;
      this.errors = errors;
      this.file = file;
    },
    closeDialogError: function closeDialogError() {
      this.showDialog = false;
    },
    downloadFile: function downloadFile() {
      var _this2 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append('excel_file', this.file);
      formData.append('data', stringify_default()(this.errors));
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_ERROR_TEMPLATE, formData, {
        responseType: 'blob'
      }).then(function (response) {
        var filename = response.headers.filename;
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(function (err) {
        console.warn('No se ha podido obtener data de errores', err);
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73586d0b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-dialog-error.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          Errores encontrados\n        ")]),_vm._v(" "),_c('v-card-text',[_c('ul',_vm._l((_vm.errors),function(error,idx){return _c('li',{key:idx},[_c('strong',[_vm._v("Fila: ")]),_vm._v(" "+_vm._s(error.row)+"\n              "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Detalle: ")]),_vm._v(" "),_c('ul',_vm._l((error.error_details),function(e,i){return _c('li',{key:i},[_vm._v("\n                  Columna: "+_vm._s(e.column)+"\n                  "),_c('br'),_vm._v("\n                  Error: "+_vm._s(e.error_message)+"\n                  "),_c('br'),_vm._v("\n                  Tipo de Error: "+_vm._s(e.error_type)+"\n                ")])}),0)])}),0)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","outlined":"","disabled":_vm.loading},on:{"click":_vm.closeDialogError}},[_vm._v("\n            Cerrar\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","outlined":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.downloadFile}},[_vm._v("\n            Descargar\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-dialog-error.vue
function injectStyle (context) {
  __webpack_require__("65cD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_dialog_error,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_dialog_error = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1DXM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reports/tree-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var tree_item = ({
  name: 'tree-item',
  props: {
    iData: Object
  },
  data: function data() {
    return {
      open: false
    };
  },

  methods: {
    setItemClass: function setItemClass(isFolder, isHidden) {
      var q = '';
      if (isFolder) {
        q += 'strategio-tree-folder ';
      } else {
        q += 'strategio-tree-item ';
      }

      if (isHidden) {
        q += 'strategio-item-hidden';
      }
      return q;
    },
    handleChange: function handleChange(checked) {
      this.iData.checked = checked;
      reportsStorage["default"].toggleTree(this.iData.children, checked);
    },
    toggle: function toggle() {
      this.open = !this.open;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6378a2c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/tree-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"strategio-tree-list-item mt-2"},[_c('v-card-actions',{class:_vm.setItemClass (_vm.iData.isFolder, _vm.iData.hidden)},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iData.isFolder),expression:"iData.isFolder"}],staticStyle:{"cursor":"pointer"},attrs:{"color":"grey darken-2"},on:{"click":function($event){return _vm.toggle()}}},[_vm._v("\n      "+_vm._s(_vm.open ? 'remove' : 'add')+"\n    ")]),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-checkbox',{staticClass:"strategio-report-checkbox",staticStyle:{"color":"#01C0D1 !important"},attrs:{"hide-details":"","ripple":false,"label":((_vm.iData.itemName) + " " + (_vm.iData.hidden ? '(oculto)' : ''))},on:{"change":_vm.handleChange},model:{value:(_vm.iData.checked),callback:function ($$v) {_vm.$set(_vm.iData, "checked", $$v)},expression:"iData.checked"}}),_vm._v(" "),_c('v-divider')],1)],1),_vm._v(" "),(_vm.open)?_c('ul',{staticStyle:{"margin-left":"32px"}},_vm._l((_vm.iData.children),function(c,$index){return _c('tree-item',{key:$index,attrs:{"i-data":c}})}),1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/reports/tree-item.vue
function injectStyle (context) {
  __webpack_require__("aV+L")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  tree_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_tree_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1HtN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/users/user-form.vue + 2 modules
var user_form = __webpack_require__("3GQB");

// EXTERNAL MODULE: ./src/storage/adminStorage.js
var adminStorage = __webpack_require__("6orz");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/user-admin-by-id.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var user_admin_by_id = ({
  name: 'user-admin-by-id',
  data: function data() {
    return {
      user: {},
      subs: [],
      message: ''
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.loadUser(to.params.userID);
    next();
  },
  mounted: function mounted() {
    this.loadUser(this.$route.params.userID);
  },

  methods: {
    loadUser: function loadUser(userID) {
      var _this = this;

      adminStorage["default"].getAdminUsers({
        userID: userID,
        fromCache: true,
        onSuccess: function onSuccess(user) {
          _this.user = user;
        },
        onError: function onError(error) {
          console.warn(error);
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No pudimos obtener los datos del usuario', itsOk: false });
        }
      });

      adminStorage["default"].getSubscriptions({
        userID: userID,
        onSuccess: function onSuccess(subs) {
          _this.buildTreeItemsSubscriptions(subs);
        },
        onError: function onError(error) {
          console.warn(error);
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No pudimos obtener las subscripciones del usuario', itsOk: false });
        }
      });
    },
    buildTreeItemsSubscriptions: function buildTreeItemsSubscriptions(subs) {
      var _this2 = this;

      reportsStorage["default"].getData({
        forceLoad: false,
        onSuccess: function onSuccess(data) {
          _this2.subs = reportsStorage["default"].buildTree(subs);
          console.warn(_this2.subs);
        },
        onError: function onError(error) {
          var message = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            message = 'Error desconocido: ' + error.message;
          }
          eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
        }
      });
    }
  },
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    UserForm: user_form["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e8be2c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/user-admin-by-id.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('user-form',{attrs:{"user-data":_vm.user,"items-tree":_vm.subs,"parent-route":"/user/admin","back-button-text":"Regresar"}})],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/user-admin-by-id.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_admin_by_id,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_user_admin_by_id = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1Hyf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-alt1.688d2b2.png";

/***/ }),

/***/ "1W7+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1Wy7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./src/utils/storageCleaner.js
var storageCleaner = __webpack_require__("Rqrm");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/codigo-usuario.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var codigo_usuario = ({
  name: 'codigo-usuario',
  data: function data() {
    delete localStorage.token;
    delete localStorage.user;
    storageCleaner["default"].cleanStorage();
    return {
      msg: 'Welcome to Your Vue.js App',
      hidePassword: true,
      errorMessage: '',
      isLoading: false,
      brandMessage: {
        title: 'Y tú ¿Cuánto vendiste ayer?',
        subtitle: 'Analiza lo mejor. Todo es realidad con nosotros'
      }
    };
  },

  methods: {
    logIn: function logIn(e) {
      var _this = this;

      e.preventDefault();
      this.errorMessage = '';
      this.isLoading = true;

      var user = document.getElementById('txtUser').value;
      var password = document.getElementById('txtPassword').value;
      auth["default"].login({
        context: this,
        creds: { user: user, password: password },
        onSuccess: function onSuccess(response) {
          _this.isLoading = false;
          console.log(response.data.user);
          if (response.data.user.forceChangePassword === 1) {
            response.data.status = '1';
            response.data.message = 'OK';
            _this.$router.push({ name: 'UserAccount', params: { showStrategioAppBar: false } });
          } else {
            if (response.data.user.userType === 'SUPERVISOR') {
              _this.$router.push('/supervise/dashboard');
            } else {
              // this.$router.push('/0')
              _this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              });
            }
          }
        },
        onError: function onError(error) {
          _this.isLoading = false;
          var errMessage = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            errMessage = error.response.data.message;
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            errMessage = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            errMessage = 'Error desconocido: ' + error.errorMessage;
          }
          _this.errorMessage = errMessage;
          // console.log(error.config)
        }
      });
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f427da3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/codigo-usuario.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pa-6",style:([
    {'background-image': ("url('" + (__webpack_require__("dkhU")) + "')")},
    {'background-repeat': 'no-repeat'},
    {'background-size': 'cover'}
    ])},[_c('v-container',{attrs:{"id":"codigo-usuario","fluid":""}},[_c('v-row',{staticClass:"py-md-4 ma-lg-4",attrs:{"align-content":"center"}},[_c('v-col',[_c('v-img',{attrs:{"width":"253px","height":"auto","src":__webpack_require__("KaMS")}})],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8"}),_vm._v(" "),_c('v-row',{staticClass:"pt--md-16 ma-5"},[_c('v-col',{staticClass:"py-3"},[_c('div',{staticClass:"text-sm-left",attrs:{"id":"brand-message-title"}},[_vm._v("\n            "+_vm._s(_vm.brandMessage.title)+"\n          ")]),_vm._v(" "),_c('div',{attrs:{"id":"brand-message-subtitle"}},[_vm._v("\n            "+_vm._s(_vm.brandMessage.subtitle)+"\n          ")])])],1)],1)],1),_vm._v(" "),_c('v-col',{style:([
    {'background-color': "#FBFBFB"}      
    ])},[_c('v-container',{attrs:{"id":"codigo-usuario","fluid":""}},[_c('v-col',[_c('v-row',{staticClass:"py-md-4 ma-lg-3",attrs:{"align-content":"center"}},[_c('v-col',[_c('v-img',{attrs:{"width":"235px","height":"auto","src":__webpack_require__("KDbQ")}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"align-content":"center"}},[_c('v-col',[_c('v-form',{on:{"submit":function($event){return _vm.logIn($event)}}},[_c('v-card',{staticClass:"pa-lg-16 mx-lg-16",staticStyle:{"padding":"6px!important"},attrs:{"elevation":"0","color":"#FBFBFB"}},[_c('v-row',{staticClass:"hidden-xs-only"},[_c('v-col',{attrs:{"cols":"8","align-self":"center"}},[_c('v-card-text',{staticClass:"text-h3",staticStyle:{"color":"#25235F","-webkit-text-stroke":"0.8px","height":"auto","font-size":"11vw","font-weight":"bold"}},[_vm._v("\n                   Restaura tu contraseña\n                    ")])],1),_vm._v(" "),_c('v-col',{attrs:{"align-self":"center","cols":"3","offset-lg":"1"}},[_c('v-img',{attrs:{"width":"83.83px","height":"auto","src":__webpack_require__("pCjg")}})],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"21px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Usuario\n                    ")]),_vm._v(" "),_c('v-text-field',{staticClass:"pa-xs-0 txtUser",staticStyle:{"margin-bottom":"-20px"},attrs:{"id":"txtUser","name":"txtUser","label":"Escribe tu usuario","prepend-inner-icon":"person_outline","outlined":"","background-color":"#FFFFFF"}})],1),_vm._v(" "),_c('div',{staticClass:"strategio-login-error-message"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage)+"\n                  ")]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.restaurar_cont}},[_vm._v("Olvidaste tu contraseña?")])]),_vm._v(" "),_c('div',[_c('v-btn',{staticClass:"mx-0",staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"18px"},attrs:{"block":"","large":"","rounded":"","depressed":"","type":"submit","loading":_vm.isLoading,"disabled":_vm.isLoading},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("\n                      Enviar  \n                    ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"18px"},attrs:{"block":"","large":"","rounded":"","depressed":"","type":"submit","loading":_vm.isLoading,"disabled":_vm.isLoading},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("\n                      Volver  \n                    ")])],1)])],1)],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8"}),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8"})],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"px-4 mb-2 text-right",staticStyle:{"font-size":"10px","color":"black"},attrs:{"color":"transparent"}},[_c('v-col',[_vm._v("\n        © TODOS LOS DERECHOS RESERVADOS - VIDA SOFTWARE\n      ")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/codigo-usuario.vue
function injectStyle (context) {
  __webpack_require__("eHOx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  codigo_usuario,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_codigo_usuario = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1iFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/folder-form-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var folder_form_dialog = ({
  name: 'folder-form-dialog',
  data: function data() {
    return {
      dialog: false,
      // dialog: true,
      folderID: '',
      folderName: '',
      parentName: '',
      containedBy: '',
      structureID: '',
      isNew: false,
      // isNew: true,
      enterInFolder: false,
      heritable: false,
      toBeHeritable: false,

      inherited: 0,
      structureItemInheritance: false,

      heritableFolders: [],
      heritableSelected: '',

      isLoadingOK: false
      // isLoadingReplication: false
    };
  },

  computed: {
    toBeHeritableFinal: {
      set: function set(newVal) {
        this.toBeHeritable = newVal;
      },
      get: function get() {
        return (!!this.heritable || this.toBeHeritable) && !this.heritableSelected;
      }
    }
  },
  methods: {
    hasStructureItemInheritance: function hasStructureItemInheritance() {
      // console.log('???', 'containedBy', this.containedBy)
      // console.log('???', `containedBy.startsWith('HI')`, this.containedBy.startsWith('HI'))
      return this.containedBy.startsWith('HI');
    },
    sendNewData: function sendNewData() {
      var _this = this;

      this.isLoadingOK = true;
      if (this.isNew) {
        if (this.toBeHeritableFinal) {
          // Preguntar si estoy en root o no
          // eslint-disable-next-line
          if (this.containedBy == 0) {
            // alert('hmm')
            structureStorage["default"].createHeritableStructure({
              data: {
                folderName: this.folderName
              },
              onSuccess: function onSuccess() {
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Estructura heredable creada exitosamente', itsOk: true });

                eventBus["default"].$emit('reload-items');
                _this.dialog = false;
                _this.isLoadingOK = false;
              },
              onError: function onError(error) {
                console.warn('Error creando estructura heredable: ', error);
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Error creando estructura heredable', itsOk: false });
                _this.isLoadingOK = false;
              }
            });
          } else {
            // CHEQUEAR, NO DEBE HACER HEREDABLES
            //  A LAS CARPETAS HIJAS
            structureStorage["default"].createHeritableItem({
              data: {
                structureID: this.structureID,
                itemName: this.folderName,
                description: '',
                labels: '',
                isFolder: true,
                containedBy: this.containedBy,
                structureItemInheritance: this.hasStructureItemInheritance()
              },
              onSuccess: function onSuccess(result) {
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Folder heredable creado exitosamente', itsOk: true });

                eventBus["default"].$emit('reload-items');
                _this.dialog = false;
                _this.isLoadingOK = false;
              },
              onError: function onError(error) {
                console.warn('Error creando folder heredable: ', error);
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Error creando folder heredable', itsOk: false });
                _this.isLoadingOK = false;
              }
            });
          }
        } else {
          // Se podría usar esa variable en algún momento, u otro caso
          // eslint-disable-next-line
          var _ref = /^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1) || [false, 0],
              _ref2 = slicedToArray_default()(_ref, 2),
              structureItemInheritanceFlag = _ref2[0],
              structureID = _ref2[1];

          if (this.heritableSelected) {
            // Si he seleccionado alguna estr.
            /* // console.log({
              structureID: 'hmm:' + structureID,
              folderName: 'hmm:' + this.folderName,
              containedBy: 'hmm:' + this.containedBy
            }) */
            structureStorage["default"].replicateStructure({
              data: {
                structureID: structureID,
                folderName: this.folderName,
                containedBy: this.containedBy
              },
              onSuccess: function onSuccess(result) {
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Estructura replicada exitosamente', itsOk: true });

                eventBus["default"].$emit('reload-items');
                _this.dialog = false;
                _this.isLoadingOK = false;
              },
              onError: function onError(error) {
                console.warn('Error replicando estructura: ', error);
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'Error replicando estructura', itsOk: false });
                _this.isLoadingOK = false;
              }
            });
          } else {
            // Con esto creo un folder que esta vinculado a una estructura
            //  pero que no lo replica, el cual es el propósito de esto.
            reportsStorage["default"].addItem({
              data: {
                itemName: this.folderName,
                containedBy: this.containedBy,
                isFolder: true,
                // Se pueden enviar por defecto ya que
                //  no hay otra forma en este caso,
                //  si es sin heredar se pueden quitar
                /* inherited: inherited,
                structureItemInheritance: structureItemInheritance */
                inherited: 0,
                structureItemInheritance: false
              },
              onSuccess: function onSuccess(response) {
                // console.log('this.enterInFolder', this.enterInFolder)
                if (_this.enterInFolder) {
                  // console.log('Routing in')
                  _this.$router.push('/' + response.data.item.itemID);
                } else {
                  // console.log('No routing')
                  // emit to routes/main-page.vue
                  eventBus["default"].$emit('reload-items');
                }
                _this.dialog = false;
                _this.isLoadingOK = false;
              },
              onError: function onError(error) {
                console.warn('No pudo crearse carpeta', error);
                eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha podido crear la carpeta', itsOk: false });
                _this.isLoadingOK = false;
              }
            });
          }
        }
      } else {
        if (this.toBeHeritableFinal) {
          structureStorage["default"].updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: true,
              itemID: this.folderID,
              itemName: this.folderName,
              description: '',
              labels: '',
              imageUrl: '',
              removed: false
            },
            onSuccess: function onSuccess() {
              _this.enterInFolder && _this.$router.push('/' + _this.folderID);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha actualizado el reporte heredable correctamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;
              _this.isLoadingOK = false;
            },
            onError: function onError(error) {
              console.warn('Error updating a heritable report: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema actualizando el reporte heredable', itsOk: false });
              _this.isLoadingOK = false;
            }
          });
        } else {
          var _ref3 = /^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1) || [false, 0],
              _ref4 = slicedToArray_default()(_ref3, 2),
              structureItemInheritance = _ref4[0],
              inherited = _ref4[1];

          var wasPossible = reportsStorage["default"].editItem({ itemID: this.folderID }, {
            itemName: this.folderName,
            isFolder: true,
            // inherited: inherited,
            // structureItemInheritance: structureItemInheritance
            inherited: inherited,
            structureItemInheritance: structureItemInheritance && structureItemInheritance.startsWith('HI')
          }, {
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha actualizado el folder', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items', {});
              _this.dialog = false;
              _this.isLoadingOK = false;
            },
            onError: function onError(error) {
              console.warn('Error updating normal folder: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema actualizando el folder', itsOk: false });
              _this.isLoadingOK = false;
            }
          });

          if (wasPossible && this.enterInFolder) {
            this.$router.push('/' + this.folderID);
          }
        }
      }
    },
    replicateFolder: function replicateFolder() {
      var _this2 = this;

      // emits to: components/dialogs/replicate-folder-dialog
      eventBus["default"].$emit('open-replicate-folder-dialog', {
        itemID: this.folderID,
        originalName: this.folderName,
        onSuccess: function onSuccess() {
          _this2.dialog = false;
        }
      });
      /* this.isLoadingReplication = true
      structureStorage.replicateFolder({
        data: {
          itemID: this.folderID
        },
        onSuccess: () => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Se ha creado el folder base correctamente', itsOk: true})
          // emit to routes/main-page.vue
          eventBus.$emit('reload-items', {})
          this.dialog = false
          this.isLoadingReplication = false
        },
        onError: (error) => {
          console.warn('Error replicating folder: ', error)
          eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema creando el folder base', itsOk: false})
          this.isLoadingReplication = false
        }
      }) */
    }
  },
  created: function created() {
    var _this3 = this;

    eventBus["default"].$off('open-folder-form');
    eventBus["default"].$on('open-folder-form', function (item, heritableFolders) {
      structureStorage["default"].getHeritableItems({
        onSuccess: function onSuccess(heritableFolders) {
          _this3.heritableFolders = Object(lodash["filter"])(heritableFolders, function (item) {
            // eslint-disable-next-line
            return item.isFolder === 1 && item.containedBy == 0;
          });
        }
      });
      _this3.toBeHeritable = false;

      _this3.heritable = item.heritable;
      _this3.isNew = !('itemID' in item);
      _this3.containedBy = item.containedBy;
      _this3.folderID = item.itemID;
      _this3.folderName = item.itemName;
      // this.parentName = item.parentName
      _this3.structureID = item.structureID || item.origin;

      _this3.inherited = item.inherited;
      _this3.structureItemInheritance = item.structureItemInheritance;

      _this3.heritableSelected = _this3.structureItemInheritance !== undefined ? (_this3.structureItemInheritance ? 'HI' : 'H') + _this3.inherited : '';

      _this3.dialog = true;
      _this3.isLoadingOK = false;
      // this.isLoadingReplication = false
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36855d44","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/folder-form-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v(_vm._s(_vm.isNew ? 'Crear carpeta' : 'Editar carpeta')+" "+_vm._s(_vm.heritable ? 'base' : ''))]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[(_vm.heritable)?_c('v-select',{attrs:{"clearable":"","item-text":"itemName","item-value":"itemID","items":_vm.heritableFolders,"label":_vm.isNew ? 'Seleccione estructura' : 'Vincular a estructura'},model:{value:(_vm.heritableSelected),callback:function ($$v) {_vm.heritableSelected=$$v},expression:"heritableSelected"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"newFolderName","label":"Nuevo nombre de la carpeta","id":"newFolderName","clearable":""},model:{value:(_vm.folderName),callback:function ($$v) {_vm.folderName=$$v},expression:"folderName"}}),_vm._v(" "),_c('v-checkbox',{staticStyle:{"color":"#01C0D1 !important"},attrs:{"label":"Entrar a la carpeta"},model:{value:(_vm.enterInFolder),callback:function ($$v) {_vm.enterInFolder=$$v},expression:"enterInFolder"}}),_vm._v(" "),(_vm.isNew && (_vm.$route.params.folderID == 0 || String(_vm.$route.params.folderID).startsWith('H')))?_c('v-checkbox',{staticStyle:{"color":"#01C0D1 !important"},attrs:{"label":"Heredable","disabled":!!_vm.heritable || !!_vm.heritableSelected},model:{value:(_vm.toBeHeritableFinal),callback:function ($$v) {_vm.toBeHeritableFinal=$$v},expression:"toBeHeritableFinal"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',[(true)?_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"grey lighten-3","disabled":_vm.isLoadingOK},nativeOn:{"click":function($event){return _vm.replicateFolder.apply(null, arguments)}}},[_vm._v("Crear estructura")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","dark":"","depressed":"","rounded":"","color":"error"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","dark":"","depressed":"","rounded":"","color":"success","loading":_vm.isLoadingOK},nativeOn:{"click":function($event){return _vm.sendNewData()}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/folder-form-dialog.vue
function injectStyle (context) {
  __webpack_require__("UHR5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  folder_form_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_folder_form_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1wbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var vueInstance = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
var introBus = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  getVueInstance: function getVueInstance() {
    return vueInstance;
  },
  getIntroBus: function getIntroBus() {
    return introBus;
  },
  setIntroBus: function setIntroBus(bus) {
    introBus = bus;
  }
});

/***/ }),

/***/ "28sX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2LHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Lcq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Z1F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Light.1be8e55.otf";

/***/ }),

/***/ "3Dow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/adminStorage.js
var adminStorage = __webpack_require__("6orz");

// EXTERNAL MODULE: ./src/components/dialogs/show-reports-permisions-dialog.vue + 2 modules
var show_reports_permisions_dialog = __webpack_require__("/LT7");

// EXTERNAL MODULE: ./src/components/dialogs/are-you-sure-dialog.vue + 2 modules
var are_you_sure_dialog = __webpack_require__("u9Gr");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/user-form.bk.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var user_form_bk = ({
  name: 'user-form',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('show-updated-Reports');
    eventBus["default"].$on('show-updated-Reports', function (data) {
      _this.loadedAssignedReports = true;
      _this.assignedReports = data;
    });
  },
  mounted: function mounted() {
    // emits to: /components/header-bar/strategio-app-bar.vue
    eventBus["default"].$emit('enable-tutorial-button');

    eventBus["default"].$off('start-user-form-tutorial');
    eventBus["default"].$on('start-user-form-tutorial', function () {
      // Existen varias versiones del formulario
      // Preguntar en que ruta nos encontramos
      var intro = introBus["default"].getIntroBus();
      intro.addSteps([{
        element: '#profile-layout',
        intro: 'En esta sección uno podrá alterar el perfil del usuario.'
      }, {
        element: '#security-layout',
        intro: 'Aquí se podrá crear o modificar la contraseña.'
      }, {
        element: '#access-layout',
        intro: 'Finalmente, en esta sección se puede manipular el nivel de permisos con el que el usuario contará'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));
      intro.start();
    });
  },
  data: function data() {
    var _this2 = this;

    return {
      password: '',
      confirmPassword: '',
      hidePassword: true,
      canChangePassword: false,
      showReportsDialog: false,
      items: [{
        type: 'NORMAL',
        name: 'Normal',
        description: 'Acceso a perfil, visualizador, favoritos y tutorial'
      }, {
        type: 'GLOBAL',
        name: 'Global',
        description: 'Acceso NORMAL, más acceso a todos los reportes'
      }],
      assignedReports: [],
      loadedAssignedReports: false,
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage: 'Cerrar',
      snackActionFunction: function snackActionFunction() {
        _this2.snackbar = false;
      }
    };
  },

  computed: {
    hintMessage: function hintMessage() {
      var _this3 = this;

      // return find(this.items, (item) => item.type === this.userData.userType).description
      return Object(lodash["find"])(this.items, function (item) {
        return item.type === _this3.userData.userType;
      }) ? Object(lodash["find"])(this.items, function (item) {
        return item.type === _this3.userData.userType;
      }).description : '';
    }
  },
  methods: {
    openSnackBar: function openSnackBar(message, itsOk, snackAction) {
      eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: itsOk, snackAction: snackAction });
    },
    validatePassword: function validatePassword() {
      this.canChangePassword = this.password === this.confirmPassword && this.password.length >= 6;
      return this.canChangePassword || 'Los passwords deben ser iguales';
    },
    updateUserProfile: function updateUserProfile() {
      var _this4 = this;

      if (this.isMyAccount) {
        userStorage["default"].updateUserInfo({
          data: this.userData,
          onSuccess: function onSuccess() {
            return _this4.openSnackBar('Perfil actualizado', true);
          },
          onError: function onError() {
            return _this4.openSnackBar('Error al actualizar perfil', false);
          }
        });
      } else {
        adminStorage["default"].updateUserInfo({
          data: this.userData,
          onSuccess: function onSuccess() {
            return _this4.openSnackBar('Perfil actualizado', true);
          },
          onError: function onError() {
            return _this4.openSnackBar('Error al actualizar perfil', false);
          }
        });
      }
    },
    updateUserPassword: function updateUserPassword() {
      var _this5 = this;

      if (this.isMyAccount) {
        userStorage["default"].updatePassword({
          newPassword: this.password,
          onSuccess: function onSuccess() {
            return _this5.openSnackBar('Password cambiado', true);
          },
          onError: function onError() {
            return _this5.openSnackBar('Error al cambiar de password', false);
          }
        });
      } else {
        adminStorage["default"].updatePassword({
          userID: this.userData.userID,
          newPassword: this.password,
          onSuccess: function onSuccess() {
            return _this5.openSnackBar('Password cambiado', true);
          },
          onError: function onError() {
            return _this5.openSnackBar('Error al cambiar de password', false);
          }
        });
      }
    },
    updateUserAccessLevel: function updateUserAccessLevel() {
      var _this6 = this;

      adminStorage["default"].updateAccessLevel({
        userID: this.userData.userID,
        newUserType: this.userData.userType,
        isEnabled: this.userData.isEnabled,
        onSuccess: function onSuccess() {
          return _this6.openSnackBar('Nivel de acceso actualizado', true);
        },
        onError: function onError() {
          return _this6.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false);
        }
      });
    },
    createUser: function createUser() {
      var _this7 = this;

      adminStorage["default"].createUser({
        userData: extends_default()({}, this.userData, { password: this.password, permissions: this.assignedReports }),
        onSuccess: function onSuccess(response) {
          _this7.password = '';
          _this7.confirmPassword = '';
          _this7.canChangePassword = false;
          // eslint-disable-next-line
          if (response.data.status == 1 && !['SUPERVISOR', 'GLOBAL'].includes(_this7.userData.userType)) {
            _this7.openSnackBar('El usuario ha sido creado pero no puede ver reportes', 'warning', {
              title: 'Ver usuario',
              action: function action() {
                _this7.$router.push('/user/admin/' + response.data.userID);
              }
            });
          } else {
            _this7.openSnackBar('El usuario ha sido creado', true, {
              title: 'Ver usuario',
              action: function action() {
                _this7.$router.push('/user/admin/' + response.data.userID);
              }
            });
          }
        },
        onError: function onError(error) {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            _this7.password = '';
            _this7.confirmPassword = '';
            _this7.canChangePassword = false;
            _this7.openSnackBar('El codigo o email del usuario es duplicado', false);
          } else {
            _this7.openSnackBar('Ha habido un error creando el usuario', false);
          }
        }
      });
    },
    goBack: function goBack() {
      var _this8 = this;

      if (this.isNewUser) {
        eventBus["default"].$emit('open-are-you-sure-dialog', {
          title: '¿Seguro que desea salir?',
          message: 'Los datos ingresados no se guardaran',
          onOk: function onOk() {
            _this8.$router.push(_this8.parentRoute);
          }
        });
      } else {
        this.$router.push(this.parentRoute);
      }
    }
  },
  props: {
    userData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isMyAccount: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    itemsTree: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parentRoute: String,
    backButtonText: String,
    isNewUser: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    ShowReportsPermisionsDialog: show_reports_permisions_dialog["default"],
    CustomSnackBar: custom_snack_bar["default"],
    AreYouSureDialog: are_you_sure_dialog["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7124da92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/user-form.bk.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',[_c('v-btn',{attrs:{"icon":"","flat":"","color":"grey"},on:{"click":function($event){return _vm.goBack()}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("chevron_left")])],1),_vm._v(" "),_c('span',{staticClass:"strategio-user-form-return-button",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("\n                    "+_vm._s(_vm.backButtonText)+"\n                  ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"id":"profile-layout","row":"","wrap":""}},[_c('v-flex',{staticClass:"strategio-my-account-sub-division",attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n                Perfil\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"id":"txtUserName","name":"txtUserName","label":"Nombre","prepend-icon":"person_outline"},model:{value:(_vm.userData.name),callback:function ($$v) {_vm.$set(_vm.userData, "name", $$v)},expression:"userData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":"","id":"txtDescription","name":"txtDescription","label":"Cargo o descripcion","prepend-icon":"business_center"},model:{value:(_vm.userData.description),callback:function ($$v) {_vm.$set(_vm.userData, "description", $$v)},expression:"userData.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"id":"txtMail","name":"txtMail","label":"Correo o codigo de usuario","prepend-icon":"mail_outline"},model:{value:(_vm.userData.mail),callback:function ($$v) {_vm.$set(_vm.userData, "mail", $$v)},expression:"userData.mail"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"id":"txtPhone","name":"txtPhone","label":"Telefono","prepend-icon":"phone"},model:{value:(_vm.userData.phone),callback:function ($$v) {_vm.$set(_vm.userData, "phone", $$v)},expression:"userData.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","x12":""}},[_c('v-text-field',{attrs:{"id":"txtProfileImageUrl","name":"txtProfileImageUrl","label":"URL de la imagen de perfil","prepend-icon":"link"},model:{value:(_vm.userData.profileImageUrl),callback:function ($$v) {_vm.$set(_vm.userData, "profileImageUrl", $$v)},expression:"userData.profileImageUrl"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.updateUserProfile()}}},[_vm._v("Actualizar perfil")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"id":"security-layout","row":"","wrap":""}},[_c('v-flex',{staticClass:"strategio-my-account-sub-division",attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n                Seguridad "),_c('br'),_vm._v(" "),_c('v-subheader',[_vm._v("El password debe contener al menos 6 caracteres")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"id":"txtPassword","name":"txtPassword","label":"Nuevo password","prepend-icon":"lock_outline","append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.hidePassword = !_vm.hidePassword); },"type":_vm.hidePassword ? 'password' : 'text',"rules":[function (v) { return v.length >= 6 || 'Minimo 6 characters'; }],"counter":6},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('v-text-field',{attrs:{"id":"txtConfirmPassword","name":"txtConfirmPassword","label":"Confirmar password","prepend-icon":"lock_outline","rules":[_vm.validatePassword()],"append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.hidePassword = !_vm.hidePassword); },"type":_vm.hidePassword ? 'password' : 'text'},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canChangePassword || _vm.password === '',"color":"primary"},on:{"click":function($event){return _vm.updateUserPassword()}}},[_vm._v("\n                    Cambiar password\n                  ")])],1)],1)],1),_vm._v(" "),(!_vm.isMyAccount || _vm.isNewUser)?_c('v-layout',{attrs:{"id":"access-layout","row":"","wrap":""}},[(!_vm.isMyAccount)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-flex',{staticClass:"strategio-my-account-sub-division",attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n                  Acceso\n                ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',[_c('v-checkbox',{attrs:{"label":"Habilitado","color":"primary"},model:{value:(_vm.userData.isEnabled),callback:function ($$v) {_vm.$set(_vm.userData, "isEnabled", $$v)},expression:"userData.isEnabled"}}),_vm._v(" "),_c('v-select',{attrs:{"bottom":"","item-text":"name","item-value":"type","items":_vm.items,"hint":_vm.hintMessage,"persistent-hint":"","label":"Tipo de usuario"},scopedSlots:_vm._u([{key:"item",fn:function(data){return _c('v-tooltip',{staticClass:"layout column",attrs:{"top":""}},[_c('v-flex',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                          "+_vm._s(data.item.name)+"\n                        ")]),_vm._v(" "),_c('v-flex',[_vm._v(_vm._s(data.item.description))])],1)}}],null,false,2008416422),model:{value:(_vm.userData.userType),callback:function ($$v) {_vm.$set(_vm.userData, "userType", $$v)},expression:"userData.userType"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.updateUserAccessLevel()}}},[_vm._v("\n                      Actualizar niveles de acceso\n                    ")])],1)],1),_vm._v(" "),(_vm.userData.userType === 'NORMAL')?_c('v-flex',{staticClass:"strategio-my-account-sub-division",attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_vm._v("\n                  Permisos "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedAssignedReports),expression:"loadedAssignedReports"}]}),_vm._v(" "),_c('v-subheader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedAssignedReports),expression:"loadedAssignedReports"}]},[_vm._v("Se han asignado   "),_c('b',[_vm._v(_vm._s(_vm.assignedReports.length))]),_vm._v("  items a este usuario ")])],1):_vm._e(),_vm._v(" "),(_vm.userData.userType === 'NORMAL')?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('show-reports-permisions-dialog',{attrs:{"user-id":_vm.userData.userID,"items-data":_vm.itemsTree,"is-new-user":this.isNewUser}})],1):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(this.isNewUser),expression:"this.isNewUser"}],attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canChangePassword || _vm.password === '',"color":"primary"},on:{"click":function($event){return _vm.createUser()}}},[_vm._v("\n                    Crear usuario\n                  ")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('are-you-sure-dialog')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/users/user-form.bk.vue
function injectStyle (context) {
  __webpack_require__("77w4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_form_bk,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_user_form_bk = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3GQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/adminStorage.js
var adminStorage = __webpack_require__("6orz");

// EXTERNAL MODULE: ./src/components/dialogs/show-reports-permisions-dialog.vue + 2 modules
var show_reports_permisions_dialog = __webpack_require__("/LT7");

// EXTERNAL MODULE: ./src/components/dialogs/are-you-sure-dialog.vue + 2 modules
var are_you_sure_dialog = __webpack_require__("u9Gr");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/user-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var user_form = ({
  name: 'user-form',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('show-updated-Reports');
    eventBus["default"].$on('show-updated-Reports', function (data) {
      _this.loadedAssignedReports = true;
      _this.assignedReports = data;
    });
  },
  mounted: function mounted() {
    // emits to: /components/header-bar/strategio-app-bar.vue
    eventBus["default"].$emit('enable-tutorial-button');

    eventBus["default"].$off('start-user-form-tutorial');
    eventBus["default"].$on('start-user-form-tutorial', function () {
      // Existen varias versiones del formulario
      // Preguntar en que ruta nos encontramos
      var intro = introBus["default"].getIntroBus();
      intro.addSteps([{
        element: '#profile-layout',
        intro: 'En esta sección uno podrá alterar el perfil del usuario.'
      }, {
        element: '#security-layout',
        intro: 'Aquí se podrá crear o modificar la contraseña.'
      }, {
        element: '#access-layout',
        intro: 'Finalmente, en esta sección se puede manipular el nivel de permisos con el que el usuario contará'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));
      intro.start();
    });
  },
  data: function data() {
    var _this2 = this;

    var userInfo = userStorage["default"].getUserInfo();
    var itemList = [{
      type: 'NORMAL',
      name: 'Normal',
      description: 'Acceso a perfil, visualizador, favoritos y tutorial'
    }, {
      type: 'GLOBAL',
      name: 'Global',
      description: 'Acceso NORMAL, más acceso a todos los reportes'
    }];
    if (userInfo.userType === 'ADMIN') {
      itemList.push({
        type: 'SUPERVISOR',
        name: 'Supervisor',
        description: 'Acceso GLOBAL, más herramientas administrativas'
      });
    }
    return {
      password: '',
      confirmPassword: '',
      hidePassword: true,
      canChangePassword: false,
      showReportsDialog: false,
      items: itemList,
      assignedReports: [],
      loadedAssignedReports: false,
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage: 'Cerrar',
      snackActionFunction: function snackActionFunction() {
        _this2.snackbar = false;
      }
    };
  },

  computed: {
    hintMessage: function hintMessage() {
      var _this3 = this;

      // return find(this.items, (item) => item.type === this.userData.userType).description
      return Object(lodash["find"])(this.items, function (item) {
        return item.type === _this3.userData.userType;
      }) ? Object(lodash["find"])(this.items, function (item) {
        return item.type === _this3.userData.userType;
      }).description : '';
    }
  },
  methods: {
    openSnackBar: function openSnackBar(message, itsOk, snackAction) {
      eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: itsOk, snackAction: snackAction });
    },
    validatePassword: function validatePassword() {
      this.canChangePassword = this.password === this.confirmPassword && this.password.length >= 6;
      return this.canChangePassword || 'Los passwords deben ser iguales';
    },
    updateUserProfile: function updateUserProfile() {
      var _this4 = this;

      if (this.isMyAccount) {
        userStorage["default"].updateUserInfo({
          data: this.userData,
          onSuccess: function onSuccess() {
            return _this4.openSnackBar('Perfil actualizado', true);
          },
          onError: function onError() {
            return _this4.openSnackBar('Error al actualizar perfil', false);
          }
        });
      } else {
        adminStorage["default"].updateUserInfo({
          data: this.userData,
          onSuccess: function onSuccess() {
            return _this4.openSnackBar('Perfil actualizado', true);
          },
          onError: function onError() {
            return _this4.openSnackBar('Error al actualizar perfil', false);
          }
        });
      }
    },
    updateUserPassword: function updateUserPassword() {
      var _this5 = this;

      if (this.isMyAccount) {
        userStorage["default"].updatePassword({
          newPassword: this.password,
          onSuccess: function onSuccess() {
            _this5.openSnackBar('Password cambiado', true);
            // console.log(this.showStrategioAppBar)
            if (!_this5.showStrategioAppBar) {
              _this5.$router.push('/0');
            }
          },
          onError: function onError() {
            return _this5.openSnackBar('Error al cambiar de password', false);
          }
        });
      } else {
        adminStorage["default"].updatePassword({
          userID: this.userData.userID,
          newPassword: this.password,
          onSuccess: function onSuccess() {
            _this5.openSnackBar('Password cambiado', true);
            if (!_this5.showStrategioAppBar) {
              _this5.$router.push('/0');
            }
          },
          onError: function onError() {
            return _this5.openSnackBar('Error al cambiar de password', false);
          }
        });
      }
    },
    updateUserAccessLevel: function updateUserAccessLevel() {
      var _this6 = this;

      adminStorage["default"].updateAccessLevel({
        userID: this.userData.userID,
        newUserType: this.userData.userType,
        isEnabled: this.userData.isEnabled,
        onSuccess: function onSuccess() {
          return _this6.openSnackBar('Nivel de acceso actualizado', true);
        },
        onError: function onError() {
          return _this6.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false);
        }
      });
    },
    createUser: function createUser() {
      var _this7 = this;

      adminStorage["default"].createUser({
        userData: extends_default()({}, this.userData, { password: this.password, permissions: this.assignedReports }),
        onSuccess: function onSuccess(response) {
          _this7.password = '';
          _this7.confirmPassword = '';
          _this7.canChangePassword = false;
          // eslint-disable-next-line
          if (response.data.status == 1 && !['SUPERVISOR', 'GLOBAL'].includes(_this7.userData.userType)) {
            _this7.openSnackBar('El usuario ha sido creado pero no puede ver reportes', 'warning', {
              title: 'Ver usuario',
              action: function action() {
                _this7.$router.push('/user/admin/' + response.data.userID);
              }
            });
          } else {
            _this7.openSnackBar('El usuario ha sido creado', true, {
              title: 'Ver usuario',
              action: function action() {
                _this7.$router.push('/user/admin/' + response.data.userID);
              }
            });
          }
        },
        onError: function onError(error) {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            _this7.password = '';
            _this7.confirmPassword = '';
            _this7.canChangePassword = false;
            _this7.openSnackBar('El codigo o email del usuario es duplicado', false);
          } else {
            _this7.openSnackBar('Ha habido un error creando el usuario', false);
          }
        }
      });
    },
    goBack: function goBack() {
      var _this8 = this;

      if (this.isNewUser) {
        eventBus["default"].$emit('open-are-you-sure-dialog', {
          title: '¿Seguro que desea salir?',
          message: 'Los datos ingresados no se guardaran',
          onOk: function onOk() {
            _this8.$router.push(_this8.parentRoute);
          }
        });
      } else {
        this.$router.push(this.parentRoute);
      }
    }
  },
  props: {
    userData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isMyAccount: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    itemsTree: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parentRoute: String,
    backButtonText: String,
    isNewUser: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showStrategioAppBar: {
      type: Boolean, // Adjust the type to match the variable's type in "user" Biondo was here
      default: function _default() {
        return true;
      }
    }
  },
  components: {
    ShowReportsPermisionsDialog: show_reports_permisions_dialog["default"],
    CustomSnackBar: custom_snack_bar["default"],
    AreYouSureDialog: are_you_sure_dialog["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4e13c2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/user-form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows",attrs:{"id":"profile-layout"}},[_c('v-col',{attrs:{"cols":"5","align-self":"center"}},[_c('v-icon',{staticStyle:{"font-size":"52px","padding-bottom":"30px","padding-right":"10px"},attrs:{"color":'black'}},[_vm._v("ico-icon-user")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n        Mi Perfil\n      ")])],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-5",staticStyle:{"border-radius":"10px !important"},attrs:{"elevation":"0"}},[_c('v-card-text',{staticClass:"pl-12 pt-10"},[_c('span',{staticStyle:{"color":"#25235F","font-size":"35px"}},[_vm._v("Datos del Usuario")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"px-4 ma-3",attrs:{"cols":"12","md":"5","align-self":"center"}},[_c('v-card-text',{staticClass:"pl-0",staticStyle:{"padding-bottom":"22px"}},[_c('v-icon',{staticStyle:{"padding-right":"12px"},attrs:{"color":"'black'"}},[_vm._v("ico-icon-mail")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"'Open Sans'","color":"black","font-size":"18px","font-weight":"bold"}},[_vm._v("\n                  Correo o código de usuario")])],1),_vm._v(" "),_c('v-text-field',{staticStyle:{"width":"424px"},attrs:{"solo":"","id":"txtMail","name":"txtMail","label":"Correo o código de usuario","background-color":"#E0DCDC"},model:{value:(_vm.userData.mail),callback:function ($$v) {_vm.$set(_vm.userData, "mail", $$v)},expression:"userData.mail"}})],1),_vm._v(" "),_c('v-col',{staticClass:"px-4 ma-3",attrs:{"cols":"12","md":"6","align-self":"center"}},[_c('v-card-text',{staticClass:"pl-0",staticStyle:{"padding-bottom":"22px"}},[_c('v-icon',{staticStyle:{"padding-right":"12px"},attrs:{"color":"black"}},[_vm._v("ico-icon-user")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"'Open Sans'","color":"black","font-size":"18px","font-weight":"bold"}},[_vm._v("Nombres y Apellidos")])],1),_vm._v(" "),_c('v-text-field',{staticClass:"pt-0",staticStyle:{"width":"424px"},attrs:{"single-line":"","id":"txtUserName","name":"txtUserName","label":"Nombre","append-icon":"ico-icon-edit"},model:{value:(_vm.userData.name),callback:function ($$v) {_vm.$set(_vm.userData, "name", $$v)},expression:"userData.name"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{staticClass:"px-4 ma-3",attrs:{"cols":"12","md":"5"}},[_c('v-card-text',{staticClass:"pl-0",staticStyle:{"padding-bottom":"22px"}},[_c('v-icon',{staticStyle:{"padding-right":"12px"},attrs:{"color":"'black'"}},[_vm._v("ico-icon-company")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"'Open Sans'","color":"black","font-size":"18px","font-weight":"bold"}},[_vm._v("\n                    Compañía")])],1),_vm._v(" "),_c('v-text-field',{staticStyle:{"width":"424px"},attrs:{"solo":"","id":"txtDescription","name":"txtDescription","label":"Compañía","hide-details":"True","background-color":"#E0DCDC"},model:{value:(_vm.userData.company),callback:function ($$v) {_vm.$set(_vm.userData, "company", $$v)},expression:"userData.company"}})],1),_vm._v(" "),_c('v-col',{staticClass:"px-4 ma-3",attrs:{"cols":"12","md":"5","align-self":"center"}},[_c('v-card-text',{staticClass:"pl-0",staticStyle:{"padding-bottom":"22px"}},[_c('v-icon',{staticStyle:{"padding-right":"12px"},attrs:{"color":"'black'"}},[_vm._v("ico-icon-briefcase")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"'Open Sans'","color":"black","font-size":"18px","font-weight":"bold"}},[_vm._v("\n                    Cargo o descripción")])],1),_vm._v(" "),_c('v-text-field',{staticStyle:{"width":"424px"},attrs:{"single-line":"","id":"txtDescription","name":"txtDescription","label":"Cargo o descripción","append-icon":"ico-icon-edit"},model:{value:(_vm.userData.description),callback:function ($$v) {_vm.$set(_vm.userData, "description", $$v)},expression:"userData.description"}})],1)],1),_vm._v(" "),_c('v-row',{staticClass:"d-flex justify-space-between"},[_c('v-col',{staticClass:"px-4 ma-4",attrs:{"cols":"12","md":"4"}},[_c('v-card-text',{staticClass:"pl-0",staticStyle:{"padding-bottom":"22px"}},[_c('v-icon',{staticStyle:{"padding-right":"12px"},attrs:{"color":"'black'"}},[_vm._v("ico-icon-mobile")]),_vm._v(" "),_c('span',{staticStyle:{"font-family":"'Open Sans'","color":"black","font-size":"18px","font-weight":"bold"}},[_vm._v("\n                    Teléfono")])],1),_vm._v(" "),_c('v-text-field',{attrs:{"single-line":"","id":"txtPhone","name":"txtPhone","label":"Teléfono","append-icon":"ico-icon-edit"},model:{value:(_vm.userData.phone),callback:function ($$v) {_vm.$set(_vm.userData, "phone", $$v)},expression:"userData.phone"}})],1),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],staticClass:"px-4",attrs:{"cols":"12","md":"4","align-self":"center"}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-user-buttons",attrs:{"elevation":"0"},on:{"click":function($event){return _vm.updateUserProfile()}}},[_c('span',{staticStyle:{"color":"white","font-weight":"700","font-family":"'Open Sans'"}},[_vm._v("Actualizar Datos")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-refresh")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-row',{attrs:{"id":"security-layout"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-5",staticStyle:{"border-radius":"10px !important"},attrs:{"elevation":"0"}},[_c('span',{staticStyle:{"color":"#25235F","font-size":"35px","-webkit-text-stroke":"0.8px #25235F"}},[_vm._v("\n            Seguridad\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',[_vm._v("Editar Contraseña")]),_vm._v(" "),_c('v-text-field',{attrs:{"id":"txtPassword","name":"txtPassword","label":"Nueva contraseña","append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"type":_vm.hidePassword ? 'password' : 'text',"rules":[
                  function (v) { return v && v.length > 5 || 'Minimo 6 characters'; }
                ],"min":6,"single-line":""},on:{"click:append":function($event){_vm.hidePassword = !_vm.hidePassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',[_vm._v("Confirmar nueva contraseña")]),_vm._v(" "),_c('v-text-field',{attrs:{"id":"txtConfirmPassword","name":"txtConfirmPassword","label":"Confirmar contraseña","rules":[_vm.validatePassword()],"append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"type":_vm.hidePassword ? 'password' : 'text',"single-line":""},on:{"click:append":function($event){_vm.hidePassword = !_vm.hidePassword}},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],attrs:{"cols":"12","md":"4"}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-user-buttons",attrs:{"disabled":!_vm.canChangePassword || _vm.password === ''},on:{"click":function($event){return _vm.updateUserPassword()}}},[_c('span',{staticStyle:{"color":"white","font-size":"17px","font-weight":"700","font-family":"'Open Sans'"}},[_vm._v("Actualizar contraseña")])])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.isMyAccount || _vm.isNewUser)?_c('v-row',{staticStyle:{"margin-bottom":"5%"},attrs:{"id":"security-layout"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pa-5",staticStyle:{"border-radius":"10px !important"},attrs:{"elevation":"0"}},[_c('span',{staticStyle:{"color":"#25235F","font-size":"35px","-webkit-text-stroke":"0.8px #25235F"}},[_vm._v("\n            Acceso\n        ")]),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding-left":"32px !important","padding-right":"32px !important"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-checkbox',{staticStyle:{"color":"#23A2D9 !important"},attrs:{"color":"#23A2D9","label":"Está habilitado para visualizar reportes"},model:{value:(_vm.userData.isEnabled),callback:function ($$v) {_vm.$set(_vm.userData, "isEnabled", $$v)},expression:"userData.isEnabled"}})],1),_vm._v(" "),_c('v-col',{staticClass:"px-4",attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"bottom":"","item-text":"name","item-value":"type","items":_vm.items,"hint":_vm.hintMessage,"persistent-hint":"","label":"Tipo de usuario"},scopedSlots:_vm._u([{key:"item",fn:function(data){return _c('v-tooltip',{staticClass:"layout column",attrs:{"top":""}},[_c('v-col',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")]),_vm._v(" "),_c('v-col',[_vm._v(_vm._s(data.item.description))])],1)}}],null,false,4071339014),model:{value:(_vm.userData.userType),callback:function ($$v) {_vm.$set(_vm.userData, "userType", $$v)},expression:"userData.userType"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(!this.isNewUser),expression:"!this.isNewUser"}],attrs:{"cols":"12","md":"4"}},[_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-user-buttons",on:{"click":function($event){return _vm.updateUserAccessLevel()}}},[_c('span',{staticStyle:{"color":"white","font-size":"17px","font-weight":"700","font-family":"'Open Sans'"}},[_vm._v("Actualizar Acceso")])])],1)],1)],1),_vm._v(" "),_c('v-row',[(!_vm.isMyAccount)?_c('v-col',{attrs:{"cols":"12"}},[(_vm.userData.userType === 'NORMAL')?_c('v-col',{staticClass:"strategio-my-account-sub-division",attrs:{"cols":"12"}},[_vm._v("\n                Permisos "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedAssignedReports),expression:"loadedAssignedReports"}]}),_vm._v(" "),_c('v-subheader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedAssignedReports),expression:"loadedAssignedReports"}]},[_vm._v("Se han asignado   "),_c('b',[_vm._v(_vm._s(_vm.assignedReports.length))]),_vm._v("  items a este usuario ")])],1):_vm._e(),_vm._v(" "),(_vm.userData.userType === 'NORMAL')?_c('v-col',{attrs:{"cols":"12"}},[_c('show-reports-permisions-dialog',{attrs:{"user-id":_vm.userData.userID,"items-data":_vm.itemsTree,"is-new-user":this.isNewUser}})],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-row',[_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(this.isNewUser),expression:"this.isNewUser"}],attrs:{"cols":"12"}},[_c('v-card-actions',{staticClass:"white layout justify-center"},[_c('v-btn',{staticClass:"strategio-card-buttons",attrs:{"depressed":"","color":"success","disabled":!_vm.canChangePassword || _vm.password === ''},on:{"click":function($event){return _vm.createUser()}}},[_vm._v("\n                  Crear usuario\n                ")])],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('are-you-sure-dialog')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/users/user-form.vue
function injectStyle (context) {
  __webpack_require__("FxC0")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_form,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_user_form = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3Hgn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Light.1be8e55.otf";

/***/ }),

/***/ "4+6E":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4+lJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/drop-item-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var drop_item_dialog = ({
  name: 'drop-item-dialog',
  data: function data() {
    return {
      dialog: false,
      itemName: '',
      itemID: '',
      isFolder: false,
      // El método para actualizar los datos
      //  reemplaza toda la información del item
      //  por eso esta se trae y usa, en silencio.
      description: '',
      labels: '',
      imageUrl: '',

      heritable: false,
      containedBy: '',
      structureID: ''
    };
  },

  methods: {
    dropItem: function dropItem() {
      var _this = this;

      if (this.heritable) {
        if (this.isFolder) {
          var _ref = /^(HI?)(\d+)$/.exec(this.itemID) && /^(HI?)(\d+)$/.exec(this.itemID).slice(1) || [false, 0],
              _ref2 = slicedToArray_default()(_ref, 2),
              structureItemInheritanceFlag = _ref2[0],
              structureID = _ref2[1];

          structureStorage["default"].removeStructure({
            data: {
              structureID: structureID,
              structureItemInheritance: structureItemInheritanceFlag.startsWith('HI')
            },
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha eliminado la estructura correctamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;
            },
            onError: function onError(error) {
              console.warn('Error removing item: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema eliminando la estructura', itsOk: false });

              _this.dialog = false;
            }
          });
        } else {
          structureStorage["default"].updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: this.isFolder,
              itemID: this.itemID,
              itemName: this.itemName,
              description: this.description,
              labels: this.labels,
              imageUrl: this.imageUrl,
              removed: true
            },
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha eliminado el item correctamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;
            },
            onError: function onError(error) {
              console.warn('Error removing item: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema eliminando el item', itsOk: false });
            }
          });
        }
      } else {
        this.dialog = false;
        reportsStorage["default"].removeItem(this.itemID, {
          onSuccess: function onSuccess(response, removedItem) {
            // emit to routes/main-page.vue
            eventBus["default"].$emit('reload-items', {});
            // emit to custom-snack-bar
            eventBus["default"].$emit('open-custom-snack-bar', {
              message: 'Se ha eliminado un item',
              itsOk: 'warning',
              snackAction: {
                title: 'Deshacer',
                action: function action() {
                  reportsStorage["default"].unDoRemoveItem(removedItem[0], {
                    onSuccess: function onSuccess() {
                      // emit to routes/main-page.vue
                      eventBus["default"].$emit('reload-items', {});
                      // emit to custom-snack-bar
                      eventBus["default"].$emit('open-custom-snack-bar', {
                        message: 'El item ha sido restablecido',
                        itsOk: true
                      });
                    },
                    onError: function onError() {
                      // emit to custom-snack-bar
                      eventBus["default"].$emit('open-custom-snack-bar', {
                        message: 'No ha posido restablecerse el item',
                        itsOk: false
                      });
                    }
                  });
                }
              }
            });
          },
          onError: function onError() {
            eventBus["default"].$emit('open-custom-snack-bar', {
              message: 'El item no ha podido ser eliminado',
              itsOk: false
            });
          }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    eventBus["default"].$off('drop-item');
    eventBus["default"].$on('drop-item', function (item) {
      _this2.itemName = item.itemName;
      _this2.itemID = item.itemID;
      _this2.isFolder = item.isFolder;

      _this2.description = item.description;
      _this2.labels = item.labels;
      _this2.imageUrl = item.imageUrl;

      _this2.heritable = item.heritable;
      _this2.containedBy = item.containedBy;
      _this2.structureID = item.origin;
      _this2.dialog = true;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c17f740","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/drop-item-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"290px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"layout py-2 justify-center",staticStyle:{"font-size":"20px"}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_vm._v("\n          Eliminar\n        ")]),_vm._v(" "),_c('v-flex',{staticStyle:{"font-size":"16px"}},[_vm._v("\n          "+_vm._s(_vm.itemName)+"\n        ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n      ¿Está seguro de que desea borrar este item? "),_c('br'),_vm._v(" "),(_vm.isFolder)?_c('b',[_vm._v("Todos los items dentro serán borrados también")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"v-layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"grey"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"error"},nativeOn:{"click":function($event){return _vm.dropItem()}}},[_vm._v("Eliminar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/drop-item-dialog.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  drop_item_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_drop_item_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "41Kw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/components/autoservicios/processes/autoservicio-process.vue + 2 modules
var autoservicio_process = __webpack_require__("Jxcz");

// EXTERNAL MODULE: ./src/components/custom-loading.vue + 2 modules
var custom_loading = __webpack_require__("OxhJ");

// EXTERNAL MODULE: ./src/routes/show-report.vue + 2 modules
var show_report = __webpack_require__("cC8f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/processes/autoservicio-list-processes.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var autoservicio_list_processes = ({
  name: 'autoservicio-list-processes',
  data: function data() {
    return {
      loadingPage: true,
      processes: []
    };
  },

  components: {
    AutoservicioProcess: autoservicio_process["default"],
    CustomLoading: custom_loading["default"],
    ShowReport: show_report["default"]
  },
  props: {
    groupID: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  methods: {
    getProcesses: function getProcesses() {
      var _this = this;

      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_PROCESSES, {
        groupID: this.groupID
      }).then(function (response) {
        _this.processes = response.data;
      }).catch(function (err) {
        console.warn('No se ha podido obtener data del autoservicio', err);
      }).finally(function () {
        _this.loadingPage = false;
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this.getProcesses();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05614d7a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/processes/autoservicio-list-processes.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-container',[(_vm.loadingPage)?_c('v-row',{staticClass:"d-flex justify-center"},[_c('custom-loading')],1):_c('v-row',_vm._l((_vm.processes),function(process,idx){return _c('autoservicio-process',{key:idx,attrs:{"id":'autoservicioListProcesses' + idx,"process":process}})}),1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/processes/autoservicio-list-processes.vue
function injectStyle (context) {
  __webpack_require__("XV8S")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05614d7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_list_processes,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var processes_autoservicio_list_processes = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "49n3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4SVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__ = __webpack_require__("BRjr");




var userInfo = {};
// let userCards = ['REMOTE FILES', 'CONSISTENCIES', 'DATABASE']
/* let userCards = [
  {cardType: 'REMOTE FILES', cardName: 'Archivos FTP', enabled: true, reference: 'Archivos remotos'},
  {cardType: 'CONSISTENCIES', cardName: 'Consistencias', enabled: true, reference: 'Consistencias'},
  {cardType: 'DATABASE', cardName: 'Base de datos', enabled: true, reference: 'Base de datos'},
  {cardType: 'REPORTS GENERATOR', cardName: 'Generador de reportes', enabled: false, reference: 'Generador de reportes'},
  {cardType: 'SHIPPING CONTROL', cardName: 'Control de envío', enabled: false, reference: 'Control de envío'},
  {cardType: 'VALIDATOR', cardName: 'Validador', enabled: false, reference: 'Validador'}
] */
/* harmony default export */ __webpack_exports__["default"] = ({
  getUserInfo: function getUserInfo() {
    try {
      userInfo = JSON.parse(localStorage.user || '{}');
    } catch (ex) {
      delete localStorage.token;
      delete localStorage.user;
    }
    return userInfo;
  },
  updateUserInfo: function updateUserInfo(options) {
    userInfo = options.data;
    localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo);
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UPDATE_USER_INFO, options.data).then(function (response) {
      // console.log('USER UPDATED', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('ERROR UPDATING USER', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  updatePassword: function updatePassword(options) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UPDATE_USER_PASSWORD, {
      newPassword: options.newPassword
    }).then(function (response) {
      // console.log('USER PASSWORD UPDATED', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('ERROR UPDATING USER PASSWORD', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "4c0w":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "5B+D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5GOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/inconsistencies-report-question-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var inconsistencies_report_question_dialog = ({
  name: 'inconsistencies-report-question-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-inconsistencies-report-question-dialog');
    eventBus["default"].$on('open-inconsistencies-report-question-dialog', function (data) {
      _this.dialog = true;
      _this.distributorCode2 = data.distributorCode2 || '';
      _this.downloadReportLink = data.downloadLink || '';

      _this.isLoadingSendFile = false;
    });
  },
  data: function data() {
    return {
      dialog: false,
      distributorCode2: '',
      downloadReportLink: '',

      isLoadingSendFile: false
    };
  },

  methods: {
    _download: function _download(url) {
      window.open(url, '_blank');
    },
    afterAction: function afterAction() {
      this.isLoadingSendFile = false;
      this.dialog = false;
    },
    downloadFile: function downloadFile() {
      this.isLoadingSendFile = true;
      this._download(this.downloadReportLink);
      this.afterAction();
    },
    sendFile: function sendFile() {
      var _this2 = this;

      this.isLoadingSendFile = true;
      supervisorStorage["default"].sendInconsistenciesMail({
        data: {
          distributorCode2: this.distributorCode2
        },
        onSuccess: function onSuccess() {
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha enviado el reporte correctamente', itsOk: true });
          _this2.afterAction();
        },
        onError: function onError() {
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Hubo un error al enviar el reporte', itsOk: false });
          _this2.afterAction();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d547152","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/inconsistencies-report-question-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"350px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500","position":"relative"}},[_vm._v("\n      Acceso a reporte\n      "),(_vm.dialog)?_c('v-btn',{staticStyle:{"position":"absolute","right":"10px","top":"3px","color":"white"},attrs:{"flat":"","icon":"","small":"","color":"error"},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n      ¿Desea "),_c('b',[_vm._v("descargar el archivo")]),_vm._v(" desde el navegador o\n      "),_c('b',[_vm._v("desea enviarlo al distribuidor por correo")]),_vm._v("?\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"color":"white"},attrs:{"loading":_vm.isLoadingSendFile,"small":"","depressed":"","rounded":"","color":"amber darken-2"},nativeOn:{"click":function($event){return _vm.sendFile.apply(null, arguments)}}},[_vm._v("Enviar por correo")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"color":"white"},attrs:{"disabled":_vm.isLoadingSendFile,"small":"","depressed":"","rounded":"","color":"green"},nativeOn:{"click":function($event){return _vm.downloadFile.apply(null, arguments)}}},[_vm._v("Descargar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/inconsistencies-report-question-dialog.vue
function injectStyle (context) {
  __webpack_require__("zc4k")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  inconsistencies_report_question_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_inconsistencies_report_question_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5dtc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/users/users-list.vue + 2 modules
var users_list = __webpack_require__("BL3A");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/user-admin.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var user_admin = ({
  name: 'user-admin',
  mounted: function mounted() {
    eventBus["default"].$off('start-user-admin-tutorial');
    eventBus["default"].$on('start-user-admin-tutorial', function () {
      var intro = introBus["default"].getIntroBus();
      intro.addSteps([{
        element: '#usersfilter-textfield',
        intro: 'Filtro para usuarios existentes'
      }, {
        element: '#userlistitem0',
        intro: 'Estos son los usuarios agregados o filtrados. Se puede apreciar el nivel de permisos, nombre y correo del usuario'
      }, {
        element: '#adduser-button',
        intro: 'Con este botón es posible agregar usuarios nuevos'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));
      intro.start();
    });
  },

  methods: {
    goToCreateUser: function goToCreateUser() {
      this.$router.push('/user/admin-create');
    }
  },
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    UsersList: users_list["default"],
    CustomSnackBar: custom_snack_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05066cf0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/user-admin.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('v-row',{staticClass:"strategio-admin-users-main-container",attrs:{"justify-center":"","column":""}},[_c('users-list'),_vm._v(" "),_c('div',{staticClass:"strategio-speed-dial"},[_c('v-btn',{attrs:{"id":"adduser-button","fixed":"","dark":"","fab":"","bottom":"","right":"","color":"red"},on:{"click":function($event){return _vm.goToCreateUser()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1)]),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/user-admin.vue
function injectStyle (context) {
  __webpack_require__("CY8Z")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_admin,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_user_admin = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6/lO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/iconosVidaSoftware.5a93372.eot";

/***/ }),

/***/ "63oR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/show-metabase.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var show_metabase = ({
  name: 'show-metabase',
  data: function data() {
    return {
      url: 'https://analytics.softys.strategio.cloud/',
      urlSession: 'https://analytics.softys.strategio.cloud/api/session'
    };
  },

  components: {
    StrategioAppBar: strategio_app_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa2dd4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-metabase.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('iframe',{staticClass:"strategio-iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/show-metabase.vue
function injectStyle (context) {
  __webpack_require__("MhD7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_metabase,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_show_metabase = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "65cD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6NyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/components/menus/item-menu.vue + 2 modules
var item_menu = __webpack_require__("F7n2");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/folders/folder-list-item.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var folder_list_item = ({
  name: 'folder-list-item',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      isFavorite: false,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      test: [],
      dontShowFolder: ['download-cube']
    };
  },

  computed: {
    partitionedChildren: function partitionedChildren() {
      var _partition = Object(lodash["partition"])(this.folderData.children, function (child) {
        return child.isFolder;
      }),
          _partition2 = slicedToArray_default()(_partition, 2),
          isFolder = _partition2[0],
          isReport = _partition2[1];

      return {
        folders: {
          list: isFolder || []
        },
        reports: {
          list: isReport || []
        }
      };
    }
  },
  methods: {
    getFolderSize: function getFolderSize() {
      return this.$vuetify.breakpoint.name === 'xs' ? '85%' : '220px';
    },
    getAlphaedColor: function getAlphaedColor(hrgba) {
      var hexToRGBA = function hexToRGBA(hrgba) {
        var prgba = hrgba.charAt(0) === '#' ? hrgba.substring(1, 9) : hrgba;
        return {
          r: parseInt(prgba.substring(0, 2), 16),
          g: parseInt(prgba.substring(2, 4), 16),
          b: parseInt(prgba.substring(4, 6), 16),
          a: parseInt(prgba.substring(6, 8), 16) / 255
        };
      };
      return 'rgba(' + [values_default()(hexToRGBA(hrgba))].join(', ') + ')';
    },
    isNestedHeredable: function isNestedHeredable() {
      // eslint-disable-next-line
      return !(this.folderData.containedBy == this.$route.params.folderID);
    },
    getParentFolderName: function getParentFolderName(_itemID) {
      var temp = '';
      structureStorage["default"].getHeritableItems({
        onSuccess: function onSuccess(items) {
          temp = Object(lodash["find"])(items, function (_ref) {
            var itemID = _ref.itemID;
            return itemID === _itemID;
          }).itemName;
        }
      });
      return temp;
    },

    /* getParentFolder (item) {
      let temp = {}
      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          temp = find(items, ({itemID}) => itemID === item.containedBy)
        }
      })
      return temp
    }, */
    getParentFolder: function getParentFolder(item, folders) {
      var _this = this;

      var _folders = folders || [item];

      structureStorage["default"].getHeritableItems({
        onSuccess: function onSuccess(items) {
          var itemIntent = Object(lodash["find"])(items, function (_ref2) {
            var itemID = _ref2.itemID;
            return itemID === item.containedBy;
          });
          if (itemIntent) {
            _folders.push(itemIntent);
            _this.getParentFolder(itemIntent, _folders);
          }
        }
      });
      return _folders;
    },
    getParentFoldersNames: function getParentFoldersNames(item) {
      return Object(lodash["reduceRight"])(Object(lodash["flatMap"])(this.getParentFolder(item), 'itemName'), function (total, item) {
        return total + ' > ' + item;
      });
    },
    enterFolder: function enterFolder(folderID) {
      // eslint-disable-next-line
      if (folderID == this.$route.params.folderID) {
        eventBus["default"].$emit('reload-items', {});
      } else {
        this.$router.push({ name: 'MainPage', params: { folderID: folderID } });
      }
    },
    showReport: function showReport(data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización ni de descarga', itsOk: 'warning' });
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank');
          reportsStorage["default"].registerView(data.itemID, 'DOWNLOAD');
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning' });
        }
      } else {
        var _isFavorite = '';
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1';
        }
        this.$router.push('/show-report/' + data.itemID + _isFavorite);
      }
    }
  },
  components: {
    ItemMenu: item_menu["default"]
  },
  props: {
    folderData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    toUpdate: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    toUpdateOn: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    colorTheme: {
      type: Object,
      default: function _default() {
        return {
          background: 'lightgray',
          text: 'black'
        };
      }
    },
    addInnerFolder: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    addInnerReport: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    manageInnerReportsPermissions: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14879b79","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/folders/folder-list-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.dontShowFolder.includes(_vm.folderData.itemName) && (!_vm.folderData.hidden || _vm.isAdmin))?_c('v-card',{staticClass:"d-flex flex-column justify-center",class:{
    'strategio-hidden-item': _vm.folderData.hidden,
    'elevation-9': _vm.folderData.isMoving
  },style:([
    {'width': '234px'},
    {'height': '193px'},
    {'margin': '20px'},
    {'background-color': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'},
    {'border-radius': '10px'},
    {'padding': '25px'} ]),attrs:{"outlined":""},on:{"click":function($event){return _vm.enterFolder(_vm.folderData.itemID)}}},[_c('div',{staticClass:"d-flex align-center",staticStyle:{"position":"absolute","right":"9px","top":"13px"}},[(_vm.isAdmin)?_c('item-menu',{attrs:{"item":_vm.folderData,"is-searching":_vm.isSearching}}):_vm._e()],1),_vm._v(" "),_c('v-icon',{staticClass:"folder-list-item-icon",attrs:{"size":"39.17px","color":"rgba(37, 35, 95, 1)"}},[_vm._v("\n    ico-icon-folder\n  ")]),_vm._v(" "),_c('div',{staticClass:"strategio-folder-card-title",staticStyle:{"margin-top":"15px"}},[_vm._v("\n    "+_vm._s(_vm.folderData.itemName)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"strategio-folder-card-subtitle",staticStyle:{"margin-top":"10px"}},[_vm._v("\n    "+_vm._s(_vm.folderData.childrenCount)+" Reportes\n  ")]),_vm._v(" "),_c('div',{staticClass:"strategio-folder-text-button d-flex align-center"},[_vm._v("\n    Ver archivos\n    "),_c('v-icon',{staticClass:"strategio-folder-text-button-icon",attrs:{"color":"#23A2D9","size":"12px"}},[_vm._v("ico-icon-right")])],1)],1):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/folders/folder-list-item.vue
function injectStyle (context) {
  __webpack_require__("nfY/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  folder_list_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var folders_folder_list_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Ppk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6W2l":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6mg8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/metabase.0b009d3.png";

/***/ }),

/***/ "6orz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);





var adminUsersData = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  getAdminUsers: function getAdminUsers(options) {
    // TODO: Enable cache please
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].get(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_GET_ADMIN_USERS).then(function (response) {
      if (options.onSuccess) {
        adminUsersData = __WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default()(response.data.rows, ['name'], ['asc']);
        if (options.userID) {
          // eslint-disable-next-line
          options.onSuccess(__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(adminUsersData, function (u) {
            return u.userID == options.userID;
          }) || {});
        } else {
          options.onSuccess(adminUsersData);
        }
      }
    }, function (err) {
      console.warn(err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  getSubscriptions: function getSubscriptions(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_GET_ADMIN_SUBSCRIPTIONS, {
      userID: options.userID
    }).then(function (response) {
      options.onSuccess(__WEBPACK_IMPORTED_MODULE_2_lodash_orderBy___default()(response.data.rows, ['itemName', 'isFolder'], ['asc', 'desc']));
    }, function (err) {
      console.warn(err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  getFoldersSubscriptions: function getFoldersSubscriptions(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].get(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response.data.rows);
      }
    }, function (err) {
      console.warn('!!!', err);
    });
  },
  updateUserInfo: function updateUserInfo(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_ADMIN_UPDATE_USER_INFO, options.data).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('ERROR UPDATING USER', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  updatePassword: function updatePassword(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_ADMIN_UPDATE_USER_PASSWORD, {
      userID: options.userID,
      newPassword: options.newPassword
    }).then(function (response) {
      // console.log('USER PASSWORD UPDATED', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      // console.warn('ERROR UPDATING USER PASSWORD', err)
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  updateAccessLevel: function updateAccessLevel(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_ADMIN_UPDATE_ACCESS_LEVEL, {
      userID: options.userID,
      newUserType: options.newUserType,
      isEnabled: options.isEnabled
    }).then(function (response) {
      // console.log('response', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('ERR', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  createUser: function createUser(options) {
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_ADMIN_CREATE_USER, {
      name: options.userData.name,
      company: options.userData.company,
      description: options.userData.description,
      mail: options.userData.mail,
      phone: options.userData.phone,
      profileImageUrl: options.userData.profileImageUrl,
      password: options.userData.password,
      userType: options.userData.userType,
      permissions: options.userData.permissions
    }).then(function (response) {
      // console.log('response', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('ERR', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "77w4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7KIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isInternetExplorer11;

/* Sin uso, se encontró el estilo correcto :D */
function isInternetExplorer11() {
  if (navigator.appName === 'Microsoft Internet Explorer') {
    // console.warn('is ie: MIE');
    // window.location.assign('http://protisa.strategio.cloud/at/mMetro/index.php')
    return -1;
  } else if (navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Trident') !== -1) {
    // console.warn('is ie: netscape');
    // window.location.assign('http://protisa.strategio.cloud/at/mMetro/index.php')
    return 1;
  } else {
    // console.log("wat ta faq");
    // window.location.assign('http://protisa.strategio.cloud/new/index.html')
    return 0;
  }
}

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8Sb3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAhCAYAAAAlK6DZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDQyQzRBOUY3NDBDMTFFODkyRkZDRkZFOTM2MkQ1OTUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDQyQzRBOUU3NDBDMTFFODkyRkZDRkZFOTM2MkQ1OTUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZTdkNDE2N2EtY2ZjZi0xMTQzLTg2YmQtNTljZTVhNjhjY2E4IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6MDc4OWIyOGMtZTYxNS0yNTQxLTg2NDAtNDFlMmU4YWNmYjhkIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+RO7tsQAAAX9JREFUeNpi/P//PwO9ARPDAAAWZM7D168o9vaH1+83//r5KxnIfA0TMzXUpa1P//79KwOk9gGxKL2DVwefxbSMU5wWs1DbJnZ2tr8/GX6dh/GZmZnnAik/ZDWMyFmGGgkJG5AXFWOkqk+Z/vxhYPz1i+EfMzPDf3Z2+uRTrpMnGPjSMxj4Z84c3IUDWZYKFhWDMVVKJFyA7clTBuYvnxl+SUoy/OXnB5Y1r2nvU651axk4WtsYOK9cHroF/sDXMjgBLx+wMBNl+MfGAeGLIko2sBiID1JDJBiQEmnwBO+TR08Y7ty8R5HBKupKDDJyMsRbKiDAz6CspkiRpSAzSPIpJzcXAxsHO0WWAqs00iy9e+suw/nTFyiy1NDUgEFNU23wpF6sPn31/CXDQ2BiosgiYCISkxQnPniZgPHBxspGWVFHapyKiImAMV3z6a3rt4hOSO4+bgwCQgIkWYo1IQEbzGBMDGBlZWVgZGSkPCGB8hi+fDYkqzbGEdNVBAgwAJHxcx0EP51zAAAAAElFTkSuQmCC"

/***/ }),

/***/ "8lGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapper.js
var axiosWrapper = __webpack_require__("BRjr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header-main-page/header-main-page.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var header_main_page = ({
  name: 'header-main-page',
  data: function data() {
    return {
      dataIndicadores: [],
      isLoading: true
    };
  },

  methods: {
    redirectToPage: function redirectToPage() {
      // window.location.assign('http://softys25.strategio.cloud')
      if (uris["default"].URL_POWERBI_ID.length === 0) return;
      this.$router.push({ name: 'ShowReportBi' });
    },
    redirectToMetabase: function redirectToMetabase() {
      // this.$router.push({name: 'ShowMetabase'})
      if (uris["default"].URL_METABASE.length === 0) return;
      window.open(uris["default"].URL_METABASE, '_blank', 'toolbar=0,location=0,menubar=0');
    },
    getKpi: function getKpi() {
      var _this = this;

      axiosWrapper["default"].get(uris["default"].URL_GET_KPI).then(function (response) {
        _this.isLoading = false;
        _this.dataIndicadores = response.data.rows;
      }, function (err) {
        _this.isLoading = false;
        console.warn('No se ha podido obtener data de kpi', err);
      });
    },
    formatValue: function formatValue(kpi) {
      var dollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var value = 0;
      if (this.dataIndicadores.length > 0) {
        // return kpi.data.toLocaleString('en-US', {maximumFractionDigits: 0})
        // Nine Zeroes for Billions
        value = Math.abs(Number(kpi.data)) >= 1.0e+9 ? (Math.abs(Number(kpi.data)) / 1.0e+9).toFixed(2) + 'B'
        // Six Zeroes for Millions
        : Math.abs(Number(kpi.data)) >= 1.0e+6 ? (Math.abs(Number(kpi.data)) / 1.0e+6).toFixed(2) + 'M'
        // Three Zeroes for Thousands
        : Math.abs(Number(kpi.data)) >= 1.0e+3 ? (Math.abs(Number(kpi.data)) / 1.0e+3).toFixed(0) + 'K' : Math.abs(Number(kpi.data));
      }
      return dollarSign ? 'S/.' + value : value;
    }
  },
  mounted: function mounted() {
    this.getKpi();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97ee4e96","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-main-page/header-main-page.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{class:['row-cabecera']},[_c('v-col',{staticClass:"d-flex flex-column justify-center align-center flex-shrink-0",attrs:{"cols":"12","xs":"2","sm":"2","md":"3","lg":"2","xl":"1"}},[_c('v-card',{staticClass:"card-header-icon d-flex align-center justify-center tooltip",attrs:{"outlined":""},on:{"click":function($event){return _vm.redirectToPage()}}},[_c('img',{class:['card-icon'],attrs:{"src":__webpack_require__("FyRe")}}),_vm._v(" "),_c('div',{staticClass:"tooltiptext"},[_c('v-img',{attrs:{"src":__webpack_require__("D01m"),"height":"150","width":"322"}})],1)]),_vm._v(" "),_c('v-card',{staticClass:"card-header-icon d-flex align-center justify-center tooltip",attrs:{"outlined":""},on:{"click":function($event){return _vm.redirectToMetabase()}}},[_c('img',{class:['card-icon'],attrs:{"src":__webpack_require__("4+6E")}}),_vm._v(" "),_c('div',{staticClass:"tooltiptext"},[_c('v-img',{attrs:{"src":__webpack_require__("6mg8"),"height":"150","width":"322"}})],1)])],1),_vm._v(" "),_c('v-col',{staticClass:"d-flex align-center flex-wrap",attrs:{"cols":"12","xs":"9","sm":"9","md":"8","lg":"9","xl":"11"}},[_c('div',{staticClass:"indicador-container"},[_c('v-img',{class:['indicador-image'],attrs:{"src":__webpack_require__("b9tb")}}),_vm._v(" "),_c('div',{class:['indicador-ubicacion']},[(_vm.isLoading)?_c('div',{staticStyle:{"margin-bottom":"8px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"indicador-value"},[_vm._v("\n              "+_vm._s(_vm.formatValue(_vm.dataIndicadores[0], false))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"indicador-descripcion"},[_vm._v("\n              Distribuidoras al Día\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"indicador-container"},[_c('v-img',{class:['indicador-image'],attrs:{"src":__webpack_require__("jnq8")}}),_vm._v(" "),_c('div',{staticClass:"indicador-ubicacion"},[(_vm.isLoading)?_c('div',{staticStyle:{"margin-bottom":"8px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"indicador-value"},[_vm._v("\n              "+_vm._s(_vm.formatValue(_vm.dataIndicadores[1], true))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"indicador-descripcion"},[_vm._v("\n              Ventas\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"indicador-container"},[_c('v-img',{class:['indicador-image'],attrs:{"src":__webpack_require__("pg7M")}}),_vm._v(" "),_c('div',{staticClass:"indicador-ubicacion"},[(_vm.isLoading)?_c('div',{staticStyle:{"margin-bottom":"8px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"indicador-value"},[_vm._v("\n              "+_vm._s(_vm.formatValue(_vm.dataIndicadores[2], false))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"indicador-descripcion"},[_vm._v("\n              Reportes Visitados\n            ")])])],1),_vm._v(" "),_c('div',{staticClass:"indicador-container"},[_c('v-img',{class:['indicador-image'],attrs:{"src":__webpack_require__("S4jV")}}),_vm._v(" "),_c('div',{staticClass:"indicador-ubicacion"},[(_vm.isLoading)?_c('div',{staticStyle:{"margin-bottom":"8px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"indicador-value"},[_vm._v("\n              "+_vm._s(_vm.formatValue(_vm.dataIndicadores[3], false))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"indicador-descripcion"},[_vm._v("\n              Cobertura\n            ")])])],1)])],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/header-main-page/header-main-page.vue
function injectStyle (context) {
  __webpack_require__("i7Zu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  header_main_page,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var header_main_page_header_main_page = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8vt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var validation_header = ({
  name: 'validation-header',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      loading: false
    };
  },

  props: {
    processID: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  methods: {
    downloadPlantilla: function downloadPlantilla() {
      var _this = this;

      this.loading = true;
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_TEMPLATE, {
        processID: this.processID
      }, {
        responseType: 'blob'
      }).then(function (response) {
        var filename = response.headers.filename;
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(function (err) {
        console.warn('No se ha podido obtener data del autoservicio', err);
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81a897d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"#2262c6"},on:{"click":_vm.downloadPlantilla},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Descargando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n    Descargar Plantilla\n\n    "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n      mdi-cloud-download\n    ")])],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-header.vue
function injectStyle (context) {
  __webpack_require__("6Ppk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_header,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_header = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "98nQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/background-login.5b9fa45.jpg";

/***/ }),

/***/ "9FQj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logotipo-strategio.06fb004.png";

/***/ }),

/***/ "9Mjp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icono-user.aa75fe5.png";

/***/ }),

/***/ "A+kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/parse-int.js
var parse_int = __webpack_require__("gBtx");
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/folders/folder-list-item.vue + 2 modules
var folder_list_item = __webpack_require__("6NyI");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/adminStorage.js
var adminStorage = __webpack_require__("6orz");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/folders/folder-list.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var folder_list = ({
  name: 'folder-list',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      showMovingMessage: false,
      movingItem: {},
      movingMessageHeight: '100',
      isAdmin: user.userType === 'ADMIN',
      isLoadingPermissions: false,
      heritableFolders: [],
      heritableSelected: '',
      colorThemes: [{
        enabled: true,
        text: 'black',
        background: '#19BAE8'
      }, {
        enabled: true,
        text: 'black',
        background: '#00D5B2'
      }, {
        enabled: true,
        text: 'black',
        background: '#FAB100'
      }, {
        enabled: true,
        text: 'black',
        background: '#FF5F00'
      }, {
        enabled: true,
        text: 'black',
        background: '#E13A3A'
      }]
      // isSupervisor: user.userType === 'SUPERVISOR'
    };
  },

  computed: {},
  methods: {
    getColorTheme: function getColorTheme(index) {
      var _this = this;

      var getFolderContainerWidth = function getFolderContainerWidth() {
        var widthio = 0;
        switch (_this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            widthio = window.innerWidth - 16 * 2;
            break;
          case 'md':
            widthio = 900 - 16 * 2;
            break;
          case 'lg':
            widthio = 1185 - 16 * 2;
            break;
          case 'xl':
            widthio = 1785 - 16 * 2;
            break;
          default:
            // widthio = ''
            break;
        }

        return widthio;
      };

      var enabledColorThemes = [];
      if (!['xs'].includes(this.$vuetify.breakpoint.name)) {
        enabledColorThemes = Object(lodash["slice"])(this.colorThemes, 0, Math.floor(getFolderContainerWidth() / 236));
      } else {
        enabledColorThemes = Object(lodash["filter"])(this.colorThemes, 'enabled');
      }
      index %= enabledColorThemes.length;
      return enabledColorThemes[index];
    },
    goBack: function goBack() {
      this.$router.push('/' + this.containedBy.containedBy);
    },
    returnToHome: function returnToHome() {
      this.$router.push('/0');
    },
    returnToFolder: function returnToFolder() {
      eventBus["default"].$emit('reload-items', {});
    },
    pasteHere: function pasteHere() {
      var newContainedBy = this.containedBy ? this.containedBy.itemID : '0';

      // eslint-disable-next-line
      if (this.movingItem.containedBy == newContainedBy) {
        // emit to routes/main.vue
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha movido', itsOk: true });
        this.showMovingMessage = false;
        // this.movingItem.isMoving = false
        return false;
      }

      // eslint-disable-next-line
      if (this.movingItem.itemID == newContainedBy) {
        // emit to routes/main.vue
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'No puedes pegar un item dentro de si mismo' });
        return false;
      }

      reportsStorage["default"].moveItem(this.movingItem.itemID, newContainedBy);
      this.showMovingMessage = false;
      // this.movingItem.isMoving = false

      // emit to routes/main-page.vue
      eventBus["default"].$emit('reload-items', {});
    },
    cancel: function cancel() {
      // this.movingItem.isMoving = false
      this.showMovingMessage = false;
    },
    manageReportsPermissions: function manageReportsPermissions() {
      var _this2 = this;

      this.isLoadingPermissions = true;
      var containerID = parse_int_default()(this.$route.params.folderID) || 0;
      var totalHolder = {
        containedBy: containerID,
        folderName: '',
        usersID: [],
        folders: [],
        reports: []
      };

      reportsStorage["default"].getData({
        folderID: containerID,
        onSuccess: function onSuccess(result) {
          var users = [];
          var subscriptions = [];

          var foldersData = [];
          var reportsData = [];

          totalHolder.folderName = _this2.containedBy ? _this2.containedBy.itemName : 'ROOT';

          adminStorage["default"].getAdminUsers({
            onSuccess: function onSuccess(totalUsers) {
              users = totalUsers;

              adminStorage["default"].getFoldersSubscriptions({
                onSuccess: function onSuccess(foldersSubscriptions) {
                  subscriptions = foldersSubscriptions;

                  foldersData = Object(lodash["flatMap"])(Object(lodash["filter"])(result, function (item) {
                    return item.isFolder === 1 && item.containedBy === totalHolder.containedBy;
                  }), function (item) {
                    return { folderID: item.itemID, folderName: item.itemName };
                  });
                  reportsData = Object(lodash["flatMap"])(Object(lodash["filter"])(result, function (item) {
                    return item.isFolder === 0 && item.containedBy === totalHolder.containedBy;
                  }), function (item) {
                    return { reportID: item.itemID, reportName: item.itemName };
                  });

                  totalHolder.usersID = Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                    return sub.itemID === totalHolder.containedBy;
                  }), 'userID');

                  foldersData.forEach(function (folderData) {
                    var folderID = folderData.folderID,
                        folderName = folderData.folderName;

                    totalHolder.folders.push({
                      itemID: folderID,
                      itemName: folderName,
                      usersID: Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                        return sub.itemID === folderID;
                      }), 'userID')
                    });
                  });

                  reportsData.forEach(function (reportsData) {
                    var reportID = reportsData.reportID,
                        reportName = reportsData.reportName;

                    totalHolder.reports.push({
                      itemID: reportID,
                      itemName: reportName,
                      usersID: Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                        return sub.itemID === reportID;
                      }), 'userID')
                    });
                  });

                  eventBus["default"].$emit('open-show-users-folder-permissions-dialog', totalHolder, users, function () {
                    _this2.isLoadingPermissions = false;
                  });
                }
              });
            }
          });
        }
      });
    },
    manageInnerReportsPermissions: function manageInnerReportsPermissions(parentFolderData) {
      var _this3 = this;

      this.isLoadingPermissions = true;
      var containerID = parse_int_default()(parentFolderData.itemID) || 0;
      var totalHolder = {
        containedBy: containerID,
        folderName: '',
        usersID: [],
        folders: [],
        reports: []
      };

      reportsStorage["default"].getData({
        folderID: containerID,
        onSuccess: function onSuccess(result) {
          var users = [];
          var subscriptions = [];

          var foldersData = [];
          var reportsData = [];

          totalHolder.folderName = parentFolderData.itemName;

          adminStorage["default"].getAdminUsers({
            onSuccess: function onSuccess(totalUsers) {
              users = totalUsers;

              adminStorage["default"].getFoldersSubscriptions({
                onSuccess: function onSuccess(foldersSubscriptions) {
                  subscriptions = foldersSubscriptions;

                  foldersData = Object(lodash["flatMap"])(Object(lodash["filter"])(result, function (item) {
                    return item.isFolder === 1 && item.containedBy === totalHolder.containedBy;
                  }), function (item) {
                    return { folderID: item.itemID, folderName: item.itemName };
                  });
                  reportsData = Object(lodash["flatMap"])(Object(lodash["filter"])(result, function (item) {
                    return item.isFolder === 0 && item.containedBy === totalHolder.containedBy;
                  }), function (item) {
                    return { reportID: item.itemID, reportName: item.itemName };
                  });

                  totalHolder.usersID = Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                    return sub.itemID === totalHolder.containedBy;
                  }), 'userID');

                  foldersData.forEach(function (folderData) {
                    var folderID = folderData.folderID,
                        folderName = folderData.folderName;

                    totalHolder.folders.push({
                      itemID: folderID,
                      itemName: folderName,
                      usersID: Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                        return sub.itemID === folderID;
                      }), 'userID')
                    });
                  });

                  reportsData.forEach(function (reportsData) {
                    var reportID = reportsData.reportID,
                        reportName = reportsData.reportName;

                    totalHolder.reports.push({
                      itemID: reportID,
                      itemName: reportName,
                      usersID: Object(lodash["flatMap"])(Object(lodash["filter"])(subscriptions, function (sub) {
                        return sub.itemID === reportID;
                      }), 'userID')
                    });
                  });

                  eventBus["default"].$emit('open-show-users-folder-permissions-dialog', totalHolder, users, function () {
                    _this3.isLoadingPermissions = false;
                  });
                }
              });
            }
          });
        }
      });
    },
    cancelToUpdateToggle: function cancelToUpdateToggle() {
      this.toUpdateToggle();
      this.heritableSelected = '';
      // alert('hm')
    },
    getFoldersToUpdate: function getFoldersToUpdate() {
      return Object(lodash["flatMap"])(Object(lodash["filter"])(this.toUpdate, function (item) {
        return item.checked;
      }), 'itemID');
    },
    updateMultipleItemsInheritee: function updateMultipleItemsInheritee() {
      var _this4 = this;

      if (this.getFoldersToUpdate().length > 0 && this.heritableSelected) {
        var _ref = /^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1) || [false, 0],
            _ref2 = slicedToArray_default()(_ref, 2),
            structureItemInheritanceFlag = _ref2[0],
            structureID = _ref2[1];

        reportsStorage["default"].updateMultipleItemsInheritee({
          data: {
            itemsID: this.getFoldersToUpdate(),
            inherited: structureID,
            structureItemInheritance: structureItemInheritanceFlag.startsWith('HI')
          },
          onSuccess: function onSuccess() {
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'Folder(s) actualizados correctamente', itsOk: true });

            eventBus["default"].$emit('reload-items');
            _this4.cancelToUpdateToggle();
          },
          onError: function onError(error) {
            console.warn('Error vinculando folder(s) con base: ', error);
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'Error vinculando folder(s) con base', itsOk: false });
          }
        });
      } else {
        console.warn('No hay datos que actualizar');
      }
    }
  },
  created: function created() {
    var _this5 = this;

    eventBus["default"].$off('move-item');
    eventBus["default"].$on('move-item', function (item) {
      // this.movingItem.isMoving = false
      _this5.movingItem = item;
      _this5.showMovingMessage = true;

      _this5.$nextTick(function () {
        _this5.movingMessageHeight = document.getElementById('strategioMovingMessage').clientHeight + 25;
      });
    });
    if (this.isAdmin) {
      structureStorage["default"].getHeritableItems({
        onSuccess: function onSuccess(heritableFolders) {
          _this5.heritableFolders = Object(lodash["filter"])(heritableFolders, function (item) {
            // eslint-disable-next-line
            return item.isFolder === 1 && item.containedBy == 0;
          });
        }
      });
    }
  },

  // props: ['folders', 'containedBy', 'isSearching', 'searchInfo'],
  // props: ['folders', 'containedBy', 'isSearching', 'searchInfo'],
  props: {
    folders: {
      type: Array,
      default: function _default() {
        return '';
      }
    },
    containedBy: {},
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    searchInfo: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    toUpdate: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    toUpdateOn: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    toUpdateToggle: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    addInnerFolder: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    addInnerReport: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  components: {
    FolderListItem: folder_list_item["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00bfe9c6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/folders/folder-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"row":"","wrap":""}},[_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearching),expression:"!isSearching"}],style:(_vm.showMovingMessage ? ("margin-top: " + _vm.movingMessageHeight + "px") : ''),attrs:{"xs":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('div',{staticClass:"d-flex",staticStyle:{"padding-right":"100px"}},[_c('div',{staticClass:"layout d-flex align-center",staticStyle:{"padding-left":"5px"},attrs:{"align-self":"center"}},[(_vm.containedBy)?_c('v-btn',{attrs:{"disabled":!!!_vm.containedBy,"text":"","icon":"","color":"black","ripple":false},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"strategio-folder-title pl-3"},[(_vm.containedBy)?_c('div',[_vm._v("\n                "+_vm._s(_vm.containedBy.itemName)+"\n              ")]):_c('div',[_c('v-icon',{attrs:{"x-large":"","color":"#000000"}},[_vm._v("assignment")]),_vm._v("\n                Reportes\n              ")],1)]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',[(!(_vm.$route.params.folderID == 0))?_c('v-btn',{attrs:{"loading":_vm.isLoadingPermissions,"icon":"","text":"","color":"black"},on:{"click":_vm.returnToHome}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("home")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin /* || isSupervisor */ && (_vm.containedBy ? !_vm.containedBy.heritable : true))?_c('v-btn',{attrs:{"loading":_vm.isLoadingPermissions,"icon":"","text":"","color":"black"},on:{"click":_vm.manageReportsPermissions}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("settings")])],1):_vm._e()],1)])]),_vm._v(" "),(_vm.isSearching)?_c('v-col',{staticClass:"layout align-center",style:(_vm.showMovingMessage ? ("margin-top: " + _vm.movingMessageHeight + "px") : ''),attrs:{"xs":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('v-btn',{attrs:{"text":"","icon":"","color":"black","ripple":false},on:{"click":function($event){return _vm.returnToFolder()}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("arrow_back")])],1),_vm._v(" "),_c('span',{staticClass:"strategio-folder-title"},[_vm._v("Resultados de la búsqueda")])],1):_vm._e(),_vm._v(" "),(_vm.isSearching)?_c('v-col',{attrs:{"xs":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('div',{staticClass:"strategio-search-info",staticStyle:{"font-size":"16px","color":"black"}},[_vm._v(_vm._s(_vm.searchInfo))])]):_vm._e(),_vm._v(" "),(_vm.showMovingMessage)?_c('v-card',{staticClass:"strategio-moving-card elevation-5",attrs:{"id":"strategioMovingMessage"}},[_c('v-card-title',[_c('div',[_c('span',{staticClass:"grey--text"},[_vm._v("Moviendo "+_vm._s(_vm.movingItem.isFolder ? 'carpeta' : 'reporte'))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.movingItem.itemName))]),_c('br')])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"text":"","color":"orange"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"orange"},on:{"click":function($event){return _vm.pasteHere()}}},[_vm._v("Pegar")])],1)],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"expansion"}},[(_vm.toUpdateOn)?_c('v-col',[_c('v-col',{attrs:{"pa-2":""}},[_c('v-card',{staticStyle:{"border-radius":"20px"}},[_c('v-container',{staticClass:"py-0"},[_c('v-card-title',{staticClass:"pb-1"},[_c('v-row',{attrs:{"column":""}},[_c('v-col',{staticClass:"pb-2 layout justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n                      Vincular varios a carpeta base\n\n                    ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-col',{staticClass:"subheader pa-0",staticStyle:{"height":"auto","font-size":"11px"}},[_vm._v("\n                      Marque los checks de las carpetas que desee vincular a cierta carpeta base\n\n                    ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-row',{attrs:{"wrap":""}},[_c('v-col',{attrs:{"xs":"12","md6":""}},[_c('v-select',{attrs:{"clearable":"","item-text":"itemName","item-value":"itemID","label":"Seleccione estructura","items":_vm.heritableFolders},model:{value:(_vm.heritableSelected),callback:function ($$v) {_vm.heritableSelected=$$v},expression:"heritableSelected"}})],1),_vm._v(" "),_c('v-col',{staticClass:"layout align-center px-2",attrs:{"xs":"12","md6":""}},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"success"},on:{"click":_vm.updateMultipleItemsInheritee}},[_vm._v("Actualizar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"error"},on:{"click":_vm.cancelToUpdateToggle}},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.folders),function(f,i){return _c('folder-list-item',{key:f.folderID,attrs:{"color-theme":_vm.getColorTheme(i),"folder-data":f,"is-searching":_vm.isSearching,"id":'reportlistfolder' + i,"to-update":_vm.toUpdate[i],"to-update-on":_vm.toUpdateOn,"add-inner-folder":_vm.addInnerFolder,"add-inner-report":_vm.addInnerReport,"manage-inner-reports-permissions":_vm.manageInnerReportsPermissions}})})],2)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/folders/folder-list.vue
function injectStyle (context) {
  __webpack_require__("XvPd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00bfe9c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  folder_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var folders_folder_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AsE4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AuUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/components/structures/flat-structure-item.vue + 2 modules
var flat_structure_item = __webpack_require__("mxb/");

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/paste-structure-form-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var paste_structure_form_dialog = ({
  name: 'paste-structure-form-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-paste-structure-form-dialog');
    eventBus["default"].$on('open-paste-structure-form-dialog', function () {
      // console.log('opened')
      _this.dialog = true;
      _this.isLoadingStructures = true;
      structureStorage["default"].getStructures({
        onSuccess: function onSuccess(response) {
          _this.structures = response.data.rows;
          _this.isLoadingStructures = false;
        },
        onError: function onError() /* error */{
          // console.log(error)
          _this.isLoadingStructures = false;
          _this.checkingStructureNameMessages = ['Ha habido un problema con el servidor'];
        }
      });
    });
  },
  data: function data() {
    return {
      isLoadingStructures: false,
      checkingStructureNameMessages: [],
      dialog: false,
      structures: [],
      selectedStructureItems: [],
      structureName: null,
      folderName: '',
      enterInFolder: true,
      hideFolder: true,
      structureItemsDialog: false
    };
  },

  methods: {
    openDetails: function openDetails() {
      var _this2 = this;

      this.selectedStructureItems = find_default()(this.structures, function (i) {
        return i.structureName === _this2.structureName;
      })['structureItems'];
      this.structureItemsDialog = true;
    },
    buildStructure: function buildStructure() {
      var _this3 = this;

      var selectedStructureItems = find_default()(this.structures, function (i) {
        return i.structureName === _this3.structureName;
      })['structureItems'];
      console.warn('!!!', stringify_default()(selectedStructureItems, null, 2), selectedStructureItems);
      // return
      selectedStructureItems = selectedStructureItems.map(function (i) {
        return {
          structureItemID: i.structureItemID,
          itemName: i.itemName,
          description: i.description.replace(i.folderName, _this3.folderName),
          labels: i.labels.replace(i.folderName, _this3.folderName),
          imageUrl: i.imageUrl,
          isFolder: i.isFolder
        };
      });
      var sendStructure = {
        folderName: this.folderName,
        containedBy: this.$route.params.folderID,
        hideFolder: this.hideFolder,
        items: selectedStructureItems
      };
      structureStorage["default"].buildStructure({
        data: sendStructure,
        onSuccess: function onSuccess(response) {
          console.info(response.data.rows);
          reportsStorage["default"].addItems(response.data.rows);
          // emit to routes/main-page.vue
          eventBus["default"].$emit('reload-items', {});
          if (_this3.enterInFolder) {
            _this3.$router.push('/' + response.data.folderID);
          }

          _this3.dialog = false;
        },
        onError: function onError() {}
      });
    }
  },
  components: {
    FlatStructureItem: flat_structure_item["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86581a5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/paste-structure-form-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"scrollable":true,"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Utilizar estructura")]),_vm._v(" "),_c('v-card-text',[_c('v-card-actions',[_c('v-select',{attrs:{"items":_vm.structures,"item-text":"structureName","item-value":"structureName","label":"Elegir estructura","bottom":"","loading":_vm.isLoadingStructures,"error-messages":_vm.checkingStructureNameMessages},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(("" + (data.item.structureName) + (data.item.heritable ? ' - Heredable' : '') + " "))+"\n            ")]}},{key:"item",fn:function(data){return [_vm._v("\n              "+_vm._s(("" + (data.item.structureName) + (data.item.heritable ? ' - Heredable' : '') + " "))+"\n            ")]}}]),model:{value:(_vm.structureName),callback:function ($$v) {_vm.structureName=$$v},expression:"structureName"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.structureName === null,"flat":"","color":"info"},nativeOn:{"click":function($event){return _vm.openDetails()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("open_in_new")]),_vm._v(" "),_c('span',{staticClass:"hidden-xs-only"},[_vm._v("Ver estructura")])],1)],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombre del Folder ($$FOLDER)"},model:{value:(_vm.folderName),callback:function ($$v) {_vm.folderName=$$v},expression:"folderName"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Entrar a la carpeta","color":"primary"},model:{value:(_vm.enterInFolder),callback:function ($$v) {_vm.enterInFolder=$$v},expression:"enterInFolder"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Ocultar carpeta","color":"primary"},model:{value:(_vm.hideFolder),callback:function ($$v) {_vm.hideFolder=$$v},expression:"hideFolder"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-2","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":_vm.structureName === null,"flat":""},nativeOn:{"click":function($event){return _vm.buildStructure()}}},[_vm._v("Aceptar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":true,"max-width":"350px"},model:{value:(_vm.structureItemsDialog),callback:function ($$v) {_vm.structureItemsDialog=$$v},expression:"structureItemsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Vista de estructura")]),_vm._v(" "),_c('v-card-text',_vm._l((_vm.selectedStructureItems),function(i,$index){return _c('flat-structure-item',{key:$index,attrs:{"item":i}})}),1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-2","flat":""},nativeOn:{"click":function($event){_vm.structureItemsDialog = false}}},[_vm._v("Cerrar")])],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/paste-structure-form-dialog.vue
function injectStyle (context) {
  __webpack_require__("d1/t")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  paste_structure_form_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_paste_structure_form_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BL3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./src/storage/adminStorage.js
var adminStorage = __webpack_require__("6orz");

// EXTERNAL MODULE: ./src/components/users/users-list-item.vue + 2 modules
var users_list_item = __webpack_require__("sW4m");

// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__("RyI1");
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/users-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var usersData = [];

/* harmony default export */ var users_list = ({
  name: 'users-list',
  data: function data() {
    return {
      headers: [{ text: 'Tipo de Usuario', value: 'userType', align: 'center', sortable: false }, { text: 'Nombre del usuario', value: 'name', sortable: false }, { text: 'Cargo', value: 'description', sortable: false }, { text: 'Correo Electrónico', value: 'mail', sortable: false }, { text: 'Acciones', value: 'actions', align: 'center', sortable: false }],
      users: [],
      isLoading: true
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.isLoading = true;
      adminStorage["default"].getAdminUsers({
        onSuccess: function onSuccess(data) {
          usersData = data.map(function (d) {
            d.mail = d.mail ? d.mail.toUpperCase() : '';
            d.name = d.name ? d.name.toUpperCase() : '';
            d.description = d.description ? d.description.toUpperCase() : '';
            return d;
          });
          _this.users = JSON.parse(stringify_default()(usersData));
          _this.isLoading = false;

          // emits to: /components/header-bar/strategio-app-bar.vue
          eventBus["default"].$emit('enable-tutorial-button');
        },
        onError: function onError(error) {
          console.warn('Error obteniendo usuarios', error);
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ha habido un problema con el servidor', itsOk: false });
        }
      });
    },
    isEnabled: function isEnabled(_isEnabled) {
      return 'opacity: ' + (_isEnabled ? '1' : '0.5');
    },
    openSnackBar: function openSnackBar(message, itsOk, snackAction) {
      eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: itsOk, snackAction: snackAction });
    },
    search: function search() {
      var q = document.getElementById('txtBuscar').value.trim().toUpperCase();
      var qq = filter_default()(usersData, function (u) {
        return u.mail.toUpperCase().indexOf(q) > -1 || u.name.toUpperCase().indexOf(q) > -1 || u.description.toUpperCase().indexOf(q) > -1 || u.userType.toUpperCase().indexOf(q) > -1;
      });
      this.users = qq;
    },
    getColor: function getColor(userType) {
      switch (userType) {
        case 'ADMIN':
          return '#EC39CF';
        case 'SUPERVISOR':
          return '#9C9C9C';
        case 'GLOBAL':
          return '#E35361';
        case 'NORMAL':
          return '#FB9C00';
        case 'DEMO':
          return '#5E8132';
        default:
          return 'grey darken-1';
      }
    },
    adminUser: function adminUser(userID) {
      this.$router.push('/user/admin/' + userID);
    },
    disableUser: function disableUser(user) {
      var _this2 = this;

      adminStorage["default"].updateAccessLevel({
        userID: user.userID,
        newUserType: user.userType,
        isEnabled: !user.isEnabled,
        onSuccess: function onSuccess() {
          _this2.openSnackBar('Nivel de acceso actualizado', true);
          _this2.getData();
        },
        onError: function onError() {
          return _this2.openSnackBar('Ha habido un error al actualizar el nivel de acceso', false);
        }
      });
    }
  },
  components: {
    UsersListItem: users_list_item["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c46bb9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/users-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',{staticClass:"strategio-titles-windows",attrs:{"id":"profile-layout"}},[_c('v-col',{attrs:{"cols":"20","align-self":"center"}},[_c('v-icon',{staticStyle:{"font-size":"52px","padding-bottom":"30px","padding-right":"10px"},attrs:{"color":'black'}},[_vm._v("\n        ico-icontune\n      ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n        Administrar usuarios\n      ")])],1)],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[_c('v-col',{attrs:{"cols":"40"}},[_c('v-card',{staticClass:"strategio-card-container"},[_c('v-card-text',{staticStyle:{"background-color":"#23A2D9"}},[_c('v-form',{attrs:{"id":"usersfilter-textfield"},on:{"submit":function($event){$event.preventDefault();return _vm.search()}}},[_c('v-text-field',{attrs:{"single-line":"","outlined":"","id":"txtBuscar","name":"txtBuscar","label":"Buscar por nombre, cargo o correo","prepend-inner-icon":"search","autocomplete":"off","rounded":"","hide-details":"auto"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-btn',{staticStyle:{"background-color":"#23A2D9","width":"41px","height":"41px","margin-top":"-9px"},attrs:{"color":"white","id":"search-button","text":"","icon":""},on:{"click":function($event){return _vm.search()}}},[_c('v-icon',[_vm._v("mdi-arrow-right")])],1)],1)]},proxy:true}])})],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0"},[_c('v-data-table',{attrs:{"item-key":"name","headers":_vm.headers,"items":_vm.users,"loading":_vm.isLoading,"sort-by":"users","loading-text":"Loading... Please wait","hide-default-header":""},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var headers = ref.props.headers;
return [_c('thead',{staticStyle:{"background-color":"#FDFDFD"}},[_c('tr',{staticStyle:{"height":"80px"}},_vm._l((headers),function(h){return _c('th',{key:h.class,staticStyle:{"text-align":"center","font-size":"16px","color":"black","font-family":"'Open Sans'"}},[_c('span',[_vm._v(_vm._s(h.text))])])}),0)])]}},(!_vm.isLoading)?{key:"body",fn:function(ref){
var items = ref.items;
return [_c('tbody',_vm._l((items),function(item){return _c('tr',{key:item.name},[_c('td',{staticStyle:{"text-align":"center"},style:(_vm.isEnabled(item.isEnabled))},[_c('v-chip',{attrs:{"color":_vm.getColor(item.userType),"dark":""}},[_vm._v(_vm._s(item.userType))])],1),_vm._v(" "),_c('td',{style:(_vm.isEnabled(item.isEnabled))},[_c('div',[_vm._v("\n                    "+_vm._s(item.name)+"\n                    ")])]),_vm._v(" "),_c('td',{style:(_vm.isEnabled(item.isEnabled))},[_c('div',[_vm._v("\n                    "+_vm._s(item.description)+"\n                    ")])]),_vm._v(" "),_c('td',{style:(_vm.isEnabled(item.isEnabled))},[_c('div',[_vm._v("\n                    "+_vm._s(item.mail)+"\n                    ")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.adminUser(item.userID)}}},[_vm._v("\n                      ico-icon-edit")]),_vm._v(" "),_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.disableUser(item)}}},[_vm._v("\n                      ico-icon-disabled")])],1)])}),0)]}}:null],null,true)})],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/users/users-list.vue
function injectStyle (context) {
  __webpack_require__("L7UV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  users_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_users_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BOr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BRjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var _axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

_axios.interceptors.request.use(function (config) {
  var token = localStorage.token;
  if (token === '' || token === undefined || token === null) {
    return config;
  } else {
    config.headers.Authorization = 'Bearer ' + (token || '');
    return config;
  }
});
_axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    if (error.response.status === 401) {
      console.warn(error);
      error.response.shouldRedirectToLogin = true;
      window.location.hash = '/login';
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.message)
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["default"] = (_axios);

/***/ }),

/***/ "BbCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/structures/structure-item.vue + 2 modules
var structure_item = __webpack_require__("pSq4");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/structure-form-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var structure_form_dialog = ({
  name: 'structure-form-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-structure-form');
    eventBus["default"].$on('open-structure-form', function (data) {
      _this.isNew = data.structureID === undefined;
      _this.structureItems = data.structureItems.map(function (item) {
        return {
          itemName: item.itemName,
          description: _this.folderName + ': ' + item.itemName,
          labels: _this.folderName + ', ' + item.itemName,
          imageUrl: item.imageUrl
        };
      });
      _this.structureName = data.structureName;
      _this.dialog = true;

      _this.checkStructureName();
    });
  },
  data: function data() {
    return {
      isNew: false,
      dialog: false,
      checkingStructureName: false,
      checkingStructureNameMessages: [],
      canSaveStructure: false,
      folderName: '$$FOLDER',
      structureName: '',
      structureItems: []
    };
  },

  methods: {
    checkStructureName: function checkStructureName() {
      var _this2 = this;

      // FIXME: Cuando se cierra el dialog el @blur del nombre de la estructura se sigue ejecutando :/
      if (this.checkingStructureName) {
        return;
      }

      if (this.structureName.trim() === '') {
        this.checkingStructureNameMessages = ['El nombre de estructura no debe estar vacio'];
        return;
      }

      this.checkingStructureName = true;
      this.canSaveStructure = false;
      this.checkingStructureNameMessages = [];

      structureStorage["default"].checkStructureName({
        data: {
          structureName: this.structureName
        },
        onSuccess: function onSuccess(response) {
          _this2.checkingStructureName = false;
          // eslint-disable-next-line
          if (response.data.exists == 1) {
            _this2.checkingStructureNameMessages = ['El nombre de estructura ya existe'];
            _this2.canSaveStructure = false;
          }

          // eslint-disable-next-line
          if (response.data.exists == 0) {
            _this2.canSaveStructure = true;
          }
        },
        onError: function onError() {
          _this2.checkingStructureNameMessages = ['Ha habido un problema con el servidor'];
          _this2.checkingStructureName = false;
        }
      });
    },
    sendNewData: function sendNewData() {
      var _this3 = this;

      var data = {
        structureName: this.structureName,
        folderName: this.folderName,
        structureItems: this.structureItems
      };
      structureStorage["default"].createStructure({
        data: data,
        onSuccess: function onSuccess() {
          // console.log('success yay!')
          _this3.dialog = false;
        },
        onError: function onError(error) {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            // console.log('don worry about it, it just a duplicate')
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'Nombre de la plantilla es duplicado' });
          }
          // console.log('error fuck!')
        }
      });
    }
  },
  components: {
    StructureItem: structure_item["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5a49932","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/structure-form-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":true,"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.isNew ? 'Crear structura' : 'Editar structura'))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Nombre de la structura","loading":_vm.checkingStructureName,"error-messages":_vm.checkingStructureNameMessages},on:{"blur":function($event){return _vm.checkStructureName()}},model:{value:(_vm.structureName),callback:function ($$v) {_vm.structureName=$$v},expression:"structureName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombre del Folder","value":_vm.folderName,"readonly":""}}),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.structureItems),function(i,$index){return _c('structure-item',{key:$index,attrs:{"xs12":"","structure-item-data":i}})}),1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-2","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canSaveStructure,"color":"blue darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.sendNewData()}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/structure-form-dialog.vue
function injectStyle (context) {
  __webpack_require__("KhW7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  structure_form_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_structure_form_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Bm+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./src/utils/storageCleaner.js
var storageCleaner = __webpack_require__("Rqrm");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var login = ({
  name: 'login',
  data: function data() {
    delete localStorage.token;
    delete localStorage.user;
    storageCleaner["default"].cleanStorage();
    return {
      msg: 'Welcome to Your Vue.js App',
      hidePassword: true,
      errorMessage: '',
      isLoading: false,
      brandMessage: {
        title: 'Y tú ¿Cuánto vendiste ayer?',
        subtitle: 'Analiza lo mejor. Todo es realidad con nosotros'
      },
      showNew: true,
      newPassword: '',
      newMail: '',
      confirmPassword: '',
      canChangePassword: false,
      showInterface: false
    };
  },

  methods: {
    logIn: function logIn(e) {
      var _this = this;

      e.preventDefault();
      this.errorMessage = '';
      this.isLoading = true;

      var user = document.getElementById('txtUser').value;
      var password = document.getElementById('txtPassword').value;
      auth["default"].login({
        context: this,
        creds: { user: user, password: password },
        onSuccess: function onSuccess(response) {
          _this.isLoading = false;
          console.log(response.data.user);
          if (response.data.user.forceChangePassword === 1) {
            response.data.status = '1';
            response.data.message = 'OK';
            _this.$router.push({ name: 'UserAccount', params: { showStrategioAppBar: false } });
          } else {
            if (response.data.user.userType === 'SUPERVISOR') {
              // this.$router.push('/supervise/dashboard')
              _this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              });
            } else {
              // this.$router.push('/0')
              _this.$router.push({
                name: 'MainPage',
                params: { folderID: '0', firstTimeMenu: true }
              });
            }
          }
        },
        onError: function onError(error) {
          _this.isLoading = false;
          var errMessage = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            errMessage = error.response.data.message;
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            errMessage = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            errMessage = 'Error desconocido: ' + error.errorMessage;
          }
          _this.errorMessage = errMessage;
          // console.log(error.config)
        }
      });
      return false;
    },
    restaurar_pwd: function restaurar_pwd(e) {
      var _this2 = this;

      e.preventDefault();
      this.errorMessage = '';
      this.isLoading = true;

      var mail = document.getElementById('txtCorreo').value;
      auth["default"].correo_recuperacion({
        context: this,
        creds: { mail: mail },
        onSuccess: function onSuccess(response) {
          _this2.isLoading = false;
          console.log(response.data.status);
          if (response.data.status === '1') {
            _this2.showNewFilter();
            response.data.status = '1';
            _this2.errorMessage = response.data.message;
          }
        },
        onError: function onError(error) {
          _this2.isLoading = false;
          var errMessage = 'Error desconocido';
          if (error.response) {
            errMessage = error.response.data.message;
          } else if (error.request) {
            errMessage = 'No pudimos obtener respuesta del servidor';
          } else {
            errMessage = 'Error desconocido: ' + error.errorMessage;
          }
          _this2.errorMessage = errMessage;
        }
      });
      return false;
    },
    validatePassword: function validatePassword() {
      this.canChangePassword = this.newPassword === this.confirmPassword && this.newPassword.length >= 6;
      return this.canChangePassword || 'Los passwords deben ser iguales';
    },
    cambiar_pwd: function cambiar_pwd(e) {
      var _this3 = this;

      e.preventDefault();
      this.errorMessage = '';
      this.isLoading = false;

      var mail = this.newMail;
      var customCode = document.getElementById('txtCodigo').value;
      var pwd = this.newPassword;
      var confirmPwd = this.confirmPassword;

      if (pwd !== confirmPwd) {
        this.errorMessage = 'Las contraseñas no coinciden';
      } else {
        this.isLoading = true;
        auth["default"].correo_change_pwd({
          context: this,
          creds: { mail: mail, customCode: customCode, pwd: pwd, confirmPwd: confirmPwd },
          onSuccess: function onSuccess(response) {
            _this3.isLoading = false;
            console.log(response.data.status);
            if (response.data.status === '1') {
              _this3.showNewInterface2();
              response.data.status = '1';
              _this3.errorMessage = 'Contraseña actualizada correctamente';
            }
          },
          onError: function onError(error) {
            _this3.isLoading = false;
            _this3.newMail = '';
            _this3.newPassword = '';
            _this3.confirmPassword = '';
            var errMessage = 'Error desconocido';
            if (error.response) {
              errMessage = error.response.data.message;
            } else if (error.request) {
              errMessage = 'No pudimos obtener respuesta del servidor';
            } else {
              errMessage = 'Error desconocido: ' + error.errorMessage;
            }
            _this3.errorMessage = errMessage;
          }
        });
      }

      return false;
    },
    showNewFilter: function showNewFilter() {
      this.showNew = !this.showNew;
    },
    showNewInterface: function showNewInterface() {
      this.showInterface = !this.showInterface;
      this.showNew = !this.showNew;
    },
    showNewInterface2: function showNewInterface2() {
      this.showInterface = !this.showInterface;
      this.showNew = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765af9d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pa-6",style:([
    {'background-image': ("url('" + (__webpack_require__("dkhU")) + "')")},
    {'background-repeat': 'no-repeat'},
    {'background-size': 'cover'}
    ])},[_c('v-container',{attrs:{"id":"login","fluid":""}},[_c('v-row',{staticClass:"py-md-4 ma-lg-4",attrs:{"align-content":"center"}},[_c('v-col',[_c('v-img',{attrs:{"width":"253px","height":"auto","src":__webpack_require__("KaMS")}})],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8",staticStyle:{"padding-top":"0px!important","padding-bottom":"0px!important"}}),_vm._v(" "),_c('v-row',{staticClass:"pt--md-16 ma-5"},[_c('v-col',{staticClass:"py-3"},[_c('div',{staticClass:"text-sm-left",attrs:{"id":"brand-message-title"}},[_vm._v("\n            "+_vm._s(_vm.brandMessage.title)+"\n          ")]),_vm._v(" "),_c('div',{attrs:{"id":"brand-message-subtitle"}},[_vm._v("\n            "+_vm._s(_vm.brandMessage.subtitle)+"\n          ")])])],1)],1)],1),_vm._v(" "),_c('v-col',{style:([
    {'background-color': "#FBFBFB"}      
    ])},[_c('v-container',{attrs:{"id":"login","fluid":""}},[_c('v-col',[_c('v-row',{staticClass:"py-md-4 ma-lg-3",staticStyle:{"padding-bottom":"0px!important"},attrs:{"align-content":"center"}},[_c('v-col',[_c('v-img',{attrs:{"width":"235px","height":"auto","src":__webpack_require__("KDbQ")}})],1)],1),_vm._v(" "),_c('v-row',{attrs:{"align-content":"center"}},[_c('v-col',[_c('v-form',{on:{"submit":function($event){return _vm.logIn($event)}}},[_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showInterface),expression:"!showInterface"}],staticClass:"pa-lg-16 mx-lg-16",staticStyle:{"padding":"6px!important"},attrs:{"elevation":"0","color":"#FBFBFB"}},[_c('v-row',{staticClass:"hidden-xs-only"},[_c('v-col',{attrs:{"cols":"8","align-self":"center"}},[_c('v-card-text',{staticClass:"text-h4",staticStyle:{"color":"#25235F","-webkit-text-stroke":"0.8px","height":"auto","font-size":"11vw","font-weight":"bold"}},[_vm._v("\n                    Inicia Sesión\n                    ")])],1),_vm._v(" "),_c('v-col',{attrs:{"align-self":"center","cols":"3","offset-lg":"1"}},[_c('v-img',{attrs:{"width":"83.83px","height":"auto","src":__webpack_require__("pCjg")}})],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Usuario\n                    ")]),_vm._v(" "),_c('v-text-field',{staticClass:"pa-xs-0 txtUser",staticStyle:{"margin-bottom":"-20px"},attrs:{"id":"txtUser","name":"txtUser","prepend-inner-icon":"person_outline","outlined":"","background-color":"#FFFFFF"}})],1),_vm._v(" "),_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Contraseña\n                    ")]),_vm._v(" "),_c('v-text-field',{style:([{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]),attrs:{"id":"txtPassword","name":"txtPassword","prepend-inner-icon":"lock_outline","append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"type":_vm.hidePassword ? 'password' : 'text',"outlined":"","background-color":"#FFFFFF"},on:{"click:append":function($event){_vm.hidePassword = !_vm.hidePassword}}})],1),_vm._v(" "),_c('div',{staticClass:"strategio-login-error-message"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage)+"\n                  ")]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.showNewInterface}},[_vm._v("Olvidaste tu contraseña?")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{staticClass:"mx-0",staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"14px","width":"150px"},attrs:{"large":"","rounded":"","depressed":"","type":"submit","loading":_vm.isLoading,"disabled":_vm.isLoading},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("\n                      Ingresar\n                    ")])],1)])],1),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInterface),expression:"showInterface"}],staticClass:"pa-lg-16 mx-lg-16",staticStyle:{"padding":"6px!important"},attrs:{"elevation":"0","color":"#FBFBFB"}},[_c('v-row',{staticClass:"hidden-xs-only"},[_c('v-col',{attrs:{"cols":"8","align-self":"center"}},[_c('v-card-text',{staticClass:"text-h4",staticStyle:{"color":"#25235F","-webkit-text-stroke":"0.8px","height":"auto","font-size":"24px!important","font-weight":"bold"}},[_vm._v("\n                    Recuperar Contraseña\n                    ")])],1),_vm._v(" "),_c('v-col',{attrs:{"align-self":"center","cols":"3","offset-lg":"1"}},[_c('v-img',{attrs:{"width":"83.83px","height":"auto","src":__webpack_require__("pCjg")}})],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showNew),expression:"!showNew"}]},[_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Ingrese correo de recuperación\n                    ")]),_vm._v(" "),_c('v-text-field',{staticClass:"pa-xs-0 txtUser",staticStyle:{"margin-bottom":"-20px"},attrs:{"id":"txtCorreo","name":"txtCorreo","prepend-inner-icon":"person_outline","outlined":"","background-color":"#FFFFFF"},model:{value:(_vm.newMail),callback:function ($$v) {_vm.newMail=$$v},expression:"newMail"}})],1),_vm._v(" "),_c('div',{staticClass:"strategio-login-error-message"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage)+"\n                  ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"14px","width":"180px"},attrs:{"rounded":"","depressed":"","loading":_vm.isLoading,"disabled":_vm.newMail === '' || _vm.isLoading},on:{"click":_vm.restaurar_pwd},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("\n                      Enviar código\n                    ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"14px","width":"180px"},attrs:{"rounded":"","depressed":""},on:{"click":_vm.showNewInterface}},[_vm._v("\n                      Volver  \n                    ")])],1)]),_vm._v(" "),_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNew),expression:"showNew"}]},[_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Código\n                    ")]),_vm._v(" "),_c('v-text-field',{staticClass:"pa-xs-0 txtUser",staticStyle:{"margin-bottom":"-20px"},attrs:{"id":"txtCodigo","name":"txtCodigo","label":"Escribe el código que enviamos a tu correo","prepend-inner-icon":"person_outline","outlined":"","background-color":"#FFFFFF"}})],1),_vm._v(" "),_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Contraseña\n                    ")]),_vm._v(" "),_c('v-text-field',{style:([{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]),attrs:{"id":"txtNewPassword","name":"txtNewPassword","label":"Escribe tu nueva contraseña","prepend-inner-icon":"lock_outline","append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"type":_vm.hidePassword ? 'password' : 'text',"rules":[function (v) { return v && v.length > 5 || 'Minimo 6 characters'; }],"min":6,"single-line":"","background-color":"#FFFFFF"},on:{"click:append":function($event){_vm.hidePassword = !_vm.hidePassword}},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1),_vm._v(" "),_c('div',[_c('v-card-text',{staticStyle:{"color":"#25235F","font-size":"16px","font-weight":"700"},attrs:{"contain":true}},[_vm._v(" Confirmar Contraseña\n                    ")]),_vm._v(" "),_c('v-text-field',{style:([{'font-family': 'Open Sans'}, {'font-weight': '700'}, {'color': 'rgba(0, 0, 0, 0.3)'}]),attrs:{"id":"txtConfirmPassword","name":"txtConfirmPassword","label":"Confirma la nueva contraseña","prepend-inner-icon":"lock_outline","rules":[_vm.validatePassword()],"append-icon":_vm.hidePassword ? 'visibility' : 'visibility_off',"type":_vm.hidePassword ? 'password' : 'text',"single-line":"","background-color":"#FFFFFF"},on:{"click:append":function($event){_vm.hidePassword = !_vm.hidePassword}},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1),_vm._v(" "),_c('div',{staticClass:"strategio-login-error-message"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage)+"\n                  ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"14px","width":"150px"},attrs:{"rounded":"","depressed":"","disabled":!_vm.canChangePassword || _vm.newPassword === ''},on:{"click":_vm.cambiar_pwd}},[_vm._v("\n                     Guardar\n                    ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"background-color":"#23A2D9","color":"white","font-size":"14px","width":"150px"},attrs:{"rounded":"","depressed":""},on:{"click":_vm.showNewInterface2}},[_vm._v("\n                      Volver  \n                    ")])],1)])],1)],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8"}),_vm._v(" "),_c('v-row',{staticClass:"pa-md-8 ma-md-8"})],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"px-4 mb-2 text-right",staticStyle:{"font-size":"10px","color":"black"},attrs:{"color":"transparent"}},[_c('v-col',[_vm._v("\n        © TODOS LOS DERECHOS RESERVADOS - VIDA SOFTWARE\n      ")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/login.vue
function injectStyle (context) {
  __webpack_require__("iu63")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  login,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_login = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BmF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/menus/item-menu.vue + 2 modules
var item_menu = __webpack_require__("F7n2");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reports/report-list-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var report_list_item = ({
  name: 'report-list-item',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    var previewImage = reportsStorage["default"].getDefaultPreviewImage();
    var placeholderImage = reportsStorage["default"].getDefaultPlaceholderImage();
    return {
      previewImage: previewImage,
      placeholderImage: placeholderImage,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    };
  },

  methods: {
    searchByChip: function searchByChip(c) {
      this.searchProps.searchCriteria = c;
      this.searchItems();
    },
    getImageUrl: function getImageUrl(report) {
      var reportImage = '';
      var reportImagesFolderPath = 'assets/report-imgs';
      var images = {
        isExcel: reportImagesFolderPath + '/icon-excel.png',
        isPowerBI: reportImagesFolderPath + '/icon-powerbi.png',
        custom1: reportImagesFolderPath + '/icon-alt1.png',
        custom2: reportImagesFolderPath + '/icon-alt2.png'
      };

      if (!report.imageUrl) {
        // Siempre y cuando no lleven imageUrl
        if (report.isPowerBI) {
          reportImage = images.isPowerBI;
        } else {
          reportImage = images.isExcel;
        }
        reportImage = __webpack_require__("+gN6")("./" + reportImage);
      } else {
        reportImage = report.imageUrl;
      }
      return reportImage;
    },
    setFavorite: function setFavorite(e, report) {
      // if (this.favoritesPage) {
      //   if (report.isFavorite === 0 || report.isFavorite === false) {
      //     return
      //   }
      // } else {
      //   if (report.isFavorite === 1 || report.isFavorite === true) {
      //     return
      //   }
      // }

      e.stopPropagation();

      if (this.userType !== 'DEMO') {
        report.isFavorite = !report.isFavorite;
        this.isFavorite = report.isFavorite;
        reportsStorage["default"].setFavorite(report.itemID, report.isFavorite, {});
      }
    },
    getChipsData: function getChipsData(text) {
      if (text) {
        text = text.replace('$$FOLDER', this.containedBy.itemName);
        return text.split(',').map(function (item, index) {
          return item.trim();
        });
      }
      return [];
    },
    showReport: function showReport(data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización ni de descarga', itsOk: 'warning' });
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank');
          reportsStorage["default"].registerView(data.itemID, 'DOWNLOAD');
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning' });
        }
      } else {
        var _isFavorite = '';
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1';
        }
        this.$router.push('/show-report/' + data.itemID + _isFavorite);
      }
    }
  },
  props: {
    reportData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    favoritesPage: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    containedBy: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    searchProps: {
      type: Object,
      default: function _default() {
        return { searchCriteria: '' };
      }
    },
    searchItems: {
      type: Function,
      default: function _default() {
        return function () {
          alert('Err func');
        };
      }
    },
    'hideFavoriteIcon': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    ItemMenu: item_menu["default"]
  },
  computed: {
    getItemSubtitle: function getItemSubtitle() {
      var itemFolder = '';
      if (this.reportData.containedBy > 0) {
        itemFolder = reportsStorage["default"].findItemByID(this.reportData.containedBy);
      }

      if (itemFolder === '') {
        return '';
      }
      return itemFolder.itemName;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21b17e04","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/report-list-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.reportData.hidden || _vm.isAdmin)?_c('v-card',{staticClass:"d-flex flex-column justify-center align-start report-list-item-card",class:{
    'strategio-hidden-item': _vm.reportData.hidden
  },style:([
    {'height': '282px'},
    {'min-width': '313px'},
    {'width': '313px'},
    {'margin': '20px'},
    {'overflow': 'hidden'},
    {'background': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'},
    {'border-radius': '10px'}
  ]),attrs:{"outlined":""},on:{"click":function($event){return _vm.showReport(_vm.reportData)}}},[(_vm.reportData.imageUrl)?_c('div',[_c('img',{staticClass:"report-list-item-img",attrs:{"src":_vm.getImageUrl(_vm.reportData),"alt":"report-img"}})]):_c('div',{staticClass:"img-circle d-flex justify-center align-center"},[_c('img',{attrs:{"height":"61.89","width":"61.89","src":_vm.getImageUrl(_vm.reportData),"alt":"report-img"}})]),_vm._v(" "),(!_vm.hideFavoriteIcon)?_c('div',{staticStyle:{"position":"absolute","right":"13px","top":"25px"}},[(_vm.reportData.isFavorite)?_c('div',[_c('v-btn',{staticStyle:{"-webkit-text-stroke":"0.3px #2AFE4C"},attrs:{"icon":"","small":"","color":"#2AFE4C"},on:{"click":function($event){return _vm.setFavorite($event, _vm.reportData)}}},[_c('v-icon',[_vm._v("ico-icon-star-2")])],1)],1):_c('div',[_c('v-btn',{staticStyle:{"-webkit-text-stroke":"0.3px #2AFE4C"},attrs:{"icon":"","small":"","color":"#2AFE4C"},on:{"click":function($event){return _vm.setFavorite($event, _vm.reportData)}}},[_c('v-icon',[_vm._v("ico-icon-star")])],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"strategio-report-card-title",staticStyle:{"margin-top":"15px"}},[_vm._v("\n    "+_vm._s(_vm.reportData.itemName)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"strategio-report-card-subtitle",staticStyle:{"margin-top":"10px"}},[_vm._v("\n    "+_vm._s(_vm.getItemSubtitle)+"\n  ")]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"9px","bottom":"25px"}},[(_vm.isAdmin || _vm.reportData.url2.trim() !== '')?_c('item-menu',{attrs:{"contained-by":_vm.containedBy,"item":_vm.reportData,"is-searching":_vm.isSearching}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/reports/report-list-item.vue
function injectStyle (context) {
  __webpack_require__("KyHA")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  report_list_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_report_list_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CDy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./node_modules/powerbi-client/dist/powerbi.js
var dist_powerbi = __webpack_require__("http");
var powerbi_default = /*#__PURE__*/__webpack_require__.n(dist_powerbi);

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/show-report-bi.vue
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var show_report_bi = ({
  name: 'show-metabase',
  data: function data() {
    return {
      url: uris["default"].URL_POWERBI_ID
    };
  },

  components: {
    StrategioAppBar: strategio_app_bar["default"]
  },
  methods: {
    loadReport: function loadReport() {
      var _this = this;

      reportsStorage["default"].getAccessToken(this.url, function (at) {
        _this.loadPowerBiFolder(_this.url, at.accessToken);
      });
    },
    loadPowerBiFolder: function loadPowerBiFolder(rId, at) {
      // Report's Secured Token
      var accessToken = at;

      // Embed URL
      var embedUrl = 'https://app.powerbi.com/reportEmbed?groupId=3ddccf9f-ba6a-4ce2-8f78-8a5e15cfb780';

      // Report ID
      var embedReportId = rId;

      var models = dist_powerbi["models"];

      var config = {
        type: 'report',
        accessToken: accessToken,
        embedUrl: embedUrl,
        id: embedReportId,
        permissions: models.Permissions.All

        // Grab the reference to the div HTML element that will host the report.
      };var reportContainer = document.getElementById('reportContainer');

      // Embed the report and display it within the div container.
      var powerbi = new dist_powerbi["service"].Service(dist_powerbi["factories"].hpmFactory, dist_powerbi["factories"].wpmpFactory, dist_powerbi["factories"].routerFactory);
      var report = powerbi.embed(reportContainer, config);

      // Report.off removes a given event handler if it exists.
      report.off('loaded');

      // Report.on will add an event handler which prints to Log window.
      report.on('loaded', function () {
        // console.log('Loaded')
      });
    }
  },
  mounted: function mounted() {
    this.loadReport();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b955d06","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-report-bi.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('div',{staticClass:"strategio-iframe",attrs:{"id":"reportContainer"}})])])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/show-report-bi.vue
function injectStyle (context) {
  __webpack_require__("J6/d")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_report_bi,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_show_report_bi = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CY8Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cy8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header-bar/strategio-app-bar.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ var strategio_app_bar = (defineProperty_default()({
  name: "strategio-app-bar",
  data: function data() {
    var userInfo = userStorage["default"].getUserInfo();
    if (keys_default()(userInfo).length === 0) {
      this.$router.push("login");
    }
    var showDrawer = !["xs", "sm", "md"].includes(this.$vuetify.breakpoint.name);
    return {
      userInfo: userInfo,
      showMenu: userInfo.userType !== "DEMO",
      showSupervise: ["ADMIN", "SUPERVISOR"].indexOf(userInfo.userType) > -1,
      showAdmin: userInfo.userType === "ADMIN",
      autoserviceAccess: userInfo.autoserviceAccess === 1,
      manageUserAccess: userInfo.manageUserAccess === 1,
      drawer: showDrawer,
      acron: this.getAcron(userInfo.name),
      currentLocation: this.$route.name,
      tutorialDisabled: true,
      mini: true,
      countFavorite: 0,
      biCondition: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    eventBus["default"].$off("enable-tutorial-button");
    eventBus["default"].$on("enable-tutorial-button", function () {
      _this.tutorialDisabled = false;
    });
  },

  methods: {
    startTutorial: function startTutorial() {
      introBus["default"].setIntroBus(introBus["default"].getVueInstance().$intro());
      var intro = introBus["default"].getIntroBus();
      // intro.onskip(() => {}) // Fixed intro.js bug

      intro.setOptions({
        disableInteraction: true,
        scrollToElement: true,
        skipLabel: "Salir",
        nextLabel: "Siguiente",
        prevLabel: "Previo",
        doneLabel: "Listo",
        tooltipClass: "strategio-introjs-customclass",
        steps: [{
          element: "#favorite-button",
          intro: "Este botón le llevará a la sección de reportes marcados como favoritos. Desde allí también se podrá desmarcar cualquier reporte"
        }]
      });

      switch (this.currentLocation) {
        case "Login":
          break;
        case "MainPage":
          // emits to: /routes/main-page.vue
          eventBus["default"].$emit("start-main-page-tutorial");
          break;
        case "SearchItems":
          break;
        case "ShowReport":
          break;
        case "Favorites":
          break;
        case "UserAccount":
        case "UserAdminByID":
        case "UserAdminCreate":
          // emits to: /components/users/user-form.vue
          eventBus["default"].$emit("start-user-form-tutorial");
          break;
        case "UserAdmin":
          // emits to: /routes/user-admin.vue
          eventBus["default"].$emit("start-user-admin-tutorial");
          break;
        case "SuperviseDashboard":
          // emits to: /routes/supervise-dashboard.vue
          eventBus["default"].$emit("start-supervise-dashboard-tutorial");
          break;
        default:
          break;
      }
    },
    toggleSearchBar: function toggleSearchBar() {
      // emites to: routes/main-page.vue
      eventBus["default"].$emit("toggle-search-bar");
    },
    isProfileImage: function isProfileImage(url) {
      if (url) {
        return url.trim() !== "";
      }
      return false;
    },
    getAcron: function getAcron(text) {
      var acron = "";
      if (text.length > 1) {
        var matches = text.match(/\b(\w)/g);
        acron = matches.length > 1 ? matches[0] + matches[1] : text[0] + text[1];
      }
      return acron.toUpperCase();
    },
    goBack: function goBack() {
      // Retrocendiendo una pagina
      this.$router.go(-1);

      // Ocultando el boton de retroceso
      this.biCondition = false;
    },
    goHome: function goHome() {
      this.$router.push("/0");
    },
    goFavorites: function goFavorites() {
      this.$router.push("/user/favorites");
    },
    goReports: function goReports() {
      this.$router.push("/reports/info");
    },
    goDownloadCube: function goDownloadCube() {
      this.$router.push("/download-cube/info");
    },
    goMyAccount: function goMyAccount() {
      this.$router.push("/user/account");
    },
    goAdmin: function goAdmin() {
      this.$router.push("/user/admin");
    },
    goSupervise: function goSupervise() {
      this.$router.push("/supervise/dashboard");
    },
    goHelpdesk: function goHelpdesk() {
      if (uris["default"].URL_HELPDESK.length === 0) return;
      window.open(uris["default"].URL_HELPDESK, '_blank').focus();
      // this.$router.push({name: 'ShowHelpdesk'})
    },
    goAutoservicio: function goAutoservicio() {
      this.$router.push("/apps/info");
    },
    logOut: function logOut() {
      this.$router.push("/login");
    }
  },
  props: {
    searchCriteria: {
      type: String,
      default: function _default() {
        return "halp";
      }
    },
    searchProps: {
      type: Object,
      default: function _default() {
        return { searchCriteria: "" };
      }
    },
    searchItems: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    showTopPanel: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  }
}, "mounted", function mounted() {
  var _this2 = this;

  reportsStorage["default"].getCountFavorite({
    onSuccess: function onSuccess(data) {
      _this2.countFavorite = data;
    }
  });
  // this.changeStatus(biCondition);
  // document.getElementById('back-button');
}));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3152a575","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-bar/strategio-app-bar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.showTopPanel)?_c('v-app-bar',{staticStyle:{"box-shadow":"0px 0px 10px rgba(0, 0, 0, 0.25)"},attrs:{"app":"","color":"white","height":"87"}},[_c('v-app-bar-nav-icon',{staticClass:"ml-3 px-2 hidden-lg-and-up",on:{"click":function($event){_vm.drawer = true}}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("mdi-menu")])],1),_vm._v(" "),_c('v-col',{staticStyle:{"padding-left":"5%"},attrs:{"cols":"3"}},[_c('v-toolbar-title',{staticClass:"ml-2"},[_c('v-img',{attrs:{"width":"205px","src":__webpack_require__("KDbQ"),"alt":"strategio-logo"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"5"}},[(!['xs'].includes(_vm.$vuetify.breakpoint.name))?_c('v-text-field',{staticClass:"hidden-xs-only ",attrs:{"id":"filter-textfield","single-line":"","filled":"","rounded":"","hide-details":"auto","height":"50"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchItems()}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"search-text-label"},[_vm._v("\n            Buscar reporte\n          ")])]},proxy:true},{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"search-text-prepend",attrs:{"size":"15.83px"}},[_vm._v("ico-icons_search")])]},proxy:true},{key:"append",fn:function(){return [_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('v-btn',{staticStyle:{"background-color":"#2262C6","width":"41px","height":"41px","margin-top":"-10px","margin-right":"-17px"},attrs:{"color":"white","id":"search-button","text":"","icon":""},on:{"click":function($event){return _vm.searchItems()}}},[_c('v-icon',[_vm._v("mdi-arrow-right")])],1)],1)]},proxy:true}],null,false,714951237),model:{value:(_vm.searchProps.searchCriteria),callback:function ($$v) {_vm.$set(_vm.searchProps, "searchCriteria", $$v)},expression:"searchProps.searchCriteria"}}):_vm._e()],1),_vm._v(" "),_c('v-btn',{staticClass:"hidden-sm-and-up",attrs:{"disabled":false,"text":"","icon":""},on:{"click":_vm.toggleSearchBar}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-avatar',{staticStyle:{"margin-left":"136px","margin-right":"21px"},attrs:{"tile":false,"size":"45px"},on:{"click":function($event){return _vm.goMyAccount()}}},[_c('v-img',{attrs:{"src":__webpack_require__("9Mjp")}})],1),_vm._v(" "),_c('div',{staticClass:"hidden-xs-only",staticStyle:{"margin-right":"45.5px"}},[_c('v-row',[_c('span',{staticClass:"app-bar-text",staticStyle:{"color":"#25235F","font-weight":"bold"}},[_vm._v(_vm._s(_vm.userInfo.name))])]),_vm._v(" "),_c('v-row',[_c('span',{staticClass:"app-bar-text-subtitle"},[_vm._v(_vm._s(_vm.userInfo.company))])])],1),_vm._v(" "),_c('v-badge',{attrs:{"color":"#23A2D9","content":this.countFavorite,"value":this.countFavorite > 0,"overlap":""}},[_c('v-btn',{attrs:{"icon":"","small":"","size":"28.8px","color":"#25235F","id":"favorite-button"},on:{"click":function($event){return _vm.goFavorites()}}},[_c('v-icon',[_vm._v("ico-icon-star-2")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{staticStyle:{"border-radius":"0px"},attrs:{"app":"","mini-variant":_vm.mini,"color":"#2262C6","mini-variant-width":"80","width":"300"},on:{"update:miniVariant":function($event){_vm.mini=$event},"update:mini-variant":function($event){_vm.mini=$event}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticStyle:{"border-top":"0px lightgray solid","padding-top":"0px"}},[_c('v-list-item',{staticStyle:{"height":"87px"},on:{"click":function($event){_vm.mini = !_vm.mini}}},[_c('v-list-item-icon',{staticStyle:{"position":"absolute","left":"15px","top":"9px"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"size":"30","color":"white"}},[_vm._v("\n              "+_vm._s(_vm.mini ? 'ico-icon-eye-slashed-1' : 'close')+"\n            ")])],1)],1)],1),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goHome()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'MainPage'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-home")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{style:({'color': '#FFFFFF'})},[_vm._v("Home")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goReports()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'Reports'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-report")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{style:({'color':'#FFFFFF'})},[_vm._v("Reportes")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goDownloadCube()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'DownloadCube'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("mdi-cloud-download")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{style:({'color':'#FFFFFF'})},[_vm._v("Descargar Cubo")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goFavorites()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'Favorites'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-star")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Mis Favoritos")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goMyAccount()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'UserAccount'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-user")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Mi Perfil")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goHelpdesk()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'ShowHelpdesk'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-headphone")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Helpdesk")])],1)],1),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),(_vm.showAdmin || _vm.manageUserAccess)?_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goAdmin()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'UserAdmin'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icontune")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{style:({'color': _vm.currentLocation === 'UserAdmin' || _vm.currentLocation === 'UserAdminByID' || _vm.currentLocation === 'UserAdminCreate' ? 'white' : 'white'})},[_vm._v("Administrar")])],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),(_vm.showAdmin || _vm.autoserviceAccess)?_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.goAutoservicio()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{class:{'selected-menu': _vm.currentLocation === 'Apps'},staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"}},[_vm._v("ico-icon-config")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Apps")])],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticStyle:{"border-color":"white","opacity":"10%"}}),_vm._v(" "),_c('v-list-item',{class:['v-item'],on:{"click":function($event){return _vm.logOut()}}},[_c('v-list-item-action',{staticStyle:{"margin-right":"5%"}},[_c('v-btn',{staticStyle:{"height":"40px","width":"40px"},attrs:{"icon":"","dark":"","large":""}},[_c('v-icon',{staticStyle:{"font-size":"x-large"},attrs:{"color":"white"}},[_vm._v("ico-icon-close")])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"color":"#FFFFFF"}},[_vm._v("Cerrar sesion")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/header-bar/strategio-app-bar.vue
function injectStyle (context) {
  __webpack_require__("Jitg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  strategio_app_bar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var header_bar_strategio_app_bar = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D01m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pregunta-tus-datos.07c8c3e.png";

/***/ }),

/***/ "DITZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/groups/autoservicio-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var autoservicio_group = ({
  name: 'autoservicio-group',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    };
  },

  components: {},
  props: {
    processGroup: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    enterProcessGroup: function enterProcessGroup() {
      this.$router.push('/apps/group/' + this.processGroup.groupID);
    }
  },
  computed: {},
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418005f7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/groups/autoservicio-group.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center",class:{
    'strategio-hidden-item': _vm.processGroup.isEnabled === 0
  },style:([
    {'height': '282px'},
    {'width': '313px'},
    {'margin': '20px'},
    {'overflow': 'hidden'},
    {'background': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'},
    {'border-radius': '10px'}
  ]),attrs:{"outlined":""},on:{"click":_vm.enterProcessGroup}},[_c('div',[_c('v-icon',{staticStyle:{"font-size":"52px"},attrs:{"color":'black'}},[_vm._v("ico-icon-config")])],1),_vm._v(" "),_c('div',{staticClass:"strategio-autoservicio-card-title",staticStyle:{"margin-top":"15px"}},[_vm._v("\n    "+_vm._s(_vm.processGroup.groupName)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/groups/autoservicio-group.vue
function injectStyle (context) {
  __webpack_require__("eDGn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418005f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_group,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var groups_autoservicio_group = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DXN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EmU2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-powerbi.efb3cda.png";

/***/ }),

/***/ "Eqwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/components/autoservicios/groups/autoservicio-group.vue + 2 modules
var autoservicio_group = __webpack_require__("DITZ");

// EXTERNAL MODULE: ./src/components/custom-loading.vue + 2 modules
var custom_loading = __webpack_require__("OxhJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/groups/autoservicio-list-groups.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var autoservicio_list_groups = ({
  name: 'autoservicio-list-groups',
  data: function data() {
    return {
      loadingPage: true,
      processGroups: []
    };
  },

  components: {
    AutoservicioGroup: autoservicio_group["default"],
    CustomLoading: custom_loading["default"]
  },
  methods: {
    getStructure: function getStructure() {
      var _this = this;

      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_GROUPS).then(function (response) {
        _this.processGroups = response.data;
      }).catch(function (err) {
        console.warn('No se ha podido obtener data del autoservicio', err);
      }).finally(function () {
        _this.loadingPage = false;
      });
    }
  },
  props: {},
  computed: {},
  mounted: function mounted() {
    this.getStructure();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d592ccb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/groups/autoservicio-list-groups.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-container',[(_vm.loadingPage)?_c('v-row',{staticClass:"d-flex justify-center"},[_c('custom-loading')],1):_c('v-row',_vm._l((_vm.processGroups),function(processGroup,idx){return _c('autoservicio-group',{key:idx,attrs:{"id":'autoservicioListGroups' + idx,"processGroup":processGroup}})}),1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/groups/autoservicio-list-groups.vue
function injectStyle (context) {
  __webpack_require__("QUgZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d592ccb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_list_groups,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var groups_autoservicio_list_groups = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F7A0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-distributors-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var show_distributors_dialog = ({
  data: function data() {
    return {
      dialog: false,
      distributorFilter: '',
      distributors: [],
      status: {
        success: { color: 'green' },
        closeSuccess: { color: 'green lighten-2' },
        warning: { color: 'amber' },
        danger: { color: 'red' },
        default: { color: 'grey' },
        base: { color: 'grey lighten-2' }
      }
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-show-distributors-dialog');
    eventBus["default"].$on('open-show-distributors-dialog', function (distributors) {
      _this.distributors = distributors;
      _this.dialog = true;
    });
  },

  methods: {
    editItem: function editItem(item) {
      // emit to: /components/dialogs/distributor-form-dialog.vue
      eventBus["default"].$emit('open-distributor-form', item);
    },
    removeItem: function removeItem(item) {
      // emit to: /components/dialogs/are-you-sure-dialog.vue
      eventBus["default"].$emit('open-are-you-sure-dialog', {
        title: 'Eliminar',
        message: '¿Estás seguro de que deseas borrar esta distribuidora?',
        onOk: function onOk() {
          supervisorStorage["default"].removeDistributor({
            data: {
              item: item
            }
          });
        }
      });
    },
    statusColorItem: function statusColorItem(item) {
      var statusColor = this.status.base.color;

      var setDistributorName = item.distributorName && item.distributorName.trim() !== '';
      var setRemoteFileName = item.remoteFileName && item.remoteFileName.trim() !== '';
      var setDistributorCode1 = item.distributorCode1 && item.distributorCode1.trim() !== '';
      var setDistributorCode2 = item.distributorCode2 && item.distributorCode2.trim() !== '';
      var setDistributorCode3 = item.distributorCode3 && item.distributorCode3.trim() !== '';

      // Validaciones de estado
      var obligatoryValues = setDistributorName;
      var secundaryValues = setRemoteFileName && setDistributorCode1 && setDistributorCode2; // && setDistributorCode3
      var optionalValues = setDistributorCode3;

      var someSecundaryValues = setRemoteFileName || setDistributorCode1 || setDistributorCode2 || setDistributorCode3;
      var onlyObligatoryValues = obligatoryValues && !secundaryValues;
      var normalValues = obligatoryValues && secundaryValues;
      var allValues = obligatoryValues && secundaryValues && optionalValues;

      var successConfig = allValues;
      var closeSuccessConfig = normalValues;
      var warningConfig = obligatoryValues && someSecundaryValues;
      var defaultConfig = onlyObligatoryValues;
      var dangerConfig = !onlyObligatoryValues;

      if (successConfig) statusColor = this.status.success.color;
      if (closeSuccessConfig) statusColor = this.status.closeSuccess.color;else if (warningConfig) statusColor = this.status.warning.color;else if (defaultConfig) statusColor = this.status.default.color;else if (dangerConfig) statusColor = this.status.danger.color;

      return statusColor;
    }
  },
  computed: {
    filteredDistributors: function filteredDistributors() {
      var _this2 = this;

      var filtered = Object(lodash["filter"])(this.distributors, function (distributor) {
        return distributor.distributorName.toLowerCase().indexOf((_this2.distributorFilter || '').toLowerCase()) !== -1;
      });
      var sorted = Object(lodash["orderBy"])(filtered, ['distributorName', 'remoteFileName'], ['asc', 'asc']);

      return sorted;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b24fb8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-distributors-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":true,"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n      Distribuidoras\n      "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#00C3D7"},attrs:{"small":"","depressed":"","rounded":"","dark":""},on:{"click":function($event){return _vm.editItem({})}}},[_vm._v("Agregar")])],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('div',[_c('v-container',{staticClass:"py-1 pb-2"},[_c('v-layout',[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Filtrar","placeholder":"Nombre de distribuidora","hide-details":"","clearable":""},model:{value:(_vm.distributorFilter),callback:function ($$v) {_vm.distributorFilter=$$v},expression:"distributorFilter"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[(_vm.filteredDistributors.length > 0)?[_vm._l((_vm.filteredDistributors),function(item,index){return [_c('div',{key:index},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"align-center":""}},[_c('v-icon',{attrs:{"color":_vm.statusColorItem(item)}},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 py-1 text-xs-left",staticStyle:{"line-height":"normal"},attrs:{"xs12":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('span',{staticStyle:{"font-size":"14px","font-weight":"bold","text-transform":"capitalize"}},[_vm._v(_vm._s(item.distributorName.toLowerCase() || '~NO DEFINIDO~'))])]),_vm._v(" "),_c('v-flex',[_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("\n                      "+_vm._s(item.remoteFileName.replace('/home/validata_mdlz_7318', '~') || '~NO DEFINIDO~')+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editItem(item)}}},[_c('v-icon',{staticStyle:{"color":"#00C3D7"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.removeItem(item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)],1)],1)],1)]})]:[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"rgba(0,0,0,.38)"}},[_vm._v("\n              No data available\n            ")])],1)],1)]],2),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-card-button error",attrs:{"small":"","depressed":"","rounded":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-distributors-dialog.vue
function injectStyle (context) {
  __webpack_require__("Ye0H")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_distributors_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_distributors_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F7n2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/menus/item-menu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var item_menu = ({
  name: 'item-menu',
  methods: {
    isAdmin: function isAdmin() {
      return userStorage["default"].getUserInfo().userType === 'ADMIN';
    },
    isHeritable: function isHeritable() {
      return this.item.heritable;
    },
    edit: function edit(item) {
      if (item.isFolder) {
        // emit to components/dialogs/folder-form-dialog.vue
        eventBus["default"].$emit('open-folder-form', item);
      } else {
        // emit to components/dialogs/report-form-dialog
        eventBus["default"].$emit('open-report-form', extends_default()({}, item, {
          heritable: this.containedBy && this.containedBy.heritable,
          parentName: this.containedBy && this.containedBy.itemName,
          structureID: this.containedBy && this.containedBy.origin
        }));
      }
    },
    hide: function hide(item) {
      reportsStorage["default"].hideItem(item.itemID);
    },
    unhide: function unhide(item) {
      reportsStorage["default"].unHideItem(item.itemID);
    },
    move: function move(item) {
      // emit to components/folders/folder-list
      eventBus["default"].$emit('move-item', item);
      // item.isMoving = true
      // window.scrollTo(0, 75)
    },
    drop: function drop(item) {
      // emit to components/dialogs/drop-item-dialog.vue
      eventBus["default"].$emit('drop-item', item);
    },
    download: function download(item) {
      window.open(item.url2, '_blank');
      reportsStorage["default"].registerView(item.itemID, 'DOWNLOAD');
    }
  },
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    containedBy: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48834fdd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/item-menu.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticStyle:{"color":"#00000060"}},[_vm._v("more_vert")])],1)]}}])},[_vm._v(" "),_c('v-list',{staticClass:"item-menu-list",attrs:{"flat":""}},[_c('v-list-item-group',[(_vm.isAdmin())?_c('v-list-item',{staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.edit(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-edit")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Editar")])],1):_vm._e(),_vm._v(" "),(!(_vm.item.isFolder == 1) && _vm.item.url2.trim() !== '')?_c('v-list-item',{staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.download(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-down")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Descargar")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin() && !_vm.isHeritable())?_c('v-list-item',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.hidden),expression:"!item.hidden"}],staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.hide(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-eye-slashed")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Ocultar")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin() && !_vm.isHeritable())?_c('v-list-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.hidden),expression:"item.hidden"}],staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.unhide(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-eye")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Mostrar")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin() && !_vm.isSearching && !_vm.isHeritable())?_c('v-list-item',{staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.move(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-move")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Mover")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin())?_c('v-list-item',{staticClass:"item-menu-list-item",on:{"click":function($event){return _vm.drop(_vm.item)}}},[_c('v-icon',{staticClass:"item-menu-list-item-icon"},[_vm._v("ico-icon-trash")]),_vm._v(" "),_c('v-list-item-title',{staticClass:"item-menu-list-item-title"},[_vm._v("Eliminar")])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/menus/item-menu.vue
function injectStyle (context) {
  __webpack_require__("oAZg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  item_menu,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var menus_item_menu = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FB/y":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Fiq4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FxC0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FyRe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GFdn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iconosVidaSoftware.fbc9eb7.svg";

/***/ }),

/***/ "GGPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/distributor-details-indicators-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var distributor_details_indicators_list = ({
  data: function data() {
    return {
      cards: []
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
  },

  methods: {},
  props: {
    indicators: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    distributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a454b1be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/distributor-details-indicators-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"my-0",attrs:{"row":""}},_vm._l((_vm.indicators),function(indicator,i){return _c('v-flex',{key:i,attrs:{"text-xs-center":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('img',{attrs:{"slot":"activator","height":"24px","src":__webpack_require__("+gN6")("./" + indicator.color.iconPath),"alt":"indicator-icon"},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(indicator.text))])])],1)}),1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/distributor-details-indicators-list.vue
function injectStyle (context) {
  __webpack_require__("fybr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributor_details_indicators_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_distributor_details_indicators_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HGiz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAwCAYAAABe6Vn9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTFFNjE0REM3NTlFMTFFOEI3OTdGMzQ0REYwN0NFQTciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTFFNjE0REI3NTlFMTFFOEI3OTdGMzQ0REYwN0NFQTciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YmM4MDJlNjktYWI0OS1iYzRkLWE4MzAtYTNjNTA5ZDRjYWMwIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6Y2I2NzdlMTAtOTA2ZS0yNjRmLWI3YmEtZmRiOWQ3MGIzYzM4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+4tcvJQAABL5JREFUeNrsmm2IVFUYx8/cmWlXytosy6CyJHWtpUgXDDJ63YrIEl8gXEgNKiQpM1iIKMpePpRJSl+k/LDK5kIrkkKUq6wvSKmRIvmOEbnBSvmSW5a07u3/sL/J62VmaO7cmUuxB34c98y9zz3/Ofc853meMeX7viunzWputi4FV4r7xT1inBgt6kQtl/8pTonDYr/YJDaKX4QPJbXWtrYL/s648psn7hbzxWSE2cT6xBFxUPRy7VBxtbhDTBLPcO068YHYLPrLmUymzNWxyX0opjOR7eJTsUF8V2Ry9iU0iAfEDPGoeEx0iHniWNUFScy16raKkbw6C8Suf3m7Cd0Di8Xt9NNEo7hLdEd9XaK2VnGDeEPcW4KYfG0XNl7HZms573+U1alXd59Yj6C42kJsmu36aq7QaPouF3/rCj2jKoLS9BPxanG1FDaDz6jaHrI2Ba/kxSDGw9aUco2U08xbLRWrxI18q16Jz09z7yps9ScpyLzSNs4hO0RXCwsdruFISBcgwzXN3HMEG9uwmczBqnaUE/8J8TwH5ON81iMOcUj+xtglRApjxAjGzomvWZ12MTtJQbkYrR3M1T5EKHQLIU464Dh8BPwgviLU+VIcyGMzEUG2OssCQeUBWBLwWrYql/H3r6yWX8TLTUpyD9kemFrEjk9g2g29RcR42GpO2stZQPkeaUK6xHMpxT112OhI2sstZeO/iINYQi5UG/ByXoicl6vlWksbfsTGIWwmtod2ixZyoefEXPo/xF7208/id66/WAzHeZjTGMKK2JfxJuJmJinoIvEXr4vRFPBy9aQFqZCX8wOCc16uM2QzMUETxMeBjd4ZmtwI0vKh/N1Lut1TZE81JinoKfEJJ/y5PJ/3FJl8voD3TjEnSaeQZkXms8mjerlabHRGjbLjErSSKs4iHIA5iJtENhTLBT1czstlubaFexdha2WSr1wX7vY1XpW3xTuENnsoVR0nQnBEDFdQ4rqVdNv232k83EKKJbOSEmT3n0TUK1RwHuZ8eYRgNZUneujHOVj89wWVojNxzCnqzcfpGwJ1uDMUN3IFjkuJqocRzzniuBMcoKcL7KmG0DOqImgHaYEVCpeLfXlCFpvwNyXu55uxeYxnVMcptLa1nSVdrhFbeNWyEe153DsDWzXYPltVLydRHTiCLHthK2FLHWP54rigt8ty7UzubWdsDkFqtCpLDMX669W9T6aa5YDdTvHwIK9PuLY9lrBoIuIsfPpMvESgWsoXG6uXc0zAXhcT9iTebQKT9Yp4uT72yediRalCKuW2w8LeggwbfBTnzrtc04L3+h5H0hd3lTLjKtP63PlivLVX6Ze7CjfP/c/aoKBBQYOCBgVVVVCayKAGrio3I01SkE38ZTdQMR0OPzFWMVGZCgp6wQ3U2iwq+Iixpxmz3GlxJR76T3CqILPGxffzoq3AUYLOerJaa5dTP7Ag9roClaIozSeluWCFDvOQONuygBjHv9eIZ93534ziaN25uQcFrXYRf0ovsDebcAJeIJv12Es+Jav+mJ63P858qNBHln6PJ09az1gTeY/lSo1xKKlEPlSozUXIWvEtYybwFJ/959z2TvGgG/jvY7fBRsZ2VuqhfwswANazKdf2X4vLAAAAAElFTkSuQmCC"

/***/ }),

/***/ "HX3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-card-details-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var show_card_details_dialog = ({
  name: 'show-card-details-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-details-dialog');
    eventBus["default"].$on('open-details-dialog', function (data) {
      _this.dialog = true;
      _this.title = data.title;
      _this.subtitle = data.subtitle;
      _this.message = data.message;
      _this.body = data.body;
    });
  },
  data: function data() {
    return {
      dialog: false,
      // dialog: true,
      title: '',
      subtitle: '',
      message: '',
      body: []
    };
  },

  methods: {
    accept: function accept() {
      this.dialog = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9174512","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-card-details-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"400px","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"layout py-2 justify-center",staticStyle:{"font-size":"20px"}},[_c('span',{staticClass:"headline py-0",staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"flex text-xs-right py-0"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('div',{staticClass:"body-2 mt-1"},[_vm._v("En tarjetas")]),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.body.card),function(item,index){return _c('v-flex',{key:index},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('img',{attrs:{"slot":"activator","height":"20px","src":__webpack_require__("+gN6")("./" + item.color.iconPath),"alt":"indicator-icon"},slot:"activator"})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v(_vm._s(item.description))])])],1)],1)}),1),_vm._v(" "),_c('div',{staticClass:"body-2 mt-3"},[_vm._v("En detalle")]),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.body.detail),function(item,index){return _c('v-flex',{key:index},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('img',{attrs:{"slot":"activator","height":"20px","src":__webpack_require__("+gN6")("./" + item.color.iconPath),"alt":"indicator-icon"},slot:"activator"})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v(_vm._s(item.description))]),_c('v-spacer')],1)],1)],1)}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"v-layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"error"},nativeOn:{"click":function($event){return _vm.accept()}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-card-details-dialog.vue
function injectStyle (context) {
  __webpack_require__("ZygB")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_card_details_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_card_details_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Hibl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/distributors-details-color-filter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var distributors_details_color_filter = ({
  data: function data() {
    return {
      selection: ''
    };
  },

  methods: {
    selectColor: function selectColor(selectedItem) {
      this.item.color = selectedItem;
    }
  },
  props: {
    card: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b0e139","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/distributors-details-color-filter.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"clearable":"","persistent-hint":"","item-value":"color.color","hint":_vm.card.cardName,"append-icon":"","label":"Filtrar","items":_vm.card.extra.fab.list,"dense":""},on:{"change":_vm.selectColor},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-layout',{attrs:{"ma-0":""}},[_c('v-flex',{attrs:{"pa-0":""}},[_c('v-icon',{staticStyle:{"font-size":"18px","margin-right":"8px"},attrs:{"color":data.item.color.color}},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('v-flex',{attrs:{"pa-0":"","xs12":"","text-xs-left":""}},[_c('span',[_vm._v(_vm._s(data.item.status))])])],1)]}},{key:"item",fn:function(data){return [_c('v-layout',[_c('v-icon',{staticStyle:{"font-size":"18px","margin-right":"8px"},attrs:{"color":data.item.color.color}},[_vm._v("fiber_manual_record")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.status))])],1)]}}]),model:{value:(_vm.item.color),callback:function ($$v) {_vm.$set(_vm.item, "color", $$v)},expression:"item.color"}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/distributors-details-color-filter.vue
function injectStyle (context) {
  __webpack_require__("5dtc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributors_details_color_filter,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_distributors_details_color_filter = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HjeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/search-items.vue
//
//
//
//
//
//

/* harmony default export */ var search_items = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-144070eb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/search-items.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Query: "+_vm._s(this.$route.params.query)+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/search-items.vue
function injectStyle (context) {
  __webpack_require__("ZhQj")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  search_items,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_search_items = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HxCl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/animacion_carga.d13b6a8.gif";

/***/ }),

/***/ "I8dg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J6/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JE4U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JOiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/folders/folder-list.vue + 2 modules
var folder_list = __webpack_require__("A+kn");

// EXTERNAL MODULE: ./src/components/reports/report-list.vue + 2 modules
var report_list = __webpack_require__("MJmm");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/dialogs/folder-form-dialog.vue + 2 modules
var folder_form_dialog = __webpack_require__("1iFf");

// EXTERNAL MODULE: ./src/components/dialogs/report-form-dialog.vue + 2 modules
var report_form_dialog = __webpack_require__("MoDk");

// EXTERNAL MODULE: ./src/components/dialogs/drop-item-dialog.vue + 2 modules
var drop_item_dialog = __webpack_require__("4+lJ");

// EXTERNAL MODULE: ./src/components/dialogs/replicate-folder-dialog.vue + 2 modules
var replicate_folder_dialog = __webpack_require__("KcZP");

// EXTERNAL MODULE: ./src/components/dialogs/new-items-manager-dialog.vue + 2 modules
var new_items_manager_dialog = __webpack_require__("nVqS");

// EXTERNAL MODULE: ./src/components/dialogs/show-users-folder-permissions.vue + 2 modules
var show_users_folder_permissions = __webpack_require__("wP5p");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapper.js
var axiosWrapper = __webpack_require__("BRjr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/download-cube.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ var download_cube = ({
  name: 'main-page',
  data: function data() {
    return {
      folders: [],
      reports: [],
      containedBy: '0',
      folderID: '0',
      loading: false,
      isAdmin: userStorage["default"].getUserInfo().userType === 'ADMIN',
      fab: false,
      searchInfo: '',
      searchCriteria: '',
      hideSearchBar: true,
      searchProps: {
        searchCriteria: ''
      },
      disabledButton: false,
      actualizarButtonLoading: false,
      bloquearButtonLoading: false
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.searchProps.searchCriteria = '';
    this.searchInfo = '';

    // this.loadFolders(this.folderID)
    this.loadAll(this.folderID, false);
    next();
  },
  mounted: function mounted() {
    var _this = this;

    this.loadAll(this.folderID);

    eventBus["default"].$off('toggle-search-bar');
    eventBus["default"].$on('toggle-search-bar', function () {
      _this.hideSearchBar = !_this.hideSearchBar;
    });
  },
  created: function created() {
    var _this2 = this;

    eventBus["default"].$off('reload-items');
    eventBus["default"].$on('reload-items', function (data) {
      _this2.searchProps.searchCriteria = '';
      _this2.searchInfo = '';

      _this2.loadAll(_this2.folderID, true);
    });
  },

  methods: {
    loadAll: function loadAll(_folderID, _forceLoad) {
      var _this3 = this;

      if (_forceLoad) {
        // Actualiza el árbol total de items antes de traer
        //  los items de este directorio
        reportsStorage["default"].getData({
          forceLoad: true,
          onSuccess: function onSuccess() {
            // eslint-disable-next-line
            _this3.loadFolders(_folderID);
          }
        });
      } else {
        this.loadFolders(_folderID);
      }
    },
    loadFolders: function loadFolders(_folderID, _forceLoad) {
      var _this4 = this;

      this.loading = true;
      var folderID = _folderID || '0';
      var forceLoad = _forceLoad || false;
      reportsStorage["default"].getData({
        forceLoad: forceLoad,
        folderID: folderID,
        onSuccess: function onSuccess(data) {
          var _folders = [];
          var _reports = [];

          Object(lodash["map"])(data, function (item, index) {
            if (item.isFolder) {
              _folders.push(item);
            } else {
              _reports.push(item);
            }
          });

          _this4.folders = _folders;
          _this4.reports = _reports;
          _this4.containedBy = reportsStorage["default"].findItemByID(folderID);

          var existFolderDownloadCube = reportsStorage["default"].findItemByName('download-cube');
          if (existFolderDownloadCube) {
            var reloadPage = _this4.folderID === '0';
            _this4.folderID = existFolderDownloadCube.itemID;
            _this4.loading = false;
            if (reloadPage) {
              _this4.loadAll(_this4.folderID);
            }
          } else {
            _this4.loading = false;
          }
        },
        onError: function onError(error) {
          var message = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            message = 'Error desconocido: ' + error.message;
          }
          _this4.loading = false;
          // emits to components/snackbars/custom-snack-bar.vue
          eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
        }
      });
    },
    searchItems: function searchItems() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      for (var i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    searchItemsByTag: function searchItemsByTag() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      /* for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      } */

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    createDownloadCubeFolder: function createDownloadCubeFolder() {
      var _this5 = this;

      this.loading = true;
      reportsStorage["default"].addItem({
        data: {
          itemName: 'download-cube',
          containedBy: '0',
          isFolder: true,
          inherited: 0,
          structureItemInheritance: false
        },
        onSuccess: function onSuccess(response) {
          _this5.folderID = response.data.item.itemID;
          // reportsStorage.hideItem(response.data.item.itemID)
          eventBus["default"].$emit('reload-items');
        },
        onError: function onError(error) {
          console.warn('Error en crear la carpeta download-cube', error);
        }
      });
    },
    addReport: function addReport() {
      var parentFolder = this.folderID;

      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        parentName: this.containedBy && this.containedBy.itemName,
        structureID: this.containedBy && this.containedBy.origin
      });
    },
    addInnerReport: function addInnerReport(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        parentName: folderData.itemName,
        structureID: folderData.origin
      });
    },
    addFolder: function addFolder() {
      var parentFolder = this.folderID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        structureID: this.containedBy && this.containedBy.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    addInnerFolder: function addInnerFolder(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        structureID: folderData.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    actualizar: function actualizar() {
      var _this6 = this;

      this.disabledButton = true;
      this.actualizarButtonLoading = true;

      if (this.folderID === '0') return;

      axiosWrapper["default"].post(uris["default"].URL_ADD_CUBE_PERMISSION, {
        itemID: this.folderID
      }).then(function (response) {
        // console.log(response)
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se actualizó los permisos a todos los usuarios', itsOk: true });
      }).catch(function (err) {
        console.warn('No se ha podido actualizar los permisos de los usuarios', err);
      }).finally(function () {
        _this6.disabledButton = false;
        _this6.actualizarButtonLoading = false;
      });
    },
    bloquear: function bloquear() {
      var _this7 = this;

      this.disabledButton = true;
      this.bloquearButtonLoading = true;

      if (this.folderID === '0') return;

      axiosWrapper["default"].post(uris["default"].URL_REMOVE_CUBE_PERMISSION, {
        itemID: this.folderID
      }).then(function (response) {
        // console.log(response)
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se bloqueo los permisos a todos los usuarios', itsOk: true });
      }).catch(function (err) {
        console.warn('No se ha podido bloquear los permisos de los usuarios', err);
      }).finally(function () {
        _this7.disabledButton = false;
        _this7.bloquearButtonLoading = false;
      });
    }
  },
  computed: {
    haveFavoriteReport: function haveFavoriteReport() {
      return this.topFavoriteReports.length > 0;
    }
  },
  components: {
    FolderList: folder_list["default"],
    ReportList: report_list["default"],
    StrategioAppBar: strategio_app_bar["default"],

    FolderFormDialog: folder_form_dialog["default"],
    ReportFormDialog: report_form_dialog["default"],
    DropItemDialog: drop_item_dialog["default"],
    ReplicateFolderDialog: replicate_folder_dialog["default"],
    NewItemsManagerDialog: new_items_manager_dialog["default"],
    ShowUsersFolderPermissions: show_users_folder_permissions["default"],

    CustomSnackBar: custom_snack_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3833d40","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/download-cube.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#FBFBFB"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[(_vm.loading)?_c('div',{staticClass:"strategio-loading-main"},[_c('p',[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":"","size":"50"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"strategio-loading-main-message"},[_vm._v("\n            Un momento por favor\n          ")])],1)]):_c('div',{staticClass:"strategio-titles-windows",staticStyle:{"overflow":"hidden"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"5","align-self":"center"}},[_c('v-icon',{staticStyle:{"font-size":"52px","padding-bottom":"30px","padding-right":"10px"},attrs:{"color":'black'}},[_vm._v("mdi-cloud-download")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n                Dercargar Cubo\n              ")])],1)],1),_vm._v(" "),(_vm.isAdmin && _vm.folderID !== '0')?_c('v-row',{staticClass:"mb-2"},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v("\n              Acceso a todos los usuarios para que visualicen estos cubos\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2 white--text",style:([
                {'width': _vm.actualizarButtonLoading ? '190px' : ''} ]),attrs:{"disabled":_vm.disabledButton,"loading":_vm.actualizarButtonLoading,"color":"#2262c6"},on:{"click":function($event){return _vm.actualizar()}},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Actualizando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}],null,false,2639606396)},[_vm._v("\n              Permitir\n              "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                mdi-account-check\n              ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-2 white--text",style:([
                {'width': _vm.bloquearButtonLoading ? '190px' : ''} ]),attrs:{"disabled":_vm.disabledButton,"loading":_vm.bloquearButtonLoading,"color":"#2262c6"},on:{"click":function($event){return _vm.bloquear()}},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Bloqueando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}],null,false,3837568065)},[_vm._v("\n              Bloquear\n              "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                mdi-account-cancel\n              ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.reports.length !== 0 && _vm.folderID !== '0')?_c('div',[_c('report-list',{attrs:{"reports":_vm.reports,"contained-by":_vm.containedBy,"is-searching":_vm.searchInfo !== '',"search-props":_vm.searchProps,"search-items":_vm.searchItemsByTag,"hide-favorite-icon":true}})],1):_c('div',{staticClass:"download-cube-no-report"},[(_vm.folderID === '0')?_c('div',[(_vm.isAdmin)?_c('div',[_vm._v("\n                Todavía no se ha creado la carpeta para agregar los reportes de cubos\n                "),_c('br'),_vm._v("\n                Agregue la carpeta de descarga de cubo con el siguiente botón.\n                "),_c('v-btn',{staticClass:"ma-2",staticStyle:{"background-color":"#2262C6"},attrs:{"outlined":"","large":"","fab":"","color":"white"},on:{"click":function($event){return _vm.createDownloadCubeFolder()}}},[_c('v-icon',[_vm._v("create_new_folder")])],1)],1):_c('div',[_vm._v("\n                No tiene permiso para visualizar los cubos.\n                "),_c('br'),_vm._v("\n                Por favor comuniquese con soporte.\n              ")])]):_c('div',[(_vm.isAdmin)?_c('div',[_vm._v("\n                No hay reporte de cubo creado.\n                "),_c('br'),_vm._v("\n                Agregue un reporte de cubo con el siguiente botón.\n                "),_c('v-btn',{staticClass:"ma-2",staticStyle:{"background-color":"#2262C6"},attrs:{"outlined":"","large":"","fab":"","color":"white"},on:{"click":function($event){return _vm.addReport()}}},[_c('v-icon',[_vm._v("note_add")])],1)],1):_vm._e()])])],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('v-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInfo === ''),expression:"searchInfo === ''"}],staticClass:"strategio-speed-dial",attrs:{"id":"options-button","fixed":"","bottom":"","right":"","direction":"top","transition":"scale-transition","elevation-6":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","hover":"","large":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[(_vm.fab)?_c('v-icon',[_vm._v("close")]):_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.addReport()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("note_add")])],1),_vm._v(" "),_c('span',[_vm._v("Crear reporte")])],1)],1):_vm._e()],1)]),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('folder-form-dialog'),_vm._v(" "),_c('report-form-dialog'),_vm._v(" "),_c('new-items-manager-dialog'),_vm._v(" "),_c('drop-item-dialog'),_vm._v(" "),_c('replicate-folder-dialog'),_vm._v(" "),_c('show-users-folder-permissions')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/download-cube.vue
function injectStyle (context) {
  __webpack_require__("LpLo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  download_cube,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_download_cube = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jitg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jxcz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/routes/show-report.vue + 2 modules
var show_report = __webpack_require__("cC8f");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/processes/autoservicio-process.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var autoservicio_process = ({
  name: 'autoservicio-process',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    };
  },

  components: {
    ShowReport: show_report["default"]
  },
  props: {
    process: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    showProcess: function showProcess() {
      var processType = this.process.processType.toLowerCase();
      var processID = this.process.processID;
      if (this.process.isReport) {
        this.$router.push('/show-report/' + this.process.strategioID);
      } else {
        this.$router.push('/autoservicios/process/' + processID + '/' + processType + '/');
      }
    }
  },
  computed: {},
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c5684c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/processes/autoservicio-process.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center",class:{
    'strategio-hidden-item': _vm.process.isEnabled === 0
  },style:([
    {'height': '282px'},
    {'width': '313px'},
    {'margin': '20px'},
    {'overflow': 'hidden'},
    {'background': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'},
    {'border-radius': '10px'}
  ]),attrs:{"outlined":""},on:{"click":_vm.showProcess}},[_c('div',[_c('v-icon',{staticStyle:{"font-size":"52px"},attrs:{"color":'black'}},[_vm._v("ico-icon-config")])],1),_vm._v(" "),_c('div',{staticClass:"strategio-autoservicio-card-title",staticStyle:{"margin-top":"15px"}},[_vm._v("\n    "+_vm._s(_vm.process.processName)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/processes/autoservicio-process.vue
function injectStyle (context) {
  __webpack_require__("Qi9E")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68c5684c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_process,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var processes_autoservicio_process = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "K+Ru":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "K/Nx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/components/structures/structure-list.vue + 2 modules
var structure_list = __webpack_require__("+yo/");

// EXTERNAL MODULE: ./src/components/folders/folder-list.vue + 2 modules
var folder_list = __webpack_require__("A+kn");

// EXTERNAL MODULE: ./src/components/reports/report-list.vue + 2 modules
var report_list = __webpack_require__("MJmm");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/header-main-page/header-main-page.vue + 2 modules
var header_main_page = __webpack_require__("8lGR");

// EXTERNAL MODULE: ./src/components/dialogs/folder-form-dialog.vue + 2 modules
var folder_form_dialog = __webpack_require__("1iFf");

// EXTERNAL MODULE: ./src/components/dialogs/report-form-dialog.vue + 2 modules
var report_form_dialog = __webpack_require__("MoDk");

// EXTERNAL MODULE: ./src/components/dialogs/drop-item-dialog.vue + 2 modules
var drop_item_dialog = __webpack_require__("4+lJ");

// EXTERNAL MODULE: ./src/components/dialogs/replicate-folder-dialog.vue + 2 modules
var replicate_folder_dialog = __webpack_require__("KcZP");

// EXTERNAL MODULE: ./src/components/dialogs/structure-form-dialog.vue + 2 modules
var structure_form_dialog = __webpack_require__("BbCC");

// EXTERNAL MODULE: ./src/components/dialogs/new-items-manager-dialog.vue + 2 modules
var new_items_manager_dialog = __webpack_require__("nVqS");

// EXTERNAL MODULE: ./src/components/dialogs/paste-structure-form-dialog.vue + 2 modules
var paste_structure_form_dialog = __webpack_require__("AuUj");

// EXTERNAL MODULE: ./src/components/dialogs/show-users-folder-permissions.vue + 2 modules
var show_users_folder_permissions = __webpack_require__("wP5p");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/main-page.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ var main_page = ({
  name: 'main-page',
  data: function data() {
    var userInfo = userStorage["default"].getUserInfo();
    return {
      heritableFolders: [],
      foldersToUpdateMode: false,
      foldersInheriteeToUpdate: [],
      folders: [],
      reports: [],
      topFavoriteReports: [],
      topFrecuenteReports: [],
      topNovedadesReports: [],
      containedBy: 0,
      loading: false,
      firstTimeMenu: false,
      isAdmin: userInfo.userType === 'ADMIN',
      showCardsAdmin: userInfo.showCards === 1,
      daysTillPasswordChange: userInfo.daysTillPasswordChange,
      fab: false,
      searchInfo: '',
      searchCriteria: '',
      hideSearchBar: true,
      showDialog: false,
      searchProps: {
        searchCriteria: ''
      }
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.searchProps.searchCriteria = '';
    this.searchInfo = '';

    // this.loadFolders(to.params.folderID)
    this.loadAll(to.params.folderID, false);
    next();
  },
  mounted: function mounted() {
    var _this = this;

    if (this.daysTillPasswordChange < 10 && this.$route.params.firstTimeMenu === true) {
      eventBus["default"].$emit('open-custom-snack-bar', { message: 'Su contrase\xF1a expira en ' + this.daysTillPasswordChange + ' d\xEDas', itsOk: false });
    }

    this.loadAll(this.$route.params.folderID);
    eventBus["default"].$off('start-main-page-tutorial');
    eventBus["default"].$on('start-main-page-tutorial', function () {
      var intro = introBus["default"].getIntroBus();
      intro.setOption('doneLabel', 'Continuar');
      intro.addSteps([{
        element: '#filter-textfield',
        intro: 'Desde aquí podrá realizar el filtrado de los reportes'
      }, {
        element: '#options-button',
        intro: 'Desde aquí se podrán crear reportes y carpetas'
      }, {
        element: '#reportlistfolder0',
        intro: 'Estas son las carpetas donde los reportes serían agrupados'
      }, {
        element: '#reportlistitem0',
        intro: 'Estos son reportes individuales'
      }, {
        element: '#addfavortite-button',
        intro: 'Con este botón se podrá agregar reportes a favoritos. A continuación se verá las opciones disponibles cuando acceda a uno de estos reportes'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));
      intro.start();
      intro.oncomplete(function () {
        var anyItem = function anyItem(item) {
          return !item.isFolder;
        };
        reportsStorage["default"].getData({
          onSuccess: function onSuccess(response) {
            if (response.length > 0 && response.find(anyItem)) {
              _this.$router.push('/show-report/' + response.find(anyItem).itemID + '?main-page=true');
            }
          }
        });
      });
    });

    eventBus["default"].$off('toggle-search-bar');
    eventBus["default"].$on('toggle-search-bar', function () {
      _this.hideSearchBar = !_this.hideSearchBar;
    });
  },
  created: function created() {
    var _this2 = this;

    eventBus["default"].$off('reload-items');
    eventBus["default"].$on('reload-items', function (data) {
      _this2.searchProps.searchCriteria = '';
      _this2.searchInfo = '';

      _this2.loadAll(_this2.$route.params.folderID, true);
    });
  },

  methods: {
    setFoldersToUpdateModeOn: function setFoldersToUpdateModeOn() {
      this.foldersToUpdateMode = true;
    },
    toUpdateToggle: function toUpdateToggle() {
      this.foldersToUpdateMode = false;
      Object(lodash["map"])(this.foldersInheriteeToUpdate, function (item) {
        item.checked = false;
      });
    },
    getHeritables: function getHeritables(_forceLoad, _onSuccess) {
      var _this3 = this;

      // structureStorage.getStructures({
      structureStorage["default"].getHeritableItems({
        forceLoad: _forceLoad,
        onSuccess: function onSuccess(items) {
          var _heritableFolders;

          var folders = Object(lodash["orderBy"])(Object(lodash["filter"])(items, function (item) {
            return item.isFolder === 1 && item.containedBy === '0'
            // A los items que cumplan con lo previo
            //  asignales el parametro de heredable
            // assign(item, {heritable: 1})
            ;
          }), function (item) {
            // Si tiene 'H' o 'HI' (provienen de heredables)
            // ordenarlas, moverlas para el final
            // return /^(HI?)(\d+)$/.exec(item.itemID)[1]
            return item.itemID.startsWith('HI');
          });

          _this3.heritableFolders.splice(0);
          (_heritableFolders = _this3.heritableFolders).push.apply(_heritableFolders, toConsumableArray_default()(folders));

          _onSuccess && _onSuccess();
        }
      });
    },
    loadAll: function loadAll(_folderID, _forceLoad) {
      var _this4 = this;

      if (_forceLoad) {
        this.getHeritables(true, // forceLoad
        function () {
          // onSuccess
          if (_this4.isAdmin && String(_folderID).startsWith('H')) {
            _this4.loadStructures(_folderID);
            // this.loadStructures(_folderID)
          }
        });
        // Actualiza el árbol total de items antes de traer
        //  los items de este directorio
        reportsStorage["default"].getData({
          forceLoad: true,
          onSuccess: function onSuccess() {
            // eslint-disable-next-line
            if (!String(_folderID).startsWith('H')) {
              _this4.loadFolders(_folderID);
            }
          }
        });
      } else {
        if (this.isAdmin && String(_folderID).startsWith('H')) {
          this.loadStructures(_folderID);
        } else {
          this.loadFolders(_folderID);
        }
      }
    },
    loadStructures: function loadStructures(_folderID, _forceLoad) {
      var _this5 = this;

      this.loading = !structureStorage["default"].isHeritableDataLoaded();
      var folderID = _folderID || '0';
      var forceLoad = _forceLoad || false;
      structureStorage["default"].getHeritableItems({
        forceLoad: forceLoad,
        onSuccess: function onSuccess(items) {
          var _folders = [];
          var _reports = [];

          var data = Object(lodash["filter"])(items, function (item) {
            return item.containedBy === folderID;
          });

          Object(lodash["filter"])(data, function (item, index) {
            if (item.isFolder) {
              // assign(item, {heritable: 1}) // Es necesario?
              _folders.push(item);
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item);
            }
          });

          _this5.loading = false;
          _this5.folders = _folders;
          _this5.reports = _reports;
          _this5.containedBy = structureStorage["default"].findHeritableItemByID(folderID);

          eventBus["default"].$emit('enable-tutorial-button');
        },
        onError: function onError(err) {
          console.warn('!!!!!', 'error', err);
        }
      });
    },
    loadFolders: function loadFolders(_folderID, _forceLoad) {
      var _this6 = this;

      this.loading = !reportsStorage["default"].isDataLoaded();
      var folderID = _folderID || '0';
      var forceLoad = _forceLoad || false;
      this.isAdmin && this.getHeritables(); // Solo si es administrador
      reportsStorage["default"].getData({
        forceLoad: forceLoad,
        folderID: folderID,
        onSuccess: function onSuccess(data) {
          var _folders = [];
          var _reports = [];

          _this6.foldersInheriteeToUpdate.splice(0);
          _this6.foldersToUpdateMode = false;
          Object(lodash["map"])(data, function (item, index) {
            if (item.isFolder) {
              _folders.push(item);
              _this6.foldersInheriteeToUpdate.push({ itemID: item.itemID, checked: false });
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item);
            }
          });

          if (folderID === '0') {
            var topReports = reportsStorage["default"].getTopReports();
            _this6.topFavoriteReports = topReports.topFavoriteReports;
            _this6.topFrecuenteReports = topReports.topFrecuenteReports;
            _this6.topNovedadesReports = topReports.topNovedadesReports;
          }

          _this6.loading = false;
          _this6.folders = _folders;
          _this6.reports = _reports;
          _this6.containedBy = reportsStorage["default"].findItemByID(folderID);

          eventBus["default"].$emit('enable-tutorial-button');
        },
        onError: function onError(error) {
          var message = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            message = 'Error desconocido: ' + error.message;
          }
          _this6.loading = false;
          // emits to components/snackbars/custom-snack-bar.vue
          eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
        }
      });
    },
    searchItems: function searchItems() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      for (var i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    searchItemsByTag: function searchItemsByTag() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      /* for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      } */

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    addReport: function addReport() {
      var parentFolder = this.$route.params.folderID;
      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        parentName: this.containedBy && this.containedBy.itemName,
        structureID: this.containedBy && this.containedBy.origin
      });
    },
    addInnerReport: function addInnerReport(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        parentName: folderData.itemName,
        structureID: folderData.origin
      });
    },
    addFolder: function addFolder() {
      var parentFolder = this.$route.params.folderID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        structureID: this.containedBy && this.containedBy.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    addInnerFolder: function addInnerFolder(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        structureID: folderData.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    createSructure: function createSructure() {
      var folderName = this.containedBy ? this.containedBy.itemName : 'REPORTES';
      eventBus["default"].$emit('open-structure-form', { structureName: 'Estructura de ' + folderName, structureItems: this.reports });
    },
    pasteStructure: function pasteStructure() {
      eventBus["default"].$emit('open-paste-structure-form-dialog', {});
    }
  },
  computed: {
    isMainPage: function isMainPage() {
      return this.$route.params.folderID === '0';
    },
    haveFavoriteReport: function haveFavoriteReport() {
      return this.topFavoriteReports.length > 0;
    }
  },
  components: {
    StructureList: structure_list["default"],
    FolderList: folder_list["default"],
    ReportList: report_list["default"],
    StrategioAppBar: strategio_app_bar["default"],
    HeaderMainPage: header_main_page["default"],
    FolderFormDialog: folder_form_dialog["default"],
    ReportFormDialog: report_form_dialog["default"],
    DropItemDialog: drop_item_dialog["default"],
    ReplicateFolderDialog: replicate_folder_dialog["default"],
    StructureFormDialog: structure_form_dialog["default"],
    NewItemsManagerDialog: new_items_manager_dialog["default"],
    PasteStructureFormDialog: paste_structure_form_dialog["default"],
    ShowUsersFolderPermissions: show_users_folder_permissions["default"],
    CustomSnackBar: custom_snack_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7db221","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/main-page.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
      {'background-color': "#F4F4F4"} 
    ])},[_c('strategio-app-bar',{attrs:{"search-props":_vm.searchProps,"search-items":_vm.searchItems}}),_vm._v(" "),_c('v-main',[_c('transition',{attrs:{"name":"expansionbusq"}},[(!_vm.hideSearchBar)?_c('div',[_c('v-container',{staticClass:"hidden-sm-and-up"},[_c('v-row',[_c('v-col',{staticStyle:{"background-color":"white"},attrs:{"cols":"12"}},[_c('v-card',{attrs:{"id":"filter-textfield"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Buscar en Strategio","hide-details":"auto","full-width":"","single-line":"","type":"search"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchItems()}},model:{value:(_vm.searchProps.searchCriteria),callback:function ($$v) {_vm.$set(_vm.searchProps, "searchCriteria", $$v)},expression:"searchProps.searchCriteria"}})],1)],1)],1)],1),_vm._v("\nimport PasswordExpireWarning from '../components/dialogs/password-expire-warning.vue'\n\n        ")],1):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"strategio-loading-main"},[_c('p',[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":"","size":"50"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"strategio-loading-main-message"},[_vm._v("\n            Un momento por favor\n          ")])],1)]):_c('div',{staticStyle:{"overflow":"hidden","padding-left":"0px"}},[(_vm.isMainPage && _vm.showCardsAdmin)?_c('header-main-page'):_vm._e(),_vm._v(" "),_c('v-container',[(_vm.isMainPage && (_vm.searchInfo === ''))?_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"8","lg":"12","xl":"12"}},[_c('div',{staticClass:"strategio-title-mas-usados"},[_c('v-icon',{staticStyle:{"-webkit-text-stroke":"1px #000"},attrs:{"x-large":"","color":"#000000"}},[_vm._v("ico-icon-heart")]),_vm._v("\n                Más usados\n              ")],1),_vm._v(" "),_c('report-list',{attrs:{"reports":_vm.topFrecuenteReports}})],1)],1):_vm._e()],1),_vm._v(" "),_c('folder-list',{attrs:{"to-update-toggle":_vm.toUpdateToggle,"to-update-on":_vm.foldersToUpdateMode,"to-update":_vm.foldersInheriteeToUpdate,"folders":_vm.folders,"contained-by":_vm.containedBy,"is-searching":_vm.searchInfo !== '',"search-info":_vm.searchInfo,"add-inner-folder":_vm.addInnerFolder,"add-inner-report":_vm.addInnerReport}}),_vm._v(" "),_c('report-list',{attrs:{"reports":_vm.reports,"contained-by":_vm.containedBy,"is-searching":_vm.searchInfo !== '',"search-props":_vm.searchProps,"search-items":_vm.searchItemsByTag}})],1),_vm._v(" "),(_vm.isAdmin)?_c('v-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInfo === ''),expression:"searchInfo === ''"}],staticClass:"strategio-speed-dial",attrs:{"id":"options-button","fixed":"","bottom":"","right":"","direction":"top","transition":"scale-transition","elevation-6":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[(_vm.fab)?_c('v-icon',[_vm._v("close")]):_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.addReport()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("note_add")])],1),_vm._v(" "),_c('span',[_vm._v("Crear reporte")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.addFolder()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("create_new_folder")])],1),_vm._v(" "),_c('span',[_vm._v("Crear folder")])],1),_vm._v(" "),(_vm.isMainPage)?_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.setFoldersToUpdateModeOn()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("reply")])],1),_vm._v(" "),_c('span',[_vm._v("Vincular a base")])],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('folder-form-dialog'),_vm._v(" "),_c('report-form-dialog'),_vm._v(" "),_c('new-items-manager-dialog'),_vm._v(" "),_c('drop-item-dialog'),_vm._v(" "),_c('replicate-folder-dialog'),_vm._v(" "),_c('show-users-folder-permissions')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/main-page.vue
function injectStyle (context) {
  __webpack_require__("28sX")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  main_page,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_main_page = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KDbQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-strategio.384abd2.png";

/***/ }),

/***/ "KQcc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Bold.56018b3.otf";

/***/ }),

/***/ "KaMS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-vida-software.6b41c55.png";

/***/ }),

/***/ "KcZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/replicate-folder-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var replicate_folder_dialog = ({
  data: function data() {
    return {
      dialog: false,
      itemID: 0,
      originalName: '',
      onSuccess: function onSuccess() {},
      folderName: '',

      isLoadingReplication: false
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-replicate-folder-dialog');
    eventBus["default"].$on('open-replicate-folder-dialog', function (data) {
      _this.itemID = data.itemID || 0;
      _this.originalName = data.originalName || '';
      _this.onSuccess = data.onSuccess || function () {};
      _this.folderName = '';
      _this.isLoadingReplication = false;
      _this.dialog = true;
    });
  },

  methods: {
    replicateFolder: function replicateFolder() {
      var _this2 = this;

      this.isLoadingReplication = true;
      structureStorage["default"].replicateFolder({
        data: {
          itemID: this.itemID,
          originalName: this.originalName,
          folderName: this.folderName
        },
        onSuccess: function onSuccess() {
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha creado el folder base correctamente', itsOk: true });
          // emit to routes/main-page.vue
          eventBus["default"].$emit('reload-items', {});
          _this2.dialog = false;
          _this2.onSuccess();
          _this2.isLoadingReplication = false;
        },
        onError: function onError(error) {
          console.warn('Error replicating folder: ', error);
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema creando el folder base', itsOk: false });
          _this2.isLoadingReplication = false;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b70f4c60","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/replicate-folder-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"350px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n      Nueva estructura\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Nombre de carpeta","hint":"Nombre de la nueva carpeta base"},model:{value:(_vm.folderName),callback:function ($$v) {_vm.folderName=$$v},expression:"folderName"}})],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"success","loading":_vm.isLoadingReplication},nativeOn:{"click":function($event){return _vm.replicateFolder.apply(null, arguments)}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/replicate-folder-dialog.vue
function injectStyle (context) {
  __webpack_require__("W90M")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  replicate_folder_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_replicate_folder_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KhW7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KyHA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L7UV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKIZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/users/user-form.vue + 2 modules
var user_form = __webpack_require__("3GQB");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/user-account.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var user_account = ({
  name: 'user-account',
  data: function data() {
    return {
      user: userStorage["default"].getUserInfo(),
      showStrategioAppBar: true
    };
  },

  components: {
    StrategioAppBar: strategio_app_bar["default"],
    UserForm: user_form["default"]
  },
  mounted: function mounted() {
    // console.log(`On beforeRouteUpdate with ${this.$route.params.showStrategioAppBar}`)
    this.showStrategioAppBar = this.$route.params.showStrategioAppBar === undefined ? true : this.$route.params.showStrategioAppBar;
    // console.log(`After beforeRouteUpdate with ${this.$route.params.showStrategioAppBar}`)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f0138e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/user-account.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[(_vm.showStrategioAppBar)?_c('strategio-app-bar'):_vm._e(),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('user-form',{attrs:{"user-data":_vm.user,"is-my-account":"","parent-route":"/","back-button-text":"Pagina principal","showStrategioAppBar":_vm.showStrategioAppBar}})],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/user-account.vue
function injectStyle (context) {
  __webpack_require__("oWN+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_account,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_user_account = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LYHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LpLo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e52425","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('router-view')],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/App.vue
function injectStyle (context) {
  __webpack_require__("Qi+p")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  App,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MJmm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/reports/report-list-item-rectangle.vue + 2 modules
var report_list_item_rectangle = __webpack_require__("jYJk");

// EXTERNAL MODULE: ./src/components/reports/report-list-item.vue + 2 modules
var report_list_item = __webpack_require__("BmF5");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reports/report-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var report_list = ({
  name: 'report-list',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  props: {
    'reports': {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    'isSearching': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'containedBy': {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    'searchProps': {
      type: Object,
      default: function _default() {
        return { searchCriteria: '' };
      }
    },
    'searchItems': {
      type: Function,
      default: function _default() {
        return function () {
          alert('Err func');
        };
      }
    },
    'rectangle': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    'hideFavoriteIcon': {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    ReportListItem: report_list_item["default"],
    ReportListItemRectangle: report_list_item_rectangle["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1b79fb0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/report-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[(_vm.rectangle)?_c('v-row',_vm._l((_vm.reports),function(r,i){return _c('report-list-item-rectangle',{key:r.reportID,attrs:{"report-data":r,"contained-by":_vm.containedBy,"is-searching":_vm.isSearching,"id":'reportlistitem' + i,"search-props":_vm.searchProps,"search-items":_vm.searchItems}})}),1):_c('v-row',_vm._l((_vm.reports),function(r,i){return _c('report-list-item',{key:r.reportID,attrs:{"report-data":r,"contained-by":_vm.containedBy,"is-searching":_vm.isSearching,"id":'reportlistitem' + i,"search-props":_vm.searchProps,"search-items":_vm.searchItems,"hide-favorite-icon":_vm.hideFavoriteIcon}})}),1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/reports/report-list.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  report_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_report_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MhD7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MoDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/report-form-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var report_form_dialog = ({
  name: 'report-form-dialog',
  data: function data() {
    return {
      dialog: false,
      // dialog: true,
      reportID: '',
      parentName: '',
      containedBy: '',
      structureID: '',
      data: {
        reportName: '',
        description: '',
        url1: '',
        url2: '',
        url3: '',
        url4: '',
        url5: '',
        imageUrl: '',
        labels: '',
        inherited: 0 // Sospechoso, aunque parece que no se usa para actualizar valores, osea, no hay problema
      },
      isValidForm: false,
      isNew: false,
      // isNew: true,
      heritable: false,
      isLoading: false
    };
  },

  computed: {
    labelsPrefix: function labelsPrefix() {
      // return `${this.parentName}, ${this.data.reportName ? (this.data.labels ? this.data.reportName + ', ' : this.data.reportName) : ''}`
      return '$$FOLDER' + ', ' + (this.data.reportName ? this.data.labels ? this.data.reportName + ', ' : this.data.reportName : '');
    }
  },
  methods: {
    hasStructureItemInheritance: function hasStructureItemInheritance() {
      // console.log('???', 'containedBy', this.containedBy)
      // console.log('???', `containedBy.startsWith('HI')`, this.containedBy.startsWith('HI'))
      return this.containedBy.startsWith('HI');
    },
    sendNewData: function sendNewData() {
      var _this = this;

      if (!this.isValidForm) {
        return;
      }
      this.isLoading = true;
      if (this.isNew) {
        if (this.heritable) {
          // Crear estructura correspondiente, más los items en las carpetas
          //  que tienen como heredable a esta estructura
          var _containedBy = this.containedBy;
          structureStorage["default"].createHeritableItem({
            data: extends_default()({
              structureID: this.structureID,
              itemName: this.data.reportName
            }, Object(lodash["omit"])(this.data, 'labels'), {
              labels: this.labelsPrefix + this.data.labels,
              isFolder: false,
              containedBy: _containedBy,
              structureItemInheritance: this.hasStructureItemInheritance()
            }),
            onSuccess: function onSuccess(result) {
              // eventBus.$emit('open-custom-snack-bar', {message: 'Reporte heredable creado exitosamente', itsOk: true})
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Reporte heredable creado exitosamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;

              // console.log('???', 'result', JSON.stringify(result, null, 2), result)
              if (result.length > 0) {
                eventBus["default"].$emit('open-new-items-manager-dialog', {
                  items: result
                });
              }
              _this.isLoading = false;
            },
            onError: function onError(error) {
              console.warn('error creando reporte heredable: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha podido crear el reporte heredable', itsOk: false });
              _this.isLoading = false;
            }
          });
        } else {
          reportsStorage["default"].addItem({
            data: extends_default()({
              itemName: this.data.reportName
            }, this.data, {
              isFolder: false,
              containedBy: this.containedBy,
              inherited: 0,
              structureItemInheritance: false
            }),
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha creado el reporte correctamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;
              _this.isLoading = false;
            },
            onError: function onError(error) {
              console.warn('error creando reporte: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha podido guardar el reporte', itsOk: false });
              _this.isLoading = false;
            }
          });
        }
      } else {
        if (this.heritable) {
          structureStorage["default"].updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: false,
              itemID: this.reportID,
              itemName: this.data.reportName,
              description: this.data.description,
              labels: this.data.labels,
              imageUrl: this.data.imageUrl,
              removed: false
            },
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha actualizado el reporte heredable correctamente', itsOk: true });
              // emit to routes/main-page.vue
              eventBus["default"].$emit('reload-items');
              _this.dialog = false;
              _this.isLoading = false;
            },
            onError: function onError(error) {
              console.warn('Error updating a heritable report: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema actualizando el reporte heredable', itsOk: false });
              _this.isLoading = false;
            }
          });
        } else {
          reportsStorage["default"].editItem({ itemID: this.reportID }, {
            itemName: this.data.reportName,
            url1: this.data.url1,
            url2: this.data.url2,
            url3: this.data.url3,
            url4: this.data.url4,
            url5: this.data.url5,
            imageUrl: this.data.imageUrl,
            description: this.data.description,
            labels: this.data.labels,
            isFolder: false
          }, {
            onSuccess: function onSuccess() {
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Se ha actualizado el reporte correctamente', itsOk: true });
              _this.dialog = false;
              _this.isLoading = false;
            },
            onError: function onError(error) {
              console.warn('Error updating a report: ', error);
              eventBus["default"].$emit('open-custom-snack-bar', { message: 'Ocurrió un problema actualizando el reporte', itsOk: false });
              _this.isLoading = false;
            }
          });
        }
      }
    },
    validateReportName: function validateReportName() {
      if (this.data.reportName && this.data.reportName.trim() !== '') {
        return true;
      }
      return 'Este campo es obligatorio';
    },
    validateUrls: function validateUrls() {
      if (this.data.url1 && this.data.url1.trim() !== '' || this.data.url2 && this.data.url2.trim() !== '') {
        return true;
      }
      return 'Este campo es obligatorio';
    },
    validateForm: function validateForm() {
      var isValidReportName = this.data.reportName && this.data.reportName.trim() !== '';
      var isValidUrls = this.data.url1 && this.data.url1.trim() !== '' || this.data.url2 && this.data.url2.trim() !== '';
      if (this.heritable) {
        this.isValidForm = isValidReportName;
      } else {
        this.isValidForm = isValidReportName && isValidUrls;
      }
      return true;
    }
  },
  created: function created() {
    var _this2 = this;

    eventBus["default"].$off('open-report-form');
    eventBus["default"].$on('open-report-form', function (item) {
      _this2.heritable = item.heritable;
      _this2.isNew = !('itemID' in item);
      _this2.containedBy = item.containedBy;
      _this2.reportID = item.itemID;
      _this2.parentName = item.parentName;
      _this2.structureID = item.structureID;

      _this2.data = {
        reportName: item.itemName || '',
        description: item.description || '',
        url1: item.url1 || '',
        url2: item.url2 || '',
        url3: item.url3 || '',
        url4: item.url4 || '',
        url5: item.url5 || '',
        imageUrl: item.imageUrl || '',
        labels: item.labels || ''
      };
      _this2.dialog = true;
      _this2.isLoading = false;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da611c1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/report-form-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"650px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n        "+_vm._s(_vm.isNew ? 'Crear reporte' : 'Editar reporte')+" "+_vm._s(_vm.heritable ? 'base' : '')+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[(!_vm.heritable)?[_c('v-text-field',{attrs:{"label":"Nombre de reporte *","rules":[_vm.validateReportName(), _vm.validateForm()],"clearable":""},model:{value:(_vm.data.reportName),callback:function ($$v) {_vm.$set(_vm.data, "reportName", $$v)},expression:"data.reportName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Descripcion","clearable":""},model:{value:(_vm.data.description),callback:function ($$v) {_vm.$set(_vm.data, "description", $$v)},expression:"data.description"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL principal *","rules":[_vm.validateUrls(), _vm.validateForm()],"hint":"Esta URL es opcional si ya tenemos URL de descarga","clearable":""},model:{value:(_vm.data.url1),callback:function ($$v) {_vm.$set(_vm.data, "url1", $$v)},expression:"data.url1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL de descarga *","rules":[_vm.validateUrls(), _vm.validateForm()],"hint":"Esta URL es opcional si ya tenemos URL principal","clearable":""},model:{value:(_vm.data.url2),callback:function ($$v) {_vm.$set(_vm.data, "url2", $$v)},expression:"data.url2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL 3","clearable":""},model:{value:(_vm.data.url3),callback:function ($$v) {_vm.$set(_vm.data, "url3", $$v)},expression:"data.url3"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL 4","clearable":""},model:{value:(_vm.data.url4),callback:function ($$v) {_vm.$set(_vm.data, "url4", $$v)},expression:"data.url4"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL 5","clearable":""},model:{value:(_vm.data.url5),callback:function ($$v) {_vm.$set(_vm.data, "url5", $$v)},expression:"data.url5"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL de imagen","clearable":""},model:{value:(_vm.data.imageUrl),callback:function ($$v) {_vm.$set(_vm.data, "imageUrl", $$v)},expression:"data.imageUrl"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Labels","clearable":""},model:{value:(_vm.data.labels),callback:function ($$v) {_vm.$set(_vm.data, "labels", $$v)},expression:"data.labels"}})]:[_c('v-text-field',{attrs:{"label":"Nombre de reporte *","rules":[_vm.validateReportName(), _vm.validateForm()],"clearable":""},model:{value:(_vm.data.reportName),callback:function ($$v) {_vm.$set(_vm.data, "reportName", $$v)},expression:"data.reportName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Descripcion","clearable":""},model:{value:(_vm.data.description),callback:function ($$v) {_vm.$set(_vm.data, "description", $$v)},expression:"data.description"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"URL de imagen","clearable":""},model:{value:(_vm.data.imageUrl),callback:function ($$v) {_vm.$set(_vm.data, "imageUrl", $$v)},expression:"data.imageUrl"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"label":"Labels","clearable":"","prefix":_vm.isNew ? _vm.labelsPrefix : ''},model:{value:(_vm.data.labels),callback:function ($$v) {_vm.$set(_vm.data, "labels", $$v)},expression:"data.labels"}})]],2),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","dark":"","depressed":"","rounded":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"success","disabled":!_vm.isValidForm || _vm.isLoading},nativeOn:{"click":function($event){return _vm.sendNewData()}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/report-form-dialog.vue
function injectStyle (context) {
  __webpack_require__("dInE")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  report_form_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_report_form_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MxmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/components/structures/structure-list.vue + 2 modules
var structure_list = __webpack_require__("+yo/");

// EXTERNAL MODULE: ./src/components/folders/folder-list.vue + 2 modules
var folder_list = __webpack_require__("A+kn");

// EXTERNAL MODULE: ./src/components/reports/report-list.vue + 2 modules
var report_list = __webpack_require__("MJmm");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/header-main-page/header-main-page.vue + 2 modules
var header_main_page = __webpack_require__("8lGR");

// EXTERNAL MODULE: ./src/components/dialogs/folder-form-dialog.vue + 2 modules
var folder_form_dialog = __webpack_require__("1iFf");

// EXTERNAL MODULE: ./src/components/dialogs/report-form-dialog.vue + 2 modules
var report_form_dialog = __webpack_require__("MoDk");

// EXTERNAL MODULE: ./src/components/dialogs/drop-item-dialog.vue + 2 modules
var drop_item_dialog = __webpack_require__("4+lJ");

// EXTERNAL MODULE: ./src/components/dialogs/replicate-folder-dialog.vue + 2 modules
var replicate_folder_dialog = __webpack_require__("KcZP");

// EXTERNAL MODULE: ./src/components/dialogs/structure-form-dialog.vue + 2 modules
var structure_form_dialog = __webpack_require__("BbCC");

// EXTERNAL MODULE: ./src/components/dialogs/new-items-manager-dialog.vue + 2 modules
var new_items_manager_dialog = __webpack_require__("nVqS");

// EXTERNAL MODULE: ./src/components/dialogs/paste-structure-form-dialog.vue + 2 modules
var paste_structure_form_dialog = __webpack_require__("AuUj");

// EXTERNAL MODULE: ./src/components/dialogs/show-users-folder-permissions.vue + 2 modules
var show_users_folder_permissions = __webpack_require__("wP5p");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/reports.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ var reports = ({
  name: 'main-page',
  data: function data() {
    return {
      heritableFolders: [],
      foldersToUpdateMode: false,
      foldersInheriteeToUpdate: [],
      folders: [],
      reports: [],
      topFavoriteReports: [],
      topFrecuenteReports: [],
      topNovedadesReports: [],
      containedBy: 0,
      loading: false,
      isAdmin: userStorage["default"].getUserInfo().userType === 'ADMIN',
      fab: false,
      searchInfo: '',
      searchCriteria: '',
      hideSearchBar: true,
      searchProps: {
        searchCriteria: ''
      }
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.searchProps.searchCriteria = '';
    this.searchInfo = '';

    // this.loadFolders(to.params.folderID)
    this.loadAll(to.params.folderID, false);
    next();
  },
  mounted: function mounted() {
    var _this = this;

    this.loadAll(this.$route.params.folderID);

    eventBus["default"].$off('start-main-page-tutorial');
    eventBus["default"].$on('start-main-page-tutorial', function () {
      var intro = introBus["default"].getIntroBus();
      intro.setOption('doneLabel', 'Continuar');
      intro.addSteps([{
        element: '#filter-textfield',
        intro: 'Desde aquí podrá realizar el filtrado de los reportes'
      }, {
        element: '#options-button',
        intro: 'Desde aquí se podrán crear reportes y carpetas'
      }, {
        element: '#reportlistfolder0',
        intro: 'Estas son las carpetas donde los reportes serían agrupados'
      }, {
        element: '#reportlistitem0',
        intro: 'Estos son reportes individuales'
      }, {
        element: '#addfavortite-button',
        intro: 'Con este botón se podrá agregar reportes a favoritos. A continuación se verá las opciones disponibles cuando acceda a uno de estos reportes'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));
      intro.start();
      intro.oncomplete(function () {
        var anyItem = function anyItem(item) {
          return !item.isFolder;
        };
        reportsStorage["default"].getData({
          onSuccess: function onSuccess(response) {
            if (response.length > 0 && response.find(anyItem)) {
              _this.$router.push('/show-report/' + response.find(anyItem).itemID + '?main-page=true');
            }
          }
        });
      });
    });

    eventBus["default"].$off('toggle-search-bar');
    eventBus["default"].$on('toggle-search-bar', function () {
      _this.hideSearchBar = !_this.hideSearchBar;
    });
  },
  created: function created() {
    var _this2 = this;

    eventBus["default"].$off('reload-items');
    eventBus["default"].$on('reload-items', function (data) {
      _this2.searchProps.searchCriteria = '';
      _this2.searchInfo = '';

      _this2.loadAll(_this2.$route.params.folderID, true);
    });
  },

  methods: {
    setFoldersToUpdateModeOn: function setFoldersToUpdateModeOn() {
      this.foldersToUpdateMode = true;
    },
    toUpdateToggle: function toUpdateToggle() {
      this.foldersToUpdateMode = false;
      Object(lodash["map"])(this.foldersInheriteeToUpdate, function (item) {
        item.checked = false;
      });
    },
    getHeritables: function getHeritables(_forceLoad, _onSuccess) {
      var _this3 = this;

      // structureStorage.getStructures({
      structureStorage["default"].getHeritableItems({
        forceLoad: _forceLoad,
        onSuccess: function onSuccess(items) {
          var _heritableFolders;

          var folders = Object(lodash["orderBy"])(Object(lodash["filter"])(items, function (item) {
            return item.isFolder === 1 && item.containedBy === '0'
            // A los items que cumplan con lo previo
            //  asignales el parametro de heredable
            // assign(item, {heritable: 1})
            ;
          }), function (item) {
            // Si tiene 'H' o 'HI' (provienen de heredables)
            // ordenarlas, moverlas para el final
            // return /^(HI?)(\d+)$/.exec(item.itemID)[1]
            return item.itemID.startsWith('HI');
          });

          _this3.heritableFolders.splice(0);
          (_heritableFolders = _this3.heritableFolders).push.apply(_heritableFolders, toConsumableArray_default()(folders));

          _onSuccess && _onSuccess();
        }
      });
    },
    loadAll: function loadAll(_folderID, _forceLoad) {
      var _this4 = this;

      if (_forceLoad) {
        this.getHeritables(true, // forceLoad
        function () {
          // onSuccess
          if (_this4.isAdmin && String(_folderID).startsWith('H')) {
            _this4.loadStructures(_folderID);
            // this.loadStructures(_folderID)
          }
        });
        // Actualiza el árbol total de items antes de traer
        //  los items de este directorio
        reportsStorage["default"].getData({
          forceLoad: true,
          onSuccess: function onSuccess() {
            // eslint-disable-next-line
            if (!String(_folderID).startsWith('H')) {
              _this4.loadFolders(_folderID);
            }
          }
        });
      } else {
        if (this.isAdmin && String(_folderID).startsWith('H')) {
          this.loadStructures(_folderID);
        } else {
          this.loadFolders(_folderID);
        }
      }
    },
    loadStructures: function loadStructures(_folderID, _forceLoad) {
      var _this5 = this;

      this.loading = !structureStorage["default"].isHeritableDataLoaded();
      var folderID = _folderID || '0';
      var forceLoad = _forceLoad || false;
      structureStorage["default"].getHeritableItems({
        forceLoad: forceLoad,
        onSuccess: function onSuccess(items) {
          var _folders = [];
          var _reports = [];

          var data = Object(lodash["filter"])(items, function (item) {
            return item.containedBy === folderID;
          });

          Object(lodash["filter"])(data, function (item, index) {
            if (item.isFolder) {
              // assign(item, {heritable: 1}) // Es necesario?
              _folders.push(item);
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item);
            }
          });

          _this5.loading = false;
          _this5.folders = _folders;
          _this5.reports = _reports;
          _this5.containedBy = structureStorage["default"].findHeritableItemByID(folderID);

          eventBus["default"].$emit('enable-tutorial-button');
        },
        onError: function onError(err) {
          console.warn('!!!!!', 'error', err);
        }
      });
    },
    loadFolders: function loadFolders(_folderID, _forceLoad) {
      var _this6 = this;

      this.loading = !reportsStorage["default"].isDataLoaded();
      var folderID = _folderID || '0';
      var forceLoad = _forceLoad || false;
      this.isAdmin && this.getHeritables(); // Solo si es administrador
      reportsStorage["default"].getData({
        forceLoad: forceLoad,
        folderID: folderID,
        onSuccess: function onSuccess(data) {
          var _folders = [];
          var _reports = [];

          _this6.foldersInheriteeToUpdate.splice(0);
          _this6.foldersToUpdateMode = false;
          Object(lodash["map"])(data, function (item, index) {
            if (item.isFolder) {
              _folders.push(item);
              _this6.foldersInheriteeToUpdate.push({ itemID: item.itemID, checked: false });
            } else {
              // item.imageUrl = item.imageUrl || 'http://via.placeholder.com/320x150?text=imageUrl'
              _reports.push(item);
            }
          });

          if (folderID === '0') {
            var topReports = reportsStorage["default"].getTopReports();
            _this6.topFavoriteReports = topReports.topFavoriteReports;
            _this6.topFrecuenteReports = topReports.topFrecuenteReports;
            _this6.topNovedadesReports = topReports.topNovedadesReports;
          }

          _this6.loading = false;
          _this6.folders = _folders;
          _this6.reports = _reports;
          _this6.containedBy = reportsStorage["default"].findItemByID(folderID);

          eventBus["default"].$emit('enable-tutorial-button');
        },
        onError: function onError(error) {
          var message = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            message = 'Error desconocido: ' + error.message;
          }
          _this6.loading = false;
          // emits to components/snackbars/custom-snack-bar.vue
          eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
        }
      });
    },
    searchItems: function searchItems() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      for (var i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false;
          break;
        }
      }

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    searchItemsByTag: function searchItemsByTag() {
      var searchQuery = this.searchProps.searchCriteria.trim().split(/\s+/);
      var isValid = true;
      /* for (let i = 0; i < searchQuery.length; i++) {
        if (searchQuery[i].length < 3) {
          isValid = false
          break
        }
      } */

      if (!isValid) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Las palabras deben tener al menos 3 letras', itsOk: 'warning' });
        return;
      }

      var data = reportsStorage["default"].searchItems(searchQuery);

      var _folders = [];
      var _reports = [];
      data.map(function (item, index) {
        if (item.isFolder) {
          _folders.push(item);
        } else {
          _reports.push(item);
        }
      });
      this.folders = _folders;
      this.reports = _reports;
      if (data.length > 0) {
        this.searchInfo = _reports.length + ' reportes y ' + _folders.length + ' carpetas en ' + data.length + '/' + reportsStorage["default"].storeLength() + ' elementos';
      } else {
        this.searchInfo = 'No se encontraron elementos que coincidan con la búsqueda';
      }
      // this.containedBy = reportsStorage.findItemByID(folderID)
      /*
        TODO: la busqueda y muestra estan listos.
        * Ahora tenemos que utilizar una estrategia de renderizado para no relentizar la app.
        * Podemos hacer que la longitud minima de la busqueda sea de 3. Sin contar espacios(user trim-split)
        * Una forma de regresar a la carpeta de origen
        * Idear una forma de limpiar el cuadro de busquedas. Sobre todo cuando vamos de carpeta a carpeta
      */
    },
    addReport: function addReport() {
      var parentFolder = this.$route.path === '/reports/info' ? '0' : this.$route.params.folderID;

      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        parentName: this.containedBy && this.containedBy.itemName,
        structureID: this.containedBy && this.containedBy.origin
      });
    },
    addInnerReport: function addInnerReport(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/report-form-dialog.vue
      eventBus["default"].$emit('open-report-form', {
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        parentName: folderData.itemName,
        structureID: folderData.origin
      });
    },
    addFolder: function addFolder() {
      var parentFolder = this.$route.params.folderID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: this.containedBy && this.containedBy.heritable,
        structureID: this.containedBy && this.containedBy.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    addInnerFolder: function addInnerFolder(folderData) {
      var parentFolder = folderData.itemID;
      // emit to components/dialogs/folder-form-dialog.vue
      eventBus["default"].$emit('open-folder-form', {
        itemName: 'Nueva carpeta',
        containedBy: parentFolder,
        heritable: !!folderData.heritable,
        structureID: folderData.origin
      }, this.heritableFolders); // Para el combo de heredables
    },
    createSructure: function createSructure() {
      var folderName = this.containedBy ? this.containedBy.itemName : 'REPORTES';
      eventBus["default"].$emit('open-structure-form', { structureName: 'Estructura de ' + folderName, structureItems: this.reports });
    },
    pasteStructure: function pasteStructure() {
      eventBus["default"].$emit('open-paste-structure-form-dialog', {});
    }
  },
  computed: {
    isMainPage: function isMainPage() {
      return this.$route.params.folderID === '0';
    },
    haveFavoriteReport: function haveFavoriteReport() {
      return this.topFavoriteReports.length > 0;
    }
  },
  components: {
    StructureList: structure_list["default"],
    FolderList: folder_list["default"],
    ReportList: report_list["default"],
    StrategioAppBar: strategio_app_bar["default"],
    HeaderMainPage: header_main_page["default"],

    FolderFormDialog: folder_form_dialog["default"],
    ReportFormDialog: report_form_dialog["default"],
    DropItemDialog: drop_item_dialog["default"],
    ReplicateFolderDialog: replicate_folder_dialog["default"],
    StructureFormDialog: structure_form_dialog["default"],
    NewItemsManagerDialog: new_items_manager_dialog["default"],
    PasteStructureFormDialog: paste_structure_form_dialog["default"],
    ShowUsersFolderPermissions: show_users_folder_permissions["default"],

    CustomSnackBar: custom_snack_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce859310","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/reports.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#FBFBFB"} 
  ])},[_c('strategio-app-bar',{attrs:{"search-props":_vm.searchProps,"search-items":_vm.searchItems}}),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[(_vm.loading)?_c('div',{staticClass:"strategio-loading-main"},[_c('p',[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":"","size":"50"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"strategio-loading-main-message"},[_vm._v("\n            Un momento por favor\n          ")])],1)]):_c('div',{staticClass:"strategio-titles-windows",staticStyle:{"padding-left":"0px","overflow":"hidden"}},[_c('folder-list',{attrs:{"to-update-toggle":_vm.toUpdateToggle,"to-update-on":_vm.foldersToUpdateMode,"to-update":_vm.foldersInheriteeToUpdate,"folders":_vm.folders,"contained-by":_vm.containedBy,"is-searching":_vm.searchInfo !== '',"search-info":_vm.searchInfo,"add-inner-folder":_vm.addInnerFolder,"add-inner-report":_vm.addInnerReport}}),_vm._v(" "),_c('report-list',{attrs:{"reports":_vm.reports,"contained-by":_vm.containedBy,"is-searching":_vm.searchInfo !== '',"search-props":_vm.searchProps,"search-items":_vm.searchItemsByTag}})],1),_vm._v(" "),(_vm.isAdmin)?_c('v-speed-dial',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchInfo === ''),expression:"searchInfo === ''"}],staticClass:"strategio-speed-dial",attrs:{"id":"options-button","fixed":"","bottom":"","right":"","direction":"top","transition":"scale-transition","elevation-6":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[(_vm.fab)?_c('v-icon',[_vm._v("close")]):_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.addReport()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("note_add")])],1),_vm._v(" "),_c('span',[_vm._v("Crear reporte")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.addFolder()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("create_new_folder")])],1),_vm._v(" "),_c('span',[_vm._v("Crear folder")])],1),_vm._v(" "),(_vm.isMainPage)?_c('v-tooltip',{attrs:{"left":"","open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":""},on:{"click":function($event){return _vm.setFoldersToUpdateModeOn()}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("reply")])],1),_vm._v(" "),_c('span',[_vm._v("Vincular a base")])],1):_vm._e()],1):_vm._e()],1)]),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('folder-form-dialog'),_vm._v(" "),_c('report-form-dialog'),_vm._v(" "),_c('new-items-manager-dialog'),_vm._v(" "),_c('drop-item-dialog'),_vm._v(" "),_c('replicate-folder-dialog'),_vm._v(" "),_c('show-users-folder-permissions')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/reports.vue
function injectStyle (context) {
  __webpack_require__("UkpE")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  reports,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_reports = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_introjs_dist_index_min_js__ = __webpack_require__("TQE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_introjs_dist_index_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_introjs_dist_index_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_iconosVidaSoftware_v1_0_style_css__ = __webpack_require__("cKcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_iconosVidaSoftware_v1_0_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_assets_iconosVidaSoftware_v1_0_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "7zck"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "18/U"));

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_introjs_dist_index_min_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  vuetify: new __WEBPACK_IMPORTED_MODULE_2_vuetify___default.a(),
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["default"],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["default"] },
  icons: { iconosVidaSoftware: __WEBPACK_IMPORTED_MODULE_5__src_assets_iconosVidaSoftware_v1_0_style_css___default.a // default - only for display purposes
  } });

/*
Strategio-over-loaded: Debe tener una configuración inicial configurable para poder generar:
  * NORMAL: Visualizador + favoritos + tutorial
  * GLOBAL: NORMAL + ACCESO A TODOS LOS REPORTES
  * SUPERVISOR: GLOBAL + Modulo de supervision de datos
  * ADMIN: SUPERVISOR + Herramientas administrativas
  * DEMO: GLOBAL + aviso de versión de prueba + login automático - logout - Opciones de usuario(cerrar sesión y cambiar password, nombre y cargo)

Nucleos principales:
  - folder-list
  - folder-list-item
  - report-list
  - report-list-item (add to favorite)
  - report-list-item-show (add to favorite)
  - report-list-item-show-list
  - favorite-list
  - favorite-item
  - user-login(switch: auto)
  - strategio-header(includes openPanel(), logo, tutorial)

Núcleos administrativos:
  - folder-list-options
  - folder-list-item-options
  - report-list-options
  - report-list-item-options
  - user-options:
    NORMAL and GLOBAL: panel, show: Mi cuenta, tutorial, cerrar sesion
    ADMIN: (NORMAL and GLOBAL) + administrar*
    * administrar: admin user config, reports meta-data, reports access, enable/disable users, change user type

Tutorial:
  1. Grabs the first folder with a report inside (from caché) and start the tutorial
*/

/***/ }),

/***/ "NL7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/supervisor/card-template.vue + 2 modules
var card_template = __webpack_require__("XR0q");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-generator.vue
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var card_generator = ({
  name: 'card-generator',
  methods: {
    getCardInfo: function getCardInfo() {
      return {
        lightColor: 'red',
        cardNumber: '99+',
        message: 'Errores y advertencias al generar reportes'
      };
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    CardTemplate: card_template["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46336a5f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-generator.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-template',{attrs:{"card-title":_vm.data.cardName,"is-loading":_vm.isLoading,"card-info":_vm.getCardInfo(),"card-type":"GENERATOR"}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-generator.vue
function injectStyle (context) {
  __webpack_require__("wCAR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_generator,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_generator = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OxhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/custom-loading.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var custom_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ad0b96","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-loading.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategio-loading-main"},[_c('p',[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":"","size":"50"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"strategio-loading-main-message"},[_vm._v("\n      Un momento por favor\n    ")])],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/custom-loading.vue
function injectStyle (context) {
  __webpack_require__("vWX2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72ad0b96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  custom_loading,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_custom_loading = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PSrw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-config.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var validation_config = ({
  name: 'validation-header',
  data: function data() {
    var _this = this;

    var user = userStorage["default"].getUserInfo();
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      loadingTable: false,
      loadingSave: false,
      dialog: false,
      dialogAdd: false,
      dialogDelete: false,
      columnTypes: ['string', 'int', 'float', 'date'],
      rules: {
        nameRules: [function (v) {
          return !!v || 'Nombre es obligatorio';
        }],
        customQueryRules: [function (v) {
          return !!v || 'Custom query es obligatorio';
        }],
        customErrorRules: [function (v) {
          return !!v || 'Custom error es obligatorio';
        }],
        typeRules: [function (v) {
          return !!v || 'Tipo es obligatorio';
        }],
        orderRules: [function (v) {
          return (/^\d/.test(v) || 'Orden es obligatorio'
          );
        }, function (v) {
          return Number(v) > 0 || 'Orden no puede ser 0';
        }, function (v) {
          return _this.validacionOrder(v) || 'Orden ya existe';
        }]
      },
      columnHeaders: [{ text: 'Orden', value: 'columnNumber' }, { text: 'Campo', value: 'columnName' }, { text: 'Tipo', value: 'columnType' }, { text: 'Opcional', value: 'optional' }, { text: 'Custom Validacion', value: 'customValidation' }, { text: 'Custom Query', value: 'customValidationQuery' }, { text: 'Custom Error', value: 'errorMessage' }, { text: 'Actions', value: 'actions', sortable: false }],
      editedIndex: -1,
      editedItem: {
        optional: 0,
        columnName: '',
        columnType: '',
        columnNumber: 0,
        errorMessage: '',
        customValidation: 0,
        customValidationQuery: '',
        validationStructureId: 0
      },
      itemBeforeEdited: {},
      defaultItem: {
        optional: 0,
        columnName: '',
        columnType: '',
        columnNumber: 0,
        errorMessage: '',
        customValidation: 0,
        customValidationQuery: '',
        validationStructureId: 0
      },
      tableData: []
    };
  },

  props: {
    processID: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  computed: {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? 'Nueva Columna' : 'Editar Columna';
    }
  },
  methods: {
    goToTop: function goToTop() {
      this.$vuetify.goTo('#data-table-1', {
        offset: -50,
        container: '#data-table-1 .v-data-table__wrapper'
      });
    },
    goToNewRow: function goToNewRow() {
      var tableWrapper = document.querySelector('#data-table-1 .v-data-table__wrapper');
      this.$vuetify.goTo(tableWrapper.scrollHeight, {
        container: '#data-table-1 .v-data-table__wrapper'
      });
    },
    closeDialog: function closeDialog() {
      this.goToTop();
      this.dialog = false;
    },
    sendData: function sendData() {
      var _this2 = this;

      // console.log(this.tableData)
      this.loadingSave = true;
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_UPSERT_VALIDATIONS, {
        data: this.tableData,
        processID: this.processID
      }).then(function (response) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Data Ingresada', itsOk: true });
        _this2.goToNewRow();
      }).catch(function (err) {
        console.warn('No se ha podido obtener data de la configuración', err);
      }).finally(function () {
        _this2.loadingSave = false;
      });
    },
    validacionOrder: function validacionOrder(v) {
      var valueNumber = Number(v);
      var arrayOrder = this.tableData.map(function (d) {
        return d.columnNumber;
      });
      if (this.editedIndex !== -1) {
        var valueBeforeEdited = Number(this.itemBeforeEdited.columnNumber);
        var indexValue = arrayOrder.indexOf(valueBeforeEdited);
        if (indexValue !== -1) {
          arrayOrder.splice(indexValue, 1);
        }
      }
      return !arrayOrder.includes(valueNumber);
    },
    getValidations: function getValidations() {
      var _this3 = this;

      this.dialog = true;
      this.loadingTable = true;
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_VALIDATIONS, {
        processID: this.processID
      }).then(function (response) {
        _this3.tableData = response.data;
      }).catch(function (err) {
        console.warn('No se ha podido obtener data de la configuración', err);
      }).finally(function () {
        _this3.loadingTable = false;
      });
    },
    editItem: function editItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = assign_default()({}, item);
      this.itemBeforeEdited = assign_default()({}, item);
      this.dialogAdd = true;
    },
    deleteItem: function deleteItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = assign_default()({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm: function deleteItemConfirm() {
      this.tableData.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close: function close() {
      var _this4 = this;

      this.$refs['form-validation-config'].resetValidation();
      this.dialogAdd = false;
      this.$nextTick(function () {
        _this4.editedItem = assign_default()({}, _this4.defaultItem);
        _this4.editedIndex = -1;
      });
    },
    closeDelete: function closeDelete() {
      var _this5 = this;

      this.dialogDelete = false;
      this.$nextTick(function () {
        _this5.editedItem = assign_default()({}, _this5.defaultItem);
        _this5.editedIndex = -1;
      });
    },
    save: function save() {
      if (this.$refs['form-validation-config'].validate()) {
        if (this.editedIndex > -1) {
          assign_default()(this.tableData[this.editedIndex], this.editedItem);
        } else {
          this.tableData.push(this.editedItem);
          this.goToNewRow();
        }
        this.close();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e20944","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-config.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"disabled":_vm.dialog,"loading":_vm.dialog,"color":"#2262c6"},on:{"click":_vm.getValidations},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Configurando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n    Configuracion\n\n    "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n      mdi-cog\n    ")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"height":"600"}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n        Configuracion de Validador\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-data-table',{attrs:{"id":"data-table-1","headers":_vm.columnHeaders,"items":_vm.tableData,"loading":_vm.loadingTable,"loading-text":"Obteniendo datos...","hide-default-footer":"","sort-by":"columnNumber","fixed-header":"","disable-pagination":"","height":"360px"},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mb-5",attrs:{"color":"primary","dark":""}},'v-btn',attrs,false),on),[_vm._v("\n                      Nueva Columna\n                    ")])]}}]),model:{value:(_vm.dialogAdd),callback:function ($$v) {_vm.dialogAdd=$$v},expression:"dialogAdd"}},[_vm._v(" "),_c('v-card',[_c('v-form',{ref:"form-validation-config",attrs:{"lazy-validation":""}},[_c('v-card-title',[_c('span',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',{staticClass:"dialog-validation-config"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-text-field',{attrs:{"outlined":"","label":"Nombre","hide-details":"auto","required":"","rules":_vm.rules.nameRules},model:{value:(_vm.editedItem.columnName),callback:function ($$v) {_vm.$set(_vm.editedItem, "columnName", $$v)},expression:"editedItem.columnName"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"4"}},[_c('v-text-field',{attrs:{"outlined":"","label":"Orden","hide-details":"auto","required":"","rules":_vm.rules.orderRules},model:{value:(_vm.editedItem.columnNumber),callback:function ($$v) {_vm.$set(_vm.editedItem, "columnNumber", $$v)},expression:"editedItem.columnNumber"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"4"}},[_c('v-autocomplete',{attrs:{"items":_vm.columnTypes,"clearable":"","outlined":"","label":"Tipo","hide-details":"auto","rules":_vm.rules.typeRules,"required":""},model:{value:(_vm.editedItem.columnType),callback:function ($$v) {_vm.$set(_vm.editedItem, "columnType", $$v)},expression:"editedItem.columnType"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"4"}},[_c('v-switch',{attrs:{"true-value":1,"false-value":0,"label":"Opcional"},model:{value:(_vm.editedItem.optional),callback:function ($$v) {_vm.$set(_vm.editedItem, "optional", $$v)},expression:"editedItem.optional"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-switch',{attrs:{"true-value":1,"false-value":0,"label":"Custom Validation"},model:{value:(_vm.editedItem.customValidation),callback:function ($$v) {_vm.$set(_vm.editedItem, "customValidation", $$v)},expression:"editedItem.customValidation"}})],1),_vm._v(" "),(_vm.editedItem.customValidation)?_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-text-field',{attrs:{"label":"Custom Query","outlined":"","hide-details":"auto","required":_vm.editedItem.customValidation,"rules":_vm.rules.customQueryRules},model:{value:(_vm.editedItem.customValidationQuery),callback:function ($$v) {_vm.$set(_vm.editedItem, "customValidationQuery", $$v)},expression:"editedItem.customValidationQuery"}})],1):_vm._e(),_vm._v(" "),(_vm.editedItem.customValidation)?_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_c('v-text-field',{attrs:{"label":"Custom Error","outlined":"","hide-details":"auto","required":_vm.editedItem.customValidation,"rules":_vm.rules.customErrorRules},model:{value:(_vm.editedItem.errorMessage),callback:function ($$v) {_vm.$set(_vm.editedItem, "errorMessage", $$v)},expression:"editedItem.errorMessage"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":_vm.close}},[_vm._v("\n                          Cancel\n                        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":_vm.save}},[_vm._v("\n                          Save\n                        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("Está seguro de que quiere eliminar la columna?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":_vm.closeDelete}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":_vm.deleteItemConfirm}},[_vm._v("OK")]),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)]},proxy:true},{key:"item.optional",fn:function(ref){
var item = ref.item;
return [_c('v-checkbox',{attrs:{"disabled":""},model:{value:(item.optional),callback:function ($$v) {_vm.$set(item, "optional", $$v)},expression:"item.optional"}})]}},{key:"item.customValidation",fn:function(ref){
var item = ref.item;
return [_c('v-checkbox',{attrs:{"disabled":""},model:{value:(item.customValidation),callback:function ($$v) {_vm.$set(item, "customValidation", $$v)},expression:"item.customValidation"}})]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(item)}}},[_vm._v("\n                mdi-pencil\n              ")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v("\n                mdi-delete\n              ")])]}},{key:"no-data",fn:function(){return [_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.getValidations}},[_vm._v("\n                Reset\n              ")])]},proxy:true}])})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","disabled":_vm.loadingSave,"outlined":""},on:{"click":_vm.closeDialog}},[_vm._v("\n          Cerrar\n        ")]),_vm._v(" "),_c('v-btn',{style:({'width' : _vm.loadingSave ? '160px' : ''}),attrs:{"color":"blue darken-1","disabled":_vm.loadingSave,"loading":_vm.loadingSave,"outlined":""},on:{"click":_vm.sendData},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Guardando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n          Guardar\n\n          ")])],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-config.vue
function injectStyle (context) {
  __webpack_require__("Pfqo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_config,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_config = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PXCm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pfqo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QNHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var _axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

_axios.interceptors.request.use(function (config) {
  var token = localStorage.token_autoservicio;
  if (token === '' || token === undefined || token === null) {
    return config;
  } else {
    config.headers.Authorization = 'Bearer ' + (token || '');
    return config;
  }
});
_axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    if (error.response.status === 401) {
      console.warn(error);
      error.response.shouldRedirectToLogin = true;
      window.location.hash = '/login';
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.message)
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["default"] = (_axios);

/***/ }),

/***/ "QNmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QUgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qi+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qi9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qn1R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Regular.007b563.otf";

/***/ }),

/***/ "QsRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/reports/report-list-item.vue + 2 modules
var report_list_item = __webpack_require__("BmF5");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/favorites.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var favorites = ({
  name: 'favorites',
  data: function data() {
    return {
      favorites: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    reportsStorage["default"].getData({
      forceLoad: false,
      onSuccess: function onSuccess(data) {
        var _favorites = [];
        data.map(function (item, index) {
          if (item.isFavorite) {
            _favorites.push(item);
          }
        });
        _this.favorites = _favorites;
      },
      onError: function onError(error) {
        var message = 'Error desconocido';
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data)
          // console.log(error.response.status);
          // console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          // console.log(error.request)
          message = 'No pudimos obtener respuesta del servidor';
        } else {
          // Something happened in setting up the request that triggered an Error
          message = 'Error desconocido: ' + error.message;
        }
        eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
      }
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.push('/0');
    }
  },
  components: {
    ReportListItem: report_list_item["default"],
    StrategioAppBar: strategio_app_bar["default"],
    CustomSnackBar: custom_snack_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-490c45d2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/favorites.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('v-col',{attrs:{"cols":"5","align-self":"center"}},[_c('v-icon',{staticStyle:{"font-size":"52px","padding-bottom":"30px","padding-right":"10px"},attrs:{"color":'black'}},[_vm._v("ico-icon-star")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n              Favoritos\n            ")])],1)],1),_vm._v(" "),_c('v-row',_vm._l((_vm.favorites),function(f){return _c('report-list-item',{key:f.reportID,attrs:{"report-data":f,"favorites-page":""}})}),1)],1)],1)]),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/favorites.vue
function injectStyle (context) {
  __webpack_require__("meK2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490c45d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  favorites,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_favorites = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Rqrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_reportsStorage__ = __webpack_require__("dX8W");


/* harmony default export */ __webpack_exports__["default"] = ({
  cleanStorage: function cleanStorage() {
    __WEBPACK_IMPORTED_MODULE_0__storage_reportsStorage__["default"].cleanStorage();
  }
});

/***/ }),

/***/ "S4jV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ind4.500b2f6.png";

/***/ }),

/***/ "S8x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/user-rights-form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var user_rights_form = ({
  name: 'user-rights-form',
  data: function data() {
    return {
      items: ['GLOBAL', 'NORMAL', 'SUPERVISOR']
    };
  },


  props: ['userData', 'userSubscriptions']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2493fc0e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/user-rights-form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-switch',{attrs:{"color":"primary","label":"Habilitado?"},model:{value:(_vm.userData.isEnabled),callback:function ($$v) {_vm.$set(_vm.userData, "isEnabled", $$v)},expression:"userData.isEnabled"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-subheader',[_vm._v("Tipo de usuario")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-select',{attrs:{"items":_vm.items,"label":"Select","single-line":"","bottom":""},model:{value:(_vm.userData.userType),callback:function ($$v) {_vm.$set(_vm.userData, "userType", $$v)},expression:"userData.userType"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_vm._v("\n        asdlaks\n      ")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/users/user-rights-form.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_rights_form,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_user_rights_form = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SzZz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzIDIwLjYxMTJWOS41MDAwNEMyMyA4LjkxMDY3IDIyLjc3ODcgOC4zNDU0NCAyMi4zODQ5IDcuOTI4NjlDMjEuOTkxMSA3LjUxMTk0IDIxLjQ1NyA3LjI3NzgyIDIwLjkgNy4yNzc4MkgxMy43OTc4QzEzLjQwNzcgNy4yNzc4IDEzLjAyNTQgNy4xNjI4MyAxMi42OTM2IDYuOTQ1NzdDMTIuMzYxOCA2LjcyODcyIDEyLjA5MzcgNi40MTgxNyAxMS45MTkzIDYuMDQ4OTNMMTAuOTgwNyA0LjA2MjI2QzEwLjgwNjIgMy42OTI4NiAxMC41Mzc5IDMuMzgyMTkgMTAuMjA2IDMuMTY1MTNDOS44NzM5NyAyLjk0ODA2IDkuNDkxNCAyLjgzMzE4IDkuMTAxMTUgMi44MzMzN0g0LjFDMy41NDMwNSAyLjgzMzM3IDMuMDA4OSAzLjA2NzUgMi42MTUwOCAzLjQ4NDI1QzIuMjIxMjUgMy45MDEgMiA0LjQ2NjIzIDIgNS4wNTU2VjIwLjYxMTJDMiAyMS4yMDA1IDIuMjIxMjUgMjEuNzY1OCAyLjYxNTA4IDIyLjE4MjVDMy4wMDg5IDIyLjU5OTIgMy41NDMwNSAyMi44MzM0IDQuMSAyMi44MzM0SDIwLjlDMjEuNDU3IDIyLjgzMzQgMjEuOTkxMSAyMi41OTkyIDIyLjM4NDkgMjIuMTgyNUMyMi43Nzg3IDIxLjc2NTggMjMgMjEuMjAwNSAyMyAyMC42MTEyWiIgc3Ryb2tlPSIjMjUyMzVGIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kZWQiIHN0cm9rZS1saW5lam9pbj0icm91bmRlZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "T670":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Regular.007b563.otf";

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axiosWrapper__ = __webpack_require__("BRjr");




/* harmony default export */ __webpack_exports__["default"] = ({
  getToken: function getToken() {
    return localStorage.token || '';
  },
  logOut: function logOut() {
    delete localStorage.token;
  },
  isLoggedIn: function isLoggedIn() {
    return !!localStorage.token;
  },
  login: function login(options) {
    /*
      options: {
        context: Vue,
        creds: {user: "", password: ""}
        onSuccess()
        onError()
      }
    */

    __WEBPACK_IMPORTED_MODULE_2__axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__uris__["default"].URL_LOGIN, options.creds).then(function (data) {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      localStorage.token = data.data.token;
      localStorage.token_autoservicio = data.data.token_autoservicio;
      localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data.user);
    }, function (err) {
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  correo_recuperacion: function correo_recuperacion(options) {
    __WEBPACK_IMPORTED_MODULE_2__axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__uris__["default"].URL_FORGOT_PASSWORD, options.creds).then(function (data) {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      // localStorage.token = data.data.token
      // localStorage.token_autoservicio = data.data.token_autoservicio
      localStorage.mail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data.message);
    }, function (err) {
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  correo_change_pwd: function correo_change_pwd(options) {
    __WEBPACK_IMPORTED_MODULE_2__axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__uris__["default"].URL_CHANGE_PASSWORD, options.creds).then(function (data) {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
      // localStorage.token = data.data.token
      // localStorage.token_autoservicio = data.data.token_autoservicio
      localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data.user);
    }, function (err) {
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "Tds2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UHR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UkpE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uxnk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/supervisor/card-template.vue + 2 modules
var card_template = __webpack_require__("XR0q");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-consistencies.vue
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var card_consistencies = ({
  name: 'card-consistences',
  methods: {
    getCardInfo: function getCardInfo() {
      var consistent = supervisorStorage["default"].getConsistencyCorrectLogs();
      var total = supervisorStorage["default"].getSupervisorFtpFiles().length;
      var inconsistent = total - consistent;

      var percentageConsistency = consistent / total;
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        };
      }
      if (total === consistent) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Correcto, todos los archivos son consistentes'
        };
      }
      if (percentageConsistency > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: inconsistent,
          // message: `de ${total} distribuidora(s) tiene(n) archivos con inconsistencias`
          message: 'de ' + total + ' distribuidora(s) tiene(n) archivos inconsistentes'
        };
      }
      return {
        lightColor: 'red',
        cardNumber: inconsistent,
        message: 'de ' + total + ' distribuidora(s) tiene(n) archivos inconsistentes'
      };
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    CardTemplate: card_template["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8b69310","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-consistencies.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-template',{attrs:{"card-title":_vm.data.cardName,"is-loading":_vm.isLoading,"card-info":_vm.getCardInfo(),"card-type":"CONSISTENCIES"}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-consistencies.vue
function injectStyle (context) {
  __webpack_require__("hv5X")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_consistencies,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_consistencies = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "V91D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/autoservicios/autoservicio-btn-back.vue + 2 modules
var autoservicio_btn_back = __webpack_require__("VfmT");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/bonus/show-bonus-distributor.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var show_bonus_distributor = ({
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    AutoservicioBtnBack: autoservicio_btn_back["default"],
    CustomSnackBar: custom_snack_bar["default"]
  },
  data: function data() {
    return {
      items: [{ isOK: 0, code: '361640', marca: 'Elite', name: 'PH ELITE DH 24X 2 LA', qty: '15', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H65', tope: 65 }, { isOK: 0, code: '361639', marca: 'Elite', name: 'PH ELITE SOFT TOUCH  DH 6 X 6', qty: '11', unit: 'BOL', qty_bonus: '2', unit_2: 'PACK', code_2: '361639', marca_2: 'Elite', name_2: 'PH ELITE SOFT TOUCH  DH 6 X 6', code_3: '132H66', tope: 30 }, { isOK: 0, code: '361473', marca: 'Elite', name: 'PH ELITE DUO  DH 6 x 8  25 METROS', qty: '30', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361473', marca_2: 'Elite', name_2: 'PH ELITE DUO  DH 6 x 8  25 METROS', code_3: '132H67', tope: 80 }, { isOK: 0, code: '361051', marca: 'Elite', name: 'PH ELITE PLUS DH 24 X 2', qty: '15', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H68', tope: 30 }, { isOK: 0, code: '361618', marca: 'Noble', name: 'PH NOBLE DH 2 X 10 CON PPRECIO', qty: '3', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H88', tope: 400 }, { isOK: 0, code: '361618', marca: 'Nobble', name: 'PH NOBLE DH 2 X 10 CON PRECIO', qty: '35', unit: 'BOL', qty_bonus: '1', unit_2: 'BOL', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H69', tope: 90 }, { isOK: 0, code: '361415', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  1 X 12', qty: '3', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361415', marca_2: 'Nova', name_2: 'RC NOVA DH MEGAROLLO  1 XX 12', code_3: '132H70', tope: 100 }, { isOK: 0, code: '361473', marca: 'Elite', name: 'PH ELITE DUO  DH 6 x 8  25 METROS', qty: '10', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '361586', marca_2: 'NNova', name_2: 'SE NOVA CORTADA 200 x 15 PAQ X BOLSA', code_3: '132H72', tope: 1231 }, { isOK: 0, code: '361436', marca: 'Higienol', name: 'PH HIGIENOL DH  4 X 12', qty: '1', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H85', tope: 400 }, { isOK: 0, code: '361415', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  1 X 12', qty: '2', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361618', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10 CON PRECIO', code_3: '132H73', tope: 750 }, { isOK: 0, code: '371485', marca: 'Babysec', name: 'PL PAAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', qty: '30', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '371485', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', code_3: '128F93', tope: 100 }, { isOK: 0, code: '371485', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK GR 58x2ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '128G06', tope: 50 }, { isOK: 0, code: '371452', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK MD 64x2 ND', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 50 }, { isOK: 0, code: '371481', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 40 }, { isOK: 0, code: '371482', marca: 'Babysec', name: 'PL PAÑAL BABYSEC PREMIUM PPK XXG 44x2ND2', qty: '1', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '371481', marca_2: 'Babysec', name_2: 'PL PAÑAL BABYSEC PREMIUM PPK XG 48x2 ND2', code_3: '', tope: 40 }, { isOK: 0, code: '371541', marca: 'Ladysoft', name: 'TF LADYSOFT NOCTURNA CON ALAS 10 X 24', qty: '6', unit: 'PACK', qty_bonus: '1', unit_2: 'PACK', code_2: '360717', marca_2: 'Noble', name_2: 'PH NOBLE DH 2 X 10', code_3: '132H87', tope: 400 }, { isOK: 0, code: '371183', marca: 'Ladysoft', name: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', qty: '12', unit: 'BOL', qty_bonus: '8', unit_2: 'PACK', code_2: '371183', marca_2: 'Ladysoft', name_2: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', code_3: '128G51', tope: 80 }, { isOK: 0, code: '371183', marca: 'Ladysoft', name: 'TF LADYSOFT NORMAL CON ALAS 10 X 24 INN', qty: '6', unit: 'PACK', qty_bonus: '2', unit_2: 'UNIDADES', code_2: '360973', marca_2: 'Elite', name_2: 'PO ELITE ALOE VERA DISPENSADOR 27 X 8', code_3: '132H93', tope: 80 }, { isOK: 0, code: '361416', marca: 'Nova', name: 'RC NOVA DH MEGAROLLO  2 X 6', qty: '6', unit: 'BOL', qty_bonus: '1', unit_2: 'PACK', code_2: '361416', marca_2: 'Nova', name_2: 'RC NOVA DH MEGAROLLO  2 X 6', code_3: '132I73', tope: 250 }, { isOK: 0, code: '361557', marca: 'Noble', name: 'PH NOBLE PREMIUM DH 4x6 40 METROS', qty: '20', unit: 'BOL', qty_bonus: '3', unit_2: 'PACK', code_2: '361557', marca_2: 'Noble', name_2: 'PH NOBLE PREMIUM DH 4x6 40 METROS', code_3: '132J38', tope: 40 }, { isOK: 0, code: '361628', marca: 'Noble', name: 'PH NOBLE AHORRO PLUS DH 4x6 36 METROS', qty: '20', unit: 'BOL', qty_bonus: '3', unit_2: 'PACK', code_2: '361628', marca_2: 'Noble', name_2: 'PH NOBLE AHORRO PLUS DH 4x6 36 METROS', code_3: '132J39', tope: 800 }],
      headersTop: [{ text: 'Producto a evaluar', col: 4, color: 'yellow accent-4' }, { text: 'Mecanica bonificacion', col: 9, color: 'orange lighten-1' }],
      headers: [{ text: 'Cod. Producto', value: 'code' }, { text: 'Marca', value: 'marca' }, { text: 'Producto', value: 'name' }, { text: 'Unidad', value: 'unit' }, { text: 'Cant. Minima', value: 'qty' }, { text: 'Cod. Producto', value: 'code_2' }, { text: 'Marca', value: 'marca_2' }, { text: 'Producto', value: 'name_2' }, { text: 'Unidad', value: 'unit_2' }, { text: 'Unidades a Bonificar', value: 'qty_bonus' }, { text: 'Cod. Pro. Distribuidor', value: 'code_3', asTag: 'input' }, { text: 'Tope Bonificado', value: 'tope' }, { text: '', value: 'isOK', asTag: 'check' }],
      bonusItems: [],
      isLoading: false
    };
  },

  methods: {
    validateCheckTag: function validateCheckTag(item) {
      return item['code_3'].length > 0 && item['isOk'];
    },
    saveItems: function saveItems() {
      var _this = this;

      this.isLoading = true;

      setTimeout(function () {
        _this.isLoading = false;
        _this.goBack();
      }, 1000);
    },
    addItem: function addItem(item) {
      // console.log(item)
    },
    goBack: function goBack() {
      this.$router.back();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cadee5f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/bonus/show-bonus-distributor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategio-bgmain-view fill-height"},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('autoservicio-btn-back',{attrs:{"title-name":"Aprobar Bonificaciones"}})],1),_vm._v(" "),_c('v-row',{staticClass:"justify-space-between"},[_c('v-col',{attrs:{"cols":"6"}},[_c('h2',[_vm._v("Distribuidora: demo 01")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"2"}},[_c('v-btn',{staticClass:"white--text",attrs:{"loading":_vm.isLoading,"disabled":_vm.isLoading,"block":"","color":"#2262c6"},on:{"click":_vm.saveItems},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Cargando...")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n            Guardar\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-content-save ")])],1)],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-simple-table',{attrs:{"dense":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',_vm._l((_vm.headersTop),function(item,key){return _c('th',{key:key,class:item.color,attrs:{"colspan":item.col}},[_vm._v(_vm._s(item.text.toUpperCase()))])}),0),_vm._v(" "),_c('tr',{staticClass:"strategio-bgtemplate-color"},_vm._l((_vm.headers),function(item,key){return _c('th',{key:key,staticStyle:{"color":"white"}},[_vm._v(_vm._s(item.text.toUpperCase()))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},_vm._l((_vm.headers),function(head,keyhead){return _c('td',{key:keyhead},[(head.asTag == 'input')?_c('v-text-field',{attrs:{"dense":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{attrs:{"color":"green","small":""}},[_vm._v("mdi-pencil")])]},proxy:true}],null,true),model:{value:(item[head.value]),callback:function ($$v) {_vm.$set(item, head.value, $$v)},expression:"item[head.value]"}}):(head.asTag == 'check')?_c('v-checkbox',{attrs:{"value":_vm.validateCheckTag(item),"dense":"","disabled":item['code_3'].length == 0},on:{"change":function($event){return _vm.addItem(item)}},model:{value:(item[head.value]),callback:function ($$v) {_vm.$set(item, head.value, $$v)},expression:"item[head.value]"}}):_c('span',[_vm._v(_vm._s(item[head.value]))])],1)}),0)}),0)]},proxy:true}])})],1)],1)],1)],1),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/bonus/show-bonus-distributor.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_bonus_distributor,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var bonus_show_bonus_distributor = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VfmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/autoservicio-btn-back.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var autoservicio_btn_back = ({
  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  },
  props: {
    titleName: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3576a985","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/autoservicio-btn-back.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex  justify-center"},[_c('v-icon',{staticStyle:{"font-size":"52px","margin-right":"5px"},attrs:{"color":"black"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n  "+_vm._s(_vm.titleName)+"\n  ")])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/autoservicio-btn-back.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_btn_back,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_autoservicio_btn_back = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "W90M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAKm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZ70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/storage/logsStorage.js
var logsStorage = __webpack_require__("niPX");

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/logs/distributor-details-log-report.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var distributor_details_log_report = ({
  data: function data() {
    return {
      renderPag: false,
      cards: {},
      showMore: false,
      dataTableLogs: {},
      consistencyLogs: [],
      databaseLogs: [],
      headers: [],
      selected: [],
      pagination: {
        rowsPerPage: 4
      },
      isLoadingConsistencyLogs: false,
      isLoadingDatabaseLogs: false,

      showAllLastLog: false
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
    this.consistencyLogs = logsStorage["default"].getConsistencyLogsPointer();
    this.databaseLogs = logsStorage["default"].getDatabaseLogsPointer();
  },

  watch: {
    showAllLastLog: function showAllLastLog(val) {
      val && values_default()(this.$refs).forEach(function (i) {
        i.classList.remove('strategio-highlighting');setTimeout(function () {
          i.classList.add('strategio-highlighting');
        }, 0);
      });
    }
  },
  methods: {
    getHighlightTag: function getHighlightTag(card, distributor, showAll) {
      return card.extra.logDetails(distributor).reduce(function (t, i) {
        return t && (typeof i.data(showAll) === 'string' || !i.highlightable);
      }, true) ? null : 'highlight-' + card.cardType;
    },
    showConsistencyLogs: function showConsistencyLogs(distributor) {
      var _this = this;

      if (this.isDistributorConsistencyLogs) {
        this.renderPag = true;
        this.showMore = !this.showMore;
        return;
      }
      this.isLoadingConsistencyLogs = true;
      logsStorage["default"].getConsistencyLogs({
        data: {
          distributorCode2: distributor.distributorCode2
        },
        onSuccess: function onSuccess(consistencyLogs) {
          _this.dataTableLogs = Object(lodash["find"])(_this.consistencyLogs, function (item) {
            return item.distributorCode2 === distributor.distributorCode2;
          });

          _this.showMore = true;

          _this.isLoadingConsistencyLogs = false;
          _this.renderPag = true;
        },
        onError: function onError() {
          _this.isLoadingConsistencyLogs = false;
        }
      });
    },
    showDatabaseLogs: function showDatabaseLogs(distributor) {
      var _this2 = this;

      if (this.isDistributorDatabaseLogs) {
        this.renderPag = true;
        this.showMore = !this.showMore;
        return;
      }
      this.isLoadingDatabaseLogs = true;
      logsStorage["default"].getDatabaseLogs({
        data: {
          distributorCode1: distributor.distributorCode1
        },
        onSuccess: function onSuccess(databaseLogs) {
          _this2.dataTableLogs = Object(lodash["find"])(_this2.databaseLogs, function (item) {
            return item.distributorCode1 === distributor.distributorCode1;
          });

          _this2.showMore = true;

          _this2.isLoadingDatabaseLogs = false;
          _this2.renderPag = true;
        },
        onError: function onError() {
          _this2.isLoadingDatabaseLogs = false;
        }
      });
    },
    logsWithNoErrors: function logsWithNoErrors(dayLogs) {
      var _this3 = this;

      return dayLogs.reduce(function (t, i) {
        return t && !_this3.errorsInLog(i);
      }, true);
    },
    errorsInLog: function errorsInLog(log) {
      return (log.linesNotMatchingColumns || []).length + (log.linesWithColumnsIssues || []).length + (log.linesWithNotMatchingType || []).length > 0;
    }
  },
  computed: {
    enabledCards: function enabledCards() {
      return Object(lodash["filter"])(this.cards, 'enabled');
    },
    enabledCardsLogs: function enabledCardsLogs() {
      return Object(lodash["filter"])(this.enabledCards, function (i) {
        return i.extra.enabled;
      });
    },
    areDetailsShown: function areDetailsShown() {
      var temp = !Object(lodash["isEmpty"])(this.detailedDistributor);
      if (temp === false) {
        this.renderPag = false;
        this.showMore = false; // Necesario para que paginador no se muestre vacío
      }
      return temp;
    },
    isDistributorLogs: function isDistributorLogs() {
      var temp = this.isDistributorConsistencyLogs || this.isDistributorDatabaseLogs;
      if (temp === true) {
        // this.renderPag = true // Ocurre lo mismo, se ha movido al lugar correcto
        this.pagination.page = 1;
      }
      return temp;
    },
    isDistributorConsistencyLogs: function isDistributorConsistencyLogs() {
      var temp = this.dataTableLogs.distributorCode2 === this.detailedDistributor.distributorCode2 && this.dataTableLogs.logType === 'CONSISTENCY';
      return temp;
    },
    isDistributorDatabaseLogs: function isDistributorDatabaseLogs() {
      var temp = this.dataTableLogs.distributorCode1 === this.detailedDistributor.distributorCode1 && this.dataTableLogs.logType === 'DATABASE';
      return temp;
    },
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 1;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },

    /* pages () {
      return this.pagination.rowsPerPage ? Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) : 0
    }, */
    isLoading: function isLoading() {
      return this.isLoadingConsistencyLogs || this.isLoadingDatabaseLogs;
    }
  },
  props: {
    detailedDistributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a07026b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/logs/distributor-details-log-report.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":""}},[(_vm.areDetailsShown)?_c('v-layout',{attrs:{"fill-height":"","column":""}},[_c('v-flex',{staticClass:"pa-3",staticStyle:{"height":"100% !important","overflow":"auto"}},[_c('v-layout',{staticClass:"px-4 py-2",staticStyle:{"border-radius":"16px","border":"1px solid lightgray","color":"rgba(0,0,0,0.7)","overflow-y":"auto"},attrs:{"fill-height":"","column":""}},[_c('div',{staticClass:"pl-0 pb-0 d-block",staticStyle:{"line-height":"normal","font-size":"28px","font-weight":"600","text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.detailedDistributor.distributorName.toLowerCase()))]),_vm._v(" "),_c('div',{staticClass:"ml-0 mb-3",staticStyle:{"font-size":"12px"}},[_vm._v("\n          Código de distribuidor (1): "+_vm._s(_vm.detailedDistributor.distributorCode1)),_c('br'),_vm._v("\n          Código de distribuidor (2): "+_vm._s(_vm.detailedDistributor.distributorCode2)),_c('br')]),_vm._v(" "),_c('div',[(_vm.detailedDistributor.lastLog.length > 0 && _vm.enabledCards.length > 0)?_c('div',{staticClass:"title pb-0"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm12":"","md12":"","lg6":""}},[_vm._v("\n                Últimos logs\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm12":"","md12":"","lg6":""}},[_c('v-checkbox',{staticStyle:{"color":"#00B4C7 !important"},attrs:{"hide-details":"","label":"Mostrar todo"},model:{value:(_vm.showAllLastLog),callback:function ($$v) {_vm.showAllLastLog=$$v},expression:"showAllLastLog"}})],1)],1)],1):_c('div',[_vm._v("\n            "+_vm._s(_vm.enabledCards.length > 0 ? 'Error lógico' : (_vm.detailedDistributor.lastLog.length > 0 ? 'No hay tarjetas activadas' : 'No existen logs'))+"\n          ")]),_vm._v(" "),_c('v-data-table',{staticClass:"strategio-table-section mt-1 mb-3",attrs:{"items":_vm.enabledCardsLogs,"hide-headers":"","hide-actions":"","item-key":"cardType"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{ref:_vm.getHighlightTag(props.item, _vm.detailedDistributor, _vm.showAllLastLog),staticStyle:{"cursor":"default","color":"gray"},on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(props.item.cardName))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{staticClass:"px-4 mt-1",staticStyle:{"max-height":"205px","overflow":"auto","color":"gray"},attrs:{"flat":""}},_vm._l((props.item.extra.logDetails(_vm.detailedDistributor)),function(logDetail,index){return (logDetail.visible)?_c('div',{key:index},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(logDetail.label)+":")]),_vm._v(" "),(typeof logDetail.data(_vm.showAllLastLog) === 'string')?[_vm._v("\n                    "+_vm._s(logDetail.data(_vm.showAllLastLog))+"\n                  ")]:[_c('log-details',{attrs:{"distributor":_vm.detailedDistributor,"card":props.item,"show-all":_vm.showAllLastLog}})]],2):_vm._e()}),0)]}}],null,false,1259697879)})],1)])],1),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"fill-height":"","column":""}},[_c('v-flex',{staticClass:"mb-2"},[_c('v-layout',{attrs:{"text-xs-center":""}},[_c('v-flex',[_c('v-btn',{staticClass:"strategio-card-button mr-0",style:([{'background-color': (_vm.isDistributorConsistencyLogs && _vm.showMore) ? '#0099AB' : '#00B4C7'}]),attrs:{"depressed":"","rounded":"","dark":"","loading":_vm.isLoading},on:{"click":function($event){return _vm.showConsistencyLogs(_vm.detailedDistributor)}}},[_vm._v("\n                "+_vm._s((_vm.isDistributorConsistencyLogs && _vm.showMore) ? 'Ocultar cons. logs' : 'Ver cons. logs')+"\n              ")])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{staticClass:"strategio-card-button ml-0",staticStyle:{"background-color":"#00B4C7"},attrs:{"depressed":"","rounded":"","dark":"","loading":_vm.isLoading},on:{"click":function($event){return _vm.showDatabaseLogs(_vm.detailedDistributor)}}},[_vm._v("\n                "+_vm._s((_vm.isDistributorDatabaseLogs && _vm.showMore) ? 'Ocultar DB logs' : 'Ver DB logs')+"\n              ")])],1)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"expand"}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDistributorLogs && _vm.showMore),expression:"isDistributorLogs && showMore"}],staticClass:"my-0"},[_c('v-layout',{attrs:{"row":"","wrap":['xs', 'sm', 'md'].includes(_vm.$vuetify.breakpoint.name)}},[_c('v-flex',{staticClass:"px-3 mb-3 order-xs2 order-sm1",attrs:{"xs12":""}},[_c('v-layout',[_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDistributorConsistencyLogs),expression:"isDistributorConsistencyLogs"}],staticClass:"strategio-table-section",attrs:{"headers":_vm.headers,"items":_vm.dataTableLogs.logs,"hide-headers":"","hide-actions":"","pagination":_vm.pagination,"item-key":"logDate"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:([{'cursor': _vm.logsWithNoErrors(props.item.log || []) ? 'default' : 'pointer'}, {'color': _vm.logsWithNoErrors(props.item.log || []) ? 'darkgray' : '#777777'}]),on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.logDate)+"  ("+_vm._s(props.item.logDateFromNow)+") "),_c('span',{staticStyle:{"color":"#777777","font-weight":"bold"}},[_vm._v(_vm._s(_vm.logsWithNoErrors(props.item.log || []) ? ' - sin prob.' : ''))])])])]}},{key:"expand",fn:function(props){return [_c('v-card',{staticClass:"px-4 mt-1",staticStyle:{"max-height":"287px","overflow":"auto","color":"#777777"},attrs:{"flat":""}},[_vm._l((props.item.log),function(log,logIndex){return (_vm.errorsInLog(log))?[(log.fileName)?[_vm._v("\n                            Nombre de archivo: "+_vm._s(log.fileName)+"\n                            "),_c('ul',{key:((log.fileName) + "." + logIndex),staticClass:"ml-4 pb-1",staticStyle:{"font-size":"12px","font-weight":"300"}},[_c('li',[_vm._v("Filas removidas: "+_vm._s((log.totalLinesInput - log.totalLinesOutput) > 0 ? (log.totalLinesInput - log.totalLinesOutput) + ' filas' : 'Ninguna'))]),_vm._v(" "),_c('li',[_vm._v("Filas con columnas disparejas: "+_vm._s(log.linesNotMatchingColumns.length))]),_vm._v(" "),_c('li',[_vm._v("Filas con problemas en datos: "+_vm._s(log.linesWithColumnsIssues.length))]),_vm._v(" "),_c('li',[_vm._v("Filas con tipos de datos incorrectos: "+_vm._s(log.linesWithNotMatchingType.length))])])]:(true && log.error)?[_c('div',{key:((log.filename) + "." + logIndex)},[_c('div',[_vm._v("\n                                Nombre de archivo: "+_vm._s(log.error ? log.error.match(/\s(\w+.txt)\s/)[1].slice(0,2) : 'Sin nombre. Error no definido')+"\n                              ")]),_vm._v(" "),_c('div',[_vm._v("\n                                "+_vm._s(log.error)+"\n                              ")])]),_vm._v(" "),(logIndex + 1 < _vm.detailedDistributor.lastLog.length)?_c('v-divider',{key:logIndex}):_vm._e()]:_vm._e()]:_vm._e()})],2)]}}],null,false,517303750)}),_vm._v(" "),_c('v-data-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDistributorDatabaseLogs),expression:"isDistributorDatabaseLogs"}],staticClass:"strategio-table-section",attrs:{"headers":_vm.headers,"items":_vm.dataTableLogs.logs,"hide-headers":"","hide-actions":"","pagination":_vm.pagination,"item-key":"registerDate"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticStyle:{"cursor":"pointer","color":"gray"},on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',[_vm._v(_vm._s(props.item.registerDate)+" ("+_vm._s(props.item.registerDateFromNow)+")")])])]}},{key:"expand",fn:function(props){return [_c('v-card',{staticClass:"px-4 mt-1",staticStyle:{"max-height":"287px","overflow":"auto","color":"gray"},attrs:{"flat":""}},[_vm._v("\n                        Nombre de tabla: "+_vm._s(props.item.salesTableName)+"\n                        "),_c('ul',{staticClass:"ml-5 mb-1",staticStyle:{"font-size":"12px","font-weight":"300"}},[_c('li',[_vm._v("Ventas desactualizadas: "+_vm._s(props.item.isMaxDateOutdated ? 'Sí' : 'No'))]),_vm._v(" "),_c('li',[_vm._v("Fecha supuesta de última venta: "+_vm._s(props.item.maxDate.split(' ')[0]))]),_vm._v(" "),_c('li',[_vm._v("Tiempo supuesto desde última venta: "+_vm._s(props.item.maxDateFromNow))]),_vm._v(" "),_c('li',[_vm._v("Registros desactualizados: "+_vm._s(props.item.isRegisterDateOutdated ? 'Sí' : 'No'))])])])]}}],null,false,2172091940)})],1)],1),_vm._v(" "),(_vm.renderPag)?_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataTableLogs),expression:"dataTableLogs"}],staticClass:"pr-2 order-sm2"},[_c('v-layout',{attrs:{"fill-height":"","justify-end":"","align-end":""}},[_c('v-pagination',{staticClass:"strategio-pagination-component logs",attrs:{"total-visible":5,"length":_vm.pages},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1):_vm._e()],1)],1)],1)],1)],1)],1):_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"rgba(0,0,0,.38)"}},[_vm._v("\n        Seleccione una distribuidora\n      ")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/logs/distributor-details-log-report.vue
function injectStyle (context) {
  __webpack_require__("0TKv")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a07026b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributor_details_log_report,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var logs_distributor_details_log_report = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WsEI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Wz4N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XR0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-template.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var card_template = ({
  name: 'card-template',
  methods: {
    isAdmin: function isAdmin() {
      return userStorage["default"].getUserInfo().userType === 'ADMIN';
    },
    showCardDetails: function showCardDetails() {
      // emit to: /components/dialogs/details-dialog.vue
      eventBus["default"].$emit('open-details-dialog', {
        title: 'Leyenda', // use this.cardDetails.title for a personalized title,
        subtitle: this.card.cardName,
        message: this.card.reference,
        body: this.card.extra.details.body
      });
    }
  },
  computed: {
    cardInfo: function cardInfo() {
      return this.card.extra.info(this.isLoading);
    },
    cardDetails: function cardDetails() {
      return this.card.extra.details;
    }
  },
  props: {
    card: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e54bcf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-template.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"border-radius":"16px"}},[_c('v-card-title',{staticStyle:{"background-color":"#EDECEA"}},[_c('span',{staticStyle:{"font-size":"20px","font-weight":"bold","color":"#5F5B5A"}},[_vm._v(_vm._s(_vm.card.cardName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('img',{attrs:{"height":"32px","src":__webpack_require__("+gN6")("./"+ _vm.card.extra.iconPath),"alt":"card-icon"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(false)?_c('v-menu',{attrs:{"bottom":"","left":"","disabled":_vm.isLoading}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","disabled":_vm.isLoading},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.configure()}}},[_c('v-list-tile-title',[_vm._v("Configurar")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.remove()}}},[_c('v-list-tile-title',{staticClass:"red--text text--darken-2"},[_vm._v("Remover")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticStyle:{"font-size":"28px","font-weight":"300","width":"56px","text-align":"center"}},[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":""}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticStyle:{"font-size":"32px","font-weight":"500","width":"56px","text-align":"center","color":"#5F5B5A"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardInfo.cardNumber !== 0),expression:"cardInfo.cardNumber !== 0"}]},[_vm._v(_vm._s(_vm.cardInfo.cardNumber))]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardInfo.cardNumber === 0),expression:"cardInfo.cardNumber === 0"}],attrs:{"color":"green"}},[_vm._v("done")])],1)]),_vm._v(" "),_c('v-flex',[_c('p',{staticStyle:{"font-weight":"300","height":"42px","color":"#5F5B5A"}},[_vm._v(_vm._s(_vm.cardInfo.message))])])],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"px-2"},[_c('img',{staticStyle:{"margin-left":"10px"},attrs:{"height":"25px","src":__webpack_require__("+gN6")("./" + (_vm.isLoading ? 'assets/dashboard-icons/indicator-gray.png' : _vm.cardInfo.lightColor.iconPath)),"alt":"indicator-icon"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"background-color":"#00C3D7"},attrs:{"small":"","dark":"","rounded":"","depressed":"","disabled":_vm.isLoading},on:{"click":function($event){return _vm.showCardDetails()}}},[_vm._v("Leyenda")])],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-template.vue
function injectStyle (context) {
  __webpack_require__("LYHp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_template,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_template = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XV8S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XvPd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_main_page_vue__ = __webpack_require__("K/Nx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_reports_vue__ = __webpack_require__("MxmD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_login_vue__ = __webpack_require__("Bm+n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_show_report_vue__ = __webpack_require__("cC8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_user_account_vue__ = __webpack_require__("LKIZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_user_admin_vue__ = __webpack_require__("5qaI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_favorites_vue__ = __webpack_require__("QsRl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes_supervise_dashboard_vue__ = __webpack_require__("aXVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_user_admin_by_id_vue__ = __webpack_require__("1HtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes_user_admin_create_vue__ = __webpack_require__("ct65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__routes_search_items_vue__ = __webpack_require__("HjeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes_show_metabase_vue__ = __webpack_require__("63oR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__routes_show_helpdesk_vue__ = __webpack_require__("aecv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__routes_show_report_bi_vue__ = __webpack_require__("CDy0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__routes_autoservicios_autoservicios_vue__ = __webpack_require__("odzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__routes_autoservicios_show_autoservicio_group_vue__ = __webpack_require__("cUXx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__routes_autoservicios_show_process_validation_vue__ = __webpack_require__("tfuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__routes_autoservicios_bonus_show_validation_vue__ = __webpack_require__("dNo6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__routes_autoservicios_bonus_show_bonus_distributor_vue__ = __webpack_require__("V91D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__routes_autoservicios_bonus_show_bonus_report_vue__ = __webpack_require__("gf/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__routes_autoservicios_show_autoservicio_data_vue__ = __webpack_require__("aVm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__routes_autoservicios_homologation_show_homologation_vue__ = __webpack_require__("t+SW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__routes_download_cube_vue__ = __webpack_require__("JOiW");





























var PageNotFound = {
  template: '\n    <div>\n      The page you are looking for does not exists\n      <a href="#/0">Click here to Back in black</a>\n    </div>\n  '
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  transitionOnLoad: true,
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__routes_login_vue__["default"]
  }, {
    path: '/',
    redirect: '/0'
  }, {
    path: '/:folderID',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_3__routes_main_page_vue__["default"]
  }, {
    path: '/reports/info',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_4__routes_reports_vue__["default"]
  }, {
    path: '/download-cube/info',
    name: 'DownloadCube',
    component: __WEBPACK_IMPORTED_MODULE_25__routes_download_cube_vue__["default"]
  }, {
    path: '/metabase/data',
    name: 'ShowMetabase',
    component: __WEBPACK_IMPORTED_MODULE_14__routes_show_metabase_vue__["default"]
  }, {
    path: '/helpdesk/info',
    name: 'ShowHelpdesk',
    component: __WEBPACK_IMPORTED_MODULE_15__routes_show_helpdesk_vue__["default"]
  }, {
    path: '/show-report-bi/data',
    name: 'ShowReportBi',
    component: __WEBPACK_IMPORTED_MODULE_16__routes_show_report_bi_vue__["default"]
  }, {
    path: '/apps/info',
    name: 'Autoservicios',
    component: __WEBPACK_IMPORTED_MODULE_17__routes_autoservicios_autoservicios_vue__["default"]
  }, {
    path: '/apps/group/:groupID',
    name: 'ShowAutoservicioGroup',
    component: __WEBPACK_IMPORTED_MODULE_18__routes_autoservicios_show_autoservicio_group_vue__["default"]
  }, {
    path: '/apps/process/:processID/validacion/',
    name: 'ShowProcessValidation',
    component: __WEBPACK_IMPORTED_MODULE_19__routes_autoservicios_show_process_validation_vue__["default"]
  }, {
    path: '/apps/process/:processID/bonificado/',
    name: 'ShowProcessBonus',
    component: __WEBPACK_IMPORTED_MODULE_20__routes_autoservicios_bonus_show_validation_vue__["default"]
  }, {
    path: '/apps/process/:processID/bonificadodistribuidor',
    name: 'ShowProcessBonusDistributor',
    component: __WEBPACK_IMPORTED_MODULE_21__routes_autoservicios_bonus_show_bonus_distributor_vue__["default"]
  }, {
    path: '/apps/process/:processID/bonidicadoreporte',
    name: 'ShowProcessBonusReport',
    component: __WEBPACK_IMPORTED_MODULE_22__routes_autoservicios_bonus_show_bonus_report_vue__["default"]
  }, {
    path: '/apps/data/:processID/:id?',
    name: 'showAutoservicioData',
    component: __WEBPACK_IMPORTED_MODULE_23__routes_autoservicios_show_autoservicio_data_vue__["default"]
  }, {
    path: '/apps/process/:processID/homologation',
    name: 'ShowAutoServicioHomologation',
    component: __WEBPACK_IMPORTED_MODULE_24__routes_autoservicios_homologation_show_homologation_vue__["default"]
  }, {
    path: '/search-item/:query',
    name: 'SearchItems',
    component: __WEBPACK_IMPORTED_MODULE_13__routes_search_items_vue__["default"]
  }, {
    path: '/show-report/:reportID',
    name: 'ShowReport',
    component: __WEBPACK_IMPORTED_MODULE_6__routes_show_report_vue__["default"]
  }, {
    path: '/show-report/:reportID/:isFavorite',
    name: 'ShowReportFavorite',
    component: __WEBPACK_IMPORTED_MODULE_6__routes_show_report_vue__["default"]
  }, {
    path: '/user/favorites',
    name: 'Favorites',
    component: __WEBPACK_IMPORTED_MODULE_9__routes_favorites_vue__["default"]
  }, {
    path: '/user/account',
    name: 'UserAccount',
    component: __WEBPACK_IMPORTED_MODULE_7__routes_user_account_vue__["default"]
  }, {
    path: '/supervise/dashboard',
    name: 'SuperviseDashboard',
    component: __WEBPACK_IMPORTED_MODULE_10__routes_supervise_dashboard_vue__["default"]
  }, {
    path: '/user/admin',
    name: 'UserAdmin',
    component: __WEBPACK_IMPORTED_MODULE_8__routes_user_admin_vue__["default"]
  }, {
    path: '/user/admin/:userID',
    name: 'UserAdminByID',
    component: __WEBPACK_IMPORTED_MODULE_11__routes_user_admin_by_id_vue__["default"]
  }, {
    path: '/user/admin-create',
    name: 'UserAdminCreate',
    component: __WEBPACK_IMPORTED_MODULE_12__routes_user_admin_create_vue__["default"]
  }, {
    path: '*',
    component: PageNotFound
  }]
});

if (!__WEBPACK_IMPORTED_MODULE_2__utils_auth__["default"].isLoggedIn()) {
  router.push('login');
}

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),

/***/ "Ye0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z6iq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZhQj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZmgP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ZygB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aV+L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aVm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/show-autoservicio-data.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var show_autoservicio_data = ({
  name: 'show-autoservicio-data',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    CustomSnackBar: custom_snack_bar["default"]
  },
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      asLogId: Number(this.$route.params.id),
      processID: Number(this.$route.params.processID),
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      table: {
        headers: [],
        totalItems: -1,
        data: [],
        options: {
          // multiSort: true,
          itemsPerPage: 10
        },
        isLoad: true,
        loadText: 'Obteniendo datos...',
        footer: {
          itemsPerPageAllText: 'Todos',
          itemsPerPageText: 'Registro por pagina',
          itemsPerPageOptions: [10, 20, 30, -1]
        }
      },
      btnDownload: {
        isLoad: false
      },
      dataInfo: []
    };
  },

  methods: {
    donwnloadData: function donwnloadData() {
      var _this = this;

      this.btnDownload.isLoad = true;
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_DATA, {
        processID: this.processID,
        asLogId: this.asLogId,
        excel: 1,
        query: { 'limit': -1 }
      }, {
        responseType: 'blob'
      }).then(function (response) {
        var filename = response.headers.filename;
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(function () {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se pudo obtener archivo', itsOk: 'warning' });
      }).finally(function () {
        _this.btnDownload.isLoad = false;
      });
    },
    getData: function getData() {
      var _this2 = this;

      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.table.isLoad = true;
      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_GET_DATA, extends_default()({
        processID: this.processID,
        asLogId: this.asLogId
      }, filter)).then(function (response) {
        _this2.handlerHeader(response.data['headers']);
        _this2.table.totalItems = response.data['total'];
        _this2.table.data = _this2.handlerData(response.data['data']);
        _this2.handlerDataInfo(response.data['data_info']);
      }).catch(function (err) {
        var responseError = err.response ? err.response.data : { error: 'No se pudo obtener datos' };
        eventBus["default"].$emit('open-custom-snack-bar', { message: responseError['error'], itsOk: 'warning' });
      }).finally(function () {
        _this2.table.isLoad = false;
      });
    },

    handlerTable: function handlerTable(option) {
      this.getData({ query: { 'page': option.page, 'limit': option.itemsPerPage } });
    },
    handlerData: function handlerData(data) {
      if (!Array.isArray(data)) return [];
      var strDate = function strDate() {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return str ? str.substring(0, 10) : '';
      };
      var formatPrice = function formatPrice(price) {
        return (price == null ? 0.0 : price).toFixed(2);
      };
      var handlerData = data.map(function (row) {
        return extends_default()({}, row, { Fecha: strDate(row.Fecha), PrecioUnitario: formatPrice(row.PrecioUnitario), PrecioTotalSinIGV: formatPrice(row.PrecioTotalSinIGV) });
      });
      return handlerData;
    },
    handlerDataInfo: function handlerDataInfo(data) {
      this.dataInfo = Array.isArray(data) ? data : [];
    },
    handlerHeader: function handlerHeader(data) {
      if (!Array.isArray(data)) return null;
      this.table.headers = data.map(function (item) {
        return { text: item, value: item };
      });
    },
    goBack: function goBack() {
      this.$router.back();
    },
    formatNum: function formatNum(num) {
      return num != null ? Math.abs(num).toFixed(2) : 0.0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1560fab5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/show-autoservicio-data.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12"}},[_c('v-icon',{staticStyle:{"font-size":"52px","margin-right":"5px"},attrs:{"color":"black"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n              Datos cargados\n            ")])],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"9"}},_vm._l((_vm.dataInfo),function(item,index){return _c('div',{key:index},[_c('p',[_c('b',[_vm._v(_vm._s(item.validationName)+":")]),_vm._v(" "+_vm._s(_vm.formatNum(item.value)))])])}),0),_vm._v(" "),_c('v-col',{staticClass:"d-flex justify-end",attrs:{"cols":"3"}},[_c('v-btn',{attrs:{"color":"success","loading":_vm.btnDownload.isLoad,"disabled":_vm.btnDownload.isLoad},on:{"click":_vm.donwnloadData},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Cargando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"white"}})]},proxy:true}])},[_vm._v("\n              Descargar\n              "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("\n                mdi-cloud-download\n              ")])],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mx-5 justify-center"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.table.headers,"items":_vm.table.data,"options":_vm.table.options,"server-items-length":_vm.table.totalItems,"loading":_vm.table.isLoad,"loading-text":_vm.table.loadText,"footer-props":_vm.table.footer},on:{"update:options":_vm.handlerTable}})],1)],1)],1)]),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/show-autoservicio-data.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_autoservicio_data,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_show_autoservicio_data = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aXVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/utils/introBus.js
var introBus = __webpack_require__("1wbc");

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/supervisor/cards-list.vue + 2 modules
var cards_list = __webpack_require__("dW/+");

// EXTERNAL MODULE: ./src/components/supervisor/distributors-details.vue + 2 modules
var distributors_details = __webpack_require__("nhJ5");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/components/dialogs/inconsistencies-report-question-dialog.vue + 2 modules
var inconsistencies_report_question_dialog = __webpack_require__("5GOF");

// EXTERNAL MODULE: ./src/components/logs/distributor-details-log-report.vue + 2 modules
var distributor_details_log_report = __webpack_require__("WZ70");

// EXTERNAL MODULE: ./src/components/dialogs/show-card-details-dialog.vue + 2 modules
var show_card_details_dialog = __webpack_require__("HX3A");

// EXTERNAL MODULE: ./src/components/dialogs/show-cards-dialog.vue + 2 modules
var show_cards_dialog = __webpack_require__("sYgN");

// EXTERNAL MODULE: ./src/components/dialogs/show-distributors-dialog.vue + 2 modules
var show_distributors_dialog = __webpack_require__("F7A0");

// EXTERNAL MODULE: ./src/components/dialogs/configure-ftp-dialog.vue + 2 modules
var configure_ftp_dialog = __webpack_require__("seyq");

// EXTERNAL MODULE: ./src/components/dialogs/distributor-form-dialog.vue + 2 modules
var distributor_form_dialog = __webpack_require__("pNPm");

// EXTERNAL MODULE: ./src/components/dialogs/are-you-sure-dialog.vue + 2 modules
var are_you_sure_dialog = __webpack_require__("u9Gr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/supervise-dashboard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ var supervise_dashboard = ({
  name: 'supervise-dashboard',
  created: function created() {
    var q = [];
    for (var i = 0; i < 1 * 10; i++) {
      q.push(i);
    }
    this.clients = q;
    // const w = {
    //   name: 'distribuidor de golosinas',
    //   validator: {
    //     totalLinesInput: 229678,
    //     totalLinesOutput: 229206,
    //     linesNotMatchingColumns: [
    //       {lineNumber: 66413, columns: 16, columnsFound: 17},
    //       {lineNumber: 70456, columns: 16, columnsFound: 17},
    //       {lineNumber: 74268, columns: 16, columnsFound: 17},
    //       {lineNumber: 82615, columns: 16, columnsFound: 17},
    //       {lineNumber: 86577, columns: 16, columnsFound: 17},
    //       {lineNumber: 86650, columns: 16, columnsFound: 17},
    //       {lineNumber: 126628, columns: 16, columnsFound: 17},
    //       {lineNumber: 134055, columns: 16, columnsFound: 17},
    //       {lineNumber: 176232, columns: 16, columnsFound: 17},
    //       {lineNumber: 176233, columns: 16, columnsFound: 17}
    //     ],
    //     linesWithColumnsIssues: [],
    //     linesWithNotMatchingType: []
    //   }
    // }
    // console.log(w)
  },
  data: function data() {
    return {
      search: '',
      cards: [],
      clients: [],
      distributors: [],
      isLoadingDistributors: true,
      isLoadingCards: true,
      fab: false,
      detailedDistributor: {},
      isAdmin: userStorage["default"].getUserInfo().userType === 'ADMIN',

      alert: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    supervisorStorage["default"].getRemoteFiles({
      onSuccess: function onSuccess(distributors) {
        _this.distributors = distributors;
        _this.isLoadingDistributors = false;
      },
      onError: function onError(err) {
        console.warn(err);
      }
    });
    cardsStorage["default"].getCards({
      onSuccess: function onSuccess(cards) {
        _this.cards = cards;
        _this.isLoadingCards = false;
      },
      onError: function onError() {
        // Mostrar mensaje de error
      }
    });

    eventBus["default"].$off('start-supervise-dashboard-tutorial');
    eventBus["default"].$on('start-supervise-dashboard-tutorial', function () {
      var intro = introBus["default"].getIntroBus();
      intro.addSteps([{
        element: '#carditem0',
        intro: 'En estas tarjetas se muestra el estado de los datos que se manejan de las distribuidoras'
      }, {
        element: '#distributorstate-cards',
        intro: 'Aquí uno puede acceder a más detalles de alguna distribuidora en específico. La información se mostrará en la sección de al lado'
      },
      /* {
        element: '#distributorlog',
        intro: ''
      }, */
      {
        element: '#supervisedashboard-speed-dial',
        intro: 'Con este botón uno podrá administrar las tarjetas disponibles o la información de las distribuidoras'
      }].filter(function (obj) {
        return document.getElementById(obj.element.split('#')[1]);
      }));

      intro.start();
    });
  },

  methods: {
    listDistributors: function listDistributors() {
      // emit to: /components/dialogs/show-distributors-dialog.vue
      eventBus["default"].$emit('open-show-distributors-dialog', this.distributors);
    },
    listCards: function listCards() {
      // emit to: /components/dialogs/show-cards-dialog.vue
      eventBus["default"].$emit('open-show-cards-dialog', this.cards);
    }
  },
  computed: {
    areCardsDisabled: function areCardsDisabled() {
      return Object(lodash["filter"])(this.cards, function (card) {
        return card.enabled;
      }).length === 0;
    }
  },
  watch: {
    isLoadingCards: function isLoadingCards(newIsLoadingCards, oldIsLoadingCards) {
      // emits to: /components/header-bar/strategio-app-bar.vue
      if (!this.isLoadingCards && !this.isLoadingDistributors) eventBus["default"].$emit('enable-tutorial-button');
    },
    isLoadingDistributors: function isLoadingDistributors(newIsLoading, oldIsLoading) {
      // emits to: /components/header-bar/strategio-app-bar.vue
      if (!this.isLoadingCards && !this.isLoadingDistributors) eventBus["default"].$emit('enable-tutorial-button');
    }
  },
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    CardsList: cards_list["default"],
    DistributorsDetails: distributors_details["default"],
    DistributorDetailsLogReport: distributor_details_log_report["default"],
    ShowCardDetailsDialog: show_card_details_dialog["default"],
    ShowCardsDialog: show_cards_dialog["default"],
    ShowDistributorsDialog: show_distributors_dialog["default"],
    ConfigureFtpDialog: configure_ftp_dialog["default"],
    DistributorFormDialog: distributor_form_dialog["default"],
    AreYouSureDialog: are_you_sure_dialog["default"],
    CustomSnackBar: custom_snack_bar["default"],
    InconsistenciesReportQuestionDialog: inconsistencies_report_question_dialog["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58941aaf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/supervise-dashboard.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-image': ("url('" + (__webpack_require__("98nQ")) + "')")},
    {'background-repeat': 'repeat'}
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('div',{staticStyle:{"color":"white","font-size":"45px","font-weight":"500"}},[_vm._v("\n          Status\n        ")]),_vm._v(" "),_c('cards-list',{attrs:{"is-loading-distributors":_vm.isLoadingDistributors}}),_vm._v(" "),_c('distributors-details',{attrs:{"is-loading-distributors":_vm.isLoadingDistributors}})],1)],1)]),_vm._v(" "),(_vm.isAdmin)?_c('v-speed-dial',{staticClass:"strategio-speed-dial",attrs:{"id":"supervisedashboard-speed-dial","fixed":"","bottom":"","right":"","direction":"top","transition":"scale-transition"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"elevation-6",attrs:{"slot":"activator","color":"primary","fab":"","loading":_vm.isLoadingDistributors},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("settings")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"white","disabled":_vm.isLoadingDistributors},on:{"click":_vm.listDistributors},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("business")])],1),_vm._v(" "),_c('span',[_vm._v("Administrar dist.")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","color":"white","disabled":_vm.isLoadingCards},on:{"click":_vm.listCards},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"26px"},attrs:{"color":"grey darken-1"}},[_vm._v("collections_bookmark")])],1),_vm._v(" "),_c('span',[_vm._v("Manejar tarj.")])],1)],1):_vm._e(),_vm._v(" "),_c('show-cards-dialog'),_vm._v(" "),_c('show-distributors-dialog'),_vm._v(" "),_c('configure-ftp-dialog'),_vm._v(" "),_c('distributor-form-dialog'),_vm._v(" "),_c('are-you-sure-dialog'),_vm._v(" "),_c('show-card-details-dialog'),_vm._v(" "),_c('inconsistencies-report-question-dialog'),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/supervise-dashboard.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  supervise_dashboard,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_supervise_dashboard = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aZCl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aecv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/show-helpdesk.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var show_helpdesk = ({
  name: 'show-metabase',
  data: function data() {
    return {
      url: 'https://helpdesk.vida.software'
    };
  },

  components: {
    StrategioAppBar: strategio_app_bar["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40def895","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-helpdesk.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('iframe',{staticClass:"strategio-iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/show-helpdesk.vue
function injectStyle (context) {
  __webpack_require__("vwv5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_helpdesk,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_show_helpdesk = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "b5HX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b9tb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ind1.bb2f19d.png";

/***/ }),

/***/ "bT9G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bkhD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cC8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./node_modules/powerbi-client/dist/powerbi.js
var dist_powerbi = __webpack_require__("http");
var powerbi_default = /*#__PURE__*/__webpack_require__.n(dist_powerbi);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/show-report.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ var show_report = ({
  name: "show-report",
  data: function data() {
    return {
      reportData: {
        url2: ""
      },
      url: "",
      currentLocation: this.$route.name,
      fab: false,
      drawer: false,
      containedByFolder: {},
      reportsInFolder: [],
      biCondition: true,
      initial_leftposition: 0,
      initial_topposition: 0,
      range_leftposition: 0,
      range_topposition: 0,
      dragging: false,
      x_ini: 0,
      y_ini: 0,
      x_fin: 0,
      y_fin: 0,
      moved: false,
      loading: true,
      showTopPanel: false
    };
  },

  components: {
    StrategioAppBar: strategio_app_bar["default"]
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.loadFolders(to.params.reportID);
    // this.reportID = to.params.reportID
    next();
  },
  mounted: function mounted() {
    var _this = this;

    this.loadFolders(this.$route.params.reportID);
    // this.reportID = this.$route.params.reportID

    window.addEventListener('mouseup', this.stopDrag);
    window.addEventListener('mousedown', this.startDrag);
    window.addEventListener('mousemove', this.doDrag);

    if (this.$route.query["main-page"]) {
      // console.log("main-page: ", this.$route.query["main-page"]);

      var intro = this.$intro();
      intro.setOptions({
        skipLabel: "Saltar",
        nextLabel: "Siguiente",
        prevLabel: "Previo",
        doneLabel: "Listo"
      });

      intro.start().oncomplete(function () {
        _this.$router.push("/0");
      });
    }
  },

  methods: {
    download: function download() {
      reportsStorage["default"].registerView(this.reportData.reportID, "DOWNLOAD");
      this.url = this.reportData.url2;
    },
    setFavorite: function setFavorite(report) {
      // TODO: Enviar al servidor :D
      this.reportData.isFavorite = !this.reportData.isFavorite;
      reportsStorage["default"].setFavorite(report.itemID, this.reportData.isFavorite);
    },
    goToReport: function goToReport(report) {
      var _isFavorite = "";
      if (this.$route.params.isFavorite) {
        _isFavorite = "/1";
      }
      this.$router.push('/show-report/' + report.itemID + _isFavorite);
    },
    goBack: function goBack(containedBy) {
      if (this.$route.params.isFavorite) {
        this.$router.push("/user/favorites");
        return;
      }
      this.$router.push('/' + containedBy);
      this.currentLocation = this.$route.name;
    },
    openPanel: function openPanel() {
      this.drawer = !this.drawer;
    },
    loadFolders: function loadFolders(reportID) {
      var _this2 = this;

      this.loading = false;
      reportsStorage["default"].getData({
        folderID: "0",
        forceLoad: false,
        onSuccess: function onSuccess(data, store) {
          var report = reportsStorage["default"].findItemByID(reportID);
          _this2.reportData = report;
          _this2.url = report.url1;

          if (report.url1.length <= 36) {
            reportsStorage["default"].getAccessToken(report.url1, function (at) {
              _this2.loadPowerBiFolder(report, at.accessToken);
            });
          } else {
            _this2.biCondition = false;
          }

          if (_this2.$route.params.isFavorite) {
            _this2.containedByFolder = { itemName: "FAVORITOS" };
          } else {
            _this2.containedByFolder = reportsStorage["default"].findItemByID(report.containedBy) || { itemName: "REPORTES" };
          }

          if (_this2.$route.params.isFavorite) {
            var _favorites = [];
            store.map(function (item, index) {
              if (item.isFavorite) {
                _favorites.push(item);
              }
            });
            _this2.reportsInFolder = _favorites;
          } else {
            _this2.reportsInFolder = reportsStorage["default"].findItemsInFolder(report.containedBy, "REPORTS");
          }
          reportsStorage["default"].registerView(reportID, "VIEW");
        },
        onError: function onError(error) {
          _this2.messsage = "Error desconocido";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
            _this2.messsage = "No pudimos obtener respuesta del servidor";
          } else {
            // Something happened in setting up the request that triggered an Error
            _this2.message = 'Error desconocido: ' + error.message;
          }
          _this2.snackbar = true;
          // console.log(error.config);
        }
      });
    },
    loadPowerBiFolder: function loadPowerBiFolder(reportConfig, at) {
      // Grab the reference to the div HTML element that will host the report.
      var reportContainer = document.getElementById('reportContainer');
      reportContainer.style = "width: 0px; height: 0px";

      this.loading = true;
      // Report's Secured Token
      var paramTable = reportConfig.url3.trim();
      var paramColumn = reportConfig.url4.trim();
      var values = reportConfig.url5.split(",");
      var paraValues = Array.isArray(values) ? values.map(function (e) {
        return e.trim();
      }) : [values.trim()];
      var rId = reportConfig.url1;
      var accessToken = at;

      // Embed URL
      var embedUrl = 'https://app.powerbi.com/reportEmbed?groupId=3ddccf9f-ba6a-4ce2-8f78-8a5e15cfb780';

      var filter = {
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: paramTable, //parameter1
          column: paramColumn //parameter2
        },
        operator: "In",
        values: paraValues //parameter3
      };

      // Report ID
      var embedReportId = rId;

      var models = dist_powerbi["models"];

      var config = {
        type: 'report',
        accessToken: accessToken,
        embedUrl: embedUrl,
        id: embedReportId,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      };

      // Embed the report and display it within the div container.
      var powerbi = new dist_powerbi["service"].Service(dist_powerbi["factories"].hpmFactory, dist_powerbi["factories"].wpmpFactory, dist_powerbi["factories"].routerFactory);
      var report = powerbi.embed(reportContainer, config);

      // Report.off removes a given event handler if it exists.
      report.off('loaded');

      // Report.on will add an event handler which prints to Log window.
      report.on("loaded", function () {
        report.getFilters().then(function (filters) {
          filters.push(filter);
          return report.setFilters(filters);
        });
      });

      report.on("rendered", function () {
        this.loading = false;
        reportContainer.style = "width: 100%; height: 100%;";
      });
    },
    startDrag: function startDrag(event) {
      // console.log("Start Drag")

      this.x_ini = event.clientX;
      this.y_ini = event.clientY;
      // console.log("X ini:",this.x_ini," Y ini:",this.y_ini)

      var obj = document.getElementById("options-button");
      this.initial_leftposition = obj.offsetLeft;
      this.initial_topposition = obj.offsetTop;
      // console.log("X div:",this.initial_leftposition," Y div:",this.initial_topposition)

      this.range_leftposition = this.initial_leftposition + 72;
      this.range_topposition = this.initial_topposition + 72;

      if (this.x_ini >= this.initial_leftposition && this.x_ini <= this.range_leftposition && this.y_ini >= this.initial_topposition && this.y_ini <= this.range_topposition && this.currentLocation == 'ShowReport') {

        this.dragging = true;
      }

      this.x_mov = this.x_ini - this.initial_leftposition;
      this.y_mov = this.y_ini - this.initial_topposition;
      // console.log("X diff:",this.x_mov," Y diff:",this.y_mov)
    },
    stopDrag: function stopDrag(event) {
      // console.log("Stop Drag")
      this.dragging = false;
      this.x_fin = event.clientX;
      this.y_fin = event.clientY;

      if (this.x_ini == this.x_fin && this.y_ini == this.y_fin && this.currentLocation == 'ShowReport') {

        if (this.x_ini >= this.initial_leftposition && this.x_ini <= this.range_leftposition && this.y_ini >= this.initial_topposition && this.y_ini <= this.range_topposition) {

          this.goBack(this.reportData.containedBy);
        }
      }

      // console.log("X fin:",this.x_fin," Y fin:",this.y_fin)
      this.moved = false;
    },
    doDrag: function doDrag(event) {
      if (this.dragging) {
        // console.log("Dragging")
        this.x_fin = event.clientX;
        this.y_fin = event.clientY;

        // console.log("X mov:",this.x_fin," Y mov:",this.y_fin)

        var obj = document.getElementById("options-button");
        var x_def = this.x_fin - this.x_mov;
        var y_def = this.y_fin - this.y_mov;
        obj.style.left = x_def + "px";
        obj.style.top = y_def + "px";

        // console.log("Offset Left:",obj.offsetLeft," Offset Top:",obj.offsetTop)

        this.moved = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2378a85b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/show-report.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar',{attrs:{"showTopPanel":false}}),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[(_vm.loading)?_c('div',{staticClass:"loading-container",attrs:{"id":"loadingContainer"}},[_c('v-img',{staticClass:"loading-icon",attrs:{"src":__webpack_require__("HxCl")}})],1):_vm._e(),_vm._v(" "),(!_vm.biCondition)?_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"strategio-iframe",attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e(),_vm._v(" "),(_vm.biCondition)?_c('div',{staticClass:"strategio-iframe",attrs:{"id":"reportContainer"}}):_vm._e()])])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/show-report.vue
function injectStyle (context) {
  __webpack_require__("Wz4N")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_report,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_show_report = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cKcr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cUXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/autoservicios/processes/autoservicio-list-processes.vue + 2 modules
var autoservicio_list_processes = __webpack_require__("41Kw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/show-autoservicio-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var show_autoservicio_group = ({
  name: 'autoservicios-group',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    AutoservicioListProcesses: autoservicio_list_processes["default"]
  },
  data: function data() {
    return {};
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c04da90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/show-autoservicio-group.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"5"}},[_c('v-icon',{staticStyle:{"font-size":"52px","margin-right":"5px"},attrs:{"color":"black"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n              Procesos \n            ")])],1)],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[_c('autoservicio-list-processes',{attrs:{"groupID":Number(_vm.$route.params.groupID)}})],1)],1)],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/show-autoservicio-group.vue
function injectStyle (context) {
  __webpack_require__("bT9G")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_autoservicio_group,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_show_autoservicio_group = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ct65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/users/user-form.vue + 2 modules
var user_form = __webpack_require__("3GQB");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/user-admin-create.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var user_admin_create = ({
  name: 'user-admin-create',
  data: function data() {
    return {
      subs: [],
      uData: {
        userType: 'NORMAL',
        isEnabled: true,
        company: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.loadSubscriptions();
    });
  },

  methods: {
    loadSubscriptions: function loadSubscriptions() {
      var _this2 = this;

      reportsStorage["default"].getData({
        forceLoad: false,
        onSuccess: function onSuccess(data) {
          _this2.subs = reportsStorage["default"].buildTree([]);
          console.warn(_this2.subs);
        },
        onError: function onError(error) {
          var message = 'Error desconocido';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.warn(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.warn(error.request);
            message = 'No pudimos obtener respuesta del servidor';
          } else {
            // Something happened in setting up the request that triggered an Error
            message = 'Error desconocido: ' + error.message;
          }
          eventBus["default"].$emit('open-custom-snack-bar', { message: message, itsOk: false });
        }
      });
    }
  },
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    UserForm: user_form["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e8a4fbc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/user-admin-create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('user-form',{attrs:{"user-data":_vm.uData,"items-tree":_vm.subs,"parent-route":"/user/admin","back-button-text":"Regresar","is-new-user":""}})],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/user-admin-create.vue
function injectStyle (context) {
  __webpack_require__("hM6x")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_admin_create,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var routes_user_admin_create = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "d1/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dInE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dNo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/autoservicios/autoservicio-btn-back.vue + 2 modules
var autoservicio_btn_back = __webpack_require__("VfmT");

// EXTERNAL MODULE: ./src/components/autoservicios/bonus/custom-bonus-table.vue + 2 modules
var custom_bonus_table = __webpack_require__("jHDf");

// EXTERNAL MODULE: ./src/components/autoservicios/autoservicio-step-validation.vue + 2 modules
var autoservicio_step_validation = __webpack_require__("kOLc");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/bonus/show-validation.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var show_validation = ({
  name: 'show-bonus-validation',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    AutoservicioBtnBack: autoservicio_btn_back["default"],
    AutoservicioStepValidation: autoservicio_step_validation["default"],
    CustomSnackBar: custom_snack_bar["default"],
    CustomBonusTable: custom_bonus_table["default"]
  },
  data: function data() {
    return {
      isLoading: false,
      file: null,
      stepValidation: [{ step: 1, text: 'Validando formato de archivo', isCompleted: false }, { step: 2, text: 'Validando bonificaciones', isCompleted: false }, { step: 3, text: 'Cargando datos', isCompleted: false }, { step: 4, text: 'Datos cargados', isCompleted: false }],
      promotions: {},
      bonifications: {},
      isLoadingTable: false
    };
  },
  created: function created() {
    // this.showTables()
  },

  methods: {
    addDropFile: function addDropFile(e) {
      this.file = e.dataTransfer.file[0];
    },
    uploadFile: function uploadFile() {
      this.stepValidation = this.stepValidation.map(function (item) {
        return extends_default()({}, item, { isCompleted: false });
      });
      if (!this.file) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Archivo no seleccionado', itsOk: 'warning' });
        return false;
      }
      this.isLoading = true;
      this.exectuteStep(0);
    },
    exectuteStep: function exectuteStep(numStep) {
      var _this = this;

      if (numStep >= this.stepValidation.length) {
        eventBus["default"].$emit('open-custom-snack-bar', { message: 'Archivo cargado con exito', itsOk: 'warning' });
        this.isLoading = false;
        this.isLoadingTable = true;
        return setTimeout(function () {
          _this.isLoadingTable = false;
          _this.showTables();
        }, 1000);
      }

      return setTimeout(function () {
        _this.stepValidation[numStep].isCompleted = true;
        _this.exectuteStep(numStep + 1);
      }, 1000);
    },
    showTables: function showTables() {
      var promotions = {
        title: 'Promociones Cargadas',
        items: [{ marca: 'Babysec', total: 39 }, { marca: 'Babysec Premium', total: 2 }, { marca: 'Cotidian Clásico', total: 4 }, { marca: 'Cotidian Premiun', total: 4 }, { marca: 'Ladysoft', total: 4 }],
        headers: [{ text: 'Marca', value: 'marca' }, { text: 'Promociones Cargadas', value: 'total' }],
        footers: [{ marca: 'TOTAL', total: 53 }]
      };
      var bonifications = {
        title: 'Bonificaciones Presupuestadas',
        items: [{ dist: 'demo 01', marca: 'Babysec', qty: 120, total: 1365 }, { dist: 'demo 01', marca: 'Babysec Premium', qty: 80, total: 4400 }, { dist: 'demo 01', marca: 'Cotidian Clásico', qty: 60, total: 1680 }, { dist: 'demo 01', marca: 'Cotidian Premiun', qty: 40, total: 1400 }, { dist: 'demo 01', marca: 'Ladysoft', qty: 75, total: 1125 }],
        headers: [{ text: 'Distribuidora', value: 'dist' }, { text: 'Marca', value: 'marca' }, { text: 'Cant. Bonificaciones', value: 'qty' }, { text: 'Promociones Cargadas', value: 'total' }],
        footers: [{ marca: 'TOTAL', qty: 375, total: 9970 }]
      };

      this.promotions = promotions;
      this.bonifications = bonifications;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79de4b8a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/bonus/show-validation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',[_c('v-container',{attrs:{"align-items":"center"}},[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('autoservicio-btn-back',{attrs:{"title-name":"Cargar Bonificaciones"}})],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('div',{on:{"drop":function($event){$event.preventDefault();return _vm.addDropFile.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_c('v-file-input',{staticClass:"validation-file-input",attrs:{"label":"File input","prepend-icon":"mdi-paperclip","outlined":"","loading":_vm.isLoading,"disabled":_vm.isLoading},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)]),_vm._v(" "),_c('v-col',{staticClass:"d-flex justify-start",attrs:{"cols":"3"}},[_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"loading":_vm.isLoading,"disabled":_vm.isLoading,"color":"#2262c6"},on:{"click":_vm.uploadFile},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Cargando...")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n            Subir archivo\n      \n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-cloud-upload ")])],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"pt-10",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('autoservicio-step-validation',{attrs:{"items":_vm.stepValidation}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[(_vm.isLoadingTable)?_c('v-skeleton-loader',{attrs:{"elevation":"0","type":"table"}}):_vm._e(),_vm._v(" "),_c('custom-bonus-table',_vm._b({},'custom-bonus-table',_vm.promotions,false))],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[(_vm.isLoadingTable)?_c('v-skeleton-loader',{attrs:{"elevation":"0","type":"table"}}):_vm._e(),_vm._v(" "),_c('custom-bonus-table',_vm._b({},'custom-bonus-table',_vm.bonifications,false))],1)],1)],1)],1),_vm._v(" "),_c('custom-snack-bar')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/bonus/show-validation.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_validation,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var bonus_show_validation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dW/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// EXTERNAL MODULE: ./src/components/supervisor/card-template.vue + 2 modules
var card_template = __webpack_require__("XR0q");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/cards-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cards_list = ({
  data: function data() {
    return {
      cards: [],
      isAdmin: true
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
  },

  methods: {
    listCards: function listCards() {
      // emit to: /components/dialogs/show-cards-dialog.vue
      eventBus["default"].$emit('open-show-cards-dialog', this.cards);
    }
  },
  computed: {
    isLoadingCards: function isLoadingCards() {
      return !cardsStorage["default"].getCardsPointer().requestFinished;
    },
    areCardsDisabled: function areCardsDisabled() {
      return Object(lodash["filter"])(this.cards, function (card) {
        return card.enabled;
      }).length === 0;
    } /* ,
      cardsInfo () {
       return [
         {
           cardType: 'VALIDATOR',
           cardInfo: () => {
             return {
               lightColor: 'red',
               cardNumber: '99+',
               message: 'No definido'
             }
           },
           cardDetails: {
             title: 'Título no definido',
             message: 'Mensaje no definido',
             body: {
               card: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ],
               detail: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ]
             }
           }
         },
         {
           cardType: 'REMOTE FILES',
           cardInfo: () => {
             const outdated = supervisorStorage.getOutDatedFtpFiles()
             const updated = supervisorStorage.getUpdatedFtpFiles()
             const total = updated + outdated
              const percentageUpdated = updated / total
             // const percentageOutDated = outdated / total
             if (this.isLoading) {
               return {
                 lightColor: 'gray',
                 cardNumber: outdated,
                 message: 'Verificando archivos'
               }
             }
             if (total === updated) { // to avoid undefined trap, do not use percetageUpdated === 1
               return {
                 lightColor: 'green',
                 cardNumber: 0,
                 message: 'Todos los distribuidora(s) enviaron sus archivos'
               }
             }
             if (percentageUpdated > 0.9) {
               return {
                 lightColor: 'amber',
                 cardNumber: outdated,
                 message: `de ${total} distribuidora(s) no ha enviado sus archivos`
               }
             }
             return {
               lightColor: 'red',
               cardNumber: outdated,
               message: `de ${total} distribuidora(s) no ha enviado sus archivos`
             }
           },
           cardDetails: {
             title: `Título para 'Archivos FTP'`,
             message: ``,
             body: {
               card: [
                 {
                   color: 'green',
                   description: 'El 100% de distribuidoras envió sus archivos a la fecha'
                 },
                 {
                   color: 'amber',
                   description: 'Al menos 90% de distribuidoras envió sus achivos a la fecha'
                 },
                 {
                   color: 'red',
                   description: 'Menos del 90% de distribuidoras envió sus archivos a la fecha'
                 }
               ],
               detail: [
                 {
                   color: 'green',
                   description: 'Archivos no están fuera de fecha'
                 },
                 {
                   color: 'amber',
                   description: 'Archivos tienen hasta 2 días de antiguedad'
                 },
                 {
                   color: 'red',
                   description: 'Archivos tienen más de 2 días de antiguiedad'
                 },
                 {
                   color: 'red lighten-2',
                   description: 'No se encontraron archivos'
                 }
               ]
             }
           }
         },
         {
           cardType: 'CONSISTENCIES',
           cardInfo: () => {
             const consistent = supervisorStorage.getConsistencyCorrectLogs()
             const total = supervisorStorage.getSupervisorFtpFiles().length
             const inconsistent = total - consistent
              const percentageConsistency = consistent / total
             if (this.isLoading) {
               return {
                 lightColor: 'gray',
                 cardNumber: 0,
                 message: 'Verificando archivos'
               }
             }
             if (total === consistent) {
               return {
                 lightColor: 'green',
                 cardNumber: 0,
                 message: 'Correcto, todos los archivos son consistentes'
               }
             }
             if (percentageConsistency > 0.9) {
               return {
                 lightColor: 'amber',
                 cardNumber: inconsistent,
                 message: `de ${total} distribuidora(s) tiene archivos inconsistentes`
               }
             }
             return {
               lightColor: 'red',
               cardNumber: inconsistent,
               message: `de ${total} distribuidora(s) tiene archivos inconsistentes`
             }
           },
           cardDetails: {
             title: 'Título no definido',
             message: ``,
             body: {
               card: [
                 {
                   color: 'green',
                   description: 'El 100% de distribuidoras tiene archivos consistentes'
                 },
                 {
                   color: 'amber',
                   description: 'Al menos 90% de distribuidoras tiene archivos consistentes'
                 },
                 {
                   color: 'red',
                   description: 'Menos del 90% de distribuidoras tiene archivos consistentes'
                 }
               ],
               detail: [
                 {
                   color: 'green',
                   description: 'Logs no contienen errores ni filas removidas'
                 },
                 {
                   color: 'amber',
                   description: 'Como máximo, el 10% de logs tiene errores pero no filas removidas'
                 },
                 {
                   color: 'red',
                   description: 'Más del 10% de logs tiene errores o filas removidas, o está fuera de fecha'
                 },
                 {
                   color: 'red lighten-2',
                   description: 'No se encontraron logs o no se los puede leer'
                 }
               ]
             }
           }
         },
         {
           cardType: 'DATABASE',
           cardInfo: () => {
             const correct = supervisorStorage.getDatabaseCorrectLogs()
             const total = supervisorStorage.getSupervisorFtpFiles().length
             const incorrect = total - correct
              const percentageCorrect = correct / total
             if (this.isLoading) {
               return {
                 lightColor: 'gray',
                 cardNumber: 0,
                 message: 'Verificando archivos'
               }
             }
             if (total === correct) {
               return {
                 lightColor: 'green',
                 cardNumber: 0,
                 message: 'Correcto, ninguna distribuidora tiene errores en su BD'
               }
             } else if (percentageCorrect > 0.9) {
               return {
                 lightColor: 'amber',
                 cardNumber: incorrect,
                 message: `de ${total} distribuidora(s) tiene errores en su BD`
               }
             } else {
               return {
                 lightColor: 'red',
                 cardNumber: incorrect,
                 message: `de ${total} distribuidora(s) tiene errores en su BD`
               }
             }
           },
           cardDetails: {
             title: 'Título no definido',
             message: ``,
             body: {
               card: [
                 {
                   color: 'green',
                   description: 'El 100% de distribuidoras no tiene errores en la base de datos'
                 },
                 {
                   color: 'amber',
                   description: 'Al menos 90% de distribuidoras no tiene errores en la base de datos'
                 },
                 {
                   color: 'red',
                   description: 'Menos del 90% de distribuidoras no tiene errores en la base de datos'
                 }
               ],
               detail: [
                 {
                   color: 'green',
                   description: 'Datos de ventas tienen, como máximo, 1 día de antiguedad y están al día'
                 },
                 {
                   color: 'amber',
                   description: 'Datos de ventas tienen, como máximo, 2 días de antiguedad'
                 },
                 {
                   color: 'red',
                   description: 'Datos de ventas tienen más de 2 días de antiguedad'
                 }
               ]
             }
           }
         },
         {
           cardType: 'REPORTS GENERATOR',
           cardInfo: () => {
             return {
               lightColor: 'red',
               cardNumber: '99+',
               message: 'Errores y advertencias al generar reportes'
             }
           },
           cardDetails: {
             title: 'Título no definido',
             message: 'Mensaje no definido',
             body: {
               card: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ],
               detail: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ]
             }
           }
         },
         {
           cardType: 'SHIPPING CONTROL',
           cardInfo: () => {
             return {
               lightColor: 'red',
               cardNumber: '99+',
               message: 'No definido'
             }
           },
           cardDetails: {
             title: 'Título no definido',
             message: 'Mensaje no definido',
             body: {
               card: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ],
               detail: [
                 {
                   color: '',
                   description: 'No definido'
                 }
               ]
             }
           }
         }
       ]
      } */

  },
  props: {
    isLoadingDistributors: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  components: {
    CardTemplate: card_template["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee94c7f0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/cards-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.areCardsDisabled)?[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card,index){return (card.enabled)?_c('v-flex',{key:index,staticStyle:{"padding":"12px"},attrs:{"xs12":"","sm6":"","md6":"","lg3":"","xl3":""}},[_c('card-template',{attrs:{"id":'carditem0',"card":card,"is-loading":_vm.isLoadingDistributors}})],1):_vm._e()}),1)]:[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"white","font-weight":"500"}},[_vm._v("\n          No hay tarjetas habilitadas. \n          "),(!_vm.isAdmin)?[_vm._v("Consulte con el administradaaor.")]:[_c('v-btn',{staticClass:"strategio-card-button prim",attrs:{"depressed":"","dark":"","rounded":"","loading":_vm.isLoadingCards},on:{"click":_vm.listCards}},[_vm._v("\n              Habilitar\n            ")])]],2)],1)],1)]],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/cards-list.vue
function injectStyle (context) {
  __webpack_require__("AsE4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  cards_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_cards_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dX8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);

/* eslint-disable */



// import _ from 'lodash'





var store = [];
// let treeStore = []
var treeStore = [];
var isLoaded = false;

function setChildrenCount(arr) {
  var result = [];
  arr.map(function (item, index) {
    // eslint-disable-next-line
    item.children = __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (i) {
      return i.containedBy == item.itemID;
    });
    item.childrenCount = item.children.length;

    // item = {...item, get isPowerBI () { return this.imageUrl.indexOf('app.powerbi.com') > -1 }}
    // item = {...item, get isPowerBI () { return (this.imageUrl || '').indexOf('powerbi') > -1 }}
    item.isPowerBI = (item.url1 || '').indexOf('powerbi') > -1;
    result.push(item);
  });
  return result;
}

function counFavorite() {
  var _reports = __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (item) {
    return !item.isFolder && !item.hidden;
  });
  return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(_reports, function (item) {
    return item.isFavorite;
  }).length;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  cleanStorage: function cleanStorage() {
    isLoaded = false;
  },
  isDataLoaded: function isDataLoaded() {
    return isLoaded;
  },
  getTopReports: function getTopReports() {
    var _reports = [];
    var folderDownloadCube = this.findItemByName('download-cube');
    if (folderDownloadCube) {
      _reports = __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (item) {
        return !item.isFolder && !item.hidden && item.containedBy !== folderDownloadCube.itemID;
      });
    } else {
      _reports = __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (item) {
        return !item.isFolder && !item.hidden;
      });
    }
    var _reportsOrderByCreatedAt = __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default()(_reports, ['createdAt'], ['desc']);
    // console.log("Reports : ", _reports)
    // console.log("TopFrecuenteReports : ", orderBy(_reports, ['Views'], ['desc']).slice(0, 9))
    return {
      topFrecuenteReports: __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(_reports, function (item) {
        return item.Views > 0;
      }), ['Views'], ['desc']).slice(0, 9),
      topFavoriteReports: __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(_reportsOrderByCreatedAt, function (item) {
        return item.isFavorite;
      }).slice(0, 3),
      topNovedadesReports: _reportsOrderByCreatedAt.slice(0, 5)
    };
  },
  getCountFavorite: function getCountFavorite(options) {
    if (store.length == 0) {
      this.getData({
        forceLoad: true,
        onSuccess: function onSuccess() {
          options.onSuccess(counFavorite());
        }
      });
    } else {
      options.onSuccess(counFavorite());
    }
  },
  getData: function getData(options) {
    var _this = this;

    /*
      options: {
        forceLoad true/false
        itemID: ''
        onSuccess()
        onError()
      }
    */
    // console.log('??????', 'DATA', {isLoaded, forceLoad: options.forceLoad})
    if (!isLoaded || options.forceLoad) {
      __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].get(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_GET_ITEMS).then(function (response) {
        // console.log('??????', 'NO DEBERIA', JSON.stringify(response.data.rows, null, 2), response.data.rows)
        isLoaded = true;
        store = _this.orderFolderBy(response.data.rows, ['isFolder', 'itemName'], ['desc', 'asc']);
        // EXPERIMENTAL: REMAP STORE
        // store = store.map(i => ({...i, isMoving: false}))
        if (options.onSuccess) {
          _this.outputData(store, options);
        } else {
          console.warn('Store is loaded but no onSuccess detected');
        }
      }, function (err) {
        console.warn(err);
        if (options.onError) {
          options.onError(err);
        }
      });
    } else {
      if (options.onSuccess) {
        // console.log(store)
        store = store.slice();
        this.outputData(store, options);
      } else {
        console.warn('Store is cached but no onSuccess detected');
      }
    }
  },
  getAccessToken: function getAccessToken(idPbi, onSuccess) {
    // console.log("Id Power BI", idPbi)
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_POWERBI_ACCESS_TOKEN, {
      reportId: idPbi
    }).then(function (data) {
      // console.log("DATA Power BI", data.data.rows)
      onSuccess(data.data.rows);
    });
  },
  outputData: function outputData(store, options) {
    options.onSuccess(this.getChildrenByFolderID(store, options.folderID), store.map(function (i) {
      return i;
    }));
  },
  getChildrenByFolderID: function getChildrenByFolderID(arr, folderID) {
    if (folderID) {
      return setChildrenCount(
      // eslint-disable-next-line
      __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(arr, function (item) {
        return item.containedBy == folderID;
      }));
    }
    return arr;
  },
  orderFolderBy: function orderFolderBy(arr, fields, orders) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default()(arr, fields, orders);
  },
  findItemByID: function findItemByID(itemID) {
    // eslint-disable-next-line
    return __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(store, function (i) {
      return i.itemID == itemID;
    });
  },
  findItemByName: function findItemByName(itemName) {
    // eslint-disable-next-line
    return __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(store, function (i) {
      return i.itemName == itemName;
    });
  },
  findItemsInFolder: function findItemsInFolder(folderID, type) {
    if (type === 'REPORTS') {
      // eslint-disable-next-line
      return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (i) {
        return i.containedBy == folderID && !i.isFolder;
      });
    } else if (type === 'FOLDERS') {
      // eslint-disable-next-line
      return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (i) {
        return i.containedBy == folderID && i.isFolder;
      });
    }
    // eslint-disable-next-line
    return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (i) {
      return i.containedBy == folderID;
    });
  },
  setFavorite: function setFavorite(reportID, isFavorite, options) {
    var max = store.length;
    for (var i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].reportID == reportID) {
        store[i].isFavorite = isFavorite;
        return;
      }
    }

    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_SET_FAVORITE, {
      itemID: reportID
    }).then(function (response) {
      // console.log('Agregado a favoritos', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('No se ha podido agregar a favoritos', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  buildTree: function buildTree(subs) {
    // eslint-disable-next-line
    var roots = __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (i) {
      return i.containedBy == '0';
    });

    function getChildren(arr, parents) {
      var _loop = function _loop(i) {
        var r = parents[i];
        // eslint-disable-next-line
        r.checked = !__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(subs, function (i) {
          return i.itemID == r.itemID;
        }));
        r.children = [];
        if (r.isFolder) {
          r.children = [];
          // eslint-disable-next-line
          var children = getChildren(arr, __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(arr, function (i) {
            return i.containedBy == r.itemID;
          }));
          r.children = children;
          parents[i] = r;
        }
      };

      for (var i = 0; i < parents.length; i++) {
        _loop(i);
      }
      return parents;
    }
    treeStore = getChildren(store, roots);
    return treeStore;
  },
  toggleTree: function toggleTree(children, checked) {
    var _this2 = this;

    return children.map(function (item) {
      item.checked = checked;
      item.children = _this2.toggleTree(item.children, checked);
      return item;
    });
    /*
    for (let i = 0; i < children.length; i++) {
      children[i].checked = checked
      children[i].children = this.toggleTree(children[i].children, checked)
    }
    return children
    */
  },
  getDefaultPreviewImage: function getDefaultPreviewImage() {
    return __WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_DEFAULT_PREVIEW_IMG;
  },
  getDefaultPlaceholderImage: function getDefaultPlaceholderImage() {
    return __WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_DEFAULT_PLACEHOLDER_IMG;
  },
  registerView: function registerView(reportID, viewType) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_REGISTER_VIEW, {
      itemID: reportID,
      viewType: viewType
    }).then(function (response) {
      // console.log('Visita registrada', response)
    }, function (err) {
      console.warn('No pudo registrarse la visita', err);
    });
  },
  editItem: function editItem(item, newItemData, options) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_EDIT_ITEM, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      itemID: item.itemID
    }, newItemData)).then(function (response) {
      if (options && options.onSuccess) {
        options.onSuccess(response);
      }
      // console.log('EDITADO', response)
    }, function (err) {
      if (options && options.onError) {
        options.onError(err);
      }
      console.warn('No pudo EDITARSE', err);
    });
    var max = store.length;
    for (var i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == item.itemID) {
        var s = store[i];
        if (s.isFolder) {
          s.itemName = newItemData.itemName;
        } else {
          s.itemName = newItemData.itemName;
          s.url1 = newItemData.url1;
          s.url2 = newItemData.url2;
          s.url3 = newItemData.url3;
          s.url4 = newItemData.url4;
          s.url5 = newItemData.url5;
          s.imageUrl = newItemData.imageUrl;
          s.description = newItemData.description;
          s.labels = newItemData.labels;
        }
        store[i] = s;
        return true;
      }
    }
  },
  moveItem: function moveItem(itemID, newContainedBy) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_MOVE_ITEM, {
      itemID: itemID,
      newContainedBy: newContainedBy
    }).then(function (response) {
      // console.log('MOVED', response)
    }, function (err) {
      console.warn('ERROR MOVING', err);
    });
    var max = store.length;
    for (var i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].containedBy = newContainedBy;
        return true;
      }
    }
  },
  hideItem: function hideItem(itemID) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_HIDE_ITEM, {
      itemID: itemID
    }).then(function (response) {
      // console.log('HIDDEN', response)
    }, function (err) {
      console.warn('ERROR HIDDING', err);
    });
    var max = store.length;
    for (var i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].hidden = true;
        return true;
      }
    }
  },
  unHideItem: function unHideItem(itemID) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UNHIDE_ITEM, {
      itemID: itemID
    }).then(function (response) {
      // console.log('UNHIDDEN', response)
    }, function (err) {
      console.warn('ERROR UNHIDDING', err);
    });
    var max = store.length;
    for (var i = 0; i < max; i++) {
      // eslint-disable-next-line
      if (store[i].itemID == itemID) {
        store[i].hidden = false;
        return true;
      }
    }
  },
  removeItem: function removeItem(itemID, options) {
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_REMOVE_ITEM, {
      itemID: itemID
    }).then(function (response) {
      var max = store.length;
      var removedItem = {};
      for (var i = 0; i < max; i++) {
        // eslint-disable-next-line
        if (store[i].itemID == itemID) {
          // console.log('found ', store[i])
          removedItem = store.splice(i, 1);
          break;
        }
      }
      if (options) {
        if (options.onSuccess) {
          options.onSuccess(response, removedItem);
        }
      }
    }, function (err) {
      if (options) {
        if (options.onError) {
          options.onError(err);
        }
      }
    });
  },
  unDoRemoveItem: function unDoRemoveItem(item, options) {
    var _this3 = this;

    // console.log('item should not be remove: ', item)
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UNDO_REMOVE_ITEM, {
      itemID: item.itemID
    }).then(function (response) {
      store.push(item);
      store = _this3.orderFolderBy(store, ['isFolder', 'itemName'], ['desc', 'asc']);
      if (options) {
        if (options.onSuccess) {
          options.onSuccess(response);
        }
      }
    }, function (err) {
      if (options) {
        if (options.onError) {
          options.onError(err);
        }
      }
    });
  },
  addItem: function addItem(options) {
    var _this4 = this;

    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_ADD_ITEM, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
      // console.log('Agregado un elemento', response.data)
      store.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.item));
      store = _this4.orderFolderBy(store, ['isFolder', 'itemName'], ['desc', 'asc']);
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('El elemento no pudo agregarse', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  updatePermissions: function updatePermissions(options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UPDATE_SUBSCRIPTIONS, {
      userID: options.userID,
      permissions: options.permissions
    }).then(function (response) {
      // console.log('Actualizado', response)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('No pudo registrarse la visita', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  addItems: function addItems(items) {
    store = store.concat(items);
  },
  searchItems: function searchItems(queriesArray) {
    /*
    function checkCoincidences (str, coincidences) {
      for (let i = 0; i < coincidences.length; i++) {
        if (str.indexOf(coincidences[i]) > -1) {
          return true
        }
      }
      return false
    }
    */
    function strictCheckCoincidences(str, coincidences) {
      for (var i = 0; i < coincidences.length; i++) {
        if (str.indexOf(coincidences[i]) === -1) {
          return false;
        }
      }
      return true;
    }

    queriesArray = queriesArray.map(function (i) {
      return i.toLowerCase();
    });
    return __WEBPACK_IMPORTED_MODULE_4_lodash_orderBy___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(store, function (item) {
      var labels = item.labels.trim().toLowerCase();
      var name = item.itemName.trim().toLowerCase();

      var criteria = labels === '' ? name : labels;
      // return checkCoincidences(criteria, queriesArray)
      return strictCheckCoincidences(criteria, queriesArray);
    }), ['labels', 'itemName'], ['asc', 'asc']);
  },
  storeLength: function storeLength() {
    return store.length;
  },
  getCheckedItems: function getCheckedItems(children) {
    var q = [];
    var max = children.length;
    for (var i = 0; i < max; i++) {
      if (children[i].checked) {
        q.push(children[i].itemID);
      }
      if (children[i].children.length > 0) {
        q = q.concat(this.getCheckedItems(children[i].children));
      }
    }
    return q;
  },
  updateMultipleItemsInheritee: function updateMultipleItemsInheritee(options) {
    /*
    options: {
      data: {
        itemsID: [],
        inherited: 0,
        structureItemInheritance: false
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_2__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_1__utils_uris__["default"].URL_UPDATE_MULTIPLE_ITEMS_INHERITEE, {
      itemsID: options.data.itemsID,
      inherited: options.data.inherited,
      structureItemInheritance: options.data.structureItemInheritance
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('No se pudo actualizar ', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  }
});

/***/ }),

/***/ "dXC/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dkhU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fondo-loginstrategio.0e2a8f4.jpg";

/***/ }),

/***/ "e+PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/folders/current-folder-permissions-tree.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var current_folder_permissions_tree = ({
  data: function data() {
    return {
      pagination: {
        rowsPerPage: 3
      },
      pickColor: function pickColor(userType) {
        switch (userType) {
          case 'ADMIN':
            return 'blue darken-1';
          case 'SUPERVISOR':
            return 'amber darken-1';
          case 'GLOBAL':
            return 'light-green darken-1';
          case 'NORMAL':
            return 'cyan darken-1';
          case 'DEMO':
            return 'purple darken-1';
          default:
            return 'grey darken-1';
        }
      }
    };
  },

  computed: {
    pages: function pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 1;

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    }
  },
  methods: {
    getUserData: function getUserData(userID) {
      return Object(lodash["find"])(this.users, function (user) {
        return user.userID === userID;
      });
    },
    correctUsersID: function correctUsersID(usersID) {
      Object(lodash["flatMap"])(Object(lodash["filter"])(this.users, function (user) {
        return ['SUPERVISOR', 'GLOBAL'].includes(user.userType);
      }), 'userID').forEach(function (userID) {
        if (!usersID.includes(userID)) usersID.push(userID);
      });

      return usersID;
    }
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissionsType: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c45c43d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/folders/current-folder-permissions-tree.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"my-2"},[_vm._v("\n    "+_vm._s(_vm.permissionsType === 'FOLDER' ? 'Carpetas' : 'Reportes')+":\n  ")]),_vm._v(" "),_c('v-flex',[_c('v-data-table',{staticClass:"strategio-table-section",attrs:{"hide-headers":"","hide-actions":"","item-key":"itemID","items":_vm.items,"pagination":_vm.pagination,"no-data-text":"No hay items"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:[props.expanded ? 'expanded' : ''],staticStyle:{"background-color":"rgba(255, 255, 255, 0)"}},[_c('td',{staticClass:"pl-2 pr-0"},[_c('v-layout',{attrs:{"fill-height":"","align-center":"","body-2":""}},[_c('v-flex',{staticStyle:{"cursor":"pointer","font-size":"10px","color":"gray"},attrs:{"layout":"","align-center":"","fill-height":""},on:{"click":function($event){props.expanded = !props.expanded}}},[_vm._v("\n                "+_vm._s(props.item.itemName)+"\n              ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-0 fill-height strategio-dialog-button",style:([
                  {'border-radius': '0px'},
                  {'width': '110px'},
                  {'background-color': _vm.permissionsType === 'FOLDER' ? '#FAB100' :  '#19BAE8'}
                ]),attrs:{"small":"","depressed":"","dark":""}},[_vm._v("Agregar")])],1)],1)])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},_vm._l((_vm.correctUsersID(props.item.usersID)),function(item,index){return _c('v-card-text',{key:index,staticClass:"py-1"},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-chip',{staticClass:"ml-0",staticStyle:{"font-style":"italic","color":"white"},attrs:{"label":"","small":"","color":_vm.pickColor(_vm.getUserData(item).userType)}},[_vm._v(_vm._s(_vm.getUserData(item).userType))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":""}},[_c('span',{staticClass:"grey--text",staticStyle:{"font-weight":"500","font-style":"italic"}},[_vm._v(_vm._s(_vm.getUserData(item).name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('span',{staticClass:"grey--text",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.getUserData(item).mail))])])],1)],1)}),1)]}}])})],1),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-pagination',{class:['strategio-pagination-component', _vm.permissionsType === 'FOLDER' ? 'folder' : 'report'],attrs:{"length":_vm.pages},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/folders/current-folder-permissions-tree.vue
function injectStyle (context) {
  __webpack_require__("49n3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  current_folder_permissions_tree,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var folders_current_folder_permissions_tree = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eDGn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eHOx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f1PE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fybr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g9ls":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gEAh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gEzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/supervisor/card-template.vue + 2 modules
var card_template = __webpack_require__("XR0q");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-ftp-files.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card_ftp_files = ({
  name: 'card-ftp-files',
  methods: {
    getCardInfo: function getCardInfo() {
      var outdated = supervisorStorage["default"].getOutDatedFtpFiles();
      var updated = supervisorStorage["default"].getUpdatedFtpFiles();
      var total = updated + outdated;

      var percentageUpdated = updated / total;
      // const percentageOutDated = outdated / total
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: outdated,
          message: 'Verificando archivos'
        };
      }
      if (total === updated) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Todos los distribuidora(s) enviaron sus archivos'
        };
      }
      if (percentageUpdated > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: outdated,
          message: 'de ' + total + ' distribuidora(s) no ha(n) enviado sus archivos'
        };
      }
      return {
        lightColor: 'red',
        cardNumber: outdated,
        message: 'de ' + total + ' distribuidora(s) no ha(n) enviado sus archivos'
      };
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    CardTemplate: card_template["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57694db8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-ftp-files.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-template',{attrs:{"card-title":_vm.data.cardName,"is-loading":_vm.isLoading,"card-info":_vm.getCardInfo(),"card-type":"FTP"}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-ftp-files.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_ftp_files,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_ftp_files = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "geiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// EXTERNAL MODULE: ./src/components/supervisor/distributor-details-indicators-list.vue + 2 modules
var distributor_details_indicators_list = __webpack_require__("GGPP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/distributor-detail-section.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var distributor_detail_section = ({
  data: function data() {
    return {
      cards: [],
      isHovered: false
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
  },

  computed: {},
  methods: {},
  components: {
    DistributorDetailsIndicatorsList: distributor_details_indicators_list["default"]
  },
  props: {
    distributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    detailedDistributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showLogsDetails: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    indicators: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b7484b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/distributor-detail-section.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticStyle:{"cursor":"default"},style:([{'background-color': _vm.distributor.distributorCode1 === _vm.detailedDistributor.distributorCode1 ? '#eee' : ( _vm.isHovered ? '#eee' : 'initial')}]),on:{"click":function($event){return _vm.showLogsDetails(_vm.distributor)},"mouseover":function($event){_vm.isHovered = true},"mouseout":function($event){_vm.isHovered = false}}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('span',{staticClass:"pl-2 d-block",staticStyle:{"text-transform":"capitalize !important","font-size":"13px","font-weight":"bold"}},[_vm._v("\n        "+_vm._s(_vm.distributor.distributorName.toLowerCase())+"\n      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":"","md7":""}},[_c('distributor-details-indicators-list',{attrs:{"indicators":_vm.indicators,"distributor":_vm.distributor}})],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/distributor-detail-section.vue
function injectStyle (context) {
  __webpack_require__("lpyF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributor_detail_section,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_distributor_detail_section = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gf/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/bonus/show-bonus-report.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var show_bonus_report = ({
  components: {
    StrategioAppBar: strategio_app_bar["default"]
  },
  data: function data() {
    return {
      url: 'https://onedrive.live.com/embed?resid=C20195D3EE2F228F%2145766&authkey=!AEpusgXQNvdlQ1s&em=2&AllowTyping=True&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True'
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a88f73","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/bonus/show-bonus-report.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategio-bgmain-view fill-height"},[_c('strategio-app-bar'),_vm._v(" "),_c('v-speed-dial',{directives:[{name:"intro",rawName:"v-intro",value:('Desde aquí podrá marcar este reporte como favorito, ver la lista de reportes disponibles o regresar a la página de reportes'),expression:"'Desde aquí podrá marcar este reporte como favorito, ver la lista de reportes disponibles o regresar a la página de reportes'"}],attrs:{"id":"options-button","fixed":"","bottom":"","right":"","direction":"top","transition":"scale-transition","elevation-6":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"strategio-bgbutton-primary",attrs:{"slot":"activator","fab":"","hover":"","x-large":"","color":""},on:{"click":_vm.goBack},slot:"activator"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("arrow_back")])],1)],1),_vm._v(" "),_c('v-main',{staticClass:"fill-height"},[_c('iframe',{staticClass:"strategio-iframe",staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/bonus/show-bonus-report.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_bonus_report,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var bonus_show_bonus_report = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gm6y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hM6x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hv5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i7Zu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "irLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

// export const eventBus = new Vue()
/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ "iu63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j/nF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkU4NEUxMjg3NjJDMTFFOEFDNzRCQkM2NDQ3RDMyQUMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NkU4NEUxMjc3NjJDMTFFOEFDNzRCQkM2NDQ3RDMyQUMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDNjNjkyNjEtNDEzYi1hNDRjLWE2NDMtN2NkNDI0YzllY2RhIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NzZkZDlhYTItYzY4ZS0yZjQ1LTg1ZmUtYTlhYWVmZmUwNzUzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+zLI74AAAAXhJREFUeNrsl7tKA0EUht3RDV6wsBRJYWfjBSXEwsJG8AUsYquk9NLY+AYqtoJBQZ/BzjKFhAULhSDaBR8gCCpG3PUbOOCy7iVDFtLMgY8DZ2bPP3N2dpnjBEEw0A8bigYanjeHq8EMJK1KxwugoBMzL5DcLvzAI1TLpdJDojB2DuNwAJ+SPJrUhw2YhxNow2Bojl7MImzBNaxI3uU04VnYY3W1tFJRmWncFFwy9z1m/BW3CVdwBxfhcRWTsyNkmSvPjyaMD4MDY3E5VcJDyuCcOF3EVebhMjT9vtuUdQK/A2twA8fwZnSqDewbtOCpCE7CPRxCBVqya7/XkkbtA4oicgsLsA5L4MGqfB1fee+4ISU941S3QvFn2Kb8uhJleJF/Qj7CiNVx9ZTxJq4pn5abZ6l7Mitsha2wFbbCVtgKZwr7Oev43QgXhDztX864q4/uc/a5rqiEFsZ0pyOwK3lThavStB2lNG0mpq+4T5L3L9ivNvVXgAEAjR5aDcinhdQAAAAASUVORK5CYII="

/***/ }),

/***/ "jHDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/bonus/custom-bonus-table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var custom_bonus_table = ({
  props: {
    title: {
      type: String
    },
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footers: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157f5130","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/bonus/custom-bonus-table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1"},[_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('v-simple-table',{staticClass:"mt-2",scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',{staticClass:"strategio-bgtemplate-color"},[_c('tr',_vm._l((_vm.headers),function(item){return _c('th',{key:item.text,staticStyle:{"color":"white"}},[_vm._v(_vm._s(item.text))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.name},_vm._l((_vm.headers),function(head){return _c('td',{key:head.text},[_vm._v(_vm._s(item[head.value]))])}),0)}),0),_vm._v(" "),_c('tfoot',{staticClass:"strategio-bgtemplate-color"},_vm._l((_vm.footers),function(item){return _c('tr',{key:item.text},_vm._l((_vm.headers),function(head){return _c('td',{key:head.text,staticStyle:{"color":"white"}},[_vm._v(_vm._s(item[head.value]))])}),0)}),0)]},proxy:true}])})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/bonus/custom-bonus-table.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  custom_bonus_table,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var bonus_custom_bonus_table = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jYJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/menus/item-menu.vue + 2 modules
var item_menu = __webpack_require__("F7n2");

// EXTERNAL MODULE: ./src/storage/reportsStorage.js
var reportsStorage = __webpack_require__("dX8W");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reports/report-list-item-rectangle.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var report_list_item_rectangle = ({
  name: 'report-list-item',
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    var previewImage = reportsStorage["default"].getDefaultPreviewImage();
    var placeholderImage = reportsStorage["default"].getDefaultPlaceholderImage();
    return {
      previewImage: previewImage,
      placeholderImage: placeholderImage,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    };
  },

  methods: {
    deleteItem: function deleteItem(e, item) {
      e.stopPropagation();
      eventBus["default"].$emit('drop-item', item);
    },
    searchByChip: function searchByChip(c) {
      this.searchProps.searchCriteria = c;
      this.searchItems();
    },
    getImageUrl: function getImageUrl(report) {
      var reportImage = '';
      var reportImagesFolderPath = 'assets/report-imgs';
      var images = {
        isExcel: reportImagesFolderPath + '/icon-excel.png',
        isPowerBI: reportImagesFolderPath + '/icon-powerbi.png',
        custom1: reportImagesFolderPath + '/icon-alt1.png',
        custom2: reportImagesFolderPath + '/icon-alt2.png'
      };

      if (!report.imageUrl) {
        // Siempre y cuando no lleven imageUrl
        if (report.isPowerBI) {
          reportImage = images.isPowerBI;
        } else {
          reportImage = images.isExcel;
        }
        reportImage = __webpack_require__("+gN6")("./" + reportImage);
      } else {
        reportImage = report.imageUrl;
      }
      return reportImage;
    },
    setFavorite: function setFavorite(report) {
      // if (this.favoritesPage) {
      //   if (report.isFavorite === 0 || report.isFavorite === false) {
      //     return
      //   }
      // } else {
      //   if (report.isFavorite === 1 || report.isFavorite === true) {
      //     return
      //   }
      // }

      if (this.userType !== 'DEMO') {
        report.isFavorite = !report.isFavorite;
        this.isFavorite = report.isFavorite;
        reportsStorage["default"].setFavorite(report.itemID, report.isFavorite, {});
      }
    },
    getChipsData: function getChipsData(text) {
      if (text) {
        text = text.replace('$$FOLDER', this.containedBy.itemName);
        return text.split(',').map(function (item, index) {
          return item.trim();
        });
      }
      return [];
    },
    showReport: function showReport(data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización ni de descarga', itsOk: 'warning' });
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank');
          reportsStorage["default"].registerView(data.itemID, 'DOWNLOAD');
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning' });
        }
      } else {
        var _isFavorite = '';
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1';
        }
        this.$router.push('/show-report/' + data.itemID + _isFavorite);
      }
    }
  },
  props: {
    reportData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    favoritesPage: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    isSearching: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    containedBy: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    searchProps: {
      type: Object,
      default: function _default() {
        return { searchCriteria: '' };
      }
    },
    searchItems: {
      type: Function,
      default: function _default() {
        return function () {
          alert('Err func');
        };
      }
    }
  },
  components: {
    ItemMenu: item_menu["default"]
  },
  computed: {
    getItemSubtitle: function getItemSubtitle() {
      var itemFolder = '';
      if (this.reportData.containedBy > 0) {
        itemFolder = reportsStorage["default"].findItemByID(this.reportData.containedBy);
      }

      if (itemFolder === '') {
        return '';
      }
      return itemFolder.itemName;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c0de4d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/report-list-item-rectangle.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.reportData.hidden || _vm.isAdmin)?_c('v-card',{staticClass:"d-flex justify-space-between align-center px-5",class:{
    'strategio-hidden-item': _vm.reportData.hidden
  },style:([
    {'height': '137px'},
    {'min-width': '313px'},
    {'width': '313px'},
    {'margin': '20px'},
    {'overflow': 'hidden'},
    {'border-radius': '10px'},
    {'background': '#FFFFFF'},
    {'border': '1px solid rgba(0, 0, 0, 0.05)'}
  ]),attrs:{"outlined":""},on:{"click":function($event){return _vm.showReport(_vm.reportData)}}},[_c('div',{staticClass:"d-flex justify-center align-center pr-1"},[(_vm.reportData.imageUrl)?_c('div',[_c('img',{staticClass:"report-list-item-rectangle-img",attrs:{"src":_vm.getImageUrl(_vm.reportData),"alt":"report-img"}})]):_c('div',{staticClass:"img-circle d-flex justify-center align-center"},[_c('img',{attrs:{"height":"47.69","width":"47.69","src":_vm.getImageUrl(_vm.reportData),"alt":"report-img"}})]),_vm._v(" "),_c('div',{staticClass:"ml-2",staticStyle:{"width":"190px"}},[_c('div',{staticClass:"strategio-report-card-title",staticStyle:{"text-align":"left"}},[_vm._v("\n        "+_vm._s(_vm.reportData.itemName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"strategio-report-card-subtitle",staticStyle:{"margin-top":"10px","text-align":"left"}},[_vm._v("\n        "+_vm._s(_vm.getItemSubtitle)+"\n      ")])])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"13px","top":"25px"}},[(_vm.reportData.isFavorite)?_c('div',[_c('v-btn',{staticStyle:{"-webkit-text-stroke":"0.3px #2AFE4C"},attrs:{"icon":"","small":"","color":"#2AFE4C"},on:{"click":function($event){return _vm.setFavorite($event, _vm.reportData)}}},[_c('v-icon',[_vm._v("ico-icon-star-2")])],1)],1):_c('div',[_c('v-btn',{staticStyle:{"-webkit-text-stroke":"0.3px #2AFE4C"},attrs:{"icon":"","small":"","color":"#2AFE4C"},on:{"click":function($event){return _vm.setFavorite($event, _vm.reportData)}}},[_c('v-icon',[_vm._v("ico-icon-star")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"13px","bottom":"25px"}},[(_vm.isAdmin || _vm.reportData.url2.trim() !== '')?_c('item-menu',{attrs:{"contained-by":_vm.containedBy,"item":_vm.reportData,"is-searching":_vm.isSearching}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/reports/report-list-item-rectangle.vue
function injectStyle (context) {
  __webpack_require__("2LHG")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  report_list_item_rectangle,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_report_list_item_rectangle = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jnq8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ind2.85230da.png";

/***/ }),

/***/ "jq+h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsmt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/iconosVidaSoftware.50871ec.ttf";

/***/ }),

/***/ "kI8Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kOLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/autoservicio-step-validation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var autoservicio_step_validation = ({
  data: function data() {
    return {
      isfalse: false
    };
  },

  props: {
    items: {
      type: Array
    }
  },
  computed: {
    color: function color(item) {
      return item.isCompleted ? { color: 'green' } : {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4631a406","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/autoservicio-step-validation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"id":"autoservicio-bonus-stepper"}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.step,attrs:{"step":item.step,"complete":item.isCompleted,"cols":"3"}},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex justify-center"},[(!item.isCompleted)?_c('v-chip',{attrs:{"value":item.step}},[_vm._v("\n            "+_vm._s(item.step)+"\n          ")]):_c('v-icon',{attrs:{"color":"green","size":"30"}},[_vm._v("\n            mdi-checkbox-marked-circle\n          ")])],1),_vm._v(" "),_c('div'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])])])}),1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/autoservicio-step-validation.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicio_step_validation,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_autoservicio_step_validation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kQl+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "kZfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-dialog-confirmation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var validation_dialog_confirmation = ({
  name: 'validation-dialog-confirmation',
  data: function data() {
    return {
      loadingButton: false,
      rules: {
        confirmField: function confirmField(field) {
          return function (v) {
            return (document.querySelector('#' + field) ? document.querySelector('#' + field).value === v : false) || 'No coincide con ' + field;
          };
        }
      }
    };
  },

  props: {
    showDialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    dataFile: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    formatNumber: function formatNumber(value) {
      return Math.abs(value).toFixed(2);
    },
    closeDialog: function closeDialog() {
      this.$refs['form-validation-upload'].reset();
      this.$emit('update:showDialog', false);
    },
    confirmDialog: function confirmDialog() {
      var _this = this;

      if (this.$refs['form-validation-upload'].validate()) {
        this.loadingButton = true;
        axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_INSERT_DATA, {
          processID: this.dataFile.processID,
          asLogId: this.dataFile.asLogId
        }).then(function (response) {
          _this.$refs['form-validation-upload'].reset();
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'Archivo Cargado', itsOk: true });
          eventBus["default"].$emit('show-button-mydata', { isDisabled: false, asLogId: _this.dataFile.asLogId });
          _this.$emit('update:showDialog', false);
        }).catch(function (err) {
          if (err.response && err.response.data && err.response.data.errors) {
            eventBus["default"].$emit('open-dialog-insert-data-error', {
              showDialog: true,
              errors: err.response.data
            });
          }
          eventBus["default"].$emit('open-custom-snack-bar', { message: err.response.data.error, itsOk: 'warning' });
          console.warn('No se pudo cargar el archivo', err);
        }).finally(function () {
          _this.loadingButton = false;
        });
      }
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92b74a94","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-dialog-confirmation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          Confirmación de Carga\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form-validation-upload"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"id":"cantidad_filas","value":_vm.dataFile.cantidad_filas,"label":"Cantidad de Filas","readonly":"","required":"","hide-details":"auto"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"rules":[_vm.rules.confirmField('cantidad_filas')],"label":"Confirmar Cantidad de Filas","required":"","hide-details":"auto"}})],1)],1),_vm._v(" "),_vm._l((_vm.dataFile.criterios_validacion),function(file,idx){return _c('v-row',{key:idx},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"id":file.validationName,"value":_vm.formatNumber(file.value),"label":file.validationName,"readonly":"","required":"","hide-details":"auto"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{attrs:{"rules":[_vm.rules.confirmField(file.validationName)],"label":("Confirmar " + (file.validationName)),"required":"","hide-details":"auto"}})],1)],1)})],2)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","outlined":"","disabled":_vm.loadingButton},on:{"click":_vm.closeDialog}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('v-btn',{style:({'width' : _vm.loadingButton ? '160px' : ''}),attrs:{"color":"blue darken-1","outlined":"","disabled":_vm.loadingButton,"loading":_vm.loadingButton},on:{"click":_vm.confirmDialog},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Cargando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n            Cargar\n            ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-dialog-confirmation.vue
function injectStyle (context) {
  __webpack_require__("b5HX")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_dialog_confirmation,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_dialog_confirmation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "klvw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "l4NB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_eventBus__ = __webpack_require__("irLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__ = __webpack_require__("zaRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);










var cards = [];
var requestFinished = false;

var colors = {
  DEFAULT: {
    status: 'DEFAULT',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'grey',
    dangerValue: -1
  },
  LIGHT_GREY: {
    status: 'LIGHT_GREY',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'grey lighten-2',
    dangerValue: -1
  },
  LIGHT_GREEN: {
    status: 'LIGHT_GREEN',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'green lighten-2',
    dangerValue: -1
  },
  LIGHT_RED: {
    status: 'LIGHT_RED',
    iconPath: 'assets/dashboard-icons/indicator-light-red.png',
    color: 'red lighten-2',
    dangerValue: 0
  },
  GREEN: {
    status: 'GREEN',
    iconPath: 'assets/dashboard-icons/indicator-green.png',
    color: 'green',
    dangerValue: -1
  },
  AMBER: {
    status: 'AMBER',
    iconPath: 'assets/dashboard-icons/indicator-amber.png',
    color: 'amber',
    dangerValue: 1
  },
  RED: {
    status: 'RED',
    iconPath: 'assets/dashboard-icons/indicator-red.png',
    color: 'red',
    dangerValue: 5
  }

  /**
   * @typedef {Object} LogDetail
   * @prop {Boolean} visible Will be visible to in the log section of each distributor's detail
   * @prop {Boolean} highlightable Higlight attribute for Vue components that change when toggling showAll
   * @prop {String} label Determinates label for data
   * @prop {function(Boolean):String|import("vue").VueConstructor} data Will show data from the distributor as a String or as a Vue Component for more complexity
   */
};function cardsComplementary() {
  return [{
    cardType: 'DEFAULT',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-remote-files.png',
    info: function info() {
      // It's a function since the returned value can be a calculated one
      return {
        lightColor: 'grey',
        cardNumber: 0,
        message: 'No se ha encontrado los datos de la tarjeta'
      };
    },
    details: {
      title: 'Título de definido',
      message: 'Mensaje no definido',
      body: {
        card: [],
        detail: []
      }
    },
    indicator: function indicator() {
      // Same as the info key
      var baseColor = colors.LIGHT_GREY;
      return baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_GREY,
        status: 'Indefinido'
      }],
      active: false,
      selectedIndex: 0
    },
    logDetails: function logDetails() {
      return [{
        visible: true,
        highlightable: false,
        label: 'No definido',
        data: function data(showAll) {
          return 'No definido';
        }
      }];
    }
  }, {
    cardType: 'VALIDATOR',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-remote-files.png',
    info: function info(isLoading) {
      return {
        lightColor: colors.RED,
        cardNumber: '99+',
        message: 'No definido'
      };
    },
    details: {
      title: 'Título no definido',
      message: 'Mensaje no definido',
      body: {
        card: [{
          color: '',
          description: 'No definido'
        }],
        detail: [{
          color: '',
          description: 'No definido'
        }]
      }
    },
    indicator: function indicator(item) {
      var baseColor = colors.LIGHT_GREY;
      return baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_GREY,
        status: 'Indefinido'
      }],
      active: false,
      selectedIndex: 0
    },
    logDetails: function logDetails(distributor) {
      return [{
        visible: true,
        highlightable: false,
        label: 'No definido',
        data: function data(showAll) {
          return 'No definido';
        }
      }];
    }
  }, {
    cardType: 'REMOTE FILES',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-remote-files.png',
    info: function info(isLoading) {
      var outdated = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getOutDatedFtpFiles();
      var updated = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getUpdatedFtpFiles();
      var total = updated + outdated;

      var percentageUpdated = updated / total;
      if (isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: outdated,
          message: 'Verificando archivos'
        };
      }
      if (total === updated) {
        // to avoid undefined trap, do not use percetageUpdated === 1
        return {
          lightColor: colors.GREEN,
          cardNumber: 0,
          message: 'Todas las distribuidora(s) enviaron sus archivos'
        };
      }
      if (percentageUpdated > 0.9) {
        return {
          lightColor: colors.AMBER,
          cardNumber: outdated,
          message: 'de ' + total + ' distribuidora(s) no ha enviado sus archivos'
        };
      }
      return {
        lightColor: colors.RED,
        cardNumber: outdated,
        message: 'de ' + total + ' distribuidora(s) no ha enviado sus archivos'
      };
    },
    details: {
      title: 'T\xEDtulo para \'Archivos FTP\'',
      message: '',
      body: {
        card: [{
          color: colors.GREEN,
          description: 'El 100% de distribuidoras envió sus archivos a la fecha'
        }, {
          color: colors.AMBER,
          description: 'Al menos 90% de distribuidoras envió sus achivos a la fecha'
        }, {
          color: colors.RED,
          description: 'Menos del 90% de distribuidoras envió sus archivos a la fecha'
        }],
        detail: [{
          color: colors.GREEN,
          description: 'Archivos no están fuera de fecha'
        }, {
          color: colors.AMBER,
          description: 'Archivos tienen hasta 2 días de antiguedad'
        }, {
          color: colors.RED,
          description: 'Archivos tienen más de 2 días de antiguiedad'
        }, {
          color: colors.LIGHT_RED,
          description: 'No se encontraron archivos'
        }]
      }
    },
    indicator: function indicator(item) {
      var baseColor = colors.LIGHT_RED;

      return item.found ? !item.isOutdated || item.fromNow === 'a day ago' ? colors.GREEN : item.fromNow === '2 days ago' ? colors.AMBER : colors.RED : baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_RED,
        status: 'Incompleto, no encontrado'
      }, {
        color: colors.RED,
        status: 'Errores graves'
      }, {
        color: colors.AMBER,
        status: 'Pocos errores'
      }, {
        color: colors.GREEN,
        status: 'Correcto'
      }],
      active: false,
      selectedIndex: 0
    },
    /**  @returns {Array<LogDetail>}  */
    logDetails: function logDetails(distributor) {
      return [{
        visible: false,
        highlightable: false,
        label: 'Última fecha de modificación',
        data: function data(showAll) {
          return (distributor.modifyTime || 'No se encontró') + ' (' + (distributor.fromNow || 'No se encontró') + ')';
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Últimos datos traídos',
        data: function data(showAll) {
          return '' + (distributor.fromNow || 'No se encontró');
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Tamaño de zip',
        data: function data(showAll) {
          return '' + (distributor.size || 'No se encontró');
        }
      }];
    }
  }, {
    cardType: 'CONSISTENCIES',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-consistency.png',
    info: function info(isLoading) {
      var consistent = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getConsistencyCorrectLogs();
      var total = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getSupervisorFtpFiles().length;
      var inconsistent = total - consistent;

      var percentageConsistency = consistent / total;
      if (isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        };
      }
      if (total === consistent) {
        return {
          lightColor: colors.GREEN,
          cardNumber: 0,
          message: 'Correcto, todos los archivos tienen formato correcto'
        };
      }
      if (percentageConsistency > 0.9) {
        return {
          lightColor: colors.AMBER,
          cardNumber: inconsistent,
          message: 'de ' + total + ' distribuidora(s) tiene archivos con problemas'
        };
      }
      return {
        lightColor: colors.RED,
        cardNumber: inconsistent,
        message: 'de ' + total + ' distribuidora(s) tiene archivos con problemas'
      };
    },
    details: {
      title: 'Título no definido',
      message: '',
      body: {
        card: [{
          color: colors.GREEN,
          description: 'El 100% de distribuidoras tiene archivos con el formato correcto'
        }, {
          color: colors.AMBER,
          description: 'Al menos 90% de distribuidoras tiene archivos con el formato correcto'
        }, {
          color: colors.RED,
          description: 'Menos del 90% de distribuidoras tiene archivos con el formato correcto'
        }],
        detail: [{
          color: colors.GREEN,
          description: 'Logs no contienen errores ni filas removidas'
        }, {
          color: colors.AMBER,
          description: 'Como máximo, el 10% de logs tiene errores pero no filas removidas'
        }, {
          color: colors.RED,
          description: 'Más del 10% de logs tiene errores o filas removidas, o está fuera de fecha'
        }, {
          color: colors.LIGHT_RED,
          description: 'No se encontraron logs o no se los puede leer'
        }]
      }
    },
    indicator: function indicator(item) {
      var baseColor = colors.LIGHT_RED;
      // let baseColor = colorIndicators.RED

      return item.lastLog.length > 0 && item.canReadJsonLog ? item.isLastLogOutdated ? colors.RED : Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["reduce"])(item.lastLog, function (total, min) {
        if (min.fileName) {
          // Si encuentra ese campo
          return total && (min.totalLinesInput - min.totalLinesOutput > 0 || (min.linesNotMatchingColumns.length + min.linesWithColumnsIssues.length + min.linesWithNotMatchingType.length) / min.totalLinesInput > 0.1);
        } else if (min.error) {
          return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/);
        } else {
          return false;
        }
      }, true) === true ? colors.RED : Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["reduce"])(item.lastLog, function (total, min) {
        if (min.fileName) {
          // Si encuentra ese campo
          return total && min.linesNotMatchingColumns.length === 0 && min.linesWithColumnsIssues.length === 0 && min.linesWithNotMatchingType.length === 0;
        } else if (min.error) {
          return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/);
        } else {
          return false;
        }
      }, true) === true ? colors.GREEN : colors.AMBER : baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_RED,
        status: 'Incompleto, no encontrado'
      }, {
        color: colors.RED,
        status: 'Errores graves'
      }, {
        color: colors.AMBER,
        status: 'Pocos errores'
      }, {
        color: colors.GREEN,
        status: 'Correcto'
      }],
      active: false,
      selectedIndex: 0
    },
    /**  @returns {Array<LogDetail>}  */
    logDetails: function logDetails(distributor) {
      return [{
        visible: false,
        highlightable: false,
        label: 'Última fecha',
        data: function data(showAll) {
          return (distributor.lastLogDate || 'No se encontró') + ' (' + (distributor.logDateFromNow || 'No se encontró') + ')';
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Problemas con el log',
        data: function data(showAll) {
          var failedStatus = !distributor.lastLog.length > 0 || !distributor.canReadJsonLog || distributor.isLastLogOutdated;
          var reason = !distributor.lastLog.length > 0 || !distributor.canReadJsonLog ? 'No se pudo procesar la información' : distributor.isLastLogOutdated ? 'Fuera de fecha' : '-';
          return failedStatus ? 'S\xED. ' + reason : 'No';
        }
      }, {
        visible: true,
        highlightable: true,
        label: 'Lista de archivos',
        data: function data(showAll) {
          var lastLog = [];
          if (distributor.lastLog && !Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(distributor.lastLog)) {
            lastLog = distributor.lastLog;
          }
          return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('log-details', {
            data: function data() {
              return {
                lastLog: lastLog
              };
            },

            template: '\n                    <div>\n                      <template v-if="!logHasNoProblems(lastLog) || showAll">\n                        <div :key="index" v-for="(filedata, index) in lastLog" v-if="!filedata.error && (fileHasProblems(filedata) || showAll)">\n                          <div style="font-size:12px;font-weight:500;">Archivo: {{ filedata.fileName }}</div>\n                          <ul class="ml-3 mb-1" style="font-size:11px">\n                            <li>Filas con columnas disparejas: {{ filedata.linesNotMatchingColumns.length || \'Ninguna\' }}</li>\n                            <li>Filas con problemas en datos: {{ filedata.linesWithColumnsIssues.length || \'Ninguna\' }}</li>\n                            <li>Filas con tipos de datos incorrectos: {{ filedata.linesWithNotMatchingType.length || \'Ninguna\' }}</li>\n                          </ul>\n                        </div>\n                      </template>\n                      <template v-else>\n                        No hay archivos con problemas\n                      </template>\n                    </div>\n                  ',
            methods: {
              fileHasProblems: function fileHasProblems(filedata) {
                return filedata.fileName && filedata.linesNotMatchingColumns.length + filedata.linesWithColumnsIssues.length + filedata.linesWithNotMatchingType.length > 0;
              },
              logHasNoProblems: function logHasNoProblems(log) {
                var _this = this;

                return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])(log, function (i) {
                  return _this.fileHasProblems(i);
                }).length <= 0;
              }
            },
            props: {
              showAll: {
                type: Boolean,
                default: function _default() {
                  return false;
                }
              },
              card: {
                type: Object,
                default: function _default() {
                  return {};
                }
              }
            }
          });
        }
      }];
    }
  }, {
    cardType: 'DATABASE',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-database.png',
    info: function info(isLoading) {
      var correct = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getDatabaseCorrectLogs();
      var total = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getSupervisorFtpFiles().length;
      var incorrect = total - correct;

      var percentageCorrect = correct / total;
      if (isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        };
      }
      if (total === correct) {
        return {
          lightColor: colors.GREEN,
          cardNumber: 0,
          message: 'Correcto, ninguna distribuidora tiene datos desactualizados'
        };
      } else if (percentageCorrect > 0.9) {
        return {
          lightColor: colors.AMBER,
          cardNumber: incorrect,
          message: 'de ' + total + ' distribuidora(s) tiene datos fuera de fecha'
        };
      } else {
        return {
          lightColor: colors.RED,
          cardNumber: incorrect,
          message: 'de ' + total + ' distribuidora(s) tiene datos fuera de fecha'
        };
      }
    },
    details: {
      title: 'Título no definido',
      message: '',
      body: {
        card: [{
          color: colors.GREEN,
          description: 'El 100% de distribuidoras no tiene datos desactualizados'
        }, {
          color: colors.AMBER,
          description: 'Al menos 90% de distribuidoras no tiene errores en la base de datos'
        }, {
          color: colors.RED,
          description: 'Menos del 90% de distribuidoras no tiene errores en la base de datos'
        }],
        detail: [{
          color: colors.GREEN,
          description: 'Datos de ventas tienen, como máximo, 1 día de antiguedad y están al día'
        }, {
          color: colors.AMBER,
          description: 'Datos de ventas tienen, como máximo, 2 días de antiguedad'
        }, {
          color: colors.RED,
          description: 'Datos de ventas tienen más de 2 días de antiguedad'
        }]
      }
    },
    indicator: function indicator(item) {
      return !item.isSalesMaxDateOutdated && !item.isSalesLastUpdatedOutdated || item.salesMaxDateFromNow === 'a day ago' || item.salesLastUpdateFromNow === 'a day ago' ? colors.GREEN : item.salesMaxDateFromNow === '2 days ago' || item.salesLastUpdateFromNow === '2 days ago' ? colors.AMBER : colors.RED;
    },
    fab: {
      list: [{
        color: colors.RED,
        status: 'Errores graves'
      }, {
        color: colors.AMBER,
        status: 'Pocos errores'
      }, {
        color: colors.GREEN,
        status: 'Correcto'
      }],
      active: false,
      selectedIndex: 0
    },
    /**  @returns {Array<LogDetail>}  */
    logDetails: function logDetails(distributor) {
      return [
      /* <li>Ventas desactualizadas: {{ props.item.isMaxDateOutdated ? 'Sí' : 'No' }}</li>
      <li>Fecha supuesta de última venta: {{ props.item.maxDate.split(' ')[0] }}</li>
      <li>Tiempo supuesto desde última venta: {{ props.item.maxDateFromNow }}</li>
      <li>Registros desactualizados: {{ props.item.isRegisterDateOutdated ? 'Sí' : 'No' }}</li> */
      {
        visible: false,
        highlightable: false,
        label: 'Última fecha',
        data: function data(showAll) {
          return (distributor.salesLastUpdate || 'No se encontró') + ' (' + (distributor.salesLastUpdateFromNow || 'No se encontró') + ')';
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Problemas con el log',
        data: function data(showAll) {
          var failedStatus = (distributor.isSalesMaxDateOutdated || distributor.isSalesLastUpdatedOutdated) && distributor.salesMaxDateFromNow !== 'a day ago' && !distributor.salesLastUpdateFromNow !== 'a day ago';
          var reason = 'Log tiene un día o más de antiguedad';
          return failedStatus ? 'S\xED. ' + reason : 'No';
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Ventas actualizadas',
        data: function data(showAll) {
          return '' + (!distributor.isSalesMaxDateOutdated ? 'Sí' : 'No');
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Fecha supuesta de última venta',
        data: function data(showAll) {
          return '' + distributor.salesMaxDate.split(' ')[0];
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Tiempo supuesto desde última venta',
        data: function data(showAll) {
          return '' + distributor.salesMaxDateFromNow;
        }
      }, {
        visible: true,
        highlightable: false,
        label: 'Registros actualizados',
        data: function data(showAll) {
          return '' + (!distributor.isSalesLastUpdatedOutdated ? 'Sí' : 'No');
        }
      }];
    }
  }, {
    cardType: 'INCONSISTENCIES',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-database.png',
    info: function info(isLoading) {
      var nonInconsistent = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getNonInconsistencyCorrectData();
      var total = __WEBPACK_IMPORTED_MODULE_5__supervisorStorage__["default"].getSupervisorFtpFiles().length;
      var inconsistent = total - nonInconsistent;

      var percentageInconsistency = nonInconsistent / total;

      if (isLoading) {
        return {
          lightColor: 'grey',
          cardNumber: 0,
          message: 'Verificando archivos'
        };
      }
      if (total === nonInconsistent) {
        return {
          lightColor: colors.GREEN,
          cardNumber: 0,
          message: 'Correcto, los datos relacionados están completos'
        };
      }
      if (percentageInconsistency > 0.9) {
        return {
          lightColor: colors.AMBER,
          cardNumber: inconsistent,
          message: 'de ' + total + ' distribuidora(s) tiene datos relacionados incompletos'
        };
      }
      return {
        lightColor: colors.RED,
        cardNumber: inconsistent,
        message: 'de ' + total + ' distribuidora(s) tiene datos relacionados incompletos'
      };
    },
    details: {
      title: 'T\xEDtulo para \'Datos relacionados\'',
      message: '',
      body: {
        card: [{
          color: colors.GREEN,
          description: 'El 100% de distribuidoras tiene datos relacionados completos'
        }, {
          color: colors.AMBER,
          description: 'Al menos 90% de distribuidoras tiene datos relacionados completos'
        }, {
          color: colors.RED,
          description: 'Menos del 90% de distribuidoras tiene datos relaciones completos'
        }],
        detail: [{
          color: colors.GREEN,
          description: 'Datos relacionados están completos'
        }, {
          color: colors.AMBER,
          description: 'Datos relacionados faltantes'
        }, {
          color: colors.LIGHT_RED,
          description: 'No se encontró información al respecto'
        }]
      }
    },
    // Merge in indicator object which will be traspased to the visual object
    indicator: function indicator(item) {
      // Same as the info key
      var baseColor = colors.LIGHT_RED;

      return item.inconsistenciesCounter === -1 ? baseColor : item.inconsistenciesCounter === 0 ? colors.GREEN : colors.AMBER;
    },
    fab: {
      list: [{
        color: colors.LIGHT_RED,
        status: 'Incompleto, no encontrado'
      }, {
        color: colors.AMBER,
        status: 'Pocos errores'
      }, {
        color: colors.GREEN,
        status: 'Correcto'
      }],
      active: false,
      selectedIndex: 0
    },
    logDetails: function logDetails(distributor) {
      return [{
        visible: true,
        highlightable: false,
        label: 'Obtener archivo',
        data: function data(showAll) {
          return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('log-details', {
            data: function data() {
              return {};
            },

            template: '\n                    <span>\n                      <v-btn\n                        small icon\n                        :style="[{\'background-color\':distributor.inconsistenciesFileUrl ? \'#00B4C7\' : \'#FF3737\'}, {\'color\':\'white\'}]"\n                        @click="getInconsistencyFile"\n                        :disabled="notInconsisteciesFound()"\n                      >\n                        <v-icon small>cloud_download</v-icon>\n                      </v-btn>\n                      <span v-if="notInconsisteciesFound()">No existen inconsistencias</span>\n                    </span>\n                  ',
            methods: {
              notInconsisteciesFound: function notInconsisteciesFound() {
                return this.distributor.inconsistenciesCounter === 0;
              },
              getInconsistencyFile: function getInconsistencyFile() {
                if (this.distributor.inconsistenciesFileUrl) {
                  __WEBPACK_IMPORTED_MODULE_4__utils_eventBus__["default"].$emit('open-inconsistencies-report-question-dialog', {
                    downloadLink: this.distributor.inconsistenciesFileUrl,
                    distributorCode2: this.distributor.distributorCode2
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_4__utils_eventBus__["default"].$emit('open-custom-snack-bar', { message: 'No existe link de descarga', itsOk: false });
                }
              }
            },
            props: {
              showAll: {
                type: Boolean,
                default: function _default() {
                  return false;
                }
              },
              card: {
                type: Object,
                default: function _default() {
                  return {};
                }
              },
              distributor: {
                type: Object,
                default: function _default() {
                  return {};
                }
              }
            }
          });
        }
      }];
    }
  }, {
    cardType: 'REPORTS GENERATOR',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-remote-files.png',
    info: function info(isLoading) {
      return {
        lightColor: colors.RED,
        cardNumber: '99+',
        message: 'Errores y advertencias al generar reportes'
      };
    },
    details: {
      title: 'Título no definido',
      message: 'Mensaje no definido',
      body: {
        card: [{
          color: '',
          description: 'No definido'
        }],
        detail: [{
          color: '',
          description: 'No definido'
        }]
      }
    },
    indicator: function indicator(item) {
      var baseColor = colors.LIGHT_GREY;
      // let baseColor = colorIndicators.AMBER
      return baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_GREY,
        status: 'Indefinido'
      }],
      active: false,
      selectedIndex: 0
    },
    logDetails: function logDetails(distributor) {
      return [{
        visible: true,
        highlightable: false,
        label: 'No definido',
        data: function data(showAll) {
          return 'No definido';
        }
      }];
    }
  }, {
    cardType: 'SHIPPING CONTROL',
    enabled: true,
    iconPath: 'assets/dashboard-icons/card-remote-files.png',
    info: function info(isLoading) {
      return {
        lightColor: colors.RED,
        cardNumber: '99+',
        message: 'No definido'
      };
    },
    details: {
      title: 'Título no definido',
      message: 'Mensaje no definido',
      body: {
        card: [{
          color: '',
          description: 'No definido'
        }],
        detail: [{
          color: '',
          description: 'No definido'
        }]
      }
    },
    indicator: function indicator(item) {
      var baseColor = colors.LIGHT_GREY;
      return baseColor;
    },
    fab: {
      list: [{
        color: colors.LIGHT_GREY,
        status: 'Indefinido'
      }],
      active: false,
      selectedIndex: 0
    },
    logDetails: function logDetails(distributor) {
      return [{
        visible: true,
        highlightable: false,
        label: 'No definido',
        data: function data(showAll) {
          return 'No definido';
        }
      }];
    }
  }];
}

/* harmony default export */ __webpack_exports__["default"] = ({
  getCardsPointer: function getCardsPointer() {
    return {
      requestFinished: requestFinished,
      cards: cards
    };
  },
  getCards: function getCards(options) {
    /*
      options: {
        onSuccess: () => {},
        onError: () => {}
      }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].get(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_GET_CARDS).then(function (response) {
      var temp = [];
      // console.log('CARDS OBTAINED', response)
      // temp.splice(0)
      temp.push.apply(temp, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.data.rows));
      // AQUI SE INSERTARIA LA INFORMACION DESDE CARDSCOMPLEMENTARY
      temp.forEach(function (card) {
        card.extra = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["omit"])(Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(cardsComplementary(), function (item) {
          return item.cardType === card.cardType;
        }) || Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(cardsComplementary(), function (item) {
          return item.cardType === 'DEFAULT';
        }), 'cardType');
      });

      cards.splice(0);
      cards.push.apply(cards, temp);
      if (options.onSuccess) {
        options.onSuccess(cards);
      }
      requestFinished = true;
    }, function (err) {
      // console.warn('ERROR GETTING CARDS', err)
      if (options.onError) {
        options.onError(err);
      }
      requestFinished = true;
    });
    return cards;
  },
  updateCards: function updateCards(options) {
    /*
      options: {
        data: {
          cards: [
            {
              cardType: '',
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
              cardName: '',
              enabled: false
            },
            ...
          ]
        },
        onSuccess: () => {},
        onError: () => {}
      }
     */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_UPDATE_CARDS, {
      cards: options.data.cards
    }).then(function (response) {
      // console.log('CARDS UPDATED', response)
      // MAPEAR, REEMPLAZANDO LOS VIEJOS VALORES POR NUEVOS?
      Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(cards, function (row, index) {
        Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["assign"])(row, options.data.cards[index]);
      });
      if (options.onSuccess) {
        options.onSuccess(response.data);
      }
    }, function (err) {
      console.warn('ERROR UPDATING CARDS', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "ljja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-insert-data-dialog-error.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import uris from '../../../utils/uris'
// import axios from '../../../utils/axiosWrapperAutoservicio'


/* harmony default export */ var validation_insert_data_dialog_error = ({
  name: 'validation-dialog-error',
  data: function data() {
    return {
      loading: false,
      showDialog: false,
      errors: {},
      file: []
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-dialog-insert-data-error');
    eventBus["default"].$on('open-dialog-insert-data-error', function (data) {
      _this.openDialogError(data.showDialog, data.errors, data.file);
    });
  },

  methods: {
    openDialogError: function openDialogError(showDialog, errors, file) {
      this.showDialog = showDialog;
      this.errors = errors;
      this.file = file;
    },
    closeDialogError: function closeDialogError() {
      this.showDialog = false;
    },
    downloadFile: function downloadFile() {
      // this.loading = true
      // let formData = new FormData()
      // formData.append('excel_file', this.file)
      // formData.append('data', JSON.stringify(this.errors))

      // console.log(formData)
      // axios.post(uris.URL_AUTOSERVICIO_GET_ERROR_TEMPLATE,
      //   formData
      //   , {
      //     responseType: 'blob'
      //   })
      //   .then((response) => {
      //     const filename = response.headers.filename
      //     const url = window.URL.createObjectURL(new Blob([response.data]))
      //     const link = document.createElement('a')
      //     link.href = url
      //     link.setAttribute('download', filename)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //   })
      //   .catch((err) => {
      //     console.warn('No se ha podido obtener data de errores', err)
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e14fe14","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-insert-data-dialog-error.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"700"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-h5"},[_vm._v("\n          "+_vm._s(_vm.errors.error)+"\n        ")]),_vm._v(" "),_c('v-card-text',[_c('ul',_vm._l((_vm.errors.errors),function(error,idx){return _c('li',{key:idx},[_c('div',{staticClass:"text-error"},[_vm._v("Detalle: "+_vm._s(error.description))]),_vm._v(" "),_c('ul',_vm._l((error.errors),function(e,i){return _c('li',{key:i},[_c('div',{staticClass:"text-error"},[_vm._v("Mensaje: ")]),_vm._v(" \n                  "+_vm._s(e.message_error)+"\n                  "),_c('div',{staticClass:"text-error"},[_vm._v("Descripción: ")]),_vm._v(" \n                  Para "+_vm._s(e.rule_col)+" con valor "+_vm._s(e.rule_value)+" se encontraron los siguientes valor(es) en "+_vm._s(e.error_col)+":\n                  "),_c('br'),_vm._v(" "),_c('ol',_vm._l((e.error_value),function(ev,iv){return _c('li',{key:iv},[_vm._v("\n                      "+_vm._s(ev)+"\n                    ")])}),0)])}),0)])}),0)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","outlined":"","disabled":_vm.loading},on:{"click":_vm.closeDialogError}},[_vm._v("\n            Cerrar\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-insert-data-dialog-error.vue
function injectStyle (context) {
  __webpack_require__("+44D")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_insert_data_dialog_error,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_insert_data_dialog_error = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lpyF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "meK2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mjlg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Nexa_Bold.56018b3.otf";

/***/ }),

/***/ "mxb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/structures/flat-structure-item.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flat_structure_item = ({
  name: 'flat-structure-item',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21fbfb79","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/structures/flat-structure-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticStyle:{"font-size":"18px","font-weight":"300"}},[_vm._v(_vm._s(_vm.item.itemName))]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"72px"}},[_c('b',[_vm._v("Descripcion:")]),_vm._v(" "+_vm._s(_vm.item.description))]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"72px"}},[_c('b',[_vm._v("Labels:")]),_vm._v(" "+_vm._s(_vm.item.labels))]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"72px","text-overflow":"ellipsis","white-space":"nowrap","overflow":"hidden"}},[_c('b',[_vm._v("Vista previa:")]),_vm._v(" "+_vm._s(_vm.item.imageUrl))])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/structures/flat-structure-item.vue
function injectStyle (context) {
  __webpack_require__("zdJO")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  flat_structure_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var structures_flat_structure_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "myCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// EXTERNAL MODULE: ./src/components/supervisor/distributor-detail-section.vue + 2 modules
var distributor_detail_section = __webpack_require__("geiL");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/distributors-details-list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var distributors_details_list = ({
  data: function data() {
    return {
      cards: [],
      distributors: []
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
    this.distributors = supervisorStorage["default"].getDistributorsPointer();
  },

  computed: {
    filteredDistributors: function filteredDistributors() {
      var _this = this;

      var filteredDistributors = Object(lodash["filter"])(this.distributors, function (distributor) {
        return distributor.distributorName.toLowerCase().indexOf((_this.textFilter || '').toLowerCase()) !== -1 && _this.colorFilter(distributor);
      });
      return Object(lodash["orderBy"])(filteredDistributors, this.totalDanger, 'desc');
    },
    enabledCards: function enabledCards() {
      return Object(lodash["filter"])(this.cards, function (card) {
        return card.enabled;
      });
    }
  },
  methods: {
    colors: function colors(distributor) {
      var _this2 = this;

      return Object(lodash["map"])(this.tooltips(distributor), function (item, index) {
        return ['', null, item.color.color].includes(_this2.colorsFilters[index].color);
      });
    },
    colorFilter: function colorFilter(distributor) {
      return Object(lodash["reduce"])(this.colors(distributor), function (total, item) {
        return total && item;
      }, true);
    },
    tooltips: function tooltips(distributor) {
      var indicators = [];
      Object(lodash["filter"])(this.cards, 'enabled').forEach(function (card) {
        indicators.push({
          color: card.extra.indicator(distributor),
          text: card.cardName || '',
          type: card.cardType
        });
      });

      return indicators;
    },
    totalDanger: function totalDanger(distributor) {
      return Object(lodash["reduce"])(Object(lodash["flatMap"])(this.tooltips(distributor), 'color.dangerValue'), function (total, item) {
        return total + item;
      }, 0);
    },
    closeOthersFAB: function closeOthersFAB(index) {
      this.cards.forEach(function (card) {
        card.extra.fab.active = false;
      });
    },
    selectColor: function selectColor(card, index) {
      card.extra.fab.selectedIndex = index;
    }
  },
  components: {
    DistributorDetailSection: distributor_detail_section["default"]
  },
  props: {
    textFilter: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    colorsFilters: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    detailedDistributor: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showLogsDetails: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709c94e7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/distributors-details-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[(_vm.filteredDistributors.length > 0)?[_c('v-layout',{staticClass:"px-3 align-center",staticStyle:{"background-color":"#E4E4E4","height":"3vw","min-height":"30px","max-height":"40px","border-bottom":"2px lightgray solid","font-size":"10px"},attrs:{"row":""}},[_c('v-flex',{staticClass:"pl-2",attrs:{"hidden-xs-only":"","xs12":"","sm5":""}},[_c('span',[_vm._v("Distribuidora")])]),_vm._v(" "),_c('v-flex',{staticClass:"layout justify-center",attrs:{"xs12":"","sm7":""}},[_c('span',[_vm._v("Indicadores")])])],1),_vm._v(" "),_vm._l((_vm.filteredDistributors),function(item,index){return _c('div',{key:index,staticStyle:{"background-color":"#F9F8F6"}},[_c('distributor-detail-section',{attrs:{"indicators":_vm.tooltips(item),"detailed-distributor":_vm.detailedDistributor,"show-logs-details":_vm.showLogsDetails,"distributor":item}}),_vm._v(" "),(item !== _vm.filteredDistributors.length - 1)?_c('v-divider'):_vm._e()],1)})]:[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"rgba(0,0,0,.38)"}},[_vm._v("\n              No data available\n            ")])],1)],1)]],2)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/distributors-details-list.vue
function injectStyle (context) {
  __webpack_require__("5B+D")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributors_details_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_distributors_details_list = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "n6WR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/supervisor/card-template.vue + 2 modules
var card_template = __webpack_require__("XR0q");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-database.vue
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var card_database = ({
  name: 'card-database',
  methods: {
    getCardInfo: function getCardInfo() {
      var correct = supervisorStorage["default"].getDatabaseCorrectLogs();
      var total = supervisorStorage["default"].getSupervisorFtpFiles().length;
      var incorrect = total - correct;

      var percentageCorrect = correct / total;
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        };
      }
      if (percentageCorrect === 1) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Correcto, todos los logs de la base de datos son correctos'
        };
      } else if (percentageCorrect > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: incorrect,
          message: 'de ' + total + ' distribuidora(s) tiene(n) errores en BD'
        };
      } else {
        return {
          lightColor: 'red',
          cardNumber: incorrect,
          message: 'de ' + total + ' distribuidora(s) tiene(n) errores en BD'
        };
      }
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    CardTemplate: card_template["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06536ed5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-database.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-template',{attrs:{"card-title":_vm.data.cardName,"is-loading":_vm.isLoading,"card-info":_vm.getCardInfo(),"card-type":"DATABASE"}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-database.vue
function injectStyle (context) {
  __webpack_require__("kI8Z")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_database,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_database = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nCdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







var store = [];
var isLoaded = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  getStructures: function getStructures(options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_GET_STRUCTURES, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
      // console.log('Se obtuvieron las estructuras')
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('Error obteniendo las estructuras');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  getChildren: function getChildren(items, itemID) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(items, function (item) {
      return item.containedBy === itemID;
    });
  },
  isHeritableDataLoaded: function isHeritableDataLoaded() {
    return isLoaded;
  },
  getHeritableItems: function getHeritableItems(options) {
    var _this = this;

    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    if (!isLoaded || options.forceLoad) {
      __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_GET_HERITABLE_ITEMS, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
        var temp = response.data.rows;

        Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(temp, function (item) {
          var children = _this.getChildren(temp, item.itemID);

          Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["assign"])(item, { heritable: 1 });
          return item.isFolder === 1 &&
          // A los items que cumplan con lo previo
          //  asignales el parámetro de heredable
          //  además de conteo (directo) de items
          Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["assign"])(item, {
            // heritable: 1,
            childrenCount: children.length,
            children: children
          });
        });

        store.splice(0);
        store.push.apply(store, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(temp));
        isLoaded = true;
        if (options.onSuccess) {
          options.onSuccess(store);
        }
      }, function (err) {
        console.warn('Error obteniendo las estructuras');
        if (options.onError) {
          options.onError(err);
        }
      });
    } else {
      if (options.onSuccess) {
        options.onSuccess(store);
      }
    }
  },
  findHeritableItemByID: function findHeritableItemByID(itemID) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(store, function (i) {
      return i.itemID === itemID;
    });
  },
  checkStructureName: function checkStructureName(options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_CHECK_STRUCTURE_NAME, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
      // console.log('Checkeo correcto')
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('La estructura no ha podido revisada');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  createStructure: function createStructure(options) {
    /*
    options: {
      userID: ''
      permissions: [],
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_CREATE_STRUCTURE, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
      // console.log('Se ha creado una estructura', response.data)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('La estructura no ha podido crearse', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  createHeritableItem: function createHeritableItem(options) {
    /*
    options: {
      data: {
        structureID: 0,
        itemName: '',
        isFolder: 0,
        description: '',
        labels: '',
        containedBy: 7
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */

    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_CREATE_HERITABLE_ITEM, {
      structureID: options.data.structureID,
      itemName: options.data.itemName,
      description: options.data.description,
      labels: options.data.labels,
      imageUrl: options.data.imageUrl,
      isFolder: options.data.isFolder,
      containedBy: options.data.containedBy,
      structureItemInheritance: options.data.structureItemInheritance
    }).then(function (response) {
      // console.log('Se ha creado un item de estructura', response.data)
      if (options.onSuccess) {
        options.onSuccess(response.data.items);
      }
    }, function (err) {
      console.warn('El item de estructura no ha podido crearse', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  updateHeritableItem: function updateHeritableItem(options) {
    /*
    options: {
      data: {
        containedBy: ''
        structureID: ''
        isFolder: 0
        itemID: ''
        itemName: ''
        description: '' // O no en caso de folders
        labels: '' // Igual que campo [description],
        imageUrl: '' // Igual
        removed: 0
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */

    var _parentDataArr = /^(HI?)(\d+)$/.exec(options.data.containedBy);
    var _parentData = {
      itemID: _parentDataArr ? _parentDataArr[2] : '0',
      structureItemInheritance: _parentDataArr ? _parentDataArr[1].startsWith('HI') : false

      // eslint-disable-next-line
    };var _isParentRoot = options.data.containedBy == 0;
    var _structureID = options.data.structureID;
    var _isFolder = options.data.isFolder;
    var _itemID = /^(HI?)(\d+)$/.exec(options.data.itemID)[2];
    var _parentItemID = _parentData.itemID;
    var _parentStructureItemInheritance = _parentData.structureItemInheritance;
    var _newItemName = options.data.itemName;
    var _newDescription = options.data.description;
    var _newLabels = options.data.labels;
    var _newImageUrl = options.data.imageUrl;
    var _removed = options.data.removed;

    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_UPDATE_HERITABLE_ITEM, {
      isParentRoot: _isParentRoot,
      structureID: _structureID,
      isFolder: _isFolder,
      itemID: _itemID,
      parentItemID: _parentItemID,
      parentStructureItemInheritance: _parentStructureItemInheritance,
      newItemName: _newItemName,
      newDescription: _newDescription,
      newLabels: _newLabels,
      newImageUrl: _newImageUrl,
      removed: _removed
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  createHeritableStructure: function createHeritableStructure(options) {
    /*
    options: {
      data: {
        folderName: ''
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_CREATE_HERITABLE_STRUCTURE, {
      structureName: options.data.folderName
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('La estructura no ha podido crearse', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  replicateStructure: function replicateStructure(options) {
    /*
    options: {
      data: {
        structureID: 0,
        folderName: '',
        containedBy: 0
      },
      onSuccess: () => {}.
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_REPLICATE_STRUCTURE, {
      structureID: options.data.structureID,
      folderName: options.data.folderName,
      containedBy: options.data.containedBy
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('La estructura no pudo duplicarse', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  removeStructure: function removeStructure(options) {
    /*
    options: {
      data: {
        structureID: 0,
        structureItemInheritance: false
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_REMOVE_STRUCTURE, {
      structureID: options.data.structureID,
      structureItemInheritance: options.data.structureItemInheritance
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('La estructura no pudo borrarse', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  updateSpecificItemData: function updateSpecificItemData(options) {
    /*
    options: {
      data: {
        items: []
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_UPDATE_SPECIFIC_ITEM_DATA, {
      items: options.data.items
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('Los items no pudieron actualizarse', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  replicateFolder: function replicateFolder(options) {
    /*
    options: {
      data: {
        itemID: [],
        originalName: '',
        folderName: ''
      },
      onSuccess: () => {},
      onError: () => {}
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_REPLICATE_FOLDER, {
      itemID: options.data.itemID,
      originalName: options.data.originalName,
      folderName: options.data.folderName
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (error) {
      console.warn('El folder no pudo replicarse', error);
      if (options.onError) {
        options.onError(error);
      }
    });
  },
  buildStructure: function buildStructure(options) {
    /*
    options: {
      data: '',
      onSuccess: (),
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_BUILD_STRUCTURE, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options.data)).then(function (response) {
      // console.log('Se ha construido la estructura', response.data)
      if (options.onSuccess) {
        options.onSuccess(response);
      }
    }, function (err) {
      console.warn('La estructura no ha podido construirse', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "nFpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/uris.js
var uris = __webpack_require__("xbPH");

// EXTERNAL MODULE: ./src/utils/axiosWrapperAutoservicio.js
var axiosWrapperAutoservicio = __webpack_require__("QNHe");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-dialog-confirmation.vue + 2 modules
var validation_dialog_confirmation = __webpack_require__("kZfn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/autoservicios/validation/validation-upload-file.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var validation_upload_file = ({
  name: 'validation-header',
  components: {
    ValidationDialogConfirmation: validation_dialog_confirmation["default"]
  },
  data: function data() {
    return {
      btnMydata: {
        isLoading: false,
        isDisabled: true,
        asLogId: -1
      },
      loading: false,
      file: [],
      showDialogConfirmation: false,
      responseSuccess: {}
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('show-button-mydata');
    eventBus["default"].$on('show-button-mydata', function (option) {
      _this.btnMydata.isDisabled = option.isDisabled;
      _this.btnMydata.asLogId = option.asLogId !== 0 ? option.asLogId : -1;
    });
  },

  props: {
    processID: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  methods: {
    addDropFile: function addDropFile(e) {
      this.file = e.dataTransfer.files[0];
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append('processID', this.processID);
      formData.append('excel_file', this.file);

      axiosWrapperAutoservicio["default"].post(uris["default"].URL_AUTOSERVICIO_VALIDATE_DATA, formData).then(function (response) {
        _this2.showDialogConfirmation = true;
        _this2.responseSuccess = response.data;
      }).catch(function (err) {
        if (err.response && err.response.data && err.response.data.errors) {
          if (err.response.data.type === 'DQ') {
            eventBus["default"].$emit('open-dialog-insert-data-error', {
              showDialog: true,
              errors: err.response.data
            });
          } else {
            eventBus["default"].$emit('open-dialog-autoservicio-error', {
              showDialog: true,
              errors: err.response.data.errors,
              file: _this2.file
            });
          }
        }
        eventBus["default"].$emit('open-custom-snack-bar', { message: err.response.data.error, itsOk: 'warning' });
        console.warn('No se ha podido subir el archivo', err);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    showMydata: function showMydata() {
      this.$router.push('/autoservicios/data/' + this.processID + '/' + this.btnMydata.asLogId);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302ec140","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/validation/validation-upload-file.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"drop":function($event){$event.preventDefault();return _vm.addDropFile.apply(null, arguments)},"dragover":function($event){$event.preventDefault();}}},[_c('v-file-input',{staticClass:"validation-file-input",attrs:{"label":"File input","prepend-icon":"mdi-paperclip","outlined":"","loading":_vm.loading,"disabled":_vm.loading},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"#2262c6"},on:{"click":_vm.uploadFile},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Subiendo")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n    Subir archivo\n    \n    "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n      mdi-cloud-upload\n    ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-2",attrs:{"loading":_vm.btnMydata.isLoading,"disabled":_vm.btnMydata.isDisabled,"depressed":_vm.btnMydata.isDisabled,"color":"white"},on:{"click":_vm.showMydata},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Cargando")]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-1",attrs:{"indeterminate":"","size":"16","color":"primary"}})]},proxy:true}])},[_vm._v("\n    Ver Datos\n    \n    "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n      mdi-information\n    ")])],1),_vm._v(" "),(_vm.showDialogConfirmation)?_c('validation-dialog-confirmation',{attrs:{"showDialog":_vm.showDialogConfirmation,"dataFile":_vm.responseSuccess},on:{"update:showDialog":function($event){_vm.showDialogConfirmation=$event},"update:show-dialog":function($event){_vm.showDialogConfirmation=$event}}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/autoservicios/validation/validation-upload-file.vue
function injectStyle (context) {
  __webpack_require__("lsXq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  validation_upload_file,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var validation_validation_upload_file = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nVqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/storage/structureStorage.js
var structureStorage = __webpack_require__("nCdY");

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/new-items-manager-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var new_items_manager_dialog = ({
  data: function data() {
    return {
      dialog: false,
      items: [
        /* {
          itemID: 113,
          parentName: 'FolderEstructurado0-H1-01',
          url1: '',
          url2: ''
        },
        {
          itemID: 114,
          parentName: 'FolderEstructurado0-H1-02',
          url1: '',
          url2: ''
        },
        {
          itemID: 115,
          parentName: 'FolderEstructurado0-H1-03',
          url1: '',
          url2: ''
        } */
      ],
      data: {
        url1s: [],
        url2s: []
      }
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-new-items-manager-dialog');
    eventBus["default"].$on('open-new-items-manager-dialog', function (data) {
      Object(lodash["map"])(data.items, function (item) {
        Object(lodash["assign"])(item, { url1: '', url2: '' });
      });

      // console.log('!!!!!!!!!!!!!!!', JSON.stringify(items, null, 2))
      // this.items.splice(0)
      // this.items.push(...items)
      _this.items = data.items;

      _this.dialog = true;
    });
  },

  computed: {
    anyItemToUpdate: function anyItemToUpdate() {
      return Object(lodash["reduce"])(this.items, function (total, item) {
        return total || !!(item.url1 || item.url2);
      }, false);
    }
  },
  methods: {
    update: function update() {
      var _this2 = this;

      var filteringItemsToUpdate = function filteringItemsToUpdate() {
        return Object(lodash["filter"])(_this2.items, function (item) {
          return !!(item.url1 || item.url2);
        });
      };

      if (this.anyItemToUpdate) {
        // console.log('updating..' + filteringItemsToUpdate().length, JSON.stringify(filteringItemsToUpdate(), null, 2))
        structureStorage["default"].updateSpecificItemData({
          data: {
            items: filteringItemsToUpdate()
          },
          onSuccess: function onSuccess() {
            // console.log('SUCCESS')
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'Reportes actualizados correctamente', itsOk: true });

            eventBus["default"].$emit('reload-items');
            _this2.dialog = false;
          },
          onError: function onError(error) {
            console.warn('Error actualizando reportes: ', error);
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'Error actualizando reportes', itsOk: false });
          }
        });
      } else {
        // console.log('No hay items que actualizar')
      }
    }
    /* validateUrls () {
      if ((this.data.url1 && this.data.url1.trim() !== '') || (this.data.url2 && this.data.url2.trim() !== '')) {
        return true
      }
      return 'Este campo es obligatorio'
    } */

  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9a98906","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/new-items-manager-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n      Actualizando reportes\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.items),function(item,index){return _c('v-flex',{key:index},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_vm._v("\n                En "),_c('b',[_vm._v(_vm._s(item.parentName))]),_c('br')]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"clearable":"","label":"URL principal","hint":"Esta URL es opcional si ya tenemos URL de descarga"},model:{value:(item.url1),callback:function ($$v) {_vm.$set(item, "url1", $$v)},expression:"item.url1"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"clearable":"","label":"URL de descarga","hint":"Esta URL es opcional si ya tenemos URL principal"},model:{value:(item.url2),callback:function ($$v) {_vm.$set(item, "url2", $$v)},expression:"item.url2"}})],1)],1)],1)],1)],1)}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"color":"white"},attrs:{"small":"","depressed":"","rounded":"","color":!_vm.anyItemToUpdate ? 'red darken-2' : 'grey darken-2'},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Ignorar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"background-color":"#61B965","color":"white"},attrs:{"small":"","depressed":"","rounded":"","disabled":!_vm.anyItemToUpdate},nativeOn:{"click":function($event){return _vm.update.apply(null, arguments)}}},[_vm._v("Grabar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/new-items-manager-dialog.vue
function injectStyle (context) {
  __webpack_require__("2Lcq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  new_items_manager_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_new_items_manager_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nfY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nhJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// EXTERNAL MODULE: ./src/components/supervisor/distributors-details-color-filter.vue + 2 modules
var distributors_details_color_filter = __webpack_require__("Hibl");

// EXTERNAL MODULE: ./src/components/supervisor/distributors-details-list.vue + 2 modules
var distributors_details_list = __webpack_require__("myCr");

// EXTERNAL MODULE: ./src/components/logs/distributor-details-log-report.vue + 2 modules
var distributor_details_log_report = __webpack_require__("WZ70");

// EXTERNAL MODULE: ./src/components/dialogs/show-distributor-details-dialog.vue + 2 modules
var show_distributor_details_dialog = __webpack_require__("+Mpy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/distributors-details.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var distributors_details = ({
  data: function data() {
    return {
      textFilter: '',
      colorsFilters: [],
      cards: [],
      detailedDistributor: {}
    };
  },
  mounted: function mounted() {
    this.cards = cardsStorage["default"].getCardsPointer().cards;
  },

  computed: {
    enabledCards: function enabledCards() {
      return Object(lodash["filter"])(this.cards, 'enabled');
    },
    colorsFiltersMap: function colorsFiltersMap() {
      var _colorsFilters;

      this.colorsFilters.splice(0);
      (_colorsFilters = this.colorsFilters).push.apply(_colorsFilters, toConsumableArray_default()(Object(lodash["map"])(this.enabledCards, function () {
        return { color: '' };
      })));
      return this.colorsFilters;
    }
  },
  methods: {
    showLogsDetails: function showLogsDetails(item) {
      this.detailedDistributor = this.detailedDistributor !== item ? item : {};
    },
    clearFilters: function clearFilters() {
      this.textFilter = '';
      this.colorsFilters.forEach(function (item) {
        item.color = '';
      });
    }
  },
  components: {
    DistributorsDetailsColorFilter: distributors_details_color_filter["default"],
    DistributorsDetailsList: distributors_details_list["default"],
    DistributorDetailsLogReport: distributor_details_log_report["default"],
    ShowDistributorDetailsDialog: show_distributor_details_dialog["default"]
  },
  props: {
    isLoadingDistributors: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac3d82e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/distributors-details.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"color":"white","font-size":"45px","font-weight":"500"}},[_vm._v("Detalle")]),_vm._v(" "),_c('v-layout',{staticStyle:{"margin":"12px","border-radius":"16px"},attrs:{"column":"","elevation-2":""}},[_c('v-flex',[_c('v-card',{staticStyle:{"border-radius":"16px 16px 0px 0px"}},[_c('v-card-text',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","xl10":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-container',{staticClass:"py-1"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"clearable":"","label":"Distribuidora","hint":"Introduzca el nombre de la distribuidora que busca"},model:{value:(_vm.textFilter),callback:function ($$v) {_vm.textFilter=$$v},expression:"textFilter"}})],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{staticClass:"strategio-card-button",staticStyle:{"background-color":"#00C3D7"},attrs:{"depressed":"","rounded":"","dark":""},on:{"click":_vm.clearFilters}},[_vm._v("\n                          Limpiar "),_c('span',{staticClass:"hidden-xs-only"},[_vm._v("filtros")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-up"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{staticClass:"body-2",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                        Filtros\n                      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.enabledCards),function(card,i){return _c('v-flex',{key:card.cardType,attrs:{"xs12":"","sm4":"","md4":"","lg3":""}},[_c('distributors-details-color-filter',{attrs:{"item":_vm.colorsFiltersMap[i],"card":card}})],1)}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-xs-only"},[_c('v-container',{staticClass:"py-1",attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.enabledCards),function(card,i){return _c('v-flex',{key:card.cardType,attrs:{"xs12":"","sm4":"","md4":"","lg3":""}},[_c('distributors-details-color-filter',{attrs:{"item":_vm.colorsFiltersMap[i],"card":card}})],1)}),1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{attrs:{"id":'distributorstate-cards'}},[_c('v-card',{staticStyle:{"border-radius":"0px 0px 16px 16px"}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[(!_vm.isLoadingDistributors)?[_c('v-flex',{staticStyle:{"z-index":"1","max-height":"600px"},attrs:{"xs12":"","sm6":"","md6":"","lg6":"","xl6":"","pa-3":"","px-4":""}},[_c('v-layout',{staticStyle:{"border":"1px red none","height":"100%","overflow-y":"auto","border-radius":"16px"}},[_c('distributors-details-list',{attrs:{"text-filter":_vm.textFilter,"colors-filters":_vm.colorsFiltersMap,"show-logs-details":_vm.showLogsDetails,"detailed-distributor":_vm.detailedDistributor}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"border-left":"1px lightgray none","max-height":"600px"},attrs:{"xs12":"","sm6":"","md6":"","lg6":"","xl6":"","hidden-xs-only":""}},[_c('distributor-details-log-report',{attrs:{"id":'distributorlog',"detailedDistributor":_vm.detailedDistributor}})],1)]:[_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":"","px-3":""}},[(_vm.isLoadingDistributors)?_c('v-progress-linear',{staticClass:"strategio-progress-linear-component",attrs:{"size":"50","indeterminate":""}}):_vm._e()],1)]],2)],1)],1)],1),_vm._v(" "),_c('show-distributor-details-dialog',{attrs:{"detailedDistributor":_vm.detailedDistributor,"showLogsDetails":_vm.showLogsDetails}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/distributors-details.vue
function injectStyle (context) {
  __webpack_require__("I8dg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributors_details,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_distributors_details = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "niPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





var consistencyLogs = [];
var databaseLogs = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  getConsistencyLogsPointer: function getConsistencyLogsPointer() {
    return consistencyLogs;
  },
  getDatabaseLogsPointer: function getDatabaseLogsPointer() {
    return databaseLogs;
  },
  getConsistencyLogs: function getConsistencyLogs(options) {
    /*
      options: {
        data: {
          distributorCode2: ''
        },
        onSuccess: () => {},
        onError: () => {}
      }
    */
    // PODRIA HACER UNA CONFIRMACION ANTES DE HACER EL POST
    // PREGUNTANDO SI ESA DATA YA EXISTE
    // CONSULTAR SI SE DEBE HACER ASI
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS, {
      distributorCode2: options.data.distributorCode2
    }).then(function (response) {
      var log = {
        distributorCode2: options.data.distributorCode2,
        logs: response.data.rows,
        logType: 'CONSISTENCY'
      };
      var extantLog = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(consistencyLogs, function (item) {
        return item.distributorCode2 === options.data.distributorCode2;
      });

      extantLog ? Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(extantLog, log) : consistencyLogs.push(log);

      if (options.onSuccess) {
        options.onSuccess(consistencyLogs);
      }
    }, function (err) {
      console.warn('ERROR GETTING CONSISTENCY LOGS', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  getDatabaseLogs: function getDatabaseLogs(options) {
    /*  */
    __WEBPACK_IMPORTED_MODULE_1__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_0__utils_uris__["default"].URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS, {
      distributorCode1: options.data.distributorCode1
    }).then(function (response) {
      var log = {
        distributorCode1: options.data.distributorCode1,
        logs: response.data.rows,
        logType: 'DATABASE'
      };
      var extantLog = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(databaseLogs, function (item) {
        return item.distributorCode1 === options.data.distributorCode1;
      });

      extantLog ? Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(extantLog, log) : databaseLogs.push(log);

      if (options.onSuccess) {
        options.onSuccess(databaseLogs);
      }
    }, function (err) {
      console.warn('ERROR GETTING DATABASE LOGS', err);
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "nsAd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/placeholder.efb3cda.png";

/***/ }),

/***/ "oAZg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oWN+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "odzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/autoservicios/groups/autoservicio-list-groups.vue + 2 modules
var autoservicio_list_groups = __webpack_require__("Eqwn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/autoservicios.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var autoservicios = ({
  name: 'autoservicios',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    AutoservicioListGroups: autoservicio_list_groups["default"]
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbfc3d2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/autoservicios.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('v-col',{attrs:{"cols":"5","align-self":"center"}},[_c('v-icon',{staticStyle:{"font-size":"52px","padding-bottom":"30px","padding-right":"10px"},attrs:{"color":'black'}},[_vm._v("ico-icon-config")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n              Apps\n            ")])],1)],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[_c('autoservicio-list-groups')],1)],1)],1)])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/autoservicios.vue
function injectStyle (context) {
  __webpack_require__("aZCl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autoservicios,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_autoservicios = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "op7a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pCjg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pNPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/distributor-form-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var distributor_form_dialog = ({
  name: 'distributor-form-dialog',
  data: function data() {
    return {
      dialog: false,
      distributorID: 0,
      data: {
        remoteFileName: '',
        distributorName: '',
        distributorCode1: '',
        distributorCode2: '',
        distributorCode3: '',
        contactMail: '',
        inconsistenciesFileUrl: '',

        lastLog: [],
        canReadJsonLog: false,
        lastLogDate: '',
        isLastLogOutdated: true,
        logDateFromNow: '',

        salesTableName: '',
        salesLastUpdate: '',
        isSalesLastUpdatedOutdated: true,
        salesLastUpdateFromNow: '',

        salesMaxDate: '',
        isSalesMaxDateOutdated: true,
        salesMaxDateFromNow: '',

        inconsistenciesCounter: 0
      },
      isValidForm: false,
      isNew: false,
      isLoading: false
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-distributor-form');
    eventBus["default"].$on('open-distributor-form', function (item) {
      _this.isNew = !('distributorID' in item);
      _this.distributorID = item.distributorID || 0;
      _this.data = {
        remoteFileName: item.remoteFileName || '',
        distributorName: item.distributorName || '',
        distributorCode1: item.distributorCode1 || '',
        distributorCode2: item.distributorCode2 || '',
        distributorCode3: item.distributorCode3 || '',
        contactMail: item.contactMail || '',
        inconsistenciesFileUrl: item.inconsistenciesFileUrl || '',

        lastLog: item.lastLog || [],
        canReadJsonLog: item.canReadJsonLog || false,
        lastLogDate: item.lastLogDate || '',
        isLastLogOutdated: item.isLastLogOutdated || true,
        logDateFromNow: item.logDateFromNow || '',

        salesTableName: item.salesTableName || '',
        salesLastUpdate: item.salesLastUpdate || '',
        isSalesLastUpdatedOutdated: item.isSalesLastUpdatedOutdated || true,
        salesLastUpdateFromNow: item.salesLastUpdateFromNow || '',

        salesMaxDate: item.salesMaxDate || '',
        isSalesMaxDateOutdated: item.isSalesMaxDateOutdated || true,
        salesMaxDateFromNow: item.salesMaxDateFromNow || '',

        inconsistenciesCounter: item.inconsistenciesCounter || 0
      };
      _this.dialog = true;
    });
  },

  methods: {
    sendNewData: function sendNewData() {
      var _this2 = this;

      if (!this.isValidForm) {
        return;
      }
      this.isLoading = true;
      console.warn('loading');
      if (this.isNew) {
        supervisorStorage["default"].addDistributor({
          data: {
            item: extends_default()({
              distributorID: this.distributorID
            }, this.data)
          },
          onSuccess: function onSuccess() {
            _this2.dialog = false;
          },
          onError: function onError(error) {
            console.warn('error creando distribudor: ', error);
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha podido crear el distribuidor', itsOk: false });
          },
          finally: function _finally() {
            _this2.isLoading = false;
          }
        });
      } else {
        supervisorStorage["default"].editDistributor({
          data: {
            item: extends_default()({
              distributorID: this.distributorID
            }, this.data)
          },
          onSuccess: function onSuccess() {
            _this2.dialog = false;
          },
          onError: function onError(error) {
            console.warn('error editando distribudor: ', error);
            eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se ha podido editar el distribuidor', itsOk: false });
          },
          finally: function _finally() {
            _this2.isLoading = false;
          }
        });
      }
    },
    validateDistributor: function validateDistributor() {
      if (this.data.distributorName && this.data.distributorName.trim() !== '') {
        return true;
      }
      return 'Este campo es obligatorio';
    },
    validateForm: function validateForm() {
      var isValidDistributor = this.data.distributorName && this.data.distributorName.trim() !== '';
      this.isValidForm = isValidDistributor;
      return this.isValidForm;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d9ad288","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/distributor-form-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"650px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v(_vm._s(_vm.isNew ? 'Crear distribuidor' : 'Editar distribuidor'))]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Distribuidor","rules":[_vm.validateDistributor(), _vm.validateForm()],"required":"","clearable":""},model:{value:(_vm.data.distributorName),callback:function ($$v) {_vm.$set(_vm.data, "distributorName", $$v)},expression:"data.distributorName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombre de archivo remoto","clearable":""},model:{value:(_vm.data.remoteFileName),callback:function ($$v) {_vm.$set(_vm.data, "remoteFileName", $$v)},expression:"data.remoteFileName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código de distribuidor (1)","hint":"Este código corresponde al identificador largo de la distribuidora","clearable":""},model:{value:(_vm.data.distributorCode1),callback:function ($$v) {_vm.$set(_vm.data, "distributorCode1", $$v)},expression:"data.distributorCode1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código de distribuidor (2)","hint":"Este código corresponde al identificador corto de la distribuidora","clearable":""},model:{value:(_vm.data.distributorCode2),callback:function ($$v) {_vm.$set(_vm.data, "distributorCode2", $$v)},expression:"data.distributorCode2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Código de distribuidor (3)","hint":"","clearable":""},model:{value:(_vm.data.distributorCode3),callback:function ($$v) {_vm.$set(_vm.data, "distributorCode3", $$v)},expression:"data.distributorCode3"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Correo de contacto","hint":"","clearable":""},model:{value:(_vm.data.contactMail),callback:function ($$v) {_vm.$set(_vm.data, "contactMail", $$v)},expression:"data.contactMail"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Url de reporte de inconsistencias","hint":"","clearable":""},model:{value:(_vm.data.inconsistenciesFileUrl),callback:function ($$v) {_vm.$set(_vm.data, "inconsistenciesFileUrl", $$v)},expression:"data.inconsistenciesFileUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button error",attrs:{"small":"","depressed":"","rounded":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"background-color":"#61B965","color":"white"},attrs:{"small":"","depressed":"","rounded":"","loading":_vm.isLoading,"disabled":!_vm.isValidForm},nativeOn:{"click":function($event){return _vm.sendNewData()}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/distributor-form-dialog.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  distributor_form_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_distributor_form_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pSq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/structures/structure-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var structure_item = ({
  name: 'structure-item',
  methods: {
    changeState: function changeState() {
      console.warn('change state');
    }
  },
  props: {
    structureItemData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65554dc7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/structures/structure-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"check","prepend-icon-cb":_vm.changeState,"label":"Nombre del item"},model:{value:(_vm.structureItemData.itemName),callback:function ($$v) {_vm.$set(_vm.structureItemData, "itemName", $$v)},expression:"structureItemData.itemName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","offset-xs2":""}},[_c('v-text-field',{attrs:{"label":"Descripcion del item"},model:{value:(_vm.structureItemData.description),callback:function ($$v) {_vm.$set(_vm.structureItemData, "description", $$v)},expression:"structureItemData.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","offset-xs2":""}},[_c('v-text-field',{attrs:{"label":"Etiquetas del item"},model:{value:(_vm.structureItemData.labels),callback:function ($$v) {_vm.$set(_vm.structureItemData, "labels", $$v)},expression:"structureItemData.labels"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","offset-xs2":""}},[_c('v-text-field',{attrs:{"label":"Url de vista previa","clearable":""},model:{value:(_vm.structureItemData.imageUrl),callback:function ($$v) {_vm.$set(_vm.structureItemData, "imageUrl", $$v)},expression:"structureItemData.imageUrl"}})],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/structures/structure-item.vue
function injectStyle (context) {
  __webpack_require__("JE4U")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  structure_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var structures_structure_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pg7M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ind3.ac74d5d.png";

/***/ }),

/***/ "qLC+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "qLPu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "sW4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/users-list-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var users_list_item = ({
  name: 'users-list-item',
  props: ['userData'],
  methods: {
    isEnabled: function isEnabled(_isEnabled) {
      return 'opacity: ' + (_isEnabled ? '1' : '0.5');
    },
    getChipWidth: function getChipWidth() {
      var widthio = '';
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          widthio = '70%';
          break;
        case 'md':
        case 'lg':
        case 'xl':
          widthio = '150px';
          break;
        default:
          // widthio = ''
          break;
      }

      return widthio;
    },
    pickColor: function pickColor(userType) {
      switch (userType) {
        case 'ADMIN':
          return 'blue darken-1';
        case 'SUPERVISOR':
          return 'amber darken-1';
        case 'GLOBAL':
          return 'light-green darken-1';
        case 'NORMAL':
          return 'cyan darken-1';
        case 'DEMO':
          return 'purple darken-1';
        default:
          return 'grey darken-1';
      }
    },
    adminUser: function adminUser(userID) {
      this.$router.push('/user/admin/' + userID);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c690fd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/users-list-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"strategio-user-list-item",style:(_vm.isEnabled(_vm.userData.isEnabled)),attrs:{"align-center":""},on:{"click":function($event){return _vm.adminUser(_vm.userData.userID)}}},[_c('v-col',{attrs:{"cols":"12","md":"2","align-self":"center"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-chip',{staticClass:"ml-0",style:([
          {'color': 'white'},
          {'width': _vm.getChipWidth()},
          {'justify-content': 'center'}
        ]),attrs:{"small":"","color":_vm.pickColor(_vm.userData.userType)}},[_vm._v(_vm._s(_vm.userData.userType))])],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('img',{attrs:{"height":"31px","src":__webpack_require__("qLPu"),"alt":"user-icon"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.userData.isEnabled ? "" : "[Deshabilitado] ")+_vm._s(_vm.userData.name))])]),_vm._v(" "),_c('v-col',{staticClass:"py-0 my-2",attrs:{"cols":"12","md":"7","align-self":"center"}},[_c('v-row',[_c('v-col',{staticClass:"py-0 my-2",attrs:{"cols":"12","sm":"6"}},[_c('v-row',{attrs:{"align-content":"end"}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","md":"2"}},[_c('img',{attrs:{"height":"31px","src":__webpack_require__("1W7+"),"alt":"user-icon"}})]),_vm._v(" "),_c('v-col',{staticClass:"py-0 pb-1",attrs:{"cols":"12","md":"10"}},[_c('strong',[_vm._v(_vm._s(_vm.userData.description))])])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"py-0 my-2",attrs:{"cols":"12","sm":"6"}},[_c('v-row',{attrs:{"align-content":"end"}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","md":"2"}},[_c('img',{attrs:{"height":"30px","src":__webpack_require__("ZmgP"),"alt":"user-icon"}})]),_vm._v(" "),_c('v-col',{staticClass:"py-0 pb-1",attrs:{"cols":"12","md":"10"}},[_c('span',{staticClass:"grey--text",attrs:{"ellipsis":""}},[_vm._v(_vm._s(_vm.userData.mail))])])],1)],1)],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/users/users-list-item.vue
function injectStyle (context) {
  __webpack_require__("PXCm")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  users_list_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_users_list_item = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sYgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/cardsStorage.js
var cardsStorage = __webpack_require__("l4NB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-cards-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var show_cards_dialog = ({
  data: function data() {
    return {
      dialog: false,
      editedCards: [],
      isUpdating: false
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-show-cards-dialog');
    eventBus["default"].$on('open-show-cards-dialog', function (cards) {
      _this.editedCards = Object(lodash["cloneDeep"])(Object(lodash["map"])(cards, Object(lodash["partialRight"])(lodash["pick"], ['cardType', 'cardName', 'enabled', 'reference'])));

      _this.dialog = true;
    });
  },

  methods: {
    save: function save() {
      var _this2 = this;

      this.isUpdating = true;
      cardsStorage["default"].updateCards({
        data: {
          cards: this.editedCards
        },
        onSuccess: function onSuccess() {
          _this2.isUpdating = false;
          _this2.dialog = false;
        },
        onError: function onError(error) {
          _this2.isUpdating = false;
          console.warn('error actualizando tarjetas: ', error);
          eventBus["default"].$emit('open-custom-snack-bar', { message: 'No se han podido actualizar las tarjetas', itsOk: false });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8787586","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-cards-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":true,"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container standard"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n      Tarjetas\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-2"},[(_vm.editedCards.length > 0)?[_c('v-container',{staticClass:"px-3 py-0"},[_vm._l((_vm.editedCards),function(item,index){return [_c('v-layout',{key:index,attrs:{"align-center":""}},[_c('div',{staticClass:"mr-2"},[_c('v-switch',{staticClass:"strategio-switch-control",attrs:{"ripple":false,"hide-details":""},model:{value:(item.enabled),callback:function ($$v) {_vm.$set(item, "enabled", $$v)},expression:"item.enabled"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":item.cardType,"placeholder":"Etiqueta","hint":item.reference},model:{value:(item.cardName),callback:function ($$v) {_vm.$set(item, "cardName", $$v)},expression:"item.cardName"}})],1)],1)]})],2)]:[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"rgba(0,0,0,.38)"}},[_vm._v("\n              No data available\n            ")])],1)],1)]],2),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","dark":"","color":"error"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"background-color":"#61B965","color":"white"},attrs:{"small":"","depressed":"","rounded":"","loading":_vm.isUpdating},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("Grabar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-cards-dialog.vue
function injectStyle (context) {
  __webpack_require__("gm6y")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_cards_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_cards_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "saB/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "seyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/supervisorStorage.js
var supervisorStorage = __webpack_require__("zaRw");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/configure-ftp-dialog.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var configure_ftp_dialog = ({
  name: 'configure-ftp-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-configure-ftp');
    eventBus["default"].$on('open-configure-ftp', function (data) {
      _this.dialog = true;

      _this.initialize();
    });
  },
  data: function data() {
    return {
      dialog: false,
      distributorFilter: '',
      items: [],
      editedIndex: -1,
      editedItem: {
        distributorID: 0,
        remoteFileName: ''
      },
      defaultItem: {
        distributorID: 0,
        remoteFileName: ''
      }
    };
  },

  /* methods: {
    configure () {
     }
  } */
  methods: {
    initialize: function initialize() {
      this.getRemoteFiles();
    },
    editItem: function editItem(item) {
      this.editedIndex = this.filteredDistributors.indexOf(item);
      this.editedItem = assign_default()({}, item);
      // this.dialog = true
    },
    deleteItem: function deleteItem(item) {
      // emit to: /components/dialogs/are-you-sure-dialog.vue
      eventBus["default"].$emit('open-are-you-sure-dialog', {
        title: 'Eliminar',
        message: '¿Estás seguro de que deseas borrar esta ruta?',
        onOk: function onOk() {
          supervisorStorage["default"].removeSupervisorFtpFile({
            data: {
              item: item
            }
          });
        }
      });
    },
    close: function close() {
      var _this2 = this;

      // this.dialog = false
      setTimeout(function () {
        _this2.editedItem = assign_default()({}, _this2.defaultItem);
        _this2.editedIndex = -1;
      }, 100);
    },
    save: function save() {
      // VALIDAR DATOS DE ENTRADA
      if (this.editedItem.remoteFileName.trim() !== '') {
        if (this.editedIndex > -1) {
          // Object.assign(this.items[this.editedIndex], this.editedItem)
          supervisorStorage["default"].updateSupervisorFtpFile({
            data: {
              item: this.editedItem
              // index: this.editedIndex // PODRIA TOMARSE CON LODASH, EN EL STORAGE
            }
          });
          // let item =
          /* supervisorStorage.updateSupervisorFtpFile({
            data: {
              item: this.item,
              newItem: this.editedItem // PODRIA TOMARSE CON LODASH, EN EL STORAGE
            }
          }) */
        } /*  else {
           // this.items.push(this.editedItem)
           supervisorStorage.addSupervisorFtpFile({
             data: {
               item: this.editedItem
             }
           })
          } */
        this.close();
      } else {
        // ALERTA, NO HAY REMOTEFILENAME INGRESADO
      }
    },
    getRemoteFiles: function getRemoteFiles() {
      this.items = supervisorStorage["default"].getSupervisorFtpFiles();
    }
  },
  computed: {
    filteredDistributors: function filteredDistributors() {
      var _this3 = this;

      var filtered = Object(lodash["filter"])(this.items, function (item) {
        // return item.distributorName.toLowerCase().includes((this.distributorFilter || '').toLowerCase())
        return item.distributorName.toLowerCase().indexOf((_this3.distributorFilter || '').toLowerCase()) !== -1;
      });
      var sorted = Object(lodash["orderBy"])(filtered, ['distributorName', 'remoteFileName'], ['asc', 'asc']);

      return sorted;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f906e100","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/configure-ftp-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Rutas")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',[_c('v-container',{staticClass:"py-0 pb-3"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('v-layout',[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Distribuidora","hide-details":"","clearable":""},model:{value:(_vm.distributorFilter),callback:function ($$v) {_vm.distributorFilter=$$v},expression:"distributorFilter"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"py-2",staticStyle:{"height":"auto"}},[_c('v-container',{staticClass:"px-3 py-0"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[(_vm.filteredDistributors.length > 0)?[_vm._l((_vm.filteredDistributors),function(item,index){return [_c('div',{key:'c'+index},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"align-center layout",attrs:{"sm10":"","xs12":""}},[(_vm.editedIndex > -1 && _vm.editedIndex === index)?[_c('v-text-field',{staticClass:"py-1",attrs:{"hide-details":""},model:{value:(_vm.editedItem.remoteFileName),callback:function ($$v) {_vm.$set(_vm.editedItem, "remoteFileName", $$v)},expression:"editedItem.remoteFileName"}}),_vm._v(" "),_c('v-btn',{staticClass:"mx-2",attrs:{"small":"","icon":""},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("clear")])],1)]:[_c('b',[_vm._v(_vm._s(item.distributorName || '~NO DEFINIDO~'))]),_vm._v("  -  "),_c('span',[_vm._v(_vm._s(item.remoteFileName || '~RUTA NO DEFINIDA~'))])]],2),_vm._v(" "),_c('v-flex',{attrs:{"sm2":"","xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"justify-center layout",attrs:{"xs6":""}},[(_vm.editedIndex > -1 && _vm.editedIndex === index)?[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","icon":""},on:{"click":_vm.save}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("save")])],1)]:[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editItem(item)}}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("edit")])],1)]],2),_vm._v(" "),_c('v-flex',{staticClass:"justify-center layout",attrs:{"xs6":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","icon":"","disabled":_vm.editedIndex > -1 && _vm.editedIndex === index},on:{"click":function($event){return _vm.deleteItem(item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.filteredDistributors.length)?_c('v-divider',{key:index}):_vm._e()]})]:[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"align-center layout",staticStyle:{"color":"rgba(0,0,0,.38)"}},[_vm._v("\n                    No data available\n                  ")])],1)],1)]],2)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue darken-1"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/configure-ftp-dialog.vue
function injectStyle (context) {
  __webpack_require__("Tds2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  configure_ftp_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_configure_ftp_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sluv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-excel.c8b1bb6.png";

/***/ }),

/***/ "t+SW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/autoservicios/autoservicio-btn-back.vue + 2 modules
var autoservicio_btn_back = __webpack_require__("VfmT");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/homologation/show-homologation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Axios from 'axios'



/* harmony default export */ var show_homologation = ({
  name: 'show-homologation',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    AutoservicioBtnBack: autoservicio_btn_back["default"]
  },
  data: function data() {
    return {
      url: 'https://softysi.strategio.cloud/homologacionFecha/8d6135cc-05ee-4492-b866-8cb3e2ab97b7'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45286220","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/homologation/show-homologation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategio-bgmain-view fill-height"},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticClass:"fill-height"},[_c('v-container',{attrs:{"align-items":"center"}},[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('autoservicio-btn-back',{attrs:{"title-name":"Homologacion"}})],1)],1),_vm._v(" "),_c('iframe',{staticClass:"strategio-iframe",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"ifrm-homologation","frameborder":"0","src":_vm.url}})],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/homologation/show-homologation.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_homologation,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var homologation_show_homologation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t91I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/animacion_background.f61526d.jpg";

/***/ }),

/***/ "tfuP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/header-bar/strategio-app-bar.vue + 2 modules
var strategio_app_bar = __webpack_require__("Cy8i");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-header.vue + 2 modules
var validation_header = __webpack_require__("8vt4");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-upload-file.vue + 2 modules
var validation_upload_file = __webpack_require__("nFpD");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-config.vue + 2 modules
var validation_config = __webpack_require__("PSrw");

// EXTERNAL MODULE: ./src/components/snackbars/custom-snack-bar.vue + 2 modules
var custom_snack_bar = __webpack_require__("xdpQ");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-dialog-error.vue + 2 modules
var validation_dialog_error = __webpack_require__("1CsE");

// EXTERNAL MODULE: ./src/components/autoservicios/validation/validation-insert-data-dialog-error.vue + 2 modules
var validation_insert_data_dialog_error = __webpack_require__("ljja");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/routes/autoservicios/show-process-validation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var show_process_validation = ({
  name: 'autoservicios-process-validation',
  components: {
    StrategioAppBar: strategio_app_bar["default"],
    ValidationHeader: validation_header["default"],
    ValidationUploadFile: validation_upload_file["default"],
    ValidationConfig: validation_config["default"],
    CustomSnackBar: custom_snack_bar["default"],
    validationDialogError: validation_dialog_error["default"],
    validationInsertDataDialogError: validation_insert_data_dialog_error["default"]
  },
  data: function data() {
    var user = userStorage["default"].getUserInfo();
    return {
      processID: Number(this.$route.params.processID),
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5573f761","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/autoservicios/show-process-validation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:([
    {'background-color': "#F4F4F4"} 
  ])},[_c('strategio-app-bar'),_vm._v(" "),_c('v-main',{staticStyle:{"height":"100vh","padding-top":"87px"}},[_c('div',{staticStyle:{"max-height":"100%","overflow":"auto"}},[_c('v-container',[_c('v-row',{staticClass:"strategio-titles-windows"},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12"}},[_c('v-icon',{staticStyle:{"font-size":"52px","margin-right":"5px"},attrs:{"color":"black"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n              Proceso Validacion\n            ")])],1)],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[(_vm.isAdmin)?_c('validation-config',{attrs:{"processID":_vm.processID}}):_vm._e()],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[_c('validation-header',{attrs:{"processID":_vm.processID}})],1),_vm._v(" "),_c('v-row',{staticClass:"ma-5 px-5"},[_c('validation-upload-file',{attrs:{"processID":_vm.processID}})],1)],1)],1)]),_vm._v(" "),_c('custom-snack-bar'),_vm._v(" "),_c('validation-dialog-error'),_vm._v(" "),_c('validation-insert-data-dialog-error')],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/routes/autoservicios/show-process-validation.vue
function injectStyle (context) {
  __webpack_require__("DXN9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_process_validation,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var autoservicios_show_process_validation = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u9Gr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/are-you-sure-dialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var are_you_sure_dialog = ({
  name: 'are-you-sure-dialog',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-are-you-sure-dialog');
    eventBus["default"].$on('open-are-you-sure-dialog', function (data) {
      _this.dialog = true;
      _this.title = data.title;
      _this.message = data.message;
      _this.onOk = data.onOk;
    });
  },
  data: function data() {
    return {
      dialog: false,
      title: '',
      message: '',
      onOk: function onOk() {}
    };
  },

  methods: {
    accept: function accept() {
      this.onOk();
      this.dialog = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484bb7d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/are-you-sure-dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"290px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container"},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"strategio-dialog-button",staticStyle:{"color":"white"},attrs:{"small":"","depressed":"","rounded":"","color":"grey lighten-0"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","depressed":"","rounded":"","color":"error"},nativeOn:{"click":function($event){return _vm.accept()}}},[_vm._v("Aceptar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/are-you-sure-dialog.vue
function injectStyle (context) {
  __webpack_require__("bkhD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  are_you_sure_dialog,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_are_you_sure_dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uOFS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRxK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/reports/tree-item.vue + 2 modules
var tree_item = __webpack_require__("1DXM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reports/reports-tree.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var reports_tree = ({
  name: 'reports-tree',
  methods: {},
  props: ['itemsData'],
  components: {
    TreeItem: tree_item["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b2ccd6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/reports-tree.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.itemsData),function(i,$index){return _c('tree-item',{key:$index,attrs:{"i-data":i}})}),1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/reports/reports-tree.vue
function injectStyle (context) {
  __webpack_require__("BOr9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  reports_tree,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var reports_reports_tree = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vWX2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwv5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w/aW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/storage/userStorage.js
var userStorage = __webpack_require__("4SVp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/supervisor/card-template_OLD.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card_template_OLD = ({
  name: 'card-template',
  methods: {
    configure: function configure() {
      switch (this.cardType) {
        case 'FTP':
          // emit to: /components/dialogs/configure-ftp-dialog.vue
          eventBus["default"].$emit('open-configure-ftp', {});
          break;
        default:
        // Mark an error
      }
    },
    remove: function remove() {
      switch (this.cardType) {
        case 'FTP':
          // open windows remove FTP
          break;
        default:
        // mark an error
      }
    },
    isAdmin: function isAdmin() {
      return userStorage["default"].getUserInfo().userType === 'ADMIN';
    },
    showCardDetails: function showCardDetails(item) {
      // emit to: /components/dialogs/details-dialog.vue
      eventBus["default"].$emit('open-details-dialog', {
        title: 'Titulo',
        message: 'Mensaje'
      });
    }
  },
  props: {
    cardTitle: {
      type: String,
      default: function _default() {
        return 'Sin titulo';
      }
    },
    /* cardData: {
      type: Object,
      default () {
        return {}
      }
    }, */
    isLoading: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    cardInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    cardType: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ea791e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supervisor/card-template_OLD.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-actions',[_c('div',{staticStyle:{"padding-left":"8px"}},[_vm._v("\n      "+_vm._s(_vm.cardTitle)+"\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(false)?_c('v-menu',{attrs:{"bottom":"","left":"","disabled":_vm.isLoading}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","disabled":_vm.isLoading},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.configure()}}},[_c('v-list-tile-title',[_vm._v("Configurar")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.remove()}}},[_c('v-list-tile-title',{staticClass:"red--text text--darken-2"},[_vm._v("Remover")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticStyle:{"font-size":"28px","font-weight":"300","width":"56px","text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticStyle:{"font-size":"28px","font-weight":"300","width":"56px","text-align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardInfo.cardNumber !== 0),expression:"cardInfo.cardNumber !== 0"}]},[_vm._v(_vm._s(_vm.cardInfo.cardNumber))]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardInfo.cardNumber === 0),expression:"cardInfo.cardNumber === 0"}],attrs:{"color":"green"}},[_vm._v("done")])],1)]),_vm._v(" "),_c('v-flex',[_c('p',{staticStyle:{"font-weight":"300","height":"42px"}},[_vm._v(_vm._s(_vm.cardInfo.message))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-icon',{attrs:{"color":_vm.isLoading ? 'gray' : _vm.cardInfo.lightColor}},[_vm._v("fiber_manual_record")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isLoading,"flat":"","color":"primary"},on:{"click":function($event){return _vm.showCardDetails({})}}},[_vm._v("Detalles")])],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/supervisor/card-template_OLD.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  card_template_OLD,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var supervisor_card_template_OLD = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wCAR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wP5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// EXTERNAL MODULE: ./src/components/folders/current-folder-permissions-tree.vue + 2 modules
var current_folder_permissions_tree = __webpack_require__("e+PE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialogs/show-users-folder-permissions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var show_users_folder_permissions = ({
  data: function data() {
    return {
      dialog: false,
      users: [],
      totalHolder: [],
      pickColor: function pickColor(userType) {
        switch (userType) {
          case 'ADMIN':
            return 'blue darken-1';
          case 'SUPERVISOR':
            return 'amber darken-1';
          case 'GLOBAL':
            return 'light-green darken-1';
          case 'NORMAL':
            return 'cyan darken-1';
          case 'DEMO':
            return 'purple darken-1';
          default:
            return 'grey darken-1';
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-show-users-folder-permissions-dialog');
    eventBus["default"].$on('open-show-users-folder-permissions-dialog', function (totalHolder, users, isLoadingFalse) {
      _this.users = users;
      _this.totalHolder = totalHolder;
      _this.dialog = true;

      isLoadingFalse();
    });
  },

  methods: {
    getUserData: function getUserData(userID) {
      return Object(lodash["find"])(this.users, function (user) {
        return user.userID === userID;
      });
    },
    correctUsersID: function correctUsersID(usersID) {
      Object(lodash["flatMap"])(Object(lodash["filter"])(this.users, function (user) {
        return ['SUPERVISOR', 'GLOBAL'].includes(user.userType);
      }), 'userID').forEach(function (userID) {
        if (!usersID.includes(userID)) usersID.push(userID);
      });

      return usersID;
    }
  },
  components: {
    CurrentFolderPermissionsTree: current_folder_permissions_tree["default"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0031585e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/show-users-folder-permissions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"550px","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"py-2 strategio-card-container",staticStyle:{"border-radius":"20px"}},[_c('v-card-title',{staticClass:"py-2 justify-center",staticStyle:{"font-size":"20px","font-weight":"500"}},[_vm._v("\n      Permisos\n    ")]),_vm._v(" "),_c('div',{staticClass:"divisor"},[_c('v-divider')],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":"","mb-3":""}},[_c('v-flex',{staticClass:"my-1"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('span',{staticClass:"body-1"},[_vm._v("Carpeta: ")]),_vm._v(" "),_c('span',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.totalHolder.folderName))])]),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","rounded":"","depressed":"","color":"success"}},[_vm._v("Agregar")])],1)],1),_vm._v(" "),_c('v-flex',[(_vm.totalHolder.containedBy === 0)?void 0:_vm._l((_vm.correctUsersID(_vm.totalHolder.usersID)),function(item,index){return _c('v-layout',{key:index,staticClass:"pl-3",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-chip',{staticClass:"ml-0",staticStyle:{"font-style":"italic","color":"white"},attrs:{"label":"","small":"","color":_vm.pickColor(_vm.getUserData(item).userType)}},[_vm._v(_vm._s(_vm.getUserData(item).userType))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('span',{staticClass:"grey--text",staticStyle:{"font-weight":"500","font-style":"italic"}},[_vm._v(_vm._s(_vm.getUserData(item).name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('span',{staticClass:"grey--text",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.getUserData(item).mail))])])],1)})],2)],1),_vm._v(" "),_c('current-folder-permissions-tree',{attrs:{"users":_vm.users,"items":_vm.totalHolder.folders,"permissionsType":"FOLDER"}}),_vm._v(" "),_c('current-folder-permissions-tree',{attrs:{"users":_vm.users,"items":_vm.totalHolder.reports,"permissionsType":"REPORT"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"strategio-dialog-button",attrs:{"small":"","dark":"","depressed":"","rounded":"","color":"red"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/dialogs/show-users-folder-permissions.vue
function injectStyle (context) {
  __webpack_require__("WAKm")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  show_users_folder_permissions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dialogs_show_users_folder_permissions = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wlwR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wwhr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6REY5OTQwRTQ3NjJDMTFFODk4N0JFMUFGMTFEQzAzRkYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6REY5OTQwRTM3NjJDMTFFODk4N0JFMUFGMTFEQzAzRkYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDNjNjkyNjEtNDEzYi1hNDRjLWE2NDMtN2NkNDI0YzllY2RhIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NzZkZDlhYTItYzY4ZS0yZjQ1LTg1ZmUtYTlhYWVmZmUwNzUzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+QVDqvwAABCVJREFUeNrEV2tIFFEU3lkfa6ml9gJ/FEE/xIwwexBRUlQg/QjMyl4W/Sh62JMy6ElkERIJQvWrUoKkjAgMhF4GGYiopFRSWVJkxfYgTUvX3ek79N24jDNTW4IXvr1nZ86ce+75zjl3xjBN0zMYI1J+jIr6dkxDgV75G6YN8TwaaANyzZyMlr9eGCMOOA1UAxG85qVR0yIbRIhzDzAfWAPEh7VjjD6gDt7e+5ewIWKxmFaFHWqOKBpZytBdBsYCq4FCYBiwFqiBg/XUMyFXUD+s4dXkEOc8IJ+OTAGOUh5FB2ZQbxOw+b+SS0WMcz0TLQC8Am6Tik7gJvCaejWaswOy8CmGMIRwNkFeQdkPeSPwg3onmWzWDA97YTXSSYFkeAKwCCgDfEAm8BR4Tr0g8JDRGSm0wMG3WmX0y0OgHRvZb8ex8HYQBmShWUAx5WTgHBeXUQDs03YqtobTgUQLkjinAbudQi0cfqUjn4AWyhLiZuAz9V5oz0pWvwc2YDePXcouC9Mlp4WPy0IwIOGrgXKOyOxuy9kwZBywqRAf9EZj3soEVXbfABe4nuHE8TgaaYQR4XiS8EKO05jpwuN46jdb6BJ+JzM/TP6Ppc2QXXKpjBRvE7DoSswZwBnIKZhlJyXMegnXHq3ufzchROcd5sUOofa5ZXUsu5TibgSdimSSqC4Vb1PHUnZxbEDqviz2jJURcKvjAtax8HpXMhtyH2RJunlacuXbLQwMYXdL0v7LZsqdQq1Gt8VQh0bFN83rbru+ACf9cHKJthGZg2xC0W4cF0s9QimbNVsOeQwPjCrgBHBRuKd+riXUEuJ1DLVKrjZcv8aG47hjU/PUy5cDr01Y7V4YgkzCbC1PDHJ8iz3fkWPpTl5y3AB5B2Xp1TvZUDx8cbCOaOi2Yp7rkNUxbjuuU57ByEcoV1LuhlylOViLa9ZDIQgdaZvrtVALry+ZXAE3jo/IQzCwC/NU6WSQFzKEZ4HzwA05nXBdsr/Akoxydi9gGYbYwWqBq39qIBPY6CO4WDplKYvpQCX1Jtocg5EstzxLVkuedKm3HOvC6qQqJcc92JF4epjyB8h7gQbqlTicx2JnNhCjNR5psfd1fTuOqzUFPx3x0OPr9N5jNcQRYA8/xF6tdvyESdnrFuotElbs8BjmVOEc8jJyVkiupDS2kbMizYYP0XlEeuyyeqbbwpnkVl5tUliTUTzI5Y2ziQtnUb/IJquz2KNVqCVyd5zqWHF8hQ9J2BppOMCHC1luHp6vpk2vlvLZzrfSEPv0A1Jo27kCrNcy7VorDw0ZX7iwh3qllmdN9mQ/qYnSNtSB65243u9lT+ZpuNFFRUP7bAnyvql9tugttJdlJjubAxuJvKdHIxnXU6n363tNvhYH6KNN6PlOHg0XvW7sPtkYrM/UnwIMAJ8Vh88oQwMPAAAAAElFTkSuQmCC"

/***/ }),

/***/ "xbPH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var URL_BASE = window.s3_config_port;
var URL_AUTOSERVICIO_BASE = window.s3_config_port_autoservicio;
var URL_POWERBI_ID = window.s3_config_port_powerbi_id;
var URL_METABASE = window.s3_config_port_metabase;
var URL_HELPDESK = window.s3_config_port_helpdesk;

var URL_LOGIN = URL_BASE + "/authService/login";
var URL_GET_ITEMS = URL_BASE + "/api/protected/getItems";
var URL_GET_KPI = URL_BASE + "/api/protected/getKpi";
var URL_REGISTER_VIEW = URL_BASE + "/api/protected/registerView";

var URL_EDIT_ITEM = URL_BASE + "/api/protected/editItem";
var URL_MOVE_ITEM = URL_BASE + "/api/protected/moveItem";
var URL_HIDE_ITEM = URL_BASE + "/api/protected/hideItem";
var URL_UNHIDE_ITEM = URL_BASE + "/api/protected/unHideItem";
var URL_REMOVE_ITEM = URL_BASE + "/api/protected/removeItem";
var URL_UNDO_REMOVE_ITEM = URL_BASE + "/api/protected/unDoRemoveItem";
var URL_ADD_ITEM = URL_BASE + "/api/protected/addItem";
var URL_SET_FAVORITE = URL_BASE + "/api/protected/setFavorite";
var URL_ADD_CUBE_PERMISSION = URL_BASE + "/api/protected/addDownloadCubePermission";
var URL_REMOVE_CUBE_PERMISSION = URL_BASE + "/api/protected/removeDownloadCubePermission";

var URL_UPDATE_USER_INFO = URL_BASE + "/api/protected/updateUserInfo";
var URL_UPDATE_USER_PASSWORD = URL_BASE + "/api/protected/updateUserPassword";

var URL_GET_ADMIN_USERS = URL_BASE + "/api/protected/admin/getUsers";
var URL_GET_ADMIN_SUBSCRIPTIONS = URL_BASE + "/api/protected/admin/getSubscriptions";
var URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS = URL_BASE + "/api/protected/admin/getFoldersSubscriptions";
var URL_UPDATE_SUBSCRIPTIONS = URL_BASE + "/api/protected/admin/updateSubscriptions";
var URL_ADMIN_UPDATE_USER_INFO = URL_BASE + "/api/protected/admin/updateUserInfo";
var URL_ADMIN_UPDATE_USER_PASSWORD = URL_BASE + "/api/protected/admin/updateUserPassword";
var URL_ADMIN_UPDATE_ACCESS_LEVEL = URL_BASE + "/api/protected/admin/updateAccessLevel";
var URL_ADMIN_CREATE_USER = URL_BASE + "/api/protected/admin/createUser";

var URL_CREATE_STRUCTURE = URL_BASE + "/api/protected/structures/createStructure";
var URL_CHECK_STRUCTURE_NAME = URL_BASE + "/api/protected/structures/checkStructureName";
var URL_GET_STRUCTURES = URL_BASE + "/api/protected/structures/getStructures";
var URL_BUILD_STRUCTURE = URL_BASE + "/api/protected/structures/buildStructure";
var URL_CREATE_HERITABLE_ITEM = URL_BASE + "/api/protected/structures/createHeritableItem";
var URL_UPDATE_HERITABLE_ITEM = URL_BASE + "/api/protected/structures/updateHeritableItem";
var URL_CREATE_HERITABLE_STRUCTURE = URL_BASE + "/api/protected/structures/createHeritableStructure";
var URL_REPLICATE_STRUCTURE = URL_BASE + "/api/protected/structures/replicateStructure";
var URL_REMOVE_STRUCTURE = URL_BASE + "/api/protected/structures/removeStructure";
var URL_UPDATE_SPECIFIC_ITEM_DATA = URL_BASE + "/api/protected/structures/updateSpecificItemData";
var URL_REPLICATE_FOLDER = URL_BASE + "/api/protected/structures/replicateFolder";
var URL_UPDATE_MULTIPLE_ITEMS_INHERITEE = URL_BASE + "/api/protected/structures/updateMultipleItemsInheritee";
var URL_GET_HERITABLE_ITEMS = URL_BASE + "/api/protected/getHeritableItems";

var URL_SUPERVISOR_REMOTE_FILES = URL_BASE + "/api/protected/supervisor/getFiles";
var URL_SUPERVISOR_REMOTE_UPDATE_FILE = URL_BASE + "/api/protected/supervisor/updateFile";
var URL_SUPERVISOR_REMOTE_REMOVE_FILE = URL_BASE + "/api/protected/supervisor/removeFile";
var URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR = URL_BASE + "/api/protected/supervisor/addDistributor";
var URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR = URL_BASE + "/api/protected/supervisor/editDistributor";
var URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR = URL_BASE + "/api/protected/supervisor/removeDistributor";
var URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL = URL_BASE + "/api/protected/supervisor/sendInconsistenciesMail";

var URL_SUPERVISOR_REMOTE_GET_CARDS = URL_BASE + "/api/protected/supervisor/getCards";
var URL_SUPERVISOR_REMOTE_UPDATE_CARDS = URL_BASE + "/api/protected/supervisor/updateCards";

var URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS = URL_BASE + "/api/protected/supervisor/getConsistencyLogByCode2";
var URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS = URL_BASE + "/api/protected/supervisor/getMaxDatesByCode1";

var URL_POWERBI_ACCESS_TOKEN = URL_BASE + "/api/protected/powerbi/getReport";

var URL_AUTOSERVICIO_GET_GROUPS = URL_AUTOSERVICIO_BASE + "/api/protected/structure/getGroups";
var URL_AUTOSERVICIO_GET_PROCESSES = URL_AUTOSERVICIO_BASE + "/api/protected/structure/getProcesses";
var URL_AUTOSERVICIO_GET_VALIDATIONS = URL_AUTOSERVICIO_BASE + "/api/protected/structure/getValidations";
var URL_AUTOSERVICIO_GET_TEMPLATE = URL_AUTOSERVICIO_BASE + "/api/protected/templates/getTemplate";
var URL_AUTOSERVICIO_VALIDATE_DATA = URL_AUTOSERVICIO_BASE + "/api/protected/dataVal/validateData";
var URL_AUTOSERVICIO_UPSERT_VALIDATIONS = URL_AUTOSERVICIO_BASE + "/api/protected/structure/upsertValidations";
var URL_AUTOSERVICIO_INSERT_DATA = URL_AUTOSERVICIO_BASE + "/api/protected/dataVal/insertData";
var URL_AUTOSERVICIO_GET_ERROR_TEMPLATE = URL_AUTOSERVICIO_BASE + "/api/protected/templates/getErrorTemplate";
var URL_AUTOSERVICIO_GET_DATA = URL_AUTOSERVICIO_BASE + "/api/protected/dataVal/getData";

var URL_FORGOT_PASSWORD = URL_BASE + "/authService/forgotPassword";
var URL_CHANGE_PASSWORD = URL_BASE + "/authService/changePassword";

/* harmony default export */ __webpack_exports__["default"] = ({
  URL_LOGIN: URL_LOGIN,
  URL_GET_ITEMS: URL_GET_ITEMS,
  URL_GET_KPI: URL_GET_KPI,
  URL_REGISTER_VIEW: URL_REGISTER_VIEW,

  URL_EDIT_ITEM: URL_EDIT_ITEM,
  URL_MOVE_ITEM: URL_MOVE_ITEM,
  URL_HIDE_ITEM: URL_HIDE_ITEM,
  URL_UNHIDE_ITEM: URL_UNHIDE_ITEM,
  URL_REMOVE_ITEM: URL_REMOVE_ITEM,
  URL_UNDO_REMOVE_ITEM: URL_UNDO_REMOVE_ITEM,
  URL_ADD_ITEM: URL_ADD_ITEM,
  URL_SET_FAVORITE: URL_SET_FAVORITE,
  URL_ADD_CUBE_PERMISSION: URL_ADD_CUBE_PERMISSION,
  URL_REMOVE_CUBE_PERMISSION: URL_REMOVE_CUBE_PERMISSION,

  URL_UPDATE_USER_INFO: URL_UPDATE_USER_INFO,
  URL_UPDATE_USER_PASSWORD: URL_UPDATE_USER_PASSWORD,

  URL_GET_ADMIN_USERS: URL_GET_ADMIN_USERS,
  URL_GET_ADMIN_SUBSCRIPTIONS: URL_GET_ADMIN_SUBSCRIPTIONS,
  URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS: URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS,
  URL_UPDATE_SUBSCRIPTIONS: URL_UPDATE_SUBSCRIPTIONS,
  URL_ADMIN_UPDATE_USER_INFO: URL_ADMIN_UPDATE_USER_INFO,
  URL_ADMIN_UPDATE_USER_PASSWORD: URL_ADMIN_UPDATE_USER_PASSWORD,
  URL_ADMIN_UPDATE_ACCESS_LEVEL: URL_ADMIN_UPDATE_ACCESS_LEVEL,
  URL_ADMIN_CREATE_USER: URL_ADMIN_CREATE_USER,

  URL_CREATE_STRUCTURE: URL_CREATE_STRUCTURE,
  URL_CHECK_STRUCTURE_NAME: URL_CHECK_STRUCTURE_NAME,
  URL_GET_STRUCTURES: URL_GET_STRUCTURES,
  URL_BUILD_STRUCTURE: URL_BUILD_STRUCTURE,
  URL_CREATE_HERITABLE_ITEM: URL_CREATE_HERITABLE_ITEM,
  URL_UPDATE_HERITABLE_ITEM: URL_UPDATE_HERITABLE_ITEM,
  URL_CREATE_HERITABLE_STRUCTURE: URL_CREATE_HERITABLE_STRUCTURE,
  URL_REPLICATE_STRUCTURE: URL_REPLICATE_STRUCTURE,
  URL_REMOVE_STRUCTURE: URL_REMOVE_STRUCTURE,
  URL_UPDATE_SPECIFIC_ITEM_DATA: URL_UPDATE_SPECIFIC_ITEM_DATA,
  URL_REPLICATE_FOLDER: URL_REPLICATE_FOLDER,
  URL_UPDATE_MULTIPLE_ITEMS_INHERITEE: URL_UPDATE_MULTIPLE_ITEMS_INHERITEE,
  URL_GET_HERITABLE_ITEMS: URL_GET_HERITABLE_ITEMS,

  URL_SUPERVISOR_REMOTE_FILES: URL_SUPERVISOR_REMOTE_FILES,
  URL_SUPERVISOR_REMOTE_UPDATE_FILE: URL_SUPERVISOR_REMOTE_UPDATE_FILE,
  URL_SUPERVISOR_REMOTE_REMOVE_FILE: URL_SUPERVISOR_REMOTE_REMOVE_FILE,
  URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR: URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR: URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR: URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR,
  URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL: URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL,

  URL_SUPERVISOR_REMOTE_GET_CARDS: URL_SUPERVISOR_REMOTE_GET_CARDS,
  URL_SUPERVISOR_REMOTE_UPDATE_CARDS: URL_SUPERVISOR_REMOTE_UPDATE_CARDS,

  URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS: URL_SUPERVISOR_REMOTE_GET_CONSISTENCY_LOGS,
  URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS: URL_SUPERVISOR_REMOTE_GET_DATABASE_LOGS,

  URL_POWERBI_ACCESS_TOKEN: URL_POWERBI_ACCESS_TOKEN,

  URL_AUTOSERVICIO_GET_GROUPS: URL_AUTOSERVICIO_GET_GROUPS,
  URL_AUTOSERVICIO_GET_PROCESSES: URL_AUTOSERVICIO_GET_PROCESSES,
  URL_AUTOSERVICIO_GET_VALIDATIONS: URL_AUTOSERVICIO_GET_VALIDATIONS,
  URL_AUTOSERVICIO_GET_TEMPLATE: URL_AUTOSERVICIO_GET_TEMPLATE,
  URL_AUTOSERVICIO_VALIDATE_DATA: URL_AUTOSERVICIO_VALIDATE_DATA,
  URL_AUTOSERVICIO_UPSERT_VALIDATIONS: URL_AUTOSERVICIO_UPSERT_VALIDATIONS,
  URL_AUTOSERVICIO_INSERT_DATA: URL_AUTOSERVICIO_INSERT_DATA,
  URL_AUTOSERVICIO_GET_ERROR_TEMPLATE: URL_AUTOSERVICIO_GET_ERROR_TEMPLATE,
  URL_AUTOSERVICIO_GET_DATA: URL_AUTOSERVICIO_GET_DATA,

  URL_POWERBI_ID: URL_POWERBI_ID,
  URL_METABASE: URL_METABASE,
  URL_HELPDESK: URL_HELPDESK,

  URL_CHANGE_PASSWORD: URL_CHANGE_PASSWORD,
  URL_FORGOT_PASSWORD: URL_FORGOT_PASSWORD
});

/***/ }),

/***/ "xdpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/utils/eventBus.js
var eventBus = __webpack_require__("irLX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/snackbars/custom-snack-bar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var custom_snack_bar = ({
  name: 'custom-snack-bar',
  created: function created() {
    var _this = this;

    eventBus["default"].$off('open-custom-snack-bar');
    eventBus["default"].$on('open-custom-snack-bar', function (data) {
      _this.openSnackBar(data.message, data.itsOk, data.snackAction);
    });
  },
  data: function data() {
    var _this2 = this;

    return {
      snackMessage: '',
      snackbar: false,
      snackItsOk: true,
      isWarning: false,
      snackActionMessage2: 'Cambiar',
      snackActionMessage: 'Cerrar',
      snackActionFunction: function snackActionFunction() {
        _this2.snackbar = false;
      },
      cambiarPwdFunction: function cambiarPwdFunction() {
        _this2.$router.push('/user/account');
      }
    };
  },

  methods: {
    openSnackBar: function openSnackBar(message, itsOk, snackAction) {
      var _this3 = this;

      this.snackMessage = message;
      this.snackbar = true;
      this.snackItsOk = itsOk;
      this.isWarning = itsOk === 'warning';
      if (snackAction) {
        this.snackActionMessage = snackAction.title;
        this.snackActionFunction = snackAction.action;
      } else {
        this.snackActionMessage = 'Cerrar';
        this.snackActionFunction = function () {
          _this3.snackbar = false;
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ee32c1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snackbars/custom-snack-bar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":6000,"top":"","right":"","multi-line":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('v-icon',{staticStyle:{"margin-right":"16px"},attrs:{"color":_vm.isWarning ? 'amber' : (_vm.snackItsOk ? 'green' : 'red')}},[_vm._v("\n    "+_vm._s(_vm.isWarning ? 'info' : (_vm.snackItsOk ? 'check' : 'warning'))+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.snackMessage)+"\n  "),_c('v-btn',{attrs:{"text":"","color":"green"},nativeOn:{"click":function($event){return _vm.cambiarPwdFunction()}}},[_vm._v("\n    "+_vm._s(_vm.snackActionMessage2)+"\n  ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"amber"},nativeOn:{"click":function($event){return _vm.snackActionFunction()}}},[_vm._v("\n    "+_vm._s(_vm.snackActionMessage)+"\n  ")])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/snackbars/custom-snack-bar.vue
function injectStyle (context) {
  __webpack_require__("jq+h")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  custom_snack_bar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var snackbars_custom_snack_bar = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yUJT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMmM1MmY2MC02N2FkLThhNDctYWRmZC1mZjNlYjJhNmEyZTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUM4NjZFRTI3NjJDMTFFOEI5NjVENkY2QTdBOTdFRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUM4NjZFRTE3NjJDMTFFOEI5NjVENkY2QTdBOTdFRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDNjNjkyNjEtNDEzYi1hNDRjLWE2NDMtN2NkNDI0YzllY2RhIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NzZkZDlhYTItYzY4ZS0yZjQ1LTg1ZmUtYTlhYWVmZmUwNzUzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+04i64wAAAXhJREFUeNrslztLA0EQx73VCz6wsBSxsLPxgSm0sLAR/ABaaKuk9NHY+A1UbAWDgtaWdpYpRESLCEG0C36AIKgY8dbfwoDHeY8sOUizAz8GZvfmvzu3d+x4WuuuTlhPNOBd3k/iyjAOSasy8QIoaMbM05Lbhx94hJJeLlYThbETGIRd+JTk0aQBrMAUHEIDukNzzGJmYB0uYF7yzqUJT8A2qyunlYrKjOFG4Iy57zHjr7g1OIcbOA2Pq5icTSHLfHm+P2G81+jDQFxOlfCQsjgnXgtxlXm4LM287wZlHcJvwiJcwQG8WZ1qC/sGI3gkgsPwAHuwCnXZddBuSaP2AaMicg3TsARFuIMF+Tq+8t7xrZT0mFNdD8WfYYPym0rMwov8E/IRRqyCq6SM13A1+bT8PEvdljlhJ+yEnbATdsJOOFM4yFknaEW4IORp/3LGXX1Mn7PDdUUltDC2O+2DLcmbKlySpm0/pWmzMXPFfZK8f8FOtam/AgwAsVJZKCU+/OUAAAAASUVORK5CYII="

/***/ }),

/***/ "zaRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uris__ = __webpack_require__("xbPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__ = __webpack_require__("BRjr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







var supervisorDistributors = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  getDistributorsPointer: function getDistributorsPointer() {
    return supervisorDistributors;
  },
  getRemoteFiles: function getRemoteFiles(options) {
    /*
    options: {
      onSuccess: ()
      onError: ()
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].get(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_FILES).then(function (response) {
      // console.log('Se obtuvieron los archivos remotos')
      supervisorDistributors.splice(0);
      supervisorDistributors.push.apply(supervisorDistributors, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.data.rows));

      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
    }, function (err) {
      console.warn('Error obteniendo los archivos remotos');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  getOutDatedFtpFiles: function getOutDatedFtpFiles() {
    /*
      Esta desactualizado si:
      - isOutDate = true o undefined
    */
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(supervisorDistributors, function (s) {
      return (s.isOutdated === undefined || s.isOutdated === true) && s.fromNow !== 'a day ago';
    }).length;
  },
  getUpdatedFtpFiles: function getUpdatedFtpFiles() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(supervisorDistributors, function (s) {
      return s.isOutdated === false || s.fromNow === 'a day ago';
    }).length;
  },
  getConsistencyCorrectLogs: function getConsistencyCorrectLogs() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(supervisorDistributors, function (s) {
      try {
        return s.lastLog.length > 0 && s.canReadJsonLog && !s.isLastLogOutdated && Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["reduce"])(s.lastLog, function (total, min) {
          if (min.fileName) {
            // Si encuentra ese campo
            return total && min.linesNotMatchingColumns.length === 0 && min.linesWithColumnsIssues.length === 0 && min.linesWithNotMatchingType.length === 0 && min.totalLinesInput - min.totalLinesOutput === 0;
          } else if (min.error) {
            return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/);
          } else {
            return false;
          }
        }, true) === true;
      } catch (error) {
        return s.lastLog.length > 0 && s.canReadJsonLog && !s.isLastLogOutdated && Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["reduce"])(s.lastLog, function (total, min) {
          return total && min.errors.length === 0 && min.rowsRemove === 0;
        }, true) === true;
      }
    }).length;
  },
  getDatabaseCorrectLogs: function getDatabaseCorrectLogs() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(supervisorDistributors, function (s) {
      return !s.isSalesMaxDateOutdated && !s.isSalesLastUpdatedOutdated || s.salesMaxDateFromNow === 'a day ago' || s.salesLastUpdateFromNow === 'a day ago';
    }).length;
  },
  getNonInconsistencyCorrectData: function getNonInconsistencyCorrectData() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(supervisorDistributors, function (s) {
      return s.inconsistenciesCounter === 0;
    }).length;
  },
  getSupervisorFtpFiles: function getSupervisorFtpFiles() {
    return supervisorDistributors;
  },
  updateSupervisorFtpFile: function updateSupervisorFtpFile(options) {
    /*
    options: {
      data: {
        item: {}
      }
    }
    */
    // PARSEAR AQUI Y EN REMOVE?
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_UPDATE_FILE, {
      distributorID: options.data.item.distributorID !== 0 ? String(options.data.item.distributorID) : '',
      newRemoteFileName: options.data.item.remoteFileName
    }).then(function (response) {
      var index = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(supervisorDistributors, function (file) {
        return file.distributorID === options.data.item.distributorID;
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(supervisorDistributors[index], options.data.item);
      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
    }, function (err) {
      console.warn('Error actualizando archivo remoto');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  removeSupervisorFtpFile: function removeSupervisorFtpFile(options) {
    /*
    options: {
      data: {
        item: {}
      }
    }
    */
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_REMOVE_FILE, {
      distributorID: options.data.item.distributorID !== 0 ? String(options.data.item.distributorID) : ''
    }).then(function (response) {
      // let index = supervisorFtpFiles.indexOf(options.data.item)
      var index = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(supervisorDistributors, function (file) {
        return file.distributorID === options.data.item.distributorID;
      });
      supervisorDistributors[index].remoteFileName = '';
      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
    }, function (err) {
      console.warn('Error eliminando archivo remoto');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  addDistributor: function addDistributor(options) {
    /* let distributor = {
      distributorID: 0,
      remoteFileName: options.data.item.remoteFileName,
      distributorName: options.data.item.distributorName,
      distributorCode1: options.data.item.distributorCode1,
      distributorCode2: options.data.item.distributorCode2,
      distributorCode3: options.data.item.distributorCode3
    } */
    var distributor = options.data.item;
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_ADD_DISTRIBUTOR, {
      distributorID: distributor.distributorID,
      remoteFileName: distributor.remoteFileName,
      distributorName: distributor.distributorName,
      distributorCode1: distributor.distributorCode1,
      distributorCode2: distributor.distributorCode2,
      distributorCode3: distributor.distributorCode3,
      contactMail: distributor.contactMail,
      inconsistenciesFileUrl: distributor.inconsistenciesFileUrl
    }).then(function (response) {
      distributor.distributorID = response.data.distributorID;
      supervisorDistributors.push(distributor);
      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
      if (options.finally) options.finally();
    }, function (err) {
      console.warn('Error agregando distribuidora');
      if (options.onError) {
        options.onError(err);
      }
      if (options.finally) options.finally();
    });
  },
  editDistributor: function editDistributor(options) {
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_EDIT_DISTRIBUTOR, Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["assign"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(options.data.item), { distributorID: String(options.data.item.distributorID) })).then(function (response) {
      var index = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(supervisorDistributors, function (distributor) {
        return distributor.distributorID === options.data.item.distributorID;
      });
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(supervisorDistributors[index], options.data.item);
      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
      if (options.finally) options.finally();
    }, function (err) {
      console.warn('Error actualizando distribuidora');
      if (options.onError) {
        options.onError(err);
      }
      if (options.finally) options.finally();
    });
  },
  removeDistributor: function removeDistributor(options) {
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_REMOVE_DISTRIBUTOR, Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["assign"])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["cloneDeep"])(options.data.item), { distributorID: String(options.data.item.distributorID) })).then(function (response) {
      var index = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(supervisorDistributors, function (distributor) {
        return distributor.distributorID === options.data.item.distributorID;
      });
      supervisorDistributors.splice(index, 1);
      if (options.onSuccess) {
        options.onSuccess(supervisorDistributors);
      }
    }, function (err) {
      console.warn('Error eliminando distribuidora');
      if (options.onError) {
        options.onError(err);
      }
    });
  },
  sendInconsistenciesMail: function sendInconsistenciesMail(options) {
    __WEBPACK_IMPORTED_MODULE_3__utils_axiosWrapper__["default"].post(__WEBPACK_IMPORTED_MODULE_2__utils_uris__["default"].URL_SUPERVISOR_REMOTE_SEND_INCONSISTENCIES_MAIL, {
      distributorCode2: options.data.distributorCode2
    }).then(function (response) {
      if (options.onSuccess) {
        options.onSuccess();
      }
    }).catch(function (err) {
      console.warn('Error enviando correo');
      if (options.onError) {
        options.onError(err);
      }
    });
  }
});

/***/ }),

/***/ "zc4k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d8219ee300c1c170d5a2.js